var fabric = fabric || { version: '1.7.17' };
'undefined' != typeof exports && (exports.fabric = fabric),
  (fabric.document = document),
  (fabric.window = window),
  (fabric.isTouchSupported = 'ontouchstart' in fabric.document.documentElement),
  (fabric.isLikelyNode =
    'undefined' != typeof Buffer && 'undefined' == typeof window),
  (fabric.SHARED_ATTRIBUTES = [
    'display',
    'transform',
    'fill',
    'fill-opacity',
    'fill-rule',
    'opacity',
    'stroke',
    'stroke-dasharray',
    'stroke-linecap',
    'stroke-linejoin',
    'stroke-miterlimit',
    'stroke-opacity',
    'stroke-width',
    'id',
  ]),
  (fabric.DPI = 96),
  (fabric.reNum = '(?:[-+]?(?:\\d+|\\d*\\.\\d+)(?:e[-+]?\\d+)?)'),
  (fabric.fontPaths = {}),
  (fabric.iMatrix = [1, 0, 0, 1, 0, 0]),
  (fabric.canvasModule = 'canvas'),
  (fabric.perfLimitSizeTotal = 2097152),
  (fabric.maxCacheSideLimit = 4096),
  (fabric.minCacheSideLimit = 256),
  (fabric.charWidthsCache = {}),
  (fabric.devicePixelRatio =
    fabric.window.devicePixelRatio ||
    fabric.window.webkitDevicePixelRatio ||
    fabric.window.mozDevicePixelRatio ||
    1),
  (function () {
    function r(t, e) {
      if (this.__eventListeners[t]) {
        var i = this.__eventListeners[t];
        e ? (i[i.indexOf(e)] = !1) : fabric.util.array.fill(i, !1);
      }
    }
    function t(t, e) {
      if (
        (this.__eventListeners || (this.__eventListeners = {}),
        1 === arguments.length)
      )
        for (var i in t) this.on(i, t[i]);
      else
        this.__eventListeners[t] || (this.__eventListeners[t] = []),
          this.__eventListeners[t].push(e);
      return this;
    }
    function e(t, e) {
      if (this.__eventListeners) {
        if (0 === arguments.length)
          for (t in this.__eventListeners) r.call(this, t);
        else if (1 === arguments.length && 'object' == typeof t)
          for (var i in t) r.call(this, i, t[i]);
        else r.call(this, t, e);
        return this;
      }
    }
    function i(t, e) {
      if (this.__eventListeners) {
        var i = this.__eventListeners[t];
        if (i) {
          for (var r = 0, n = i.length; r < n; r++)
            i[r] && i[r].call(this, e || {});
          return (
            (this.__eventListeners[t] = i.filter(function (t) {
              return !1 !== t;
            })),
            this
          );
        }
      }
    }
    fabric.Observable = {
      observe: t,
      stopObserving: e,
      fire: i,
      on: t,
      off: e,
      trigger: i,
    };
  })(),
  (fabric.Collection = {
    _objects: [],
    add: function () {
      if (
        (this._objects.push.apply(this._objects, arguments),
        this._onObjectAdded)
      )
        for (var t = 0, e = arguments.length; t < e; t++)
          this._onObjectAdded(arguments[t]);
      return this.renderOnAddRemove && this.renderAll(), this;
    },
    insertAt: function (t, e, i) {
      var r = this.getObjects();
      return (
        i ? (r[e] = t) : r.splice(e, 0, t),
        this._onObjectAdded && this._onObjectAdded(t),
        this.renderOnAddRemove && this.renderAll(),
        this
      );
    },
    remove: function () {
      for (
        var t, e = this.getObjects(), i = !1, r = 0, n = arguments.length;
        r < n;
        r++
      )
        -1 !== (t = e.indexOf(arguments[r])) &&
          ((i = !0),
          e.splice(t, 1),
          this._onObjectRemoved && this._onObjectRemoved(arguments[r]));
      return this.renderOnAddRemove && i && this.renderAll(), this;
    },
    forEachObject: function (t, e) {
      for (var i = this.getObjects(), r = 0, n = i.length; r < n; r++)
        t.call(e, i[r], r, i);
      return this;
    },
    getObjects: function (e) {
      return void 0 === e
        ? this._objects
        : this._objects.filter(function (t) {
            return t.type === e;
          });
    },
    item: function (t) {
      return this.getObjects()[t];
    },
    isEmpty: function () {
      return 0 === this.getObjects().length;
    },
    size: function () {
      return this.getObjects().length;
    },
    contains: function (t) {
      return -1 < this.getObjects().indexOf(t);
    },
    complexity: function () {
      return this.getObjects().reduce(function (t, e) {
        return (t += e.complexity ? e.complexity() : 0);
      }, 0);
    },
  }),
  (fabric.CommonMethods = {
    _setOptions: function (t) {
      for (var e in t) this.set(e, t[e]);
    },
    _initGradient: function (t, e) {
      !t ||
        !t.colorStops ||
        t instanceof fabric.Gradient ||
        this.set(e, new fabric.Gradient(t));
    },
    _initPattern: function (t, e, i) {
      !t || !t.source || t instanceof fabric.Pattern
        ? i && i()
        : this.set(e, new fabric.Pattern(t, i));
    },
    _initClipping: function (t) {
      if (t.clipTo && 'string' == typeof t.clipTo) {
        var e = fabric.util.getFunctionBody(t.clipTo);
        void 0 !== e && (this.clipTo = new Function('ctx', e));
      }
    },
    _setObject: function (t) {
      for (var e in t) this._set(e, t[e]);
    },
    set: function (t, e) {
      return (
        'object' == typeof t
          ? this._setObject(t)
          : 'function' == typeof e && 'clipTo' !== t
          ? this._set(t, e(this.get(t)))
          : this._set(t, e),
        this
      );
    },
    _set: function (t, e) {
      this[t] = e;
    },
    toggle: function (t) {
      var e = this.get(t);
      return 'boolean' == typeof e && this.set(t, !e), this;
    },
    get: function (t) {
      return this[t];
    },
  }),
  (function (s) {
    var d = Math.sqrt,
      g = Math.atan2,
      o = Math.pow,
      a = Math.abs,
      h = Math.PI / 180;
    fabric.util = {
      removeFromArray: function (t, e) {
        var i = t.indexOf(e);
        return -1 !== i && t.splice(i, 1), t;
      },
      getRandomInt: function (t, e) {
        return Math.floor(Math.random() * (e - t + 1)) + t;
      },
      degreesToRadians: function (t) {
        return t * h;
      },
      radiansToDegrees: function (t) {
        return t / h;
      },
      rotatePoint: function (t, e, i) {
        t.subtractEquals(e);
        var r = fabric.util.rotateVector(t, i);
        return new fabric.Point(r.x, r.y).addEquals(e);
      },
      rotateVector: function (t, e) {
        var i = Math.sin(e),
          r = Math.cos(e);
        return { x: t.x * r - t.y * i, y: t.x * i + t.y * r };
      },
      transformPoint: function (t, e, i) {
        return i
          ? new fabric.Point(e[0] * t.x + e[2] * t.y, e[1] * t.x + e[3] * t.y)
          : new fabric.Point(
              e[0] * t.x + e[2] * t.y + e[4],
              e[1] * t.x + e[3] * t.y + e[5]
            );
      },
      makeBoundingBoxFromPoints: function (t) {
        var e = [t[0].x, t[1].x, t[2].x, t[3].x],
          i = fabric.util.array.min(e),
          r = fabric.util.array.max(e),
          n = Math.abs(i - r),
          s = [t[0].y, t[1].y, t[2].y, t[3].y],
          o = fabric.util.array.min(s),
          a = fabric.util.array.max(s);
        return { left: i, top: o, width: n, height: Math.abs(o - a) };
      },
      invertTransform: function (t) {
        var e = 1 / (t[0] * t[3] - t[1] * t[2]),
          i = [e * t[3], -e * t[1], -e * t[2], e * t[0]],
          r = fabric.util.transformPoint({ x: t[4], y: t[5] }, i, !0);
        return (i[4] = -r.x), (i[5] = -r.y), i;
      },
      toFixed: function (t, e) {
        return parseFloat(Number(t).toFixed(e));
      },
      parseUnit: function (t, e) {
        var i = /\D{0,2}$/.exec(t),
          r = parseFloat(t);
        switch (((e = e || fabric.Text.DEFAULT_SVG_FONT_SIZE), i[0])) {
          case 'mm':
            return (r * fabric.DPI) / 25.4;
          case 'cm':
            return (r * fabric.DPI) / 2.54;
          case 'in':
            return r * fabric.DPI;
          case 'pt':
            return (r * fabric.DPI) / 72;
          case 'pc':
            return ((r * fabric.DPI) / 72) * 12;
          case 'em':
            return r * e;
          default:
            return r;
        }
      },
      falseFunction: function () {
        return !1;
      },
      getKlass: function (t, e) {
        return (
          (t = fabric.util.string.camelize(
            t.charAt(0).toUpperCase() + t.slice(1)
          )),
          fabric.util.resolveNamespace(e)[t]
        );
      },
      resolveNamespace: function (t) {
        if (!t) return fabric;
        var e,
          i = t.split('.'),
          r = i.length,
          n = s || fabric.window;
        for (e = 0; e < r; ++e) n = n[i[e]];
        return n;
      },
      loadImage: function (t, e, i, r) {
        if (t) {
          var n = fabric.util.createImage();
          (n.onload = function () {
            e && e.call(i, n), (n = n.onload = n.onerror = null);
          }),
            (n.onerror = function () {
              fabric.log('Error loading ' + n.src),
                e && e.call(i, null, !0),
                (n = n.onload = n.onerror = null);
            }),
            0 !== t.indexOf('data') && r && (n.crossOrigin = r),
            (n.src = t);
        } else e && e.call(i, t);
      },
      enlivenObjects: function (t, e, n, s) {
        function o() {
          ++i === r && e && e(a);
        }
        var a = [],
          i = 0,
          r = (t = t || []).length;
        r
          ? t.forEach(function (i, r) {
              i && i.type
                ? fabric.util.getKlass(i.type, n).fromObject(
                    i,
                    function (t, e) {
                      e || (a[r] = t), s && s(i, t, e), o();
                    },
                    !0
                  )
                : o();
            })
          : e && e(a);
      },
      enlivenPatterns: function (t, e) {
        function i() {
          ++n === s && e && e(r);
        }
        var r = [],
          n = 0,
          s = (t = t || []).length;
        s
          ? t.forEach(function (t, e) {
              t && t.source
                ? new fabric.Pattern(t, function (t) {
                    (r[e] = t), i();
                  })
                : ((r[e] = t), i());
            })
          : e && e(r);
      },
      groupSVGElements: function (t, e, i) {
        var r;
        return (
          (r = new fabric.PathGroup(t, e)),
          void 0 !== i && (r.sourcePath = i),
          r
        );
      },
      populateWithProperties: function (t, e, i) {
        if (i && '[object Array]' === Object.prototype.toString.call(i))
          for (var r = 0, n = i.length; r < n; r++)
            i[r] in t && (e[i[r]] = t[i[r]]);
      },
      drawDashedLine: function (t, e, i, r, n, s) {
        var o = r - e,
          a = n - i,
          h = d(o * o + a * a),
          c = g(a, o),
          l = s.length,
          u = 0,
          f = !0;
        for (
          t.save(), t.translate(e, i), t.moveTo(0, 0), t.rotate(c), e = 0;
          e < h;

        )
          h < (e += s[u++ % l]) && (e = h),
            t[f ? 'lineTo' : 'moveTo'](e, 0),
            (f = !f);
        t.restore();
      },
      createCanvasElement: function (t) {
        return (
          (t = t || fabric.document.createElement('canvas')).getContext ||
            'undefined' == typeof G_vmlCanvasManager ||
            G_vmlCanvasManager.initElement(t),
          t
        );
      },
      createImage: function () {
        return fabric.isLikelyNode
          ? new (require('canvas').Image)()
          : fabric.document.createElement('img');
      },
      createAccessors: function (t) {
        var e,
          i,
          r,
          n,
          s,
          o = t.prototype;
        for (e = o.stateProperties.length; e--; )
          (n =
            'set' +
            (r =
              (i = o.stateProperties[e]).charAt(0).toUpperCase() + i.slice(1))),
            o[(s = 'get' + r)] ||
              (o[s] = new Function('return this.get("' + i + '")')),
            o[n] ||
              (o[n] = new Function(
                'value',
                'return this.set("' + i + '", value)'
              ));
      },
      clipContext: function (t, e) {
        e.save(), e.beginPath(), t.clipTo(e), e.clip();
      },
      multiplyTransformMatrices: function (t, e, i) {
        return [
          t[0] * e[0] + t[2] * e[1],
          t[1] * e[0] + t[3] * e[1],
          t[0] * e[2] + t[2] * e[3],
          t[1] * e[2] + t[3] * e[3],
          i ? 0 : t[0] * e[4] + t[2] * e[5] + t[4],
          i ? 0 : t[1] * e[4] + t[3] * e[5] + t[5],
        ];
      },
      qrDecompose: function (t) {
        var e = g(t[1], t[0]),
          i = o(t[0], 2) + o(t[1], 2),
          r = d(i),
          n = (t[0] * t[3] - t[2] * t[1]) / r,
          s = g(t[0] * t[2] + t[1] * t[3], i);
        return {
          angle: e / h,
          scaleX: r,
          scaleY: n,
          skewX: s / h,
          skewY: 0,
          translateX: t[4],
          translateY: t[5],
        };
      },
      customTransformMatrix: function (t, e, i) {
        var r = [1, 0, a(Math.tan(i * h)), 1],
          n = [a(t), 0, 0, a(e)];
        return fabric.util.multiplyTransformMatrices(n, r, !0);
      },
      resetObjectTransform: function (t) {
        (t.scaleX = 1),
          (t.scaleY = 1),
          (t.skewX = 0),
          (t.skewY = 0),
          (t.flipX = !1),
          (t.flipY = !1),
          t.setAngle(0);
      },
      getFunctionBody: function (t) {
        return (String(t).match(/function[^{]*\{([\s\S]*)\}/) || {})[1];
      },
      isTransparent: function (t, e, i, r) {
        0 < r && (r < e ? (e -= r) : (e = 0), r < i ? (i -= r) : (i = 0));
        var n,
          s = !0,
          o = t.getImageData(e, i, 2 * r || 1, 2 * r || 1),
          a = o.data.length;
        for (n = 3; n < a && !1 !== (s = o.data[n] <= 0); n += 4);
        return (o = null), s;
      },
      parsePreserveAspectRatioAttribute: function (t) {
        var e,
          i = 'meet',
          r = t.split(' ');
        return (
          r &&
            r.length &&
            ('meet' !== (i = r.pop()) && 'slice' !== i
              ? ((e = i), (i = 'meet'))
              : r.length && (e = r.pop())),
          {
            meetOrSlice: i,
            alignX: 'none' !== e ? e.slice(1, 4) : 'none',
            alignY: 'none' !== e ? e.slice(5, 8) : 'none',
          }
        );
      },
      clearFabricFontCache: function (t) {
        t
          ? fabric.charWidthsCache[t] && delete fabric.charWidthsCache[t]
          : (fabric.charWidthsCache = {});
      },
      limitDimsByArea: function (t, e) {
        var i = Math.sqrt(e * t),
          r = Math.floor(e / i);
        return { x: Math.floor(i), y: r };
      },
      capValue: function (t, e, i) {
        return Math.max(t, Math.min(e, i));
      },
    };
  })('undefined' != typeof exports ? exports : this),
  (function () {
    var L = {},
      C = {},
      D = {},
      F = Array.prototype.join;
    function v(t, e, i, r, n, s, o) {
      var a = F.call(arguments);
      if (L[a]) return L[a];
      var h = Math.PI,
        c = (o * h) / 180,
        l = Math.sin(c),
        u = Math.cos(c),
        f = 0,
        d = 0,
        g = -u * t * 0.5 - l * e * 0.5,
        p = -u * e * 0.5 + l * t * 0.5,
        v = (i = Math.abs(i)) * i,
        b = (r = Math.abs(r)) * r,
        m = p * p,
        _ = g * g,
        y = v * b - v * m - b * _,
        x = 0;
      if (y < 0) {
        var C = Math.sqrt(1 - y / (v * b));
        (i *= C), (r *= C);
      } else x = (n === s ? -1 : 1) * Math.sqrt(y / (v * m + b * _));
      var S = (x * i * p) / r,
        w = (-x * r * g) / i,
        O = u * S - l * w + 0.5 * t,
        T = l * S + u * w + 0.5 * e,
        j = R(1, 0, (g - S) / i, (p - w) / r),
        k = R((g - S) / i, (p - w) / r, (-g - S) / i, (-p - w) / r);
      0 === s && 0 < k ? (k -= 2 * h) : 1 === s && k < 0 && (k += 2 * h);
      for (
        var M = Math.ceil(Math.abs((k / h) * 2)),
          D = [],
          P = k / M,
          A = ((8 / 3) * Math.sin(P / 4) * Math.sin(P / 4)) / Math.sin(P / 2),
          E = j + P,
          I = 0;
        I < M;
        I++
      )
        (D[I] = B(j, E, u, l, i, r, O, T, A, f, d)),
          (f = D[I][4]),
          (d = D[I][5]),
          (j = E),
          (E += P);
      return (L[a] = D);
    }
    function B(t, e, i, r, n, s, o, a, h, c, l) {
      var u = F.call(arguments);
      if (C[u]) return C[u];
      var f = Math.cos(t),
        d = Math.sin(t),
        g = Math.cos(e),
        p = Math.sin(e),
        v = i * n * g - r * s * p + o,
        b = r * n * g + i * s * p + a,
        m = c + h * (-i * n * d - r * s * f),
        _ = l + h * (-r * n * d + i * s * f),
        y = v + h * (i * n * p + r * s * g),
        x = b + h * (r * n * p - i * s * g);
      return (C[u] = [m, _, y, x, v, b]), C[u];
    }
    function R(t, e, i, r) {
      var n = Math.atan2(e, t),
        s = Math.atan2(r, i);
      return n <= s ? s - n : 2 * Math.PI - (n - s);
    }
    function b(t, e, i, r, n, s, o, a) {
      var h = F.call(arguments);
      if (D[h]) return D[h];
      var c,
        l,
        u,
        f,
        d,
        g,
        p,
        v,
        b = Math.sqrt,
        m = Math.min,
        _ = Math.max,
        y = Math.abs,
        x = [],
        C = [[], []];
      (l = 6 * t - 12 * i + 6 * n),
        (c = -3 * t + 9 * i - 9 * n + 3 * o),
        (u = 3 * i - 3 * t);
      for (var S = 0; S < 2; ++S)
        if (
          (0 < S &&
            ((l = 6 * e - 12 * r + 6 * s),
            (c = -3 * e + 9 * r - 9 * s + 3 * a),
            (u = 3 * r - 3 * e)),
          y(c) < 1e-12)
        ) {
          if (y(l) < 1e-12) continue;
          0 < (f = -u / l) && f < 1 && x.push(f);
        } else
          (p = l * l - 4 * u * c) < 0 ||
            (0 < (d = (-l + (v = b(p))) / (2 * c)) && d < 1 && x.push(d),
            0 < (g = (-l - v) / (2 * c)) && g < 1 && x.push(g));
      for (var w, O, T, j = x.length, k = j; j--; )
        (w =
          (T = 1 - (f = x[j])) * T * T * t +
          3 * T * T * f * i +
          3 * T * f * f * n +
          f * f * f * o),
          (C[0][j] = w),
          (O =
            T * T * T * e +
            3 * T * T * f * r +
            3 * T * f * f * s +
            f * f * f * a),
          (C[1][j] = O);
      (C[0][k] = t), (C[1][k] = e), (C[0][k + 1] = o), (C[1][k + 1] = a);
      var M = [
        { x: m.apply(null, C[0]), y: m.apply(null, C[1]) },
        { x: _.apply(null, C[0]), y: _.apply(null, C[1]) },
      ];
      return (D[h] = M);
    }
    (fabric.util.drawArc = function (t, e, i, r) {
      for (
        var n = r[0],
          s = r[1],
          o = r[2],
          a = r[3],
          h = r[4],
          c = [[], [], [], []],
          l = v(r[5] - e, r[6] - i, n, s, a, h, o),
          u = 0,
          f = l.length;
        u < f;
        u++
      )
        (c[u][0] = l[u][0] + e),
          (c[u][1] = l[u][1] + i),
          (c[u][2] = l[u][2] + e),
          (c[u][3] = l[u][3] + i),
          (c[u][4] = l[u][4] + e),
          (c[u][5] = l[u][5] + i),
          t.bezierCurveTo.apply(t, c[u]);
    }),
      (fabric.util.getBoundsOfArc = function (t, e, i, r, n, s, o, a, h) {
        for (
          var c,
            l = 0,
            u = 0,
            f = [],
            d = v(a - t, h - e, i, r, s, o, n),
            g = 0,
            p = d.length;
          g < p;
          g++
        )
          (c = b(l, u, d[g][0], d[g][1], d[g][2], d[g][3], d[g][4], d[g][5])),
            f.push({ x: c[0].x + t, y: c[0].y + e }),
            f.push({ x: c[1].x + t, y: c[1].y + e }),
            (l = d[g][4]),
            (u = d[g][5]);
        return f;
      }),
      (fabric.util.getBoundsOfCurve = b);
  })(),
  (function () {
    var o = Array.prototype.slice;
    function i(t, e, i) {
      if (t && 0 !== t.length) {
        var r = t.length - 1,
          n = e ? t[r][e] : t[r];
        if (e) for (; r--; ) i(t[r][e], n) && (n = t[r][e]);
        else for (; r--; ) i(t[r], n) && (n = t[r]);
        return n;
      }
    }
    Array.prototype.indexOf ||
      (Array.prototype.indexOf = function (t) {
        if (null == this) throw new TypeError();
        var e = Object(this),
          i = e.length >>> 0;
        if (0 == i) return -1;
        var r = 0;
        if (
          (0 < arguments.length &&
            ((r = Number(arguments[1])) != r
              ? (r = 0)
              : 0 !== r &&
                r !== Number.POSITIVE_INFINITY &&
                r !== Number.NEGATIVE_INFINITY &&
                (r = (0 < r || -1) * Math.floor(Math.abs(r)))),
          i <= r)
        )
          return -1;
        for (var n = 0 <= r ? r : Math.max(i - Math.abs(r), 0); n < i; n++)
          if (n in e && e[n] === t) return n;
        return -1;
      }),
      Array.prototype.forEach ||
        (Array.prototype.forEach = function (t, e) {
          for (var i = 0, r = this.length >>> 0; i < r; i++)
            i in this && t.call(e, this[i], i, this);
        }),
      Array.prototype.map ||
        (Array.prototype.map = function (t, e) {
          for (var i = [], r = 0, n = this.length >>> 0; r < n; r++)
            r in this && (i[r] = t.call(e, this[r], r, this));
          return i;
        }),
      Array.prototype.every ||
        (Array.prototype.every = function (t, e) {
          for (var i = 0, r = this.length >>> 0; i < r; i++)
            if (i in this && !t.call(e, this[i], i, this)) return !1;
          return !0;
        }),
      Array.prototype.some ||
        (Array.prototype.some = function (t, e) {
          for (var i = 0, r = this.length >>> 0; i < r; i++)
            if (i in this && t.call(e, this[i], i, this)) return !0;
          return !1;
        }),
      Array.prototype.filter ||
        (Array.prototype.filter = function (t, e) {
          for (var i, r = [], n = 0, s = this.length >>> 0; n < s; n++)
            n in this && ((i = this[n]), t.call(e, i, n, this) && r.push(i));
          return r;
        }),
      Array.prototype.reduce ||
        (Array.prototype.reduce = function (t) {
          var e,
            i = this.length >>> 0,
            r = 0;
          if (1 < arguments.length) e = arguments[1];
          else
            for (;;) {
              if (r in this) {
                e = this[r++];
                break;
              }
              if (++r >= i) throw new TypeError();
            }
          for (; r < i; r++)
            r in this && (e = t.call(null, e, this[r], r, this));
          return e;
        }),
      (fabric.util.array = {
        fill: function (t, e) {
          for (var i = t.length; i--; ) t[i] = e;
          return t;
        },
        invoke: function (t, e) {
          for (
            var i = o.call(arguments, 2), r = [], n = 0, s = t.length;
            n < s;
            n++
          )
            r[n] = i.length ? t[n][e].apply(t[n], i) : t[n][e].call(t[n]);
          return r;
        },
        min: function (t, e) {
          return i(t, e, function (t, e) {
            return t < e;
          });
        },
        max: function (t, e) {
          return i(t, e, function (t, e) {
            return e <= t;
          });
        },
      });
  })(),
  (function () {
    function o(t, e, i) {
      if (i)
        if (!fabric.isLikelyNode && e instanceof Element) t = e;
        else if (e instanceof Array) {
          t = [];
          for (var r = 0, n = e.length; r < n; r++) t[r] = o({}, e[r], i);
        } else if (e && 'object' == typeof e)
          for (var s in e) e.hasOwnProperty(s) && (t[s] = o({}, e[s], i));
        else t = e;
      else for (var s in e) t[s] = e[s];
      return t;
    }
    fabric.util.object = {
      extend: o,
      clone: function (t, e) {
        return o({}, t, e);
      },
    };
  })(),
  String.prototype.trim ||
    (String.prototype.trim = function () {
      return this.replace(/^[\s\xA0]+/, '').replace(/[\s\xA0]+$/, '');
    }),
  (fabric.util.string = {
    camelize: function (t) {
      return t.replace(/-+(.)?/g, function (t, e) {
        return e ? e.toUpperCase() : '';
      });
    },
    capitalize: function (t, e) {
      return (
        t.charAt(0).toUpperCase() + (e ? t.slice(1) : t.slice(1).toLowerCase())
      );
    },
    escapeXml: function (t) {
      return t
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    },
  }),
  (function () {
    function n() {}
    var s = Array.prototype.slice,
      o = Function.prototype.apply;
    Function.prototype.bind ||
      (Function.prototype.bind = function (t) {
        var e,
          i = this,
          r = s.call(arguments, 1);
        return (
          (e = r.length
            ? function () {
                return o.call(
                  i,
                  this instanceof n ? this : t,
                  r.concat(s.call(arguments))
                );
              }
            : function () {
                return o.call(i, this instanceof n ? this : t, arguments);
              }),
          (n.prototype = this.prototype),
          (e.prototype = new n()),
          e
        );
      });
  })(),
  (function () {
    function s() {}
    function o(t, r, n) {
      for (var e in r)
        e in t.prototype &&
        'function' == typeof t.prototype[e] &&
        -1 < (r[e] + '').indexOf('callSuper')
          ? (t.prototype[e] = (function (i) {
              return function () {
                var t = this.constructor.superclass;
                this.constructor.superclass = n;
                var e = r[i].apply(this, arguments);
                if (((this.constructor.superclass = t), 'initialize' !== i))
                  return e;
              };
            })(e))
          : (t.prototype[e] = r[e]),
          i &&
            (r.toString !== Object.prototype.toString &&
              (t.prototype.toString = r.toString),
            r.valueOf !== Object.prototype.valueOf &&
              (t.prototype.valueOf = r.valueOf));
    }
    var a = Array.prototype.slice,
      i = (function () {
        for (var t in { toString: 1 }) if ('toString' === t) return !1;
        return !0;
      })();
    function h() {}
    function c(t) {
      for (var e = null, i = this; i.constructor.superclass; ) {
        var r = i.constructor.superclass.prototype[t];
        if (i[t] !== r) {
          e = r;
          break;
        }
        i = i.constructor.superclass.prototype;
      }
      return e
        ? 1 < arguments.length
          ? e.apply(this, a.call(arguments, 1))
          : e.call(this)
        : console.log(
            'tried to callSuper ' + t + ', method not found in prototype chain',
            this
          );
    }
    fabric.util.createClass = function () {
      var t = null,
        e = a.call(arguments, 0);
      function i() {
        this.initialize.apply(this, arguments);
      }
      'function' == typeof e[0] && (t = e.shift()),
        (i.superclass = t),
        (i.subclasses = []),
        t &&
          ((h.prototype = t.prototype),
          (i.prototype = new h()),
          t.subclasses.push(i));
      for (var r = 0, n = e.length; r < n; r++) o(i, e[r], t);
      return (
        i.prototype.initialize || (i.prototype.initialize = s),
        ((i.prototype.constructor = i).prototype.callSuper = c),
        i
      );
    };
  })(),
  (function () {
    var r = 'unknown';
    function t(t) {
      var e,
        i,
        r = Array.prototype.slice.call(arguments, 1),
        n = r.length;
      for (i = 0; i < n; i++)
        if (((e = typeof t[r[i]]), !/^(?:function|object|unknown)$/.test(e)))
          return !1;
      return !0;
    }
    var n,
      s,
      e,
      i,
      a =
        ((e = 0),
        function (t) {
          return t.__uniqueID || (t.__uniqueID = 'uniqueID__' + e++);
        });
    function o(t, e) {
      return {
        handler: e,
        wrappedHandler:
          ((i = t),
          (r = e),
          function (t) {
            r.call(n(i), t || fabric.window.event);
          }),
      };
      var i, r;
    }
    (i = {}),
      (n = function (t) {
        return i[t];
      }),
      (s = function (t, e) {
        i[t] = e;
      });
    var h,
      c,
      l =
        t(
          fabric.document.documentElement,
          'addEventListener',
          'removeEventListener'
        ) && t(fabric.window, 'addEventListener', 'removeEventListener'),
      u =
        t(fabric.document.documentElement, 'attachEvent', 'detachEvent') &&
        t(fabric.window, 'attachEvent', 'detachEvent'),
      f = {},
      d = {};
    (c = l
      ? ((h = function (t, e, i, r) {
          t && t.addEventListener(e, i, !u && r);
        }),
        function (t, e, i, r) {
          t && t.removeEventListener(e, i, !u && r);
        })
      : u
      ? ((h = function (t, e, i) {
          if (t) {
            var r = a(t);
            s(r, t), f[r] || (f[r] = {}), f[r][e] || (f[r][e] = []);
            var n = o(r, i);
            f[r][e].push(n), t.attachEvent('on' + e, n.wrappedHandler);
          }
        }),
        function (t, e, i) {
          if (t) {
            var r,
              n = a(t);
            if (f[n] && f[n][e])
              for (var s = 0, o = f[n][e].length; s < o; s++)
                (r = f[n][e][s]) &&
                  r.handler === i &&
                  (t.detachEvent('on' + e, r.wrappedHandler),
                  (f[n][e][s] = null));
          }
        })
      : ((h = function (t, e, i) {
          if (t) {
            var n,
              s,
              r = a(t);
            if ((d[r] || (d[r] = {}), !d[r][e])) {
              d[r][e] = [];
              var o = t['on' + e];
              o && d[r][e].push(o),
                (t['on' + e] =
                  ((n = r),
                  (s = e),
                  function (t) {
                    if (d[n] && d[n][s])
                      for (var e = d[n][s], i = 0, r = e.length; i < r; i++)
                        e[i].call(this, t || fabric.window.event);
                  }));
            }
            d[r][e].push(i);
          }
        }),
        function (t, e, i) {
          if (t) {
            var r = a(t);
            if (d[r] && d[r][e])
              for (var n = d[r][e], s = 0, o = n.length; s < o; s++)
                n[s] === i && n.splice(s, 1);
          }
        })),
      (fabric.util.addListener = h),
      (fabric.util.removeListener = c);
    var g = function (t) {
        return typeof t.clientX != r ? t.clientX : 0;
      },
      p = function (t) {
        return typeof t.clientY != r ? t.clientY : 0;
      };
    function v(t, e, i) {
      var r = 'touchend' === t.type ? 'changedTouches' : 'touches';
      return (
        (t[r] && t[r][0] && t[r][0][e] - (t[r][0][e] - t[r][0][i])) || t[i]
      );
    }
    fabric.isTouchSupported &&
      ((g = function (t) {
        return v(t, 'pageX', 'clientX');
      }),
      (p = function (t) {
        return v(t, 'pageY', 'clientY');
      })),
      (fabric.util.getPointer = function (t) {
        var e =
            (t = t || fabric.window.event).target ||
            (typeof t.srcElement != r ? t.srcElement : null),
          i = fabric.util.getScrollLeftTop(e);
        return { x: g(t) + i.left, y: p(t) + i.top };
      }),
      fabric.util.object.extend(fabric.util, fabric.Observable);
  })(),
  (function () {
    var t = fabric.document.createElement('div'),
      e = 'string' == typeof t.style.opacity,
      i = 'string' == typeof t.style.filter,
      r = /alpha\s*\(\s*opacity\s*=\s*([^\)]+)\)/,
      n = function (t) {
        return t;
      };
    e
      ? (n = function (t, e) {
          return (t.style.opacity = e), t;
        })
      : i &&
        (n = function (t, e) {
          var i = t.style;
          return (
            t.currentStyle && !t.currentStyle.hasLayout && (i.zoom = 1),
            r.test(i.filter)
              ? ((e = 0.9999 <= e ? '' : 'alpha(opacity=' + 100 * e + ')'),
                (i.filter = i.filter.replace(r, e)))
              : (i.filter += ' alpha(opacity=' + 100 * e + ')'),
            t
          );
        }),
      (fabric.util.setStyle = function (t, e) {
        var i = t.style;
        if (!i) return t;
        if ('string' == typeof e)
          return (
            (t.style.cssText += ';' + e),
            -1 < e.indexOf('opacity')
              ? n(t, e.match(/opacity:\s*(\d?\.?\d*)/)[1])
              : t
          );
        for (var r in e) {
          if ('opacity' === r) n(t, e[r]);
          else
            i[
              'float' === r || 'cssFloat' === r
                ? void 0 === i.styleFloat
                  ? 'cssFloat'
                  : 'styleFloat'
                : r
            ] = e[r];
        }
        return t;
      });
  })(),
  (function () {
    var e = Array.prototype.slice;
    var t,
      h,
      i,
      r,
      n = function (t) {
        return e.call(t, 0);
      };
    try {
      t = n(fabric.document.childNodes) instanceof Array;
    } catch (t) {}
    function s(t, e) {
      var i = fabric.document.createElement(t);
      for (var r in e)
        'class' === r
          ? (i.className = e[r])
          : 'for' === r
          ? (i.htmlFor = e[r])
          : i.setAttribute(r, e[r]);
      return i;
    }
    function c(t) {
      for (
        var e = 0,
          i = 0,
          r = fabric.document.documentElement,
          n = fabric.document.body || { scrollLeft: 0, scrollTop: 0 };
        t &&
        (t.parentNode || t.host) &&
        ((t = t.parentNode || t.host) === fabric.document
          ? ((e = n.scrollLeft || r.scrollLeft || 0),
            (i = n.scrollTop || r.scrollTop || 0))
          : ((e += t.scrollLeft || 0), (i += t.scrollTop || 0)),
        1 !== t.nodeType ||
          'fixed' !== fabric.util.getElementStyle(t, 'position'));

      );
      return { left: e, top: i };
    }
    t ||
      (n = function (t) {
        for (var e = new Array(t.length), i = t.length; i--; ) e[i] = t[i];
        return e;
      }),
      (h =
        fabric.document.defaultView &&
        fabric.document.defaultView.getComputedStyle
          ? function (t, e) {
              var i = fabric.document.defaultView.getComputedStyle(t, null);
              return i ? i[e] : void 0;
            }
          : function (t, e) {
              var i = t.style[e];
              return !i && t.currentStyle && (i = t.currentStyle[e]), i;
            }),
      (i = fabric.document.documentElement.style),
      (r =
        'userSelect' in i
          ? 'userSelect'
          : 'MozUserSelect' in i
          ? 'MozUserSelect'
          : 'WebkitUserSelect' in i
          ? 'WebkitUserSelect'
          : 'KhtmlUserSelect' in i
          ? 'KhtmlUserSelect'
          : ''),
      (fabric.util.makeElementUnselectable = function (t) {
        return (
          void 0 !== t.onselectstart &&
            (t.onselectstart = fabric.util.falseFunction),
          r
            ? (t.style[r] = 'none')
            : 'string' == typeof t.unselectable && (t.unselectable = 'on'),
          t
        );
      }),
      (fabric.util.makeElementSelectable = function (t) {
        return (
          void 0 !== t.onselectstart && (t.onselectstart = null),
          r
            ? (t.style[r] = '')
            : 'string' == typeof t.unselectable && (t.unselectable = ''),
          t
        );
      }),
      (fabric.util.getScript = function (t, e) {
        var i = fabric.document.getElementsByTagName('head')[0],
          r = fabric.document.createElement('script'),
          n = !0;
        (r.onload = r.onreadystatechange =
          function (t) {
            if (n) {
              if (
                'string' == typeof this.readyState &&
                'loaded' !== this.readyState &&
                'complete' !== this.readyState
              )
                return;
              (n = !1),
                e(t || fabric.window.event),
                (r = r.onload = r.onreadystatechange = null);
            }
          }),
          (r.src = t),
          i.appendChild(r);
      }),
      (fabric.util.getById = function (t) {
        return 'string' == typeof t ? fabric.document.getElementById(t) : t;
      }),
      (fabric.util.toArray = n),
      (fabric.util.makeElement = s),
      (fabric.util.addClass = function (t, e) {
        t &&
          -1 === (' ' + t.className + ' ').indexOf(' ' + e + ' ') &&
          (t.className += (t.className ? ' ' : '') + e);
      }),
      (fabric.util.wrapElement = function (t, e, i) {
        return (
          'string' == typeof e && (e = s(e, i)),
          t.parentNode && t.parentNode.replaceChild(e, t),
          e.appendChild(t),
          e
        );
      }),
      (fabric.util.getScrollLeftTop = c),
      (fabric.util.getElementOffset = function (t) {
        var e,
          i,
          r = t && t.ownerDocument,
          n = { left: 0, top: 0 },
          s = { left: 0, top: 0 },
          o = {
            borderLeftWidth: 'left',
            borderTopWidth: 'top',
            paddingLeft: 'left',
            paddingTop: 'top',
          };
        if (!r) return s;
        for (var a in o) s[o[a]] += parseInt(h(t, a), 10) || 0;
        return (
          (e = r.documentElement),
          void 0 !== t.getBoundingClientRect && (n = t.getBoundingClientRect()),
          (i = c(t)),
          {
            left: n.left + i.left - (e.clientLeft || 0) + s.left,
            top: n.top + i.top - (e.clientTop || 0) + s.top,
          }
        );
      }),
      (fabric.util.getElementStyle = h);
  })(),
  (function () {
    var h = (function () {
      for (
        var t = [
            function () {
              return new ActiveXObject('Microsoft.XMLHTTP');
            },
            function () {
              return new ActiveXObject('Msxml2.XMLHTTP');
            },
            function () {
              return new ActiveXObject('Msxml2.XMLHTTP.3.0');
            },
            function () {
              return new XMLHttpRequest();
            },
          ],
          e = t.length;
        e--;

      )
        try {
          if (t[e]()) return t[e];
        } catch (t) {}
    })();
    function c() {}
    fabric.util.request = function (t, e) {
      var i,
        r,
        n = (e = e || {}).method ? e.method.toUpperCase() : 'GET',
        s = e.onComplete || function () {},
        o = h(),
        a = e.body || e.parameters;
      return (
        (o.onreadystatechange = function () {
          4 === o.readyState && (s(o), (o.onreadystatechange = c));
        }),
        'GET' === n &&
          ((a = null),
          'string' == typeof e.parameters &&
            ((i = t),
            (r = e.parameters),
            (t = i + (/\?/.test(i) ? '&' : '?') + r))),
        o.open(n, t, !0),
        ('POST' !== n && 'PUT' !== n) ||
          o.setRequestHeader(
            'Content-Type',
            'application/x-www-form-urlencoded'
          ),
        o.send(a),
        o
      );
    };
  })(),
  (fabric.log = function () {}),
  (fabric.warn = function () {}),
  'undefined' != typeof console &&
    ['log', 'warn'].forEach(function (t) {
      void 0 !== console[t] &&
        'function' == typeof console[t].apply &&
        (fabric[t] = function () {
          return console[t].apply(console, arguments);
        });
    }),
  (function () {
    function e() {
      return !1;
    }
    var t =
      fabric.window.requestAnimationFrame ||
      fabric.window.webkitRequestAnimationFrame ||
      fabric.window.mozRequestAnimationFrame ||
      fabric.window.oRequestAnimationFrame ||
      fabric.window.msRequestAnimationFrame ||
      function (t) {
        fabric.window.setTimeout(t, 1e3 / 60);
      };
    function m() {
      return t.apply(fabric.window, arguments);
    }
    (fabric.util.animate = function (b) {
      m(function (t) {
        b = b || {};
        var o,
          a = t || +new Date(),
          h = b.duration || 500,
          c = a + h,
          l = b.onChange || e,
          u = b.abort || e,
          f = b.onComplete || e,
          d =
            b.easing ||
            function (t, e, i, r) {
              return -i * Math.cos((t / r) * (Math.PI / 2)) + i + e;
            },
          g = 'startValue' in b ? b.startValue : 0,
          p = 'endValue' in b ? b.endValue : 100,
          v = b.byValue || p - g;
        b.onStart && b.onStart(),
          (function t(e) {
            if (u()) f(p, 1, 1);
            else {
              o = e || +new Date();
              var i = c < o ? h : o - a,
                r = i / h,
                n = d(i, g, v, h),
                s = Math.abs((n - g) / v);
              l(n, s, r), c < o ? b.onComplete && b.onComplete() : m(t);
            }
          })(a);
      });
    }),
      (fabric.util.requestAnimFrame = m);
  })(),
  (fabric.util.animateColor = function (t, e, i, c) {
    var r = new fabric.Color(t).getSource(),
      n = new fabric.Color(e).getSource();
    (c = c || {}),
      fabric.util.animate(
        fabric.util.object.extend(c, {
          duration: i || 500,
          startValue: r,
          endValue: n,
          byValue: n,
          easing: function (t, e, i, r) {
            var n,
              s,
              o,
              a,
              h = c.colorEasing
                ? c.colorEasing(t, r)
                : 1 - Math.cos((t / r) * (Math.PI / 2));
            return (
              (n = e),
              (s = i),
              (o = h),
              (a =
                'rgba(' +
                parseInt(n[0] + o * (s[0] - n[0]), 10) +
                ',' +
                parseInt(n[1] + o * (s[1] - n[1]), 10) +
                ',' +
                parseInt(n[2] + o * (s[2] - n[2]), 10)),
              (a += ',' + (n && s ? parseFloat(n[3] + o * (s[3] - n[3])) : 1)),
              (a += ')')
            );
          },
        })
      );
  }),
  (function () {
    function o(t, e, i, r) {
      return (
        (r =
          t < Math.abs(e)
            ? ((t = e), i / 4)
            : 0 === e && 0 === t
            ? (i / (2 * Math.PI)) * Math.asin(1)
            : (i / (2 * Math.PI)) * Math.asin(e / t)),
        { a: t, c: e, p: i, s: r }
      );
    }
    function a(t, e, i) {
      return (
        t.a *
        Math.pow(2, 10 * --e) *
        Math.sin(((e * i - t.s) * (2 * Math.PI)) / t.p)
      );
    }
    function n(t, e, i, r) {
      return i - s(r - t, 0, i, r) + e;
    }
    function s(t, e, i, r) {
      return (t /= r) < 1 / 2.75
        ? i * (7.5625 * t * t) + e
        : t < 2 / 2.75
        ? i * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + e
        : t < 2.5 / 2.75
        ? i * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + e
        : i * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + e;
    }
    fabric.util.ease = {
      easeInQuad: function (t, e, i, r) {
        return i * (t /= r) * t + e;
      },
      easeOutQuad: function (t, e, i, r) {
        return -i * (t /= r) * (t - 2) + e;
      },
      easeInOutQuad: function (t, e, i, r) {
        return (t /= r / 2) < 1
          ? (i / 2) * t * t + e
          : (-i / 2) * (--t * (t - 2) - 1) + e;
      },
      easeInCubic: function (t, e, i, r) {
        return i * (t /= r) * t * t + e;
      },
      easeOutCubic: function (t, e, i, r) {
        return i * ((t = t / r - 1) * t * t + 1) + e;
      },
      easeInOutCubic: function (t, e, i, r) {
        return (t /= r / 2) < 1
          ? (i / 2) * t * t * t + e
          : (i / 2) * ((t -= 2) * t * t + 2) + e;
      },
      easeInQuart: function (t, e, i, r) {
        return i * (t /= r) * t * t * t + e;
      },
      easeOutQuart: function (t, e, i, r) {
        return -i * ((t = t / r - 1) * t * t * t - 1) + e;
      },
      easeInOutQuart: function (t, e, i, r) {
        return (t /= r / 2) < 1
          ? (i / 2) * t * t * t * t + e
          : (-i / 2) * ((t -= 2) * t * t * t - 2) + e;
      },
      easeInQuint: function (t, e, i, r) {
        return i * (t /= r) * t * t * t * t + e;
      },
      easeOutQuint: function (t, e, i, r) {
        return i * ((t = t / r - 1) * t * t * t * t + 1) + e;
      },
      easeInOutQuint: function (t, e, i, r) {
        return (t /= r / 2) < 1
          ? (i / 2) * t * t * t * t * t + e
          : (i / 2) * ((t -= 2) * t * t * t * t + 2) + e;
      },
      easeInSine: function (t, e, i, r) {
        return -i * Math.cos((t / r) * (Math.PI / 2)) + i + e;
      },
      easeOutSine: function (t, e, i, r) {
        return i * Math.sin((t / r) * (Math.PI / 2)) + e;
      },
      easeInOutSine: function (t, e, i, r) {
        return (-i / 2) * (Math.cos((Math.PI * t) / r) - 1) + e;
      },
      easeInExpo: function (t, e, i, r) {
        return 0 === t ? e : i * Math.pow(2, 10 * (t / r - 1)) + e;
      },
      easeOutExpo: function (t, e, i, r) {
        return t === r ? e + i : i * (1 - Math.pow(2, (-10 * t) / r)) + e;
      },
      easeInOutExpo: function (t, e, i, r) {
        return 0 === t
          ? e
          : t === r
          ? e + i
          : (t /= r / 2) < 1
          ? (i / 2) * Math.pow(2, 10 * (t - 1)) + e
          : (i / 2) * (2 - Math.pow(2, -10 * --t)) + e;
      },
      easeInCirc: function (t, e, i, r) {
        return -i * (Math.sqrt(1 - (t /= r) * t) - 1) + e;
      },
      easeOutCirc: function (t, e, i, r) {
        return i * Math.sqrt(1 - (t = t / r - 1) * t) + e;
      },
      easeInOutCirc: function (t, e, i, r) {
        return (t /= r / 2) < 1
          ? (-i / 2) * (Math.sqrt(1 - t * t) - 1) + e
          : (i / 2) * (Math.sqrt(1 - (t -= 2) * t) + 1) + e;
      },
      easeInElastic: function (t, e, i, r) {
        var n = 0;
        return 0 === t
          ? e
          : 1 === (t /= r)
          ? e + i
          : -a(o(i, i, (n = n || 0.3 * r), 1.70158), t, r) + e;
      },
      easeOutElastic: function (t, e, i, r) {
        var n = 0;
        if (0 === t) return e;
        if (1 === (t /= r)) return e + i;
        var s = o(i, i, (n = n || 0.3 * r), 1.70158);
        return (
          s.a *
            Math.pow(2, -10 * t) *
            Math.sin(((t * r - s.s) * (2 * Math.PI)) / s.p) +
          s.c +
          e
        );
      },
      easeInOutElastic: function (t, e, i, r) {
        var n = 0;
        if (0 === t) return e;
        if (2 === (t /= r / 2)) return e + i;
        var s = o(i, i, (n = n || r * (0.3 * 1.5)), 1.70158);
        return t < 1
          ? -0.5 * a(s, t, r) + e
          : s.a *
              Math.pow(2, -10 * --t) *
              Math.sin(((t * r - s.s) * (2 * Math.PI)) / s.p) *
              0.5 +
              s.c +
              e;
      },
      easeInBack: function (t, e, i, r, n) {
        return (
          void 0 === n && (n = 1.70158),
          i * (t /= r) * t * ((n + 1) * t - n) + e
        );
      },
      easeOutBack: function (t, e, i, r, n) {
        return (
          void 0 === n && (n = 1.70158),
          i * ((t = t / r - 1) * t * ((n + 1) * t + n) + 1) + e
        );
      },
      easeInOutBack: function (t, e, i, r, n) {
        return (
          void 0 === n && (n = 1.70158),
          (t /= r / 2) < 1
            ? (i / 2) * (t * t * ((1 + (n *= 1.525)) * t - n)) + e
            : (i / 2) * ((t -= 2) * t * ((1 + (n *= 1.525)) * t + n) + 2) + e
        );
      },
      easeInBounce: n,
      easeOutBounce: s,
      easeInOutBounce: function (t, e, i, r) {
        return t < r / 2
          ? 0.5 * n(2 * t, 0, i, r) + e
          : 0.5 * s(2 * t - r, 0, i, r) + 0.5 * i + e;
      },
    };
  })(),
  (function (t) {
    'use strict';
    var m,
      e,
      i,
      _,
      r,
      n,
      y = t.fabric || (t.fabric = {}),
      x = y.util.object.extend,
      u = y.util.object.clone,
      C = y.util.toFixed,
      S = y.util.parseUnit,
      w = y.util.multiplyTransformMatrices,
      f = /^(path|circle|polygon|polyline|ellipse|rect|line|image|text)$/i,
      O = /^(symbol|image|marker|pattern|view|svg)$/i,
      d = /^(?:pattern|defs|symbol|metadata|clipPath|mask)$/i,
      T = /^(symbol|g|a|svg)$/i,
      j = {
        cx: 'left',
        x: 'left',
        r: 'radius',
        cy: 'top',
        y: 'top',
        display: 'visible',
        visibility: 'visible',
        transform: 'transformMatrix',
        'fill-opacity': 'fillOpacity',
        'fill-rule': 'fillRule',
        'font-family': 'fontFamily',
        'font-size': 'fontSize',
        'font-style': 'fontStyle',
        'font-weight': 'fontWeight',
        'stroke-dasharray': 'strokeDashArray',
        'stroke-linecap': 'strokeLineCap',
        'stroke-linejoin': 'strokeLineJoin',
        'stroke-miterlimit': 'strokeMiterLimit',
        'stroke-opacity': 'strokeOpacity',
        'stroke-width': 'strokeWidth',
        'text-decoration': 'textDecoration',
        'text-anchor': 'originX',
        opacity: 'opacity',
      },
      k = { stroke: 'strokeOpacity', fill: 'fillOpacity' };
    function p(t, e) {
      for (var i, r, n = [], s = 0; s < e.length; s++)
        (i = e[s]),
          (r = t.getElementsByTagName(i)),
          (n = n.concat(Array.prototype.slice.call(r)));
      return n;
    }
    function M(t, e, i) {
      t[i] = Math.tan(y.util.degreesToRadians(e[0]));
    }
    function D(t, e) {
      var i,
        r = !0;
      return (
        (i = s(t, e.pop())) &&
          e.length &&
          (r = (function (t, e) {
            var i,
              r = !0;
            for (; t.parentNode && 1 === t.parentNode.nodeType && e.length; )
              r && (i = e.pop()), (t = t.parentNode), (r = s(t, i));
            return 0 === e.length;
          })(t, e)),
        i && r && 0 === e.length
      );
    }
    function s(t, e) {
      var i,
        r = t.nodeName,
        n = t.getAttribute('class'),
        s = t.getAttribute('id');
      if (
        ((i = new RegExp('^' + r, 'i')),
        (e = e.replace(i, '')),
        s &&
          e.length &&
          ((i = new RegExp('#' + s + '(?![a-zA-Z\\-]+)', 'i')),
          (e = e.replace(i, ''))),
        n && e.length)
      )
        for (var o = (n = n.split(' ')).length; o--; )
          (i = new RegExp('\\.' + n[o] + '(?![a-zA-Z\\-]+)', 'i')),
            (e = e.replace(i, ''));
      return 0 === e.length;
    }
    function v(t, e) {
      var i;
      if ((t.getElementById && (i = t.getElementById(e)), i)) return i;
      var r,
        n,
        s = t.getElementsByTagName('*');
      for (n = 0; n < s.length; n++)
        if (e === (r = s[n]).getAttribute('id')) return r;
    }
    (y.cssRules = {}),
      (y.gradientDefs = {}),
      (y.parseTransformAttribute =
        ((m = [1, 0, 0, 1, 0, 0]),
        (e = y.reNum),
        (_ =
          '(?:' +
          ('(?:(matrix)\\s*\\(\\s*(' +
            e +
            ')' +
            (i = '(?:\\s+,?\\s*|,\\s*)') +
            '(' +
            e +
            ')' +
            i +
            '(' +
            e +
            ')' +
            i +
            '(' +
            e +
            ')' +
            i +
            '(' +
            e +
            ')' +
            i +
            '(' +
            e +
            ')\\s*\\))') +
          '|' +
          ('(?:(translate)\\s*\\(\\s*(' +
            e +
            ')(?:' +
            i +
            '(' +
            e +
            '))?\\s*\\))') +
          '|' +
          ('(?:(scale)\\s*\\(\\s*(' +
            e +
            ')(?:' +
            i +
            '(' +
            e +
            '))?\\s*\\))') +
          '|' +
          ('(?:(rotate)\\s*\\(\\s*(' +
            e +
            ')(?:' +
            i +
            '(' +
            e +
            ')' +
            i +
            '(' +
            e +
            '))?\\s*\\))') +
          '|' +
          ('(?:(skewX)\\s*\\(\\s*(' + e + ')\\s*\\))') +
          '|' +
          ('(?:(skewY)\\s*\\(\\s*(' + e + ')\\s*\\))') +
          ')'),
        (r = new RegExp(
          '^\\s*(?:' + ('(?:' + _ + '(?:' + i + '*' + _ + ')*)') + '?)\\s*$'
        )),
        (n = new RegExp(_, 'g')),
        function (t) {
          var v = m.concat(),
            b = [];
          if (!t || (t && !r.test(t))) return v;
          t.replace(n, function (t) {
            var e,
              i,
              r,
              n,
              s,
              o,
              a,
              h,
              c,
              l,
              u,
              f,
              d = new RegExp(_).exec(t).filter(function (t) {
                return !!t;
              }),
              g = d[1],
              p = d.slice(2).map(parseFloat);
            switch (g) {
              case 'translate':
                (f = p), ((u = v)[4] = f[0]), 2 === f.length && (u[5] = f[1]);
                break;
              case 'rotate':
                (p[0] = y.util.degreesToRadians(p[0])),
                  (s = v),
                  (o = p),
                  (a = Math.cos(o[0])),
                  (h = Math.sin(o[0])),
                  (l = c = 0),
                  3 === o.length && ((c = o[1]), (l = o[2])),
                  (s[0] = a),
                  (s[1] = h),
                  (s[2] = -h),
                  (s[3] = a),
                  (s[4] = c - (a * c - h * l)),
                  (s[5] = l - (h * c + a * l));
                break;
              case 'scale':
                (e = v),
                  (r = (i = p)[0]),
                  (n = 2 === i.length ? i[1] : i[0]),
                  (e[0] = r),
                  (e[3] = n);
                break;
              case 'skewX':
                M(v, p, 2);
                break;
              case 'skewY':
                M(v, p, 1);
                break;
              case 'matrix':
                v = p;
            }
            b.push(v.concat()), (v = m.concat());
          });
          for (var e = b[0]; 1 < b.length; )
            b.shift(), (e = y.util.multiplyTransformMatrices(e, b[0]));
          return e;
        }));
    var P = new RegExp(
      '^\\s*(' +
        y.reNum +
        '+)\\s*,?\\s*(' +
        y.reNum +
        '+)\\s*,?\\s*(' +
        y.reNum +
        '+)\\s*,?\\s*(' +
        y.reNum +
        '+)\\s*$'
    );
    function b(t) {
      var e,
        i,
        r,
        n,
        s,
        o,
        a = t.getAttribute('viewBox'),
        h = 1,
        c = 1,
        l = t.getAttribute('width'),
        u = t.getAttribute('height'),
        f = t.getAttribute('x') || 0,
        d = t.getAttribute('y') || 0,
        g = t.getAttribute('preserveAspectRatio') || '',
        p = !a || !O.test(t.nodeName) || !(a = a.match(P)),
        v = !l || !u || '100%' === l || '100%' === u,
        b = p && v,
        m = {},
        _ = '';
      if (((m.width = 0), (m.height = 0), (m.toBeParsed = b))) return m;
      if (p) return (m.width = S(l)), (m.height = S(u)), m;
      if (
        ((e = -parseFloat(a[1])),
        (i = -parseFloat(a[2])),
        (r = parseFloat(a[3])),
        (n = parseFloat(a[4])),
        v
          ? ((m.width = r), (m.height = n))
          : ((m.width = S(l)),
            (m.height = S(u)),
            (h = m.width / r),
            (c = m.height / n)),
        'none' !== (g = y.util.parsePreserveAspectRatioAttribute(g)).alignX &&
          (c = h = c < h ? c : h),
        1 === h && 1 === c && 0 == e && 0 == i && 0 === f && 0 === d)
      )
        return m;
      if (
        ((f || d) && (_ = ' translate(' + S(f) + ' ' + S(d) + ') '),
        (s =
          _ + ' matrix(' + h + ' 0 0 ' + c + ' ' + e * h + ' ' + i * c + ') '),
        'svg' === t.nodeName)
      ) {
        for (o = t.ownerDocument.createElement('g'); t.firstChild; )
          o.appendChild(t.firstChild);
        t.appendChild(o);
      } else s = (o = t).getAttribute('transform') + s;
      return o.setAttribute('transform', s), m;
    }
    y.parseSVGDocument = function (t, e, i, r) {
      if (t) {
        !(function (t) {
          for (
            var e = p(t, ['use', 'svg:use']), i = 0;
            e.length && i < e.length;

          ) {
            var r,
              n,
              s,
              o,
              a = e[i],
              h = a.getAttribute('xlink:href').substr(1),
              c = a.getAttribute('x') || 0,
              l = a.getAttribute('y') || 0,
              u = v(t, h).cloneNode(!0),
              f =
                (u.getAttribute('transform') || '') +
                ' translate(' +
                c +
                ', ' +
                l +
                ')',
              d = e.length;
            if ((b(u), /^svg$/i.test(u.nodeName))) {
              var g = u.ownerDocument.createElement('g');
              for (n = 0, o = (s = u.attributes).length; n < o; n++)
                (r = s.item(n)), g.setAttribute(r.nodeName, r.nodeValue);
              for (; u.firstChild; ) g.appendChild(u.firstChild);
              u = g;
            }
            for (n = 0, o = (s = a.attributes).length; n < o; n++)
              'x' !== (r = s.item(n)).nodeName &&
                'y' !== r.nodeName &&
                'xlink:href' !== r.nodeName &&
                ('transform' === r.nodeName
                  ? (f = r.nodeValue + ' ' + f)
                  : u.setAttribute(r.nodeName, r.nodeValue));
            u.setAttribute('transform', f),
              u.setAttribute('instantiated_by_use', '1'),
              u.removeAttribute('id'),
              a.parentNode.replaceChild(u, a),
              e.length === d && i++;
          }
        })(t);
        var n = y.Object.__uid++,
          s = b(t),
          o = y.util.toArray(t.getElementsByTagName('*'));
        if (
          ((s.crossOrigin = r && r.crossOrigin),
          (s.svgUid = n),
          0 === o.length && y.isLikelyNode)
        ) {
          for (
            var a = [],
              h = 0,
              c = (o = t.selectNodes('//*[name(.)!="svg"]')).length;
            h < c;
            h++
          )
            a[h] = o[h];
          o = a;
        }
        var l = o.filter(function (t) {
          return (
            b(t),
            f.test(t.nodeName.replace('svg:', '')) &&
              !(function (t, e) {
                for (; (t = t && t.parentNode); )
                  if (
                    t.nodeName &&
                    e.test(t.nodeName.replace('svg:', '')) &&
                    !t.getAttribute('instantiated_by_use')
                  )
                    return !0;
                return !1;
              })(t, d)
          );
        });
        !l || (l && !l.length)
          ? e && e([], {})
          : ((y.gradientDefs[n] = y.getGradientDefs(t)),
            (y.cssRules[n] = y.getCSSRules(t)),
            y.parseElements(
              l,
              function (t) {
                e && e(t, s);
              },
              u(s),
              i,
              r
            ));
      }
    };
    var h = new RegExp(
      '(normal|italic)?\\s*(normal|small-caps)?\\s*(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(' +
        y.reNum +
        '(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|' +
        y.reNum +
        '))?\\s+(.*)'
    );
    x(y, {
      parseFontDeclaration: function (t, e) {
        var i = t.match(h);
        if (i) {
          var r = i[1],
            n = i[3],
            s = i[4],
            o = i[5],
            a = i[6];
          r && (e.fontStyle = r),
            n && (e.fontWeight = isNaN(parseFloat(n)) ? n : parseFloat(n)),
            s && (e.fontSize = S(s)),
            a && (e.fontFamily = a),
            o && (e.lineHeight = 'normal' === o ? 1 : o);
        }
      },
      getGradientDefs: function (t) {
        var e,
          i,
          r,
          n = p(t, [
            'linearGradient',
            'radialGradient',
            'svg:linearGradient',
            'svg:radialGradient',
          ]),
          s = 0,
          o = {},
          a = {};
        for (s = n.length; s--; )
          (r = (e = n[s]).getAttribute('xlink:href')),
            (i = e.getAttribute('id')),
            r && (a[i] = r.substr(1)),
            (o[i] = e);
        for (i in a) {
          var h = o[a[i]].cloneNode(!0);
          for (e = o[i]; h.firstChild; ) e.appendChild(h.firstChild);
        }
        return o;
      },
      parseAttributes: function (i, t, e) {
        if (i) {
          var r,
            n,
            s = {};
          void 0 === e && (e = i.getAttribute('svgUid')),
            i.parentNode &&
              T.test(i.parentNode.nodeName) &&
              (s = y.parseAttributes(i.parentNode, t, e)),
            (n =
              (s && s.fontSize) ||
              i.getAttribute('font-size') ||
              y.Text.DEFAULT_SVG_FONT_SIZE);
          var o = t.reduce(function (t, e) {
            return (r = i.getAttribute(e)) && (t[e] = r), t;
          }, {});
          o = x(
            o,
            x(
              (function (t, e) {
                var i = {};
                for (var r in y.cssRules[e])
                  if (D(t, r.split(' ')))
                    for (var n in y.cssRules[e][r]) i[n] = y.cssRules[e][r][n];
                return i;
              })(i, e),
              y.parseStyleAttribute(i)
            )
          );
          var a,
            h,
            c,
            l,
            u,
            f,
            d,
            g,
            p,
            v = {};
          for (var b in o)
            (a = (p = b) in j ? j[p] : p),
              (c = a),
              (l = o[b]),
              (u = s),
              (f = n),
              (d = void 0),
              (g = '[object Array]' === Object.prototype.toString.call(l)),
              ('fill' !== c && 'stroke' !== c) || 'none' !== l
                ? 'strokeDashArray' === c
                  ? (l =
                      'none' === l
                        ? null
                        : l
                            .replace(/,/g, ' ')
                            .split(/\s+/)
                            .map(function (t) {
                              return parseFloat(t);
                            }))
                  : 'transformMatrix' === c
                  ? (l =
                      u && u.transformMatrix
                        ? w(u.transformMatrix, y.parseTransformAttribute(l))
                        : y.parseTransformAttribute(l))
                  : 'visible' === c
                  ? ((l = 'none' !== l && 'hidden' !== l),
                    u && !1 === u.visible && (l = !1))
                  : 'opacity' === c
                  ? ((l = parseFloat(l)),
                    u && void 0 !== u.opacity && (l *= u.opacity))
                  : 'originX' === c
                  ? (l =
                      'start' === l ? 'left' : 'end' === l ? 'right' : 'center')
                  : (d = g ? l.map(S) : S(l, f))
                : (l = ''),
              (h = !g && isNaN(d) ? l : d),
              (v[a] = h);
          v && v.font && y.parseFontDeclaration(v.font, v);
          var m = x(s, v);
          return T.test(i.nodeName)
            ? m
            : (function (t) {
                for (var e in k)
                  if (void 0 !== t[k[e]] && '' !== t[e]) {
                    if (void 0 === t[e]) {
                      if (!y.Object.prototype[e]) continue;
                      t[e] = y.Object.prototype[e];
                    }
                    if (0 !== t[e].indexOf('url(')) {
                      var i = new y.Color(t[e]);
                      t[e] = i.setAlpha(C(i.getAlpha() * t[k[e]], 2)).toRgba();
                    }
                  }
                return t;
              })(m);
        }
      },
      parseElements: function (t, e, i, r, n) {
        new y.ElementsParser(t, e, i, r, n).parse();
      },
      parseStyleAttribute: function (t) {
        var i,
          r,
          n,
          e = {},
          s = t.getAttribute('style');
        return (
          s &&
            ('string' == typeof s
              ? ((i = e),
                s
                  .replace(/;\s*$/, '')
                  .split(';')
                  .forEach(function (t) {
                    var e = t.split(':');
                    (r = e[0].trim().toLowerCase()),
                      (n = e[1].trim()),
                      (i[r] = n);
                  }))
              : (function (t, e) {
                  var i, r;
                  for (var n in t)
                    void 0 !== t[n] &&
                      ((i = n.toLowerCase()), (r = t[n]), (e[i] = r));
                })(s, e)),
          e
        );
      },
      parsePointsAttribute: function (t) {
        if (!t) return null;
        var e,
          i,
          r = [];
        for (
          e = 0,
            i = (t = (t = t.replace(/,/g, ' ').trim()).split(/\s+/)).length;
          e < i;
          e += 2
        )
          r.push({ x: parseFloat(t[e]), y: parseFloat(t[e + 1]) });
        return r;
      },
      getCSSRules: function (t) {
        for (
          var e = t.getElementsByTagName('style'), c = {}, i = 0, r = e.length;
          i < r;
          i++
        ) {
          var n = e[i].textContent || e[i].text;
          '' !== (n = n.replace(/\/\*[\s\S]*?\*\//g, '')).trim() &&
            n
              .match(/[^{]*\{[\s\S]*?\}/g)
              .map(function (t) {
                return t.trim();
              })
              .forEach(function (t) {
                for (
                  var e = t.match(/([\s\S]*?)\s*\{([^}]*)\}/),
                    i = {},
                    r = e[2]
                      .trim()
                      .replace(/;$/, '')
                      .split(/\s*;\s*/),
                    n = 0,
                    s = r.length;
                  n < s;
                  n++
                ) {
                  var o = r[n].split(/\s*:\s*/),
                    a = o[0],
                    h = o[1];
                  i[a] = h;
                }
                (t = e[1]).split(',').forEach(function (t) {
                  '' !== (t = t.replace(/^svg/i, '').trim()) &&
                    (c[t]
                      ? y.util.object.extend(c[t], i)
                      : (c[t] = y.util.object.clone(i)));
                });
              });
        }
        return c;
      },
      loadSVGFromURL: function (t, i, r, n) {
        (t = t.replace(/^\n\s*/, '').trim()),
          new y.util.request(t, {
            method: 'get',
            onComplete: function (t) {
              var e = t.responseXML;
              e &&
                !e.documentElement &&
                y.window.ActiveXObject &&
                t.responseText &&
                (((e = new ActiveXObject('Microsoft.XMLDOM')).async = 'false'),
                e.loadXML(
                  t.responseText.replace(
                    /<!DOCTYPE[\s\S]*?(\[[\s\S]*\])*?>/i,
                    ''
                  )
                ));
              (e && e.documentElement) || (i && i(null));
              y.parseSVGDocument(
                e.documentElement,
                function (t, e) {
                  i && i(t, e);
                },
                r,
                n
              );
            },
          });
      },
      loadSVGFromString: function (t, i, e, r) {
        var n;
        if (((t = t.trim()), 'undefined' != typeof DOMParser)) {
          var s = new DOMParser();
          s && s.parseFromString && (n = s.parseFromString(t, 'text/xml'));
        } else
          y.window.ActiveXObject &&
            (((n = new ActiveXObject('Microsoft.XMLDOM')).async = 'false'),
            n.loadXML(t.replace(/<!DOCTYPE[\s\S]*?(\[[\s\S]*\])*?>/i, '')));
        y.parseSVGDocument(
          n.documentElement,
          function (t, e) {
            i(t, e);
          },
          e,
          r
        );
      },
    });
  })('undefined' != typeof exports ? exports : this),
  (fabric.ElementsParser = function (t, e, i, r, n) {
    (this.elements = t),
      (this.callback = e),
      (this.options = i),
      (this.reviver = r),
      (this.svgUid = (i && i.svgUid) || 0),
      (this.parsingOptions = n);
  }),
  (fabric.ElementsParser.prototype.parse = function () {
    (this.instances = new Array(this.elements.length)),
      (this.numElements = this.elements.length),
      this.createObjects();
  }),
  (fabric.ElementsParser.prototype.createObjects = function () {
    for (var t = 0, e = this.elements.length; t < e; t++)
      this.elements[t].setAttribute('svgUid', this.svgUid),
        (function (t, e) {
          setTimeout(function () {
            t.createObject(t.elements[e], e);
          }, 0);
        })(this, t);
  }),
  (fabric.ElementsParser.prototype.createObject = function (t, e) {
    var i =
      fabric[fabric.util.string.capitalize(t.tagName.replace('svg:', ''))];
    if (i && i.fromElement)
      try {
        this._createObject(i, t, e);
      } catch (t) {
        fabric.log(t);
      }
    else this.checkIfDone();
  }),
  (fabric.ElementsParser.prototype._createObject = function (t, e, i) {
    if (t.async) t.fromElement(e, this.createCallback(i, e), this.options);
    else {
      var r = t.fromElement(e, this.options);
      this.resolveGradient(r, 'fill'),
        this.resolveGradient(r, 'stroke'),
        this.reviver && this.reviver(e, r),
        (this.instances[i] = r),
        this.checkIfDone();
    }
  }),
  (fabric.ElementsParser.prototype.createCallback = function (e, i) {
    var r = this;
    return function (t) {
      r.resolveGradient(t, 'fill'),
        r.resolveGradient(t, 'stroke'),
        r.reviver && r.reviver(i, t),
        (r.instances[e] = t),
        r.checkIfDone();
    };
  }),
  (fabric.ElementsParser.prototype.resolveGradient = function (t, e) {
    var i = t.get(e);
    if (/^url\(/.test(i)) {
      var r = i.slice(5, i.length - 1);
      fabric.gradientDefs[this.svgUid][r] &&
        t.set(
          e,
          fabric.Gradient.fromElement(fabric.gradientDefs[this.svgUid][r], t)
        );
    }
  }),
  (fabric.ElementsParser.prototype.checkIfDone = function () {
    0 == --this.numElements &&
      ((this.instances = this.instances.filter(function (t) {
        return null != t;
      })),
      this.callback(this.instances));
  }),
  (function (t) {
    'use strict';
    var e = t.fabric || (t.fabric = {});
    function i(t, e) {
      (this.x = t), (this.y = e);
    }
    e.Point
      ? e.warn('fabric.Point is already defined')
      : ((e.Point = i).prototype = {
          type: 'point',
          constructor: i,
          add: function (t) {
            return new i(this.x + t.x, this.y + t.y);
          },
          addEquals: function (t) {
            return (this.x += t.x), (this.y += t.y), this;
          },
          scalarAdd: function (t) {
            return new i(this.x + t, this.y + t);
          },
          scalarAddEquals: function (t) {
            return (this.x += t), (this.y += t), this;
          },
          subtract: function (t) {
            return new i(this.x - t.x, this.y - t.y);
          },
          subtractEquals: function (t) {
            return (this.x -= t.x), (this.y -= t.y), this;
          },
          scalarSubtract: function (t) {
            return new i(this.x - t, this.y - t);
          },
          scalarSubtractEquals: function (t) {
            return (this.x -= t), (this.y -= t), this;
          },
          multiply: function (t) {
            return new i(this.x * t, this.y * t);
          },
          multiplyEquals: function (t) {
            return (this.x *= t), (this.y *= t), this;
          },
          divide: function (t) {
            return new i(this.x / t, this.y / t);
          },
          divideEquals: function (t) {
            return (this.x /= t), (this.y /= t), this;
          },
          eq: function (t) {
            return this.x === t.x && this.y === t.y;
          },
          lt: function (t) {
            return this.x < t.x && this.y < t.y;
          },
          lte: function (t) {
            return this.x <= t.x && this.y <= t.y;
          },
          gt: function (t) {
            return this.x > t.x && this.y > t.y;
          },
          gte: function (t) {
            return this.x >= t.x && this.y >= t.y;
          },
          lerp: function (t, e) {
            return (
              void 0 === e && (e = 0.5),
              (e = Math.max(Math.min(1, e), 0)),
              new i(this.x + (t.x - this.x) * e, this.y + (t.y - this.y) * e)
            );
          },
          distanceFrom: function (t) {
            var e = this.x - t.x,
              i = this.y - t.y;
            return Math.sqrt(e * e + i * i);
          },
          midPointFrom: function (t) {
            return this.lerp(t);
          },
          min: function (t) {
            return new i(Math.min(this.x, t.x), Math.min(this.y, t.y));
          },
          max: function (t) {
            return new i(Math.max(this.x, t.x), Math.max(this.y, t.y));
          },
          toString: function () {
            return this.x + ',' + this.y;
          },
          setXY: function (t, e) {
            return (this.x = t), (this.y = e), this;
          },
          setX: function (t) {
            return (this.x = t), this;
          },
          setY: function (t) {
            return (this.y = t), this;
          },
          setFromPoint: function (t) {
            return (this.x = t.x), (this.y = t.y), this;
          },
          swap: function (t) {
            var e = this.x,
              i = this.y;
            (this.x = t.x), (this.y = t.y), (t.x = e), (t.y = i);
          },
          clone: function () {
            return new i(this.x, this.y);
          },
        });
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var f = t.fabric || (t.fabric = {});
    function d(t) {
      (this.status = t), (this.points = []);
    }
    f.Intersection
      ? f.warn('fabric.Intersection is already defined')
      : ((f.Intersection = d),
        (f.Intersection.prototype = {
          constructor: d,
          appendPoint: function (t) {
            return this.points.push(t), this;
          },
          appendPoints: function (t) {
            return (this.points = this.points.concat(t)), this;
          },
        }),
        (f.Intersection.intersectLineLine = function (t, e, i, r) {
          var n,
            s = (r.x - i.x) * (t.y - i.y) - (r.y - i.y) * (t.x - i.x),
            o = (e.x - t.x) * (t.y - i.y) - (e.y - t.y) * (t.x - i.x),
            a = (r.y - i.y) * (e.x - t.x) - (r.x - i.x) * (e.y - t.y);
          if (0 != a) {
            var h = s / a,
              c = o / a;
            0 <= h && h <= 1 && 0 <= c && c <= 1
              ? (n = new d('Intersection')).appendPoint(
                  new f.Point(t.x + h * (e.x - t.x), t.y + h * (e.y - t.y))
                )
              : (n = new d());
          } else n = new d(0 == s || 0 == o ? 'Coincident' : 'Parallel');
          return n;
        }),
        (f.Intersection.intersectLinePolygon = function (t, e, i) {
          for (var r, n, s, o = new d(), a = i.length, h = 0; h < a; h++)
            (r = i[h]),
              (n = i[(h + 1) % a]),
              (s = d.intersectLineLine(t, e, r, n)),
              o.appendPoints(s.points);
          return 0 < o.points.length && (o.status = 'Intersection'), o;
        }),
        (f.Intersection.intersectPolygonPolygon = function (t, e) {
          for (var i = new d(), r = t.length, n = 0; n < r; n++) {
            var s = t[n],
              o = t[(n + 1) % r],
              a = d.intersectLinePolygon(s, o, e);
            i.appendPoints(a.points);
          }
          return 0 < i.points.length && (i.status = 'Intersection'), i;
        }),
        (f.Intersection.intersectPolygonRectangle = function (t, e, i) {
          var r = e.min(i),
            n = e.max(i),
            s = new f.Point(n.x, r.y),
            o = new f.Point(r.x, n.y),
            a = d.intersectLinePolygon(r, s, t),
            h = d.intersectLinePolygon(s, n, t),
            c = d.intersectLinePolygon(n, o, t),
            l = d.intersectLinePolygon(o, r, t),
            u = new d();
          return (
            u.appendPoints(a.points),
            u.appendPoints(h.points),
            u.appendPoints(c.points),
            u.appendPoints(l.points),
            0 < u.points.length && (u.status = 'Intersection'),
            u
          );
        }));
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var c = t.fabric || (t.fabric = {});
    function l(t) {
      t ? this._tryParsingColor(t) : this.setSource([0, 0, 0, 1]);
    }
    function u(t, e, i) {
      return (
        i < 0 && (i += 1),
        1 < i && --i,
        i < 1 / 6
          ? t + 6 * (e - t) * i
          : i < 0.5
          ? e
          : i < 2 / 3
          ? t + (e - t) * (2 / 3 - i) * 6
          : t
      );
    }
    c.Color
      ? c.warn('fabric.Color is already defined.')
      : ((c.Color = l),
        (c.Color.prototype = {
          _tryParsingColor: function (t) {
            var e;
            t in l.colorNameMap && (t = l.colorNameMap[t]),
              'transparent' === t && (e = [255, 255, 255, 0]),
              (e = (e =
                (e = (e = e || l.sourceFromHex(t)) || l.sourceFromRgb(t)) ||
                l.sourceFromHsl(t)) || [0, 0, 0, 1]) && this.setSource(e);
          },
          _rgbToHsl: function (t, e, i) {
            (t /= 255), (e /= 255), (i /= 255);
            var r,
              n,
              s,
              o = c.util.array.max([t, e, i]),
              a = c.util.array.min([t, e, i]);
            if (((s = (o + a) / 2), o === a)) r = n = 0;
            else {
              var h = o - a;
              switch (((n = 0.5 < s ? h / (2 - o - a) : h / (o + a)), o)) {
                case t:
                  r = (e - i) / h + (e < i ? 6 : 0);
                  break;
                case e:
                  r = (i - t) / h + 2;
                  break;
                case i:
                  r = (t - e) / h + 4;
              }
              r /= 6;
            }
            return [
              Math.round(360 * r),
              Math.round(100 * n),
              Math.round(100 * s),
            ];
          },
          getSource: function () {
            return this._source;
          },
          setSource: function (t) {
            this._source = t;
          },
          toRgb: function () {
            var t = this.getSource();
            return 'rgb(' + t[0] + ',' + t[1] + ',' + t[2] + ')';
          },
          toRgba: function () {
            var t = this.getSource();
            return 'rgba(' + t[0] + ',' + t[1] + ',' + t[2] + ',' + t[3] + ')';
          },
          toHsl: function () {
            var t = this.getSource(),
              e = this._rgbToHsl(t[0], t[1], t[2]);
            return 'hsl(' + e[0] + ',' + e[1] + '%,' + e[2] + '%)';
          },
          toHsla: function () {
            var t = this.getSource(),
              e = this._rgbToHsl(t[0], t[1], t[2]);
            return (
              'hsla(' + e[0] + ',' + e[1] + '%,' + e[2] + '%,' + t[3] + ')'
            );
          },
          toHex: function () {
            var t,
              e,
              i,
              r = this.getSource();
            return (
              (t = 1 === (t = r[0].toString(16)).length ? '0' + t : t),
              (e = 1 === (e = r[1].toString(16)).length ? '0' + e : e),
              (i = 1 === (i = r[2].toString(16)).length ? '0' + i : i),
              t.toUpperCase() + e.toUpperCase() + i.toUpperCase()
            );
          },
          toHexa: function () {
            var t;
            return (
              (t =
                1 === (t = (t = 255 * this.getSource()[3]).toString(16)).length
                  ? '0' + t
                  : t),
              this.toHex() + t.toUpperCase()
            );
          },
          getAlpha: function () {
            return this.getSource()[3];
          },
          setAlpha: function (t) {
            var e = this.getSource();
            return (e[3] = t), this.setSource(e), this;
          },
          toGrayscale: function () {
            var t = this.getSource(),
              e = parseInt(
                (0.3 * t[0] + 0.59 * t[1] + 0.11 * t[2]).toFixed(0),
                10
              ),
              i = t[3];
            return this.setSource([e, e, e, i]), this;
          },
          toBlackWhite: function (t) {
            var e = this.getSource(),
              i = (0.3 * e[0] + 0.59 * e[1] + 0.11 * e[2]).toFixed(0),
              r = e[3];
            return (
              (t = t || 127),
              (i = Number(i) < Number(t) ? 0 : 255),
              this.setSource([i, i, i, r]),
              this
            );
          },
          overlayWith: function (t) {
            t instanceof l || (t = new l(t));
            for (
              var e = [],
                i = this.getAlpha(),
                r = this.getSource(),
                n = t.getSource(),
                s = 0;
              s < 3;
              s++
            )
              e.push(Math.round(0.5 * r[s] + 0.5 * n[s]));
            return (e[3] = i), this.setSource(e), this;
          },
        }),
        (c.Color.reRGBa =
          /^rgba?\(\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*(?:\s*,\s*((?:\d*\.?\d+)?)\s*)?\)$/),
        (c.Color.reHSLa =
          /^hsla?\(\s*(\d{1,3})\s*,\s*(\d{1,3}\%)\s*,\s*(\d{1,3}\%)\s*(?:\s*,\s*(\d+(?:\.\d+)?)\s*)?\)$/),
        (c.Color.reHex =
          /^#?([0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})$/i),
        (c.Color.colorNameMap = {
          aqua: '#00FFFF',
          black: '#000000',
          blue: '#0000FF',
          fuchsia: '#FF00FF',
          gray: '#808080',
          grey: '#808080',
          green: '#008000',
          lime: '#00FF00',
          maroon: '#800000',
          navy: '#000080',
          olive: '#808000',
          orange: '#FFA500',
          purple: '#800080',
          red: '#FF0000',
          silver: '#C0C0C0',
          teal: '#008080',
          white: '#FFFFFF',
          yellow: '#FFFF00',
        }),
        (c.Color.fromRgb = function (t) {
          return l.fromSource(l.sourceFromRgb(t));
        }),
        (c.Color.sourceFromRgb = function (t) {
          var e = t.match(l.reRGBa);
          if (e) {
            var i =
                (parseInt(e[1], 10) / (/%$/.test(e[1]) ? 100 : 1)) *
                (/%$/.test(e[1]) ? 255 : 1),
              r =
                (parseInt(e[2], 10) / (/%$/.test(e[2]) ? 100 : 1)) *
                (/%$/.test(e[2]) ? 255 : 1),
              n =
                (parseInt(e[3], 10) / (/%$/.test(e[3]) ? 100 : 1)) *
                (/%$/.test(e[3]) ? 255 : 1);
            return [
              parseInt(i, 10),
              parseInt(r, 10),
              parseInt(n, 10),
              e[4] ? parseFloat(e[4]) : 1,
            ];
          }
        }),
        (c.Color.fromRgba = l.fromRgb),
        (c.Color.fromHsl = function (t) {
          return l.fromSource(l.sourceFromHsl(t));
        }),
        (c.Color.sourceFromHsl = function (t) {
          var e = t.match(l.reHSLa);
          if (e) {
            var i,
              r,
              n,
              s = (((parseFloat(e[1]) % 360) + 360) % 360) / 360,
              o = parseFloat(e[2]) / (/%$/.test(e[2]) ? 100 : 1),
              a = parseFloat(e[3]) / (/%$/.test(e[3]) ? 100 : 1);
            if (0 == o) i = r = n = a;
            else {
              var h = a <= 0.5 ? a * (1 + o) : a + o - a * o,
                c = 2 * a - h;
              (i = u(c, h, s + 1 / 3)),
                (r = u(c, h, s)),
                (n = u(c, h, s - 1 / 3));
            }
            return [
              Math.round(255 * i),
              Math.round(255 * r),
              Math.round(255 * n),
              e[4] ? parseFloat(e[4]) : 1,
            ];
          }
        }),
        (c.Color.fromHsla = l.fromHsl),
        (c.Color.fromHex = function (t) {
          return l.fromSource(l.sourceFromHex(t));
        }),
        (c.Color.sourceFromHex = function (t) {
          if (t.match(l.reHex)) {
            var e = t.slice(t.indexOf('#') + 1),
              i = 3 === e.length || 4 === e.length,
              r = 8 === e.length || 4 === e.length,
              n = i ? e.charAt(0) + e.charAt(0) : e.substring(0, 2),
              s = i ? e.charAt(1) + e.charAt(1) : e.substring(2, 4),
              o = i ? e.charAt(2) + e.charAt(2) : e.substring(4, 6),
              a = r
                ? i
                  ? e.charAt(3) + e.charAt(3)
                  : e.substring(6, 8)
                : 'FF';
            return [
              parseInt(n, 16),
              parseInt(s, 16),
              parseInt(o, 16),
              parseFloat((parseInt(a, 16) / 255).toFixed(2)),
            ];
          }
        }),
        (c.Color.fromSource = function (t) {
          var e = new l();
          return e.setSource(t), e;
        }));
  })('undefined' != typeof exports ? exports : this),
  (function () {
    function d(t) {
      var e,
        i,
        r,
        n = t.getAttribute('style'),
        s = t.getAttribute('offset') || 0;
      if (
        ((s =
          (s = parseFloat(s) / (/%$/.test(s) ? 100 : 1)) < 0
            ? 0
            : 1 < s
            ? 1
            : s),
        n)
      ) {
        var o = n.split(/\s*;\s*/);
        '' === o[o.length - 1] && o.pop();
        for (var a = o.length; a--; ) {
          var h = o[a].split(/\s*:\s*/),
            c = h[0].trim(),
            l = h[1].trim();
          'stop-color' === c ? (e = l) : 'stop-opacity' === c && (r = l);
        }
      }
      return (
        (e = e || t.getAttribute('stop-color') || 'rgb(0,0,0)'),
        (r = r || t.getAttribute('stop-opacity')),
        (i = (e = new fabric.Color(e)).getAlpha()),
        (r = isNaN(parseFloat(r)) ? 1 : parseFloat(r)),
        (r *= i),
        { offset: s, color: e.toRgb(), opacity: r }
      );
    }
    var u = fabric.util.object.clone;
    function g(t, e, i) {
      var r,
        n = 0,
        s = 1,
        o = '';
      for (var a in e)
        'Infinity' === e[a] ? (e[a] = 1) : '-Infinity' === e[a] && (e[a] = 0),
          (r = parseFloat(e[a], 10)),
          (s = 'string' == typeof e[a] && /^\d+%$/.test(e[a]) ? 0.01 : 1),
          'x1' === a || 'x2' === a || 'r2' === a
            ? ((s *= 'objectBoundingBox' === i ? t.width : 1),
              (n = ('objectBoundingBox' === i && t.left) || 0))
            : ('y1' !== a && 'y2' !== a) ||
              ((s *= 'objectBoundingBox' === i ? t.height : 1),
              (n = ('objectBoundingBox' === i && t.top) || 0)),
          (e[a] = r * s + n);
      if (
        'ellipse' === t.type &&
        null !== e.r2 &&
        'objectBoundingBox' === i &&
        t.rx !== t.ry
      ) {
        var h = t.ry / t.rx;
        (o = ' scale(1, ' + h + ')'), e.y1 && (e.y1 /= h), e.y2 && (e.y2 /= h);
      }
      return o;
    }
    (fabric.Gradient = fabric.util.createClass({
      offsetX: 0,
      offsetY: 0,
      initialize: function (t) {
        t = t || {};
        var e = {};
        (this.id = fabric.Object.__uid++),
          (this.type = t.type || 'linear'),
          (e = {
            x1: t.coords.x1 || 0,
            y1: t.coords.y1 || 0,
            x2: t.coords.x2 || 0,
            y2: t.coords.y2 || 0,
          }),
          'radial' === this.type &&
            ((e.r1 = t.coords.r1 || 0), (e.r2 = t.coords.r2 || 0)),
          (this.coords = e),
          (this.colorStops = t.colorStops.slice()),
          t.gradientTransform && (this.gradientTransform = t.gradientTransform),
          (this.offsetX = t.offsetX || this.offsetX),
          (this.offsetY = t.offsetY || this.offsetY);
      },
      addColorStop: function (t) {
        for (var e in t) {
          var i = new fabric.Color(t[e]);
          this.colorStops.push({
            offset: parseFloat(e),
            color: i.toRgb(),
            opacity: i.getAlpha(),
          });
        }
        return this;
      },
      toObject: function (t) {
        var e = {
          type: this.type,
          coords: this.coords,
          colorStops: this.colorStops,
          offsetX: this.offsetX,
          offsetY: this.offsetY,
          gradientTransform: this.gradientTransform
            ? this.gradientTransform.concat()
            : this.gradientTransform,
        };
        return fabric.util.populateWithProperties(this, e, t), e;
      },
      toSVG: function (t) {
        var e,
          i,
          r = u(this.coords, !0),
          n = u(this.colorStops, !0),
          s = r.r1 > r.r2;
        if (
          (n.sort(function (t, e) {
            return t.offset - e.offset;
          }),
          !t.group || 'path-group' !== t.group.type)
        )
          for (var o in r)
            'x1' === o || 'x2' === o
              ? (r[o] += this.offsetX - t.width / 2)
              : ('y1' !== o && 'y2' !== o) ||
                (r[o] += this.offsetY - t.height / 2);
        if (
          ((i = 'id="SVGID_' + this.id + '" gradientUnits="userSpaceOnUse"'),
          this.gradientTransform &&
            (i +=
              ' gradientTransform="matrix(' +
              this.gradientTransform.join(' ') +
              ')" '),
          'linear' === this.type
            ? (e = [
                '<linearGradient ',
                i,
                ' x1="',
                r.x1,
                '" y1="',
                r.y1,
                '" x2="',
                r.x2,
                '" y2="',
                r.y2,
                '">\n',
              ])
            : 'radial' === this.type &&
              (e = [
                '<radialGradient ',
                i,
                ' cx="',
                s ? r.x1 : r.x2,
                '" cy="',
                s ? r.y1 : r.y2,
                '" r="',
                s ? r.r1 : r.r2,
                '" fx="',
                s ? r.x2 : r.x1,
                '" fy="',
                s ? r.y2 : r.y1,
                '">\n',
              ]),
          'radial' === this.type)
        ) {
          if (s) {
            (n = n.concat()).reverse();
            for (var a = 0; a < n.length; a++) n[a].offset = 1 - n[a].offset;
          }
          var h = Math.min(r.r1, r.r2);
          if (0 < h) {
            var c = h / Math.max(r.r1, r.r2);
            for (a = 0; a < n.length; a++) n[a].offset += c * (1 - n[a].offset);
          }
        }
        for (a = 0; a < n.length; a++) {
          var l = n[a];
          e.push(
            '<stop ',
            'offset="',
            100 * l.offset + '%',
            '" style="stop-color:',
            l.color,
            null !== l.opacity ? ';stop-opacity: ' + l.opacity : ';',
            '"/>\n'
          );
        }
        return (
          e.push(
            'linear' === this.type
              ? '</linearGradient>\n'
              : '</radialGradient>\n'
          ),
          e.join('')
        );
      },
      toLive: function (t, e) {
        var i,
          r,
          n = fabric.util.object.clone(this.coords);
        if (this.type) {
          if (e.group && 'path-group' === e.group.type)
            for (r in n)
              'x1' === r || 'x2' === r
                ? (n[r] += -this.offsetX + e.width / 2)
                : ('y1' !== r && 'y2' !== r) ||
                  (n[r] += -this.offsetY + e.height / 2);
          'linear' === this.type
            ? (i = t.createLinearGradient(n.x1, n.y1, n.x2, n.y2))
            : 'radial' === this.type &&
              (i = t.createRadialGradient(n.x1, n.y1, n.r1, n.x2, n.y2, n.r2));
          for (var s = 0, o = this.colorStops.length; s < o; s++) {
            var a = this.colorStops[s].color,
              h = this.colorStops[s].opacity,
              c = this.colorStops[s].offset;
            void 0 !== h && (a = new fabric.Color(a).setAlpha(h).toRgba()),
              i.addColorStop(c, a);
          }
          return i;
        }
      },
    })),
      fabric.util.object.extend(fabric.Gradient, {
        fromElement: function (t, e) {
          var i,
            r,
            n,
            s,
            o,
            a = t.getElementsByTagName('stop'),
            h = t.getAttribute('gradientUnits') || 'objectBoundingBox',
            c = t.getAttribute('gradientTransform'),
            l = [];
          'linear' ===
          (i =
            'linearGradient' === t.nodeName || 'LINEARGRADIENT' === t.nodeName
              ? 'linear'
              : 'radial')
            ? (r = {
                x1: (o = t).getAttribute('x1') || 0,
                y1: o.getAttribute('y1') || 0,
                x2: o.getAttribute('x2') || '100%',
                y2: o.getAttribute('y2') || 0,
              })
            : 'radial' === i &&
              (r = {
                x1: (s = t).getAttribute('fx') || s.getAttribute('cx') || '50%',
                y1: s.getAttribute('fy') || s.getAttribute('cy') || '50%',
                r1: 0,
                x2: s.getAttribute('cx') || '50%',
                y2: s.getAttribute('cy') || '50%',
                r2: s.getAttribute('r') || '50%',
              });
          for (var u = a.length; u--; ) l.push(d(a[u]));
          n = g(e, r, h);
          var f = new fabric.Gradient({
            type: i,
            coords: r,
            colorStops: l,
            offsetX: -e.left,
            offsetY: -e.top,
          });
          return (
            (!c && '' === n) ||
              (f.gradientTransform = fabric.parseTransformAttribute(
                (c || '') + n
              )),
            f
          );
        },
        forObject: function (t, e) {
          return (
            g(t, (e = e || {}).coords, 'userSpaceOnUse'), new fabric.Gradient(e)
          );
        },
      });
  })(),
  (function () {
    'use strict';
    var n = fabric.util.toFixed;
    fabric.Pattern = fabric.util.createClass({
      repeat: 'repeat',
      offsetX: 0,
      offsetY: 0,
      initialize: function (t, e) {
        if (
          ((t = t || {}),
          (this.id = fabric.Object.__uid++),
          this.setOptions(t),
          !t.source || (t.source && 'string' != typeof t.source))
        )
          e && e(this);
        else if (void 0 !== fabric.util.getFunctionBody(t.source))
          (this.source = new Function(fabric.util.getFunctionBody(t.source))),
            e && e(this);
        else {
          var i = this;
          (this.source = fabric.util.createImage()),
            fabric.util.loadImage(t.source, function (t) {
              (i.source = t), e && e(i);
            });
        }
      },
      toObject: function (t) {
        var e,
          i,
          r = fabric.Object.NUM_FRACTION_DIGITS;
        return (
          'function' == typeof this.source
            ? (e = String(this.source))
            : 'string' == typeof this.source.src
            ? (e = this.source.src)
            : 'object' == typeof this.source &&
              this.source.toDataURL &&
              (e = this.source.toDataURL()),
          (i = {
            type: 'pattern',
            source: e,
            repeat: this.repeat,
            offsetX: n(this.offsetX, r),
            offsetY: n(this.offsetY, r),
          }),
          fabric.util.populateWithProperties(this, i, t),
          i
        );
      },
      toSVG: function (t) {
        var e = 'function' == typeof this.source ? this.source() : this.source,
          i = e.width / t.width,
          r = e.height / t.height,
          n = this.offsetX / t.width,
          s = this.offsetY / t.height,
          o = '';
        return (
          ('repeat-x' !== this.repeat && 'no-repeat' !== this.repeat) ||
            (r = 1),
          ('repeat-y' !== this.repeat && 'no-repeat' !== this.repeat) ||
            (i = 1),
          e.src ? (o = e.src) : e.toDataURL && (o = e.toDataURL()),
          '<pattern id="SVGID_' +
            this.id +
            '" x="' +
            n +
            '" y="' +
            s +
            '" width="' +
            i +
            '" height="' +
            r +
            '">\n<image x="0" y="0" width="' +
            e.width +
            '" height="' +
            e.height +
            '" xlink:href="' +
            o +
            '"></image>\n</pattern>\n'
        );
      },
      setOptions: function (t) {
        for (var e in t) this[e] = t[e];
      },
      toLive: function (t) {
        var e = 'function' == typeof this.source ? this.source() : this.source;
        if (!e) return '';
        if (void 0 !== e.src) {
          if (!e.complete) return '';
          if (0 === e.naturalWidth || 0 === e.naturalHeight) return '';
        }
        return t.createPattern(e, this.repeat);
      },
    });
  })(),
  (function (t) {
    'use strict';
    var s = t.fabric || (t.fabric = {}),
      o = s.util.toFixed;
    s.Shadow
      ? s.warn('fabric.Shadow is already defined.')
      : ((s.Shadow = s.util.createClass({
          color: 'rgb(0,0,0)',
          blur: 0,
          offsetX: 0,
          offsetY: 0,
          affectStroke: !1,
          includeDefaultValues: !0,
          initialize: function (t) {
            for (var e in ('string' == typeof t && (t = this._parseShadow(t)),
            t))
              this[e] = t[e];
            this.id = s.Object.__uid++;
          },
          _parseShadow: function (t) {
            var e = t.trim(),
              i = s.Shadow.reOffsetsAndBlur.exec(e) || [];
            return {
              color: (
                e.replace(s.Shadow.reOffsetsAndBlur, '') || 'rgb(0,0,0)'
              ).trim(),
              offsetX: parseInt(i[1], 10) || 0,
              offsetY: parseInt(i[2], 10) || 0,
              blur: parseInt(i[3], 10) || 0,
            };
          },
          toString: function () {
            return [this.offsetX, this.offsetY, this.blur, this.color].join(
              'px '
            );
          },
          toSVG: function (t) {
            var e = 40,
              i = 40,
              r = s.Object.NUM_FRACTION_DIGITS,
              n = s.util.rotateVector(
                { x: this.offsetX, y: this.offsetY },
                s.util.degreesToRadians(-t.angle)
              );
            return (
              t.width &&
                t.height &&
                ((e = 100 * o((Math.abs(n.x) + this.blur) / t.width, r) + 20),
                (i = 100 * o((Math.abs(n.y) + this.blur) / t.height, r) + 20)),
              t.flipX && (n.x *= -1),
              t.flipY && (n.y *= -1),
              '<filter id="SVGID_' +
                this.id +
                '" y="-' +
                i +
                '%" height="' +
                (100 + 2 * i) +
                '%" x="-' +
                e +
                '%" width="' +
                (100 + 2 * e) +
                '%" >\n\t<feGaussianBlur in="SourceAlpha" stdDeviation="' +
                o(this.blur ? this.blur / 2 : 0, r) +
                '"></feGaussianBlur>\n\t<feOffset dx="' +
                o(n.x, r) +
                '" dy="' +
                o(n.y, r) +
                '" result="oBlur" ></feOffset>\n\t<feFlood flood-color="' +
                this.color +
                '"/>\n\t<feComposite in2="oBlur" operator="in" />\n\t<feMerge>\n\t\t<feMergeNode></feMergeNode>\n\t\t<feMergeNode in="SourceGraphic"></feMergeNode>\n\t</feMerge>\n</filter>\n'
            );
          },
          toObject: function () {
            if (this.includeDefaultValues)
              return {
                color: this.color,
                blur: this.blur,
                offsetX: this.offsetX,
                offsetY: this.offsetY,
                affectStroke: this.affectStroke,
              };
            var e = {},
              i = s.Shadow.prototype;
            return (
              ['color', 'blur', 'offsetX', 'offsetY', 'affectStroke'].forEach(
                function (t) {
                  this[t] !== i[t] && (e[t] = this[t]);
                },
                this
              ),
              e
            );
          },
        })),
        (s.Shadow.reOffsetsAndBlur =
          /(?:\s|^)(-?\d+(?:px)?(?:\s?|$))?(-?\d+(?:px)?(?:\s?|$))?(\d+(?:px)?)?(?:\s?|$)(?:$|\s)/));
  })('undefined' != typeof exports ? exports : this),
  (function () {
    'use strict';
    if (fabric.StaticCanvas)
      fabric.warn('fabric.StaticCanvas is already defined.');
    else {
      var r = fabric.util.object.extend,
        t = fabric.util.getElementOffset,
        c = fabric.util.removeFromArray,
        a = fabric.util.toFixed,
        s = fabric.util.transformPoint,
        o = fabric.util.invertTransform,
        i = new Error('Could not initialize `canvas` element');
      (fabric.StaticCanvas = fabric.util.createClass(fabric.CommonMethods, {
        initialize: function (t, e) {
          (e = e || {}), this._initStatic(t, e);
        },
        backgroundColor: '',
        backgroundImage: null,
        overlayColor: '',
        overlayImage: null,
        includeDefaultValues: !0,
        stateful: !1,
        renderOnAddRemove: !0,
        clipTo: null,
        controlsAboveOverlay: !1,
        allowTouchScrolling: !1,
        imageSmoothingEnabled: !0,
        viewportTransform: fabric.iMatrix.concat(),
        backgroundVpt: !0,
        overlayVpt: !0,
        onBeforeScaleRotate: function () {},
        enableRetinaScaling: !0,
        vptCoords: {},
        skipOffscreen: !1,
        _initStatic: function (t, e) {
          var i = fabric.StaticCanvas.prototype.renderAll.bind(this);
          (this._objects = []),
            this._createLowerCanvas(t),
            this._initOptions(e),
            this._setImageSmoothing(),
            this.interactive || this._initRetinaScaling(),
            e.overlayImage && this.setOverlayImage(e.overlayImage, i),
            e.backgroundImage && this.setBackgroundImage(e.backgroundImage, i),
            e.backgroundColor && this.setBackgroundColor(e.backgroundColor, i),
            e.overlayColor && this.setOverlayColor(e.overlayColor, i),
            this.calcOffset();
        },
        _isRetinaScaling: function () {
          return 1 !== fabric.devicePixelRatio && this.enableRetinaScaling;
        },
        getRetinaScaling: function () {
          return this._isRetinaScaling() ? fabric.devicePixelRatio : 1;
        },
        _initRetinaScaling: function () {
          this._isRetinaScaling() &&
            (this.lowerCanvasEl.setAttribute(
              'width',
              this.width * fabric.devicePixelRatio
            ),
            this.lowerCanvasEl.setAttribute(
              'height',
              this.height * fabric.devicePixelRatio
            ),
            this.contextContainer.scale(
              fabric.devicePixelRatio,
              fabric.devicePixelRatio
            ));
        },
        calcOffset: function () {
          return (this._offset = t(this.lowerCanvasEl)), this;
        },
        setOverlayImage: function (t, e, i) {
          return this.__setBgOverlayImage('overlayImage', t, e, i);
        },
        setBackgroundImage: function (t, e, i) {
          return this.__setBgOverlayImage('backgroundImage', t, e, i);
        },
        setOverlayColor: function (t, e) {
          return this.__setBgOverlayColor('overlayColor', t, e);
        },
        setBackgroundColor: function (t, e) {
          return this.__setBgOverlayColor('backgroundColor', t, e);
        },
        _setImageSmoothing: function () {
          var t = this.getContext();
          (t.imageSmoothingEnabled =
            t.imageSmoothingEnabled ||
            t.webkitImageSmoothingEnabled ||
            t.mozImageSmoothingEnabled ||
            t.msImageSmoothingEnabled ||
            t.oImageSmoothingEnabled),
            (t.imageSmoothingEnabled = this.imageSmoothingEnabled);
        },
        __setBgOverlayImage: function (e, t, i, r) {
          return (
            'string' == typeof t
              ? fabric.util.loadImage(
                  t,
                  function (t) {
                    t && (this[e] = new fabric.Image(t, r)), i && i(t);
                  },
                  this,
                  r && r.crossOrigin
                )
              : (r && t.setOptions(r), (this[e] = t), i && i(t)),
            this
          );
        },
        __setBgOverlayColor: function (t, e, i) {
          return (
            (this[t] = e),
            this._initGradient(e, t),
            this._initPattern(e, t, i),
            this
          );
        },
        _createCanvasElement: function (t) {
          var e = fabric.util.createCanvasElement(t);
          if ((e.style || (e.style = {}), !e)) throw i;
          if (void 0 === e.getContext) throw i;
          return e;
        },
        _initOptions: function (t) {
          this._setOptions(t),
            (this.width =
              this.width || parseInt(this.lowerCanvasEl.width, 10) || 0),
            (this.height =
              this.height || parseInt(this.lowerCanvasEl.height, 10) || 0),
            this.lowerCanvasEl.style &&
              ((this.lowerCanvasEl.width = this.width),
              (this.lowerCanvasEl.height = this.height),
              (this.lowerCanvasEl.style.width = this.width + 'px'),
              (this.lowerCanvasEl.style.height = this.height + 'px'),
              (this.viewportTransform = this.viewportTransform.slice()));
        },
        _createLowerCanvas: function (t) {
          (this.lowerCanvasEl =
            fabric.util.getById(t) || this._createCanvasElement(t)),
            fabric.util.addClass(this.lowerCanvasEl, 'lower-canvas'),
            this.interactive && this._applyCanvasStyle(this.lowerCanvasEl),
            (this.contextContainer = this.lowerCanvasEl.getContext('2d'));
        },
        getWidth: function () {
          return this.width;
        },
        getHeight: function () {
          return this.height;
        },
        setWidth: function (t, e) {
          return this.setDimensions({ width: t }, e);
        },
        setHeight: function (t, e) {
          return this.setDimensions({ height: t }, e);
        },
        setDimensions: function (t, e) {
          var i;
          for (var r in ((e = e || {}), t))
            (i = t[r]),
              e.cssOnly || (this._setBackstoreDimension(r, t[r]), (i += 'px')),
              e.backstoreOnly || this._setCssDimension(r, i);
          return (
            this._initRetinaScaling(),
            this._setImageSmoothing(),
            this.calcOffset(),
            e.cssOnly || this.renderAll(),
            this
          );
        },
        _setBackstoreDimension: function (t, e) {
          return (
            (this.lowerCanvasEl[t] = e),
            this.upperCanvasEl && (this.upperCanvasEl[t] = e),
            this.cacheCanvasEl && (this.cacheCanvasEl[t] = e),
            (this[t] = e),
            this
          );
        },
        _setCssDimension: function (t, e) {
          return (
            (this.lowerCanvasEl.style[t] = e),
            this.upperCanvasEl && (this.upperCanvasEl.style[t] = e),
            this.wrapperEl && (this.wrapperEl.style[t] = e),
            this
          );
        },
        getZoom: function () {
          return this.viewportTransform[0];
        },
        setViewportTransform: function (t) {
          var e,
            i = this._activeGroup;
          this.viewportTransform = t;
          for (var r = 0, n = this._objects.length; r < n; r++)
            (e = this._objects[r]).group || e.setCoords(!1, !0);
          return (
            i && i.setCoords(!1, !0),
            this.calcViewportBoundaries(),
            this.renderAll(),
            this
          );
        },
        zoomToPoint: function (t, e) {
          var i = t,
            r = this.viewportTransform.slice(0);
          (t = s(t, o(this.viewportTransform))), (r[0] = e), (r[3] = e);
          var n = s(t, r);
          return (
            (r[4] += i.x - n.x),
            (r[5] += i.y - n.y),
            this.setViewportTransform(r)
          );
        },
        setZoom: function (t) {
          return this.zoomToPoint(new fabric.Point(0, 0), t), this;
        },
        absolutePan: function (t) {
          var e = this.viewportTransform.slice(0);
          return (e[4] = -t.x), (e[5] = -t.y), this.setViewportTransform(e);
        },
        relativePan: function (t) {
          return this.absolutePan(
            new fabric.Point(
              -t.x - this.viewportTransform[4],
              -t.y - this.viewportTransform[5]
            )
          );
        },
        getElement: function () {
          return this.lowerCanvasEl;
        },
        _onObjectAdded: function (t) {
          this.stateful && t.setupState(),
            t._set('canvas', this),
            t.setCoords(),
            this.fire('object:added', { target: t }),
            t.fire('added');
        },
        _onObjectRemoved: function (t) {
          this.fire('object:removed', { target: t }),
            t.fire('removed'),
            delete t.canvas;
        },
        clearContext: function (t) {
          return t.clearRect(0, 0, this.width, this.height), this;
        },
        getContext: function () {
          return this.contextContainer;
        },
        clear: function () {
          return (
            (this._objects.length = 0),
            (this.backgroundImage = null),
            (this.overlayImage = null),
            (this.backgroundColor = ''),
            (this.overlayColor = ''),
            this._hasITextHandlers &&
              (this.off('mouse:up', this._mouseUpITextHandler),
              (this._iTextInstances = null),
              (this._hasITextHandlers = !1)),
            this.clearContext(this.contextContainer),
            this.fire('canvas:cleared'),
            this.renderAll(),
            this
          );
        },
        renderAll: function () {
          var t = this.contextContainer;
          return this.renderCanvas(t, this._objects), this;
        },
        calcViewportBoundaries: function () {
          var t = {},
            e = this.getWidth(),
            i = this.getHeight(),
            r = o(this.viewportTransform);
          return (
            (t.tl = s({ x: 0, y: 0 }, r)),
            (t.br = s({ x: e, y: i }, r)),
            (t.tr = new fabric.Point(t.br.x, t.tl.y)),
            (t.bl = new fabric.Point(t.tl.x, t.br.y)),
            (this.vptCoords = t)
          );
        },
        renderCanvas: function (t, e) {
          this.calcViewportBoundaries(),
            this.clearContext(t),
            this.fire('before:render'),
            this.clipTo && fabric.util.clipContext(this, t),
            this._renderBackground(t),
            t.save(),
            t.transform.apply(t, this.viewportTransform),
            this._renderObjects(t, e),
            t.restore(),
            !this.controlsAboveOverlay &&
              this.interactive &&
              this.drawControls(t),
            this.clipTo && t.restore(),
            this._renderOverlay(t),
            this.controlsAboveOverlay &&
              this.interactive &&
              this.drawControls(t),
            this.fire('after:render');
        },
        _renderObjects: function (t, e) {
          for (var i = 0, r = e.length; i < r; ++i) e[i] && e[i].render(t);
        },
        _renderBackgroundOrOverlay: function (t, e) {
          var i = this[e + 'Color'];
          i &&
            ((t.fillStyle = i.toLive ? i.toLive(t, this) : i),
            t.fillRect(
              i.offsetX || 0,
              i.offsetY || 0,
              this.width,
              this.height
            )),
            (i = this[e + 'Image']) &&
              (this[e + 'Vpt'] &&
                (t.save(), t.transform.apply(t, this.viewportTransform)),
              i.render(t),
              this[e + 'Vpt'] && t.restore());
        },
        _renderBackground: function (t) {
          this._renderBackgroundOrOverlay(t, 'background');
        },
        _renderOverlay: function (t) {
          this._renderBackgroundOrOverlay(t, 'overlay');
        },
        getCenter: function () {
          return { top: this.getHeight() / 2, left: this.getWidth() / 2 };
        },
        centerObjectH: function (t) {
          return this._centerObject(
            t,
            new fabric.Point(this.getCenter().left, t.getCenterPoint().y)
          );
        },
        centerObjectV: function (t) {
          return this._centerObject(
            t,
            new fabric.Point(t.getCenterPoint().x, this.getCenter().top)
          );
        },
        centerObject: function (t) {
          var e = this.getCenter();
          return this._centerObject(t, new fabric.Point(e.left, e.top));
        },
        viewportCenterObject: function (t) {
          var e = this.getVpCenter();
          return this._centerObject(t, e);
        },
        viewportCenterObjectH: function (t) {
          var e = this.getVpCenter();
          return (
            this._centerObject(t, new fabric.Point(e.x, t.getCenterPoint().y)),
            this
          );
        },
        viewportCenterObjectV: function (t) {
          var e = this.getVpCenter();
          return this._centerObject(
            t,
            new fabric.Point(t.getCenterPoint().x, e.y)
          );
        },
        getVpCenter: function () {
          var t = this.getCenter(),
            e = o(this.viewportTransform);
          return s({ x: t.left, y: t.top }, e);
        },
        _centerObject: function (t, e) {
          return (
            t.setPositionByOrigin(e, 'center', 'center'), this.renderAll(), this
          );
        },
        toDatalessJSON: function (t) {
          return this.toDatalessObject(t);
        },
        toObject: function (t) {
          return this._toObjectMethod('toObject', t);
        },
        toDatalessObject: function (t) {
          return this._toObjectMethod('toDatalessObject', t);
        },
        _toObjectMethod: function (t, e) {
          var i = { objects: this._toObjects(t, e) };
          return (
            r(i, this.__serializeBgOverlay(t, e)),
            fabric.util.populateWithProperties(this, i, e),
            i
          );
        },
        _toObjects: function (e, i) {
          return this.getObjects()
            .filter(function (t) {
              return !t.excludeFromExport;
            })
            .map(function (t) {
              return this._toObject(t, e, i);
            }, this);
        },
        _toObject: function (t, e, i) {
          var r;
          this.includeDefaultValues ||
            ((r = t.includeDefaultValues), (t.includeDefaultValues = !1));
          var n = t[e](i);
          return this.includeDefaultValues || (t.includeDefaultValues = r), n;
        },
        __serializeBgOverlay: function (t, e) {
          var i = {},
            r = this.backgroundImage,
            n = this.overlayImage;
          return (
            this.backgroundColor &&
              (i.background = this.backgroundColor.toObject
                ? this.backgroundColor.toObject(e)
                : this.backgroundColor),
            this.overlayColor &&
              (i.overlay = this.overlayColor.toObject
                ? this.overlayColor.toObject(e)
                : this.overlayColor),
            r &&
              !r.excludeFromExport &&
              (i.backgroundImage = this._toObject(r, t, e)),
            n &&
              !n.excludeFromExport &&
              (i.overlayImage = this._toObject(n, t, e)),
            i
          );
        },
        svgViewportTransformation: !0,
        toSVG: function (t, e) {
          t = t || {};
          var i = [];
          return (
            this._setSVGPreamble(i, t),
            this._setSVGHeader(i, t),
            this._setSVGBgOverlayColor(i, 'backgroundColor'),
            this._setSVGBgOverlayImage(i, 'backgroundImage', e),
            this._setSVGObjects(i, e),
            this._setSVGBgOverlayColor(i, 'overlayColor'),
            this._setSVGBgOverlayImage(i, 'overlayImage', e),
            i.push('</svg>'),
            i.join('')
          );
        },
        _setSVGPreamble: function (t, e) {
          e.suppressPreamble ||
            t.push(
              '<?xml version="1.0" encoding="',
              e.encoding || 'UTF-8',
              '" standalone="no" ?>\n',
              '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ',
              '"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n'
            );
        },
        _setSVGHeader: function (t, e) {
          var i,
            r = e.width || this.width,
            n = e.height || this.height,
            s = 'viewBox="0 0 ' + this.width + ' ' + this.height + '" ',
            o = fabric.Object.NUM_FRACTION_DIGITS;
          e.viewBox
            ? (s =
                'viewBox="' +
                e.viewBox.x +
                ' ' +
                e.viewBox.y +
                ' ' +
                e.viewBox.width +
                ' ' +
                e.viewBox.height +
                '" ')
            : this.svgViewportTransformation &&
              ((i = this.viewportTransform),
              (s =
                'viewBox="' +
                a(-i[4] / i[0], o) +
                ' ' +
                a(-i[5] / i[3], o) +
                ' ' +
                a(this.width / i[0], o) +
                ' ' +
                a(this.height / i[3], o) +
                '" ')),
            t.push(
              '<svg ',
              'xmlns="http://www.w3.org/2000/svg" ',
              'xmlns:xlink="http://www.w3.org/1999/xlink" ',
              'version="1.1" ',
              'width="',
              r,
              '" ',
              'height="',
              n,
              '" ',
              s,
              'xml:space="preserve">\n',
              '<desc>Created with Fabric.js ',
              fabric.version,
              '</desc>\n',
              '<defs>\n',
              this.createSVGFontFacesMarkup(),
              this.createSVGRefElementsMarkup(),
              '</defs>\n'
            );
        },
        createSVGRefElementsMarkup: function () {
          var i = this;
          return ['backgroundColor', 'overlayColor']
            .map(function (t) {
              var e = i[t];
              if (e && e.toLive) return e.toSVG(i, !1);
            })
            .join('');
        },
        createSVGFontFacesMarkup: function () {
          for (
            var t,
              e,
              i,
              r,
              n,
              s,
              o = '',
              a = {},
              h = fabric.fontPaths,
              c = this.getObjects(),
              l = 0,
              u = c.length;
            l < u;
            l++
          )
            if (
              ((e = (t = c[l]).fontFamily),
              -1 !== t.type.indexOf('text') &&
                !a[e] &&
                h[e] &&
                ((a[e] = !0), t.styles))
            )
              for (n in (i = t.styles))
                for (s in (r = i[n]))
                  !a[(e = r[s].fontFamily)] && h[e] && (a[e] = !0);
          for (var f in a)
            o += [
              '\t\t@font-face {\n',
              "\t\t\tfont-family: '",
              f,
              "';\n",
              "\t\t\tsrc: url('",
              h[f],
              "');\n",
              '\t\t}\n',
            ].join('');
          return (o =
            o &&
            [
              '\t<style type="text/css">',
              '<![CDATA[\n',
              o,
              ']]>',
              '</style>\n',
            ].join(''));
        },
        _setSVGObjects: function (t, e) {
          for (var i, r = 0, n = this.getObjects(), s = n.length; r < s; r++)
            (i = n[r]).excludeFromExport || this._setSVGObject(t, i, e);
        },
        _setSVGObject: function (t, e, i) {
          t.push(e.toSVG(i));
        },
        _setSVGBgOverlayImage: function (t, e, i) {
          this[e] && this[e].toSVG && t.push(this[e].toSVG(i));
        },
        _setSVGBgOverlayColor: function (t, e) {
          var i = this[e];
          if (i)
            if (i.toLive) {
              var r = i.repeat;
              t.push(
                '<rect transform="translate(',
                this.width / 2,
                ',',
                this.height / 2,
                ')"',
                ' x="',
                i.offsetX - this.width / 2,
                '" y="',
                i.offsetY - this.height / 2,
                '" ',
                'width="',
                'repeat-y' === r || 'no-repeat' === r
                  ? i.source.width
                  : this.width,
                '" height="',
                'repeat-x' === r || 'no-repeat' === r
                  ? i.source.height
                  : this.height,
                '" fill="url(#SVGID_' + i.id + ')"',
                '></rect>\n'
              );
            } else
              t.push(
                '<rect x="0" y="0" ',
                'width="',
                this.width,
                '" height="',
                this.height,
                '" fill="',
                this[e],
                '"',
                '></rect>\n'
              );
        },
        sendToBack: function (t) {
          if (!t) return this;
          var e,
            i,
            r,
            n = this._activeGroup;
          if (t === n)
            for (e = (r = n._objects).length; e--; )
              (i = r[e]), c(this._objects, i), this._objects.unshift(i);
          else c(this._objects, t), this._objects.unshift(t);
          return this.renderAll && this.renderAll();
        },
        bringToFront: function (t) {
          if (!t) return this;
          var e,
            i,
            r,
            n = this._activeGroup;
          if (t === n)
            for (r = n._objects, e = 0; e < r.length; e++)
              (i = r[e]), c(this._objects, i), this._objects.push(i);
          else c(this._objects, t), this._objects.push(t);
          return this.renderAll && this.renderAll();
        },
        sendBackwards: function (t, e) {
          if (!t) return this;
          var i,
            r,
            n,
            s,
            o,
            a = this._activeGroup,
            h = 0;
          if (t === a)
            for (o = a._objects, i = 0; i < o.length; i++)
              (r = o[i]),
                0 + h < (n = this._objects.indexOf(r)) &&
                  ((s = n - 1),
                  c(this._objects, r),
                  this._objects.splice(s, 0, r)),
                h++;
          else
            0 !== (n = this._objects.indexOf(t)) &&
              ((s = this._findNewLowerIndex(t, n, e)),
              c(this._objects, t),
              this._objects.splice(s, 0, t));
          return this.renderAll && this.renderAll(), this;
        },
        _findNewLowerIndex: function (t, e, i) {
          var r;
          if (i)
            for (var n = (r = e) - 1; 0 <= n; --n) {
              if (
                t.intersectsWithObject(this._objects[n]) ||
                t.isContainedWithinObject(this._objects[n]) ||
                this._objects[n].isContainedWithinObject(t)
              ) {
                r = n;
                break;
              }
            }
          else r = e - 1;
          return r;
        },
        bringForward: function (t, e) {
          if (!t) return this;
          var i,
            r,
            n,
            s,
            o,
            a = this._activeGroup,
            h = 0;
          if (t === a)
            for (i = (o = a._objects).length; i--; )
              (r = o[i]),
                (n = this._objects.indexOf(r)) < this._objects.length - 1 - h &&
                  ((s = n + 1),
                  c(this._objects, r),
                  this._objects.splice(s, 0, r)),
                h++;
          else
            (n = this._objects.indexOf(t)) !== this._objects.length - 1 &&
              ((s = this._findNewUpperIndex(t, n, e)),
              c(this._objects, t),
              this._objects.splice(s, 0, t));
          return this.renderAll && this.renderAll(), this;
        },
        _findNewUpperIndex: function (t, e, i) {
          var r;
          if (i)
            for (var n = (r = e) + 1; n < this._objects.length; ++n) {
              if (
                t.intersectsWithObject(this._objects[n]) ||
                t.isContainedWithinObject(this._objects[n]) ||
                this._objects[n].isContainedWithinObject(t)
              ) {
                r = n;
                break;
              }
            }
          else r = e + 1;
          return r;
        },
        moveTo: function (t, e) {
          return (
            c(this._objects, t),
            this._objects.splice(e, 0, t),
            this.renderAll && this.renderAll()
          );
        },
        dispose: function () {
          return this.clear(), this;
        },
        toString: function () {
          return (
            '#<fabric.Canvas (' +
            this.complexity() +
            '): { objects: ' +
            this.getObjects().length +
            ' }>'
          );
        },
      })),
        r(fabric.StaticCanvas.prototype, fabric.Observable),
        r(fabric.StaticCanvas.prototype, fabric.Collection),
        r(fabric.StaticCanvas.prototype, fabric.DataURLExporter),
        r(fabric.StaticCanvas, {
          EMPTY_JSON: '{"objects": [], "background": "white"}',
          supports: function (t) {
            var e = fabric.util.createCanvasElement();
            if (!e || !e.getContext) return null;
            var i = e.getContext('2d');
            if (!i) return null;
            switch (t) {
              case 'getImageData':
                return void 0 !== i.getImageData;
              case 'setLineDash':
                return void 0 !== i.setLineDash;
              case 'toDataURL':
                return void 0 !== e.toDataURL;
              case 'toDataURLWithQuality':
                try {
                  return e.toDataURL('image/jpeg', 0), !0;
                } catch (t) {}
                return !1;
              default:
                return null;
            }
          },
        }),
        (fabric.StaticCanvas.prototype.toJSON =
          fabric.StaticCanvas.prototype.toObject);
    }
  })(),
  (fabric.BaseBrush = fabric.util.createClass({
    color: 'rgb(0, 0, 0)',
    width: 1,
    shadow: null,
    strokeLineCap: 'round',
    strokeLineJoin: 'round',
    strokeDashArray: null,
    setShadow: function (t) {
      return (this.shadow = new fabric.Shadow(t)), this;
    },
    _setBrushStyles: function () {
      var t = this.canvas.contextTop;
      (t.strokeStyle = this.color),
        (t.lineWidth = this.width),
        (t.lineCap = this.strokeLineCap),
        (t.lineJoin = this.strokeLineJoin),
        this.strokeDashArray &&
          fabric.StaticCanvas.supports('setLineDash') &&
          t.setLineDash(this.strokeDashArray);
    },
    _setShadow: function () {
      if (this.shadow) {
        var t = this.canvas.contextTop,
          e = this.canvas.getZoom();
        (t.shadowColor = this.shadow.color),
          (t.shadowBlur = this.shadow.blur * e),
          (t.shadowOffsetX = this.shadow.offsetX * e),
          (t.shadowOffsetY = this.shadow.offsetY * e);
      }
    },
    _resetShadow: function () {
      var t = this.canvas.contextTop;
      (t.shadowColor = ''),
        (t.shadowBlur = t.shadowOffsetX = t.shadowOffsetY = 0);
    },
  })),
  (fabric.PencilBrush = fabric.util.createClass(fabric.BaseBrush, {
    initialize: function (t) {
      (this.canvas = t), (this._points = []);
    },
    onMouseDown: function (t) {
      this._prepareForDrawing(t), this._captureDrawingPath(t), this._render();
    },
    onMouseMove: function (t) {
      this._captureDrawingPath(t),
        this.canvas.clearContext(this.canvas.contextTop),
        this._render();
    },
    onMouseUp: function () {
      this._finalizeAndAddPath();
    },
    _prepareForDrawing: function (t) {
      var e = new fabric.Point(t.x, t.y);
      this._reset(), this._addPoint(e), this.canvas.contextTop.moveTo(e.x, e.y);
    },
    _addPoint: function (t) {
      this._points.push(t);
    },
    _reset: function () {
      (this._points.length = 0), this._setBrushStyles(), this._setShadow();
    },
    _captureDrawingPath: function (t) {
      var e = new fabric.Point(t.x, t.y);
      this._addPoint(e);
    },
    _render: function () {
      var t = this.canvas.contextTop,
        e = this.canvas.viewportTransform,
        i = this._points[0],
        r = this._points[1];
      t.save(),
        t.transform(e[0], e[1], e[2], e[3], e[4], e[5]),
        t.beginPath(),
        2 === this._points.length &&
          i.x === r.x &&
          i.y === r.y &&
          ((i.x -= 0.5), (r.x += 0.5)),
        t.moveTo(i.x, i.y);
      for (var n = 1, s = this._points.length; n < s; n++) {
        var o = i.midPointFrom(r);
        t.quadraticCurveTo(i.x, i.y, o.x, o.y),
          (i = this._points[n]),
          (r = this._points[n + 1]);
      }
      t.lineTo(i.x, i.y), t.stroke(), t.restore();
    },
    convertPointsToSVGPath: function (t) {
      var e = [],
        i = new fabric.Point(t[0].x, t[0].y),
        r = new fabric.Point(t[1].x, t[1].y);
      e.push('M ', t[0].x, ' ', t[0].y, ' ');
      for (var n = 1, s = t.length; n < s; n++) {
        var o = i.midPointFrom(r);
        e.push('Q ', i.x, ' ', i.y, ' ', o.x, ' ', o.y, ' '),
          (i = new fabric.Point(t[n].x, t[n].y)),
          n + 1 < t.length && (r = new fabric.Point(t[n + 1].x, t[n + 1].y));
      }
      return e.push('L ', i.x, ' ', i.y, ' '), e;
    },
    createPath: function (t) {
      var e = new fabric.Path(t, {
        fill: null,
        stroke: this.color,
        strokeWidth: this.width,
        strokeLineCap: this.strokeLineCap,
        strokeLineJoin: this.strokeLineJoin,
        strokeDashArray: this.strokeDashArray,
        originX: 'center',
        originY: 'center',
      });
      return (
        this.shadow &&
          ((this.shadow.affectStroke = !0), e.setShadow(this.shadow)),
        e
      );
    },
    _finalizeAndAddPath: function () {
      this.canvas.contextTop.closePath();
      var t = this.convertPointsToSVGPath(this._points).join('');
      if ('M 0 0 Q 0 0 0 0 L 0 0' !== t) {
        var e = this.createPath(t);
        this.canvas.add(e),
          e.setCoords(),
          this.canvas.clearContext(this.canvas.contextTop),
          this._resetShadow(),
          this.canvas.renderAll(),
          this.canvas.fire('path:created', { path: e });
      } else this.canvas.renderAll();
    },
  })),
  (fabric.CircleBrush = fabric.util.createClass(fabric.BaseBrush, {
    width: 10,
    initialize: function (t) {
      (this.canvas = t), (this.points = []);
    },
    drawDot: function (t) {
      var e = this.addPoint(t),
        i = this.canvas.contextTop,
        r = this.canvas.viewportTransform;
      i.save(),
        i.transform(r[0], r[1], r[2], r[3], r[4], r[5]),
        (i.fillStyle = e.fill),
        i.beginPath(),
        i.arc(e.x, e.y, e.radius, 0, 2 * Math.PI, !1),
        i.closePath(),
        i.fill(),
        i.restore();
    },
    onMouseDown: function (t) {
      (this.points.length = 0),
        this.canvas.clearContext(this.canvas.contextTop),
        this._setShadow(),
        this.drawDot(t);
    },
    onMouseMove: function (t) {
      this.drawDot(t);
    },
    onMouseUp: function () {
      var t = this.canvas.renderOnAddRemove;
      this.canvas.renderOnAddRemove = !1;
      for (var e = [], i = 0, r = this.points.length; i < r; i++) {
        var n = this.points[i],
          s = new fabric.Circle({
            radius: n.radius,
            left: n.x,
            top: n.y,
            originX: 'center',
            originY: 'center',
            fill: n.fill,
          });
        this.shadow && s.setShadow(this.shadow), e.push(s);
      }
      var o = new fabric.Group(e, { originX: 'center', originY: 'center' });
      (o.canvas = this.canvas),
        this.canvas.add(o),
        this.canvas.fire('path:created', { path: o }),
        this.canvas.clearContext(this.canvas.contextTop),
        this._resetShadow(),
        (this.canvas.renderOnAddRemove = t),
        this.canvas.renderAll();
    },
    addPoint: function (t) {
      var e = new fabric.Point(t.x, t.y),
        i =
          fabric.util.getRandomInt(
            Math.max(0, this.width - 20),
            this.width + 20
          ) / 2,
        r = new fabric.Color(this.color)
          .setAlpha(fabric.util.getRandomInt(0, 100) / 100)
          .toRgba();
      return (e.radius = i), (e.fill = r), this.points.push(e), e;
    },
  })),
  (fabric.SprayBrush = fabric.util.createClass(fabric.BaseBrush, {
    width: 10,
    density: 20,
    dotWidth: 1,
    dotWidthVariance: 1,
    randomOpacity: !1,
    optimizeOverlapping: !0,
    initialize: function (t) {
      (this.canvas = t), (this.sprayChunks = []);
    },
    onMouseDown: function (t) {
      (this.sprayChunks.length = 0),
        this.canvas.clearContext(this.canvas.contextTop),
        this._setShadow(),
        this.addSprayChunk(t),
        this.render();
    },
    onMouseMove: function (t) {
      this.addSprayChunk(t), this.render();
    },
    onMouseUp: function () {
      var t = this.canvas.renderOnAddRemove;
      this.canvas.renderOnAddRemove = !1;
      for (var e = [], i = 0, r = this.sprayChunks.length; i < r; i++)
        for (var n = this.sprayChunks[i], s = 0, o = n.length; s < o; s++) {
          var a = new fabric.Rect({
            width: n[s].width,
            height: n[s].width,
            left: n[s].x + 1,
            top: n[s].y + 1,
            originX: 'center',
            originY: 'center',
            fill: this.color,
          });
          this.shadow && a.setShadow(this.shadow), e.push(a);
        }
      this.optimizeOverlapping && (e = this._getOptimizedRects(e));
      var h = new fabric.Group(e, { originX: 'center', originY: 'center' });
      (h.canvas = this.canvas),
        this.canvas.add(h),
        this.canvas.fire('path:created', { path: h }),
        this.canvas.clearContext(this.canvas.contextTop),
        this._resetShadow(),
        (this.canvas.renderOnAddRemove = t),
        this.canvas.renderAll();
    },
    _getOptimizedRects: function (t) {
      for (var e, i = {}, r = 0, n = t.length; r < n; r++)
        i[(e = t[r].left + '' + t[r].top)] || (i[e] = t[r]);
      var s = [];
      for (e in i) s.push(i[e]);
      return s;
    },
    render: function () {
      var t = this.canvas.contextTop;
      t.fillStyle = this.color;
      var e = this.canvas.viewportTransform;
      t.save(), t.transform(e[0], e[1], e[2], e[3], e[4], e[5]);
      for (var i = 0, r = this.sprayChunkPoints.length; i < r; i++) {
        var n = this.sprayChunkPoints[i];
        void 0 !== n.opacity && (t.globalAlpha = n.opacity),
          t.fillRect(n.x, n.y, n.width, n.width);
      }
      t.restore();
    },
    addSprayChunk: function (t) {
      this.sprayChunkPoints = [];
      for (var e, i, r, n = this.width / 2, s = 0; s < this.density; s++) {
        (e = fabric.util.getRandomInt(t.x - n, t.x + n)),
          (i = fabric.util.getRandomInt(t.y - n, t.y + n)),
          (r = this.dotWidthVariance
            ? fabric.util.getRandomInt(
                Math.max(1, this.dotWidth - this.dotWidthVariance),
                this.dotWidth + this.dotWidthVariance
              )
            : this.dotWidth);
        var o = new fabric.Point(e, i);
        (o.width = r),
          this.randomOpacity &&
            (o.opacity = fabric.util.getRandomInt(0, 100) / 100),
          this.sprayChunkPoints.push(o);
      }
      this.sprayChunks.push(this.sprayChunkPoints);
    },
  })),
  (fabric.PatternBrush = fabric.util.createClass(fabric.PencilBrush, {
    getPatternSrc: function () {
      var t = fabric.document.createElement('canvas'),
        e = t.getContext('2d');
      return (
        (t.width = t.height = 25),
        (e.fillStyle = this.color),
        e.beginPath(),
        e.arc(10, 10, 10, 0, 2 * Math.PI, !1),
        e.closePath(),
        e.fill(),
        t
      );
    },
    getPatternSrcFunction: function () {
      return String(this.getPatternSrc).replace(
        'this.color',
        '"' + this.color + '"'
      );
    },
    getPattern: function () {
      return this.canvas.contextTop.createPattern(
        this.source || this.getPatternSrc(),
        'repeat'
      );
    },
    _setBrushStyles: function () {
      this.callSuper('_setBrushStyles'),
        (this.canvas.contextTop.strokeStyle = this.getPattern());
    },
    createPath: function (t) {
      var e = this.callSuper('createPath', t),
        i = e._getLeftTopCoords().scalarAdd(e.strokeWidth / 2);
      return (
        (e.stroke = new fabric.Pattern({
          source: this.source || this.getPatternSrcFunction(),
          offsetX: -i.x,
          offsetY: -i.y,
        })),
        e
      );
    },
  })),
  (function () {
    var h = fabric.util.getPointer,
      o = fabric.util.degreesToRadians,
      u = fabric.util.radiansToDegrees,
      f = Math.atan2,
      c = Math.abs,
      l = fabric.StaticCanvas.supports('setLineDash');
    for (var t in ((fabric.Canvas = fabric.util.createClass(
      fabric.StaticCanvas,
      {
        initialize: function (t, e) {
          (e = e || {}),
            this._initStatic(t, e),
            this._initInteractive(),
            this._createCacheCanvas();
        },
        uniScaleTransform: !1,
        uniScaleKey: 'shiftKey',
        centeredScaling: !1,
        centeredRotation: !1,
        centeredKey: 'altKey',
        altActionKey: 'shiftKey',
        interactive: !0,
        selection: !0,
        selectionKey: 'shiftKey',
        altSelectionKey: null,
        selectionColor: 'rgba(100, 100, 255, 0.3)',
        selectionDashArray: [],
        selectionBorderColor: 'rgba(255, 255, 255, 0.3)',
        selectionLineWidth: 1,
        hoverCursor: 'move',
        moveCursor: 'move',
        defaultCursor: 'default',
        freeDrawingCursor: 'crosshair',
        rotationCursor: 'crosshair',
        containerClass: 'canvas-container',
        perPixelTargetFind: !1,
        targetFindTolerance: 0,
        skipTargetFind: !1,
        isDrawingMode: !1,
        preserveObjectStacking: !1,
        snapAngle: 0,
        snapThreshold: null,
        stopContextMenu: !1,
        fireRightClick: !1,
        fireMiddleClick: !1,
        _initInteractive: function () {
          (this._currentTransform = null),
            (this._groupSelector = null),
            this._initWrapperElement(),
            this._createUpperCanvas(),
            this._initEventListeners(),
            this._initRetinaScaling(),
            (this.freeDrawingBrush =
              fabric.PencilBrush && new fabric.PencilBrush(this)),
            this.calcOffset();
        },
        _chooseObjectsToRender: function () {
          var t,
            e = this.getActiveGroup(),
            i = this.getActiveObject(),
            r = [],
            n = [];
          if ((!e && !i) || this.preserveObjectStacking) r = this._objects;
          else {
            for (var s = 0, o = this._objects.length; s < o; s++)
              (t = this._objects[s]),
                (e && e.contains(t)) || t === i ? n.push(t) : r.push(t);
            e && (e._set('_objects', n), r.push(e)), i && r.push(i);
          }
          return r;
        },
        renderAll: function () {
          !this.contextTopDirty ||
            this._groupSelector ||
            this.isDrawingMode ||
            (this.clearContext(this.contextTop), (this.contextTopDirty = !1));
          var t = this.contextContainer;
          return this.renderCanvas(t, this._chooseObjectsToRender()), this;
        },
        renderTop: function () {
          var t = this.contextTop;
          return (
            this.clearContext(t),
            this.selection && this._groupSelector && this._drawSelection(t),
            this.fire('after:render'),
            (this.contextTopDirty = !0),
            this
          );
        },
        _resetCurrentTransform: function () {
          var t = this._currentTransform;
          t.target.set({
            scaleX: t.original.scaleX,
            scaleY: t.original.scaleY,
            skewX: t.original.skewX,
            skewY: t.original.skewY,
            left: t.original.left,
            top: t.original.top,
          }),
            this._shouldCenterTransform(t.target)
              ? 'rotate' === t.action
                ? this._setOriginToCenter(t.target)
                : ('center' !== t.originX &&
                    ('right' === t.originX
                      ? (t.mouseXSign = -1)
                      : (t.mouseXSign = 1)),
                  'center' !== t.originY &&
                    ('bottom' === t.originY
                      ? (t.mouseYSign = -1)
                      : (t.mouseYSign = 1)),
                  (t.originX = 'center'),
                  (t.originY = 'center'))
              : ((t.originX = t.original.originX),
                (t.originY = t.original.originY));
        },
        containsPoint: function (t, e, i) {
          var r,
            n = i || this.getPointer(t, !0);
          return (
            (r =
              e.group && e.group === this.getActiveGroup()
                ? this._normalizePointer(e.group, n)
                : { x: n.x, y: n.y }),
            e.containsPoint(r) || e._findTargetCorner(n)
          );
        },
        _normalizePointer: function (t, e) {
          var i = t.calcTransformMatrix(),
            r = fabric.util.invertTransform(i),
            n = this.restorePointerVpt(e);
          return fabric.util.transformPoint(n, r);
        },
        isTargetTransparent: function (t, e, i) {
          var r = t.hasBorders,
            n = t.transparentCorners,
            s = this.contextCache,
            o = t.selectionBackgroundColor;
          (t.hasBorders = t.transparentCorners = !1),
            (t.selectionBackgroundColor = ''),
            s.save(),
            s.transform.apply(s, this.viewportTransform),
            t.render(s),
            s.restore(),
            t.active && t._renderControls(s),
            (t.hasBorders = r),
            (t.transparentCorners = n),
            (t.selectionBackgroundColor = o);
          var a = fabric.util.isTransparent(s, e, i, this.targetFindTolerance);
          return this.clearContext(s), a;
        },
        _shouldClearSelection: function (t, e) {
          var i = this.getActiveGroup(),
            r = this.getActiveObject();
          return (
            !e ||
            (e && i && !i.contains(e) && i !== e && !t[this.selectionKey]) ||
            (e && !e.evented) ||
            (e && !e.selectable && r && r !== e)
          );
        },
        _shouldCenterTransform: function (t) {
          if (t) {
            var e,
              i = this._currentTransform;
            return (
              'scale' === i.action ||
              'scaleX' === i.action ||
              'scaleY' === i.action
                ? (e = this.centeredScaling || t.centeredScaling)
                : 'rotate' === i.action &&
                  (e = this.centeredRotation || t.centeredRotation),
              e ? !i.altKey : i.altKey
            );
          }
        },
        _getOriginFromCorner: function (t, e) {
          var i = { x: t.originX, y: t.originY };
          return (
            'ml' === e || 'tl' === e || 'bl' === e
              ? (i.x = 'right')
              : ('mr' !== e && 'tr' !== e && 'br' !== e) || (i.x = 'left'),
            'tl' === e || 'mt' === e || 'tr' === e
              ? (i.y = 'bottom')
              : ('bl' !== e && 'mb' !== e && 'br' !== e) || (i.y = 'top'),
            i
          );
        },
        _getActionFromCorner: function (t, e, i) {
          if (!e) return 'drag';
          switch (e) {
            case 'mtr':
              return 'rotate';
            case 'ml':
            case 'mr':
              return i[this.altActionKey] ? 'skewY' : 'scaleX';
            case 'mt':
            case 'mb':
              return i[this.altActionKey] ? 'skewX' : 'scaleY';
            default:
              return 'scale';
          }
        },
        _setupCurrentTransform: function (t, e) {
          if (e) {
            var i = this.getPointer(t),
              r = e._findTargetCorner(this.getPointer(t, !0)),
              n = this._getActionFromCorner(e, r, t),
              s = this._getOriginFromCorner(e, r);
            (this._currentTransform = {
              target: e,
              action: n,
              corner: r,
              scaleX: e.scaleX,
              scaleY: e.scaleY,
              skewX: e.skewX,
              skewY: e.skewY,
              offsetX: i.x - e.left,
              offsetY: i.y - e.top,
              originX: s.x,
              originY: s.y,
              ex: i.x,
              ey: i.y,
              lastX: i.x,
              lastY: i.y,
              left: e.left,
              top: e.top,
              theta: o(e.angle),
              width: e.width * e.scaleX,
              mouseXSign: 1,
              mouseYSign: 1,
              shiftKey: t.shiftKey,
              altKey: t[this.centeredKey],
            }),
              (this._currentTransform.original = {
                left: e.left,
                top: e.top,
                scaleX: e.scaleX,
                scaleY: e.scaleY,
                skewX: e.skewX,
                skewY: e.skewY,
                originX: s.x,
                originY: s.y,
              }),
              this._resetCurrentTransform();
          }
        },
        _translateObject: function (t, e) {
          var i = this._currentTransform,
            r = i.target,
            n = t - i.offsetX,
            s = e - i.offsetY,
            o = !r.get('lockMovementX') && r.left !== n,
            a = !r.get('lockMovementY') && r.top !== s;
          return o && r.set('left', n), a && r.set('top', s), o || a;
        },
        _changeSkewTransformOrigin: function (t, e, i) {
          var r = 'originX',
            n = { 0: 'center' },
            s = e.target.skewX,
            o = 'left',
            a = 'right',
            h = 'mt' === e.corner || 'ml' === e.corner ? 1 : -1,
            c = 1;
          (t = 0 < t ? 1 : -1),
            'y' === i &&
              ((s = e.target.skewY),
              (o = 'top'),
              (a = 'bottom'),
              (r = 'originY')),
            (n[-1] = o),
            (n[1] = a),
            e.target.flipX && (c *= -1),
            e.target.flipY && (c *= -1),
            0 === s
              ? ((e.skewSign = -h * t * c), (e[r] = n[-t]))
              : ((s = 0 < s ? 1 : -1), (e.skewSign = s), (e[r] = n[s * h * c]));
        },
        _skewObject: function (t, e, i) {
          var r,
            n = this._currentTransform,
            s = n.target,
            o = s.get('lockSkewingX'),
            a = s.get('lockSkewingY');
          if ((o && 'x' === i) || (a && 'y' === i)) return !1;
          var h,
            c,
            l = s.getCenterPoint(),
            u = s.toLocalPoint(new fabric.Point(t, e), 'center', 'center')[i],
            f = s.toLocalPoint(
              new fabric.Point(n.lastX, n.lastY),
              'center',
              'center'
            )[i],
            d = s._getTransformedDimensions();
          return (
            this._changeSkewTransformOrigin(u - f, n, i),
            (h = s.toLocalPoint(new fabric.Point(t, e), n.originX, n.originY)[
              i
            ]),
            (c = s.translateToOriginPoint(l, n.originX, n.originY)),
            (r = this._setObjectSkew(h, n, i, d)),
            (n.lastX = t),
            (n.lastY = e),
            s.setPositionByOrigin(c, n.originX, n.originY),
            r
          );
        },
        _setObjectSkew: function (t, e, i, r) {
          var n,
            s,
            o,
            a,
            h,
            c,
            l,
            u,
            f,
            d,
            g = e.target,
            p = e.skewSign;
          return (
            (d =
              'x' === i
                ? ((h = 'y'), (c = 'Y'), (l = 'X'), (f = 0), g.skewY)
                : ((h = 'x'), (c = 'X'), (l = 'Y'), (f = g.skewX), 0)),
            (a = g._getTransformedDimensions(f, d)),
            (n =
              (u = 2 * Math.abs(t) - a[i]) <= 2
                ? 0
                : ((n =
                    p *
                    Math.atan(u / g['scale' + l] / (a[h] / g['scale' + c]))),
                  fabric.util.radiansToDegrees(n))),
            (s = g['skew' + l] !== n),
            g.set('skew' + l, n),
            0 !== g['skew' + c] &&
              ((o = g._getTransformedDimensions()),
              (n = (r[h] / o[h]) * g['scale' + c]),
              g.set('scale' + c, n)),
            s
          );
        },
        _scaleObject: function (t, e, i) {
          var r = this._currentTransform,
            n = r.target,
            s = n.get('lockScalingX'),
            o = n.get('lockScalingY'),
            a = n.get('lockScalingFlip');
          if (s && o) return !1;
          var h,
            c = n.translateToOriginPoint(
              n.getCenterPoint(),
              r.originX,
              r.originY
            ),
            l = n.toLocalPoint(new fabric.Point(t, e), r.originX, r.originY),
            u = n._getTransformedDimensions();
          return (
            this._setLocalMouse(l, r),
            (h = this._setObjectScale(l, r, s, o, i, a, u)),
            n.setPositionByOrigin(c, r.originX, r.originY),
            h
          );
        },
        _setObjectScale: function (t, e, i, r, n, s, o) {
          var a,
            h,
            c,
            l,
            u = e.target,
            f = !1,
            d = !1,
            g = !1;
          return (
            (c = (t.x * u.scaleX) / o.x),
            (l = (t.y * u.scaleY) / o.y),
            (a = u.scaleX !== c),
            (h = u.scaleY !== l),
            s && c <= 0 && c < u.scaleX && (f = !0),
            s && l <= 0 && l < u.scaleY && (d = !0),
            'equally' !== n || i || r
              ? n
                ? 'x' !== n || u.get('lockUniScaling')
                  ? 'y' !== n ||
                    u.get('lockUniScaling') ||
                    d ||
                    r ||
                    (u.set('scaleY', l) && (g = g || h))
                  : f || i || (u.set('scaleX', c) && (g = g || a))
                : (f || i || (u.set('scaleX', c) && (g = g || a)),
                  d || r || (u.set('scaleY', l) && (g = g || h)))
              : f || d || (g = this._scaleObjectEqually(t, u, e, o)),
            (e.newScaleX = c),
            (e.newScaleY = l),
            f || d || this._flipObject(e, n),
            g
          );
        },
        _scaleObjectEqually: function (t, e, i, r) {
          var n,
            s = t.y + t.x,
            o =
              (r.y * i.original.scaleY) / e.scaleY +
              (r.x * i.original.scaleX) / e.scaleX;
          return (
            (i.newScaleX = (i.original.scaleX * s) / o),
            (i.newScaleY = (i.original.scaleY * s) / o),
            (n = i.newScaleX !== e.scaleX || i.newScaleY !== e.scaleY),
            e.set('scaleX', i.newScaleX),
            e.set('scaleY', i.newScaleY),
            n
          );
        },
        _flipObject: function (t, e) {
          t.newScaleX < 0 &&
            'y' !== e &&
            ('left' === t.originX
              ? (t.originX = 'right')
              : 'right' === t.originX && (t.originX = 'left')),
            t.newScaleY < 0 &&
              'x' !== e &&
              ('top' === t.originY
                ? (t.originY = 'bottom')
                : 'bottom' === t.originY && (t.originY = 'top'));
        },
        _setLocalMouse: function (t, e) {
          var i = e.target,
            r = this.getZoom(),
            n = i.padding / r;
          'right' === e.originX
            ? (t.x *= -1)
            : 'center' === e.originX &&
              ((t.x *= 2 * e.mouseXSign),
              t.x < 0 && (e.mouseXSign = -e.mouseXSign)),
            'bottom' === e.originY
              ? (t.y *= -1)
              : 'center' === e.originY &&
                ((t.y *= 2 * e.mouseYSign),
                t.y < 0 && (e.mouseYSign = -e.mouseYSign)),
            c(t.x) > n ? (t.x < 0 ? (t.x += n) : (t.x -= n)) : (t.x = 0),
            c(t.y) > n ? (t.y < 0 ? (t.y += n) : (t.y -= n)) : (t.y = 0);
        },
        _rotateObject: function (t, e) {
          var i = this._currentTransform;
          if (i.target.get('lockRotation')) return !1;
          var r = f(i.ey - i.top, i.ex - i.left),
            n = f(e - i.top, t - i.left),
            s = u(n - r + i.theta),
            o = !0;
          if (0 < i.target.snapAngle) {
            var a = i.target.snapAngle,
              h = i.target.snapThreshold || a,
              c = Math.ceil(s / a) * a,
              l = Math.floor(s / a) * a;
            Math.abs(s - l) < h ? (s = l) : Math.abs(s - c) < h && (s = c);
          }
          return (
            s < 0 && (s = 360 + s),
            (s %= 360),
            i.target.angle === s ? (o = !1) : (i.target.angle = s),
            o
          );
        },
        setCursor: function (t) {
          this.upperCanvasEl.style.cursor = t;
        },
        _resetObjectTransform: function (t) {
          (t.scaleX = 1),
            (t.scaleY = 1),
            (t.skewX = 0),
            (t.skewY = 0),
            t.setAngle(0);
        },
        _drawSelection: function (t) {
          var e = this._groupSelector,
            i = e.left,
            r = e.top,
            n = c(i),
            s = c(r);
          if (
            (this.selectionColor &&
              ((t.fillStyle = this.selectionColor),
              t.fillRect(
                e.ex - (0 < i ? 0 : -i),
                e.ey - (0 < r ? 0 : -r),
                n,
                s
              )),
            this.selectionLineWidth && this.selectionBorderColor)
          )
            if (
              ((t.lineWidth = this.selectionLineWidth),
              (t.strokeStyle = this.selectionBorderColor),
              1 < this.selectionDashArray.length && !l)
            ) {
              var o = e.ex + 0.5 - (0 < i ? 0 : n),
                a = e.ey + 0.5 - (0 < r ? 0 : s);
              t.beginPath(),
                fabric.util.drawDashedLine(
                  t,
                  o,
                  a,
                  o + n,
                  a,
                  this.selectionDashArray
                ),
                fabric.util.drawDashedLine(
                  t,
                  o,
                  a + s - 1,
                  o + n,
                  a + s - 1,
                  this.selectionDashArray
                ),
                fabric.util.drawDashedLine(
                  t,
                  o,
                  a,
                  o,
                  a + s,
                  this.selectionDashArray
                ),
                fabric.util.drawDashedLine(
                  t,
                  o + n - 1,
                  a,
                  o + n - 1,
                  a + s,
                  this.selectionDashArray
                ),
                t.closePath(),
                t.stroke();
            } else
              fabric.Object.prototype._setLineDash.call(
                this,
                t,
                this.selectionDashArray
              ),
                t.strokeRect(
                  e.ex + 0.5 - (0 < i ? 0 : n),
                  e.ey + 0.5 - (0 < r ? 0 : s),
                  n,
                  s
                );
        },
        findTarget: function (t, e) {
          if (!this.skipTargetFind) {
            var i,
              r = this.getPointer(t, !0),
              n = this.getActiveGroup(),
              s = this.getActiveObject();
            if (
              ((this.targets = []),
              n && !e && n === this._searchPossibleTargets([n], r))
            )
              return this._fireOverOutEvents(n, t), n;
            if (s && s._findTargetCorner(r))
              return this._fireOverOutEvents(s, t), s;
            if (s && s === this._searchPossibleTargets([s], r)) {
              if (!this.preserveObjectStacking)
                return this._fireOverOutEvents(s, t), s;
              i = s;
            }
            var o = this._searchPossibleTargets(this._objects, r);
            return (
              t[this.altSelectionKey] && o && i && o !== i && (o = i),
              this._fireOverOutEvents(o, t),
              o
            );
          }
        },
        _fireOverOutEvents: function (t, e) {
          var i,
            r,
            n = this._hoveredTarget;
          n !== t &&
            ((i = { e: e, target: t, previousTarget: this._hoveredTarget }),
            (r = { e: e, target: this._hoveredTarget, nextTarget: t }),
            (this._hoveredTarget = t)),
            t
              ? n !== t &&
                (n &&
                  (this.fire('mouse:out', r),
                  n.fire(fabric.eventMapping.out, r)),
                this.fire('mouse:over', i),
                t.fire('mouseover', i))
              : n &&
                (this.fire('mouse:out', r), n.fire(fabric.eventMapping.out, r));
        },
        _checkTarget: function (t, e) {
          if (e && e.visible && e.evented && this.containsPoint(null, e, t)) {
            if (
              (!this.perPixelTargetFind && !e.perPixelTargetFind) ||
              e.isEditing
            )
              return !0;
            if (!this.isTargetTransparent(e, t.x, t.y)) return !0;
          }
        },
        _searchPossibleTargets: function (t, e) {
          for (var i, r, n, s = t.length; s--; )
            if (this._checkTarget(e, t[s])) {
              'group' === (i = t[s]).type &&
                i.subTargetCheck &&
                ((r = this._normalizePointer(i, e)),
                (n = this._searchPossibleTargets(i._objects, r)) &&
                  this.targets.push(n));
              break;
            }
          return i;
        },
        restorePointerVpt: function (t) {
          return fabric.util.transformPoint(
            t,
            fabric.util.invertTransform(this.viewportTransform)
          );
        },
        getPointer: function (t, e, i) {
          i = i || this.upperCanvasEl;
          var r,
            n = h(t),
            s = i.getBoundingClientRect(),
            o = s.width || 0,
            a = s.height || 0;
          return (
            (o && a) ||
              ('top' in s && 'bottom' in s && (a = Math.abs(s.top - s.bottom)),
              'right' in s && 'left' in s && (o = Math.abs(s.right - s.left))),
            this.calcOffset(),
            (n.x = n.x - this._offset.left),
            (n.y = n.y - this._offset.top),
            e || (n = this.restorePointerVpt(n)),
            (r =
              0 === o || 0 === a
                ? { width: 1, height: 1 }
                : { width: i.width / o, height: i.height / a }),
            { x: n.x * r.width, y: n.y * r.height }
          );
        },
        _createUpperCanvas: function () {
          var t = this.lowerCanvasEl.className.replace(
            /\s*lower-canvas\s*/,
            ''
          );
          this.upperCanvasEl
            ? (this.upperCanvasEl.className = '')
            : (this.upperCanvasEl = this._createCanvasElement()),
            fabric.util.addClass(this.upperCanvasEl, 'upper-canvas ' + t),
            this.wrapperEl.appendChild(this.upperCanvasEl),
            this._copyCanvasStyle(this.lowerCanvasEl, this.upperCanvasEl),
            this._applyCanvasStyle(this.upperCanvasEl),
            (this.contextTop = this.upperCanvasEl.getContext('2d'));
        },
        _createCacheCanvas: function () {
          (this.cacheCanvasEl = this._createCanvasElement()),
            this.cacheCanvasEl.setAttribute('width', this.width),
            this.cacheCanvasEl.setAttribute('height', this.height),
            (this.contextCache = this.cacheCanvasEl.getContext('2d'));
        },
        _initWrapperElement: function () {
          (this.wrapperEl = fabric.util.wrapElement(this.lowerCanvasEl, 'div', {
            class: this.containerClass,
          })),
            fabric.util.setStyle(this.wrapperEl, {
              width: this.getWidth() + 'px',
              height: this.getHeight() + 'px',
              position: 'relative',
            }),
            fabric.util.makeElementUnselectable(this.wrapperEl);
        },
        _applyCanvasStyle: function (t) {
          var e = this.getWidth() || t.width,
            i = this.getHeight() || t.height;
          fabric.util.setStyle(t, {
            position: 'absolute',
            width: e + 'px',
            height: i + 'px',
            left: 0,
            top: 0,
            'touch-action': 'none',
          }),
            (t.width = e),
            (t.height = i),
            fabric.util.makeElementUnselectable(t);
        },
        _copyCanvasStyle: function (t, e) {
          e.style.cssText = t.style.cssText;
        },
        getSelectionContext: function () {
          return this.contextTop;
        },
        getSelectionElement: function () {
          return this.upperCanvasEl;
        },
        _setActiveObject: function (t) {
          var e = this._activeObject;
          e &&
            (e.set('active', !1),
            t !== e &&
              e.onDeselect &&
              'function' == typeof e.onDeselect &&
              e.onDeselect()),
            (this._activeObject = t).set('active', !0);
        },
        setActiveObject: function (t, e) {
          var i = this.getActiveObject();
          return (
            i && i !== t && i.fire('deselected', { e: e }),
            this._setActiveObject(t),
            this.fire('object:selected', { target: t, e: e }),
            t.fire('selected', { e: e }),
            this.renderAll(),
            this
          );
        },
        getActiveObject: function () {
          return this._activeObject;
        },
        _onObjectRemoved: function (t) {
          this.getActiveObject() === t &&
            (this.fire('before:selection:cleared', { target: t }),
            this._discardActiveObject(),
            this.fire('selection:cleared', { target: t }),
            t.fire('deselected')),
            this._hoveredTarget === t && (this._hoveredTarget = null),
            this.callSuper('_onObjectRemoved', t);
        },
        _discardActiveObject: function () {
          var t = this._activeObject;
          t &&
            (t.set('active', !1),
            t.onDeselect &&
              'function' == typeof t.onDeselect &&
              t.onDeselect()),
            (this._activeObject = null);
        },
        discardActiveObject: function (t) {
          var e = this._activeObject;
          return (
            e &&
              (this.fire('before:selection:cleared', { target: e, e: t }),
              this._discardActiveObject(),
              this.fire('selection:cleared', { e: t }),
              e.fire('deselected', { e: t })),
            this
          );
        },
        _setActiveGroup: function (t) {
          (this._activeGroup = t) && t.set('active', !0);
        },
        setActiveGroup: function (t, e) {
          return (
            this._setActiveGroup(t),
            t &&
              (this.fire('object:selected', { target: t, e: e }),
              t.fire('selected', { e: e })),
            this
          );
        },
        getActiveGroup: function () {
          return this._activeGroup;
        },
        _discardActiveGroup: function () {
          var t = this.getActiveGroup();
          t && t.destroy(), this.setActiveGroup(null);
        },
        discardActiveGroup: function (t) {
          var e = this.getActiveGroup();
          return (
            e &&
              (this.fire('before:selection:cleared', { e: t, target: e }),
              this._discardActiveGroup(),
              this.fire('selection:cleared', { e: t })),
            this
          );
        },
        deactivateAll: function () {
          for (var t, e = this.getObjects(), i = 0, r = e.length; i < r; i++)
            (t = e[i]) && t.set('active', !1);
          return this._discardActiveGroup(), this._discardActiveObject(), this;
        },
        deactivateAllWithDispatch: function (t) {
          for (var e, i = this.getObjects(), r = 0, n = i.length; r < n; r++)
            (e = i[r]) && e.set('active', !1);
          return this.discardActiveGroup(t), this.discardActiveObject(t), this;
        },
        dispose: function () {
          fabric.StaticCanvas.prototype.dispose.call(this);
          var t = this.wrapperEl;
          return (
            this.removeListeners(),
            t.removeChild(this.upperCanvasEl),
            t.removeChild(this.lowerCanvasEl),
            delete this.upperCanvasEl,
            t.parentNode &&
              t.parentNode.replaceChild(this.lowerCanvasEl, this.wrapperEl),
            delete this.wrapperEl,
            this
          );
        },
        clear: function () {
          return (
            this.discardActiveGroup(),
            this.discardActiveObject(),
            this.clearContext(this.contextTop),
            this.callSuper('clear')
          );
        },
        drawControls: function (t) {
          var e = this.getActiveGroup();
          e ? e._renderControls(t) : this._drawObjectsControls(t);
        },
        _drawObjectsControls: function (t) {
          for (var e = 0, i = this._objects.length; e < i; ++e)
            this._objects[e] &&
              this._objects[e].active &&
              this._objects[e]._renderControls(t);
        },
        _toObject: function (t, e, i) {
          var r = this._realizeGroupTransformOnObject(t),
            n = this.callSuper('_toObject', t, e, i);
          return this._unwindGroupTransformOnObject(t, r), n;
        },
        _realizeGroupTransformOnObject: function (e) {
          if (e.group && e.group === this.getActiveGroup()) {
            var i = {};
            return (
              [
                'angle',
                'flipX',
                'flipY',
                'left',
                'scaleX',
                'scaleY',
                'skewX',
                'skewY',
                'top',
              ].forEach(function (t) {
                i[t] = e[t];
              }),
              this.getActiveGroup().realizeTransform(e),
              i
            );
          }
          return null;
        },
        _unwindGroupTransformOnObject: function (t, e) {
          e && t.set(e);
        },
        _setSVGObject: function (t, e, i) {
          var r;
          (r = this._realizeGroupTransformOnObject(e)),
            this.callSuper('_setSVGObject', t, e, i),
            this._unwindGroupTransformOnObject(e, r);
        },
      }
    )),
    fabric.StaticCanvas))
      'prototype' !== t && (fabric.Canvas[t] = fabric.StaticCanvas[t]);
    fabric.isTouchSupported &&
      (fabric.Canvas.prototype._setCursorFromEvent = function () {}),
      (fabric.Element = fabric.Canvas);
  })(),
  (function () {
    var n = { mt: 0, tr: 1, mr: 2, br: 3, mb: 4, bl: 5, ml: 6, tl: 7 },
      i = fabric.util.addListener,
      r = fabric.util.removeListener;
    function a(t, e) {
      return 'which' in t ? t.which === e : t.button === e - 1;
    }
    fabric.util.object.extend(fabric.Canvas.prototype, {
      cursorMap: [
        'n-resize',
        'ne-resize',
        'e-resize',
        'se-resize',
        's-resize',
        'sw-resize',
        'w-resize',
        'nw-resize',
      ],
      _initEventListeners: function () {
        var t = {};
        (t = window.PointerEvent
          ? {
              down: 'pointerdown',
              up: 'pointerup',
              enter: 'pointerenter',
              leave: 'pointerleave',
              over: 'pointerover',
              out: 'pointerout',
              move: 'pointermove',
            }
          : window.MSPointerEvent && window.navigator.msPointerEnabled
          ? {
              down: 'MSPointerDown',
              up: 'MSPointerUp',
              enter: 'MSPointerEnter',
              leave: 'MSPointerLeave',
              over: 'MSPointerOver',
              out: 'MSPointerOut',
              move: 'MSPointerMove',
            }
          : {
              down: 'mousedown',
              up: 'mouseup',
              enter: 'mouseover',
              leave: 'mouseout',
              over: 'mouseover',
              out: 'mouseout',
              move: 'mousemove',
            }),
          (fabric.eventMapping = t),
          this.removeListeners(),
          this._bindEvents(),
          i(fabric.window, 'resize', this._onResize),
          i(this.upperCanvasEl, fabric.eventMapping.down, this._onMouseDown),
          i(this.upperCanvasEl, fabric.eventMapping.move, this._onMouseMove),
          i(this.upperCanvasEl, fabric.eventMapping.out, this._onMouseOut),
          i(this.upperCanvasEl, fabric.eventMapping.enter, this._onMouseEnter),
          i(this.upperCanvasEl, 'wheel', this._onMouseWheel),
          i(this.upperCanvasEl, 'contextmenu', this._onContextMenu),
          i(this.upperCanvasEl, 'touchstart', this._onMouseDown, {
            passive: !1,
          }),
          i(this.upperCanvasEl, 'touchmove', this._onMouseMove, {
            passive: !1,
          }),
          'undefined' != typeof eventjs &&
            'add' in eventjs &&
            (eventjs.add(this.upperCanvasEl, 'gesture', this._onGesture),
            eventjs.add(this.upperCanvasEl, 'drag', this._onDrag),
            eventjs.add(
              this.upperCanvasEl,
              'orientation',
              this._onOrientationChange
            ),
            eventjs.add(this.upperCanvasEl, 'shake', this._onShake),
            eventjs.add(this.upperCanvasEl, 'longpress', this._onLongPress));
      },
      _bindEvents: function () {
        this.eventsBinded ||
          ((this._onMouseDown = this._onMouseDown.bind(this)),
          (this._onMouseMove = this._onMouseMove.bind(this)),
          (this._onMouseUp = this._onMouseUp.bind(this)),
          (this._onResize = this._onResize.bind(this)),
          (this._onGesture = this._onGesture.bind(this)),
          (this._onDrag = this._onDrag.bind(this)),
          (this._onShake = this._onShake.bind(this)),
          (this._onLongPress = this._onLongPress.bind(this)),
          (this._onOrientationChange = this._onOrientationChange.bind(this)),
          (this._onMouseWheel = this._onMouseWheel.bind(this)),
          (this._onMouseOut = this._onMouseOut.bind(this)),
          (this._onMouseEnter = this._onMouseEnter.bind(this)),
          (this._onContextMenu = this._onContextMenu.bind(this)),
          (this.eventsBinded = !0));
      },
      removeListeners: function () {
        r(fabric.window, 'resize', this._onResize),
          r(this.upperCanvasEl, fabric.eventMapping.down, this._onMouseDown),
          r(this.upperCanvasEl, fabric.eventMapping.move, this._onMouseMove),
          r(this.upperCanvasEl, fabric.eventMapping.out, this._onMouseOut),
          r(this.upperCanvasEl, fabric.eventMapping.enter, this._onMouseEnter),
          r(this.upperCanvasEl, 'wheel', this._onMouseWheel),
          r(this.upperCanvasEl, 'contextmenu', this._onContextMenu),
          r(this.upperCanvasEl, 'touchstart', this._onMouseDown),
          r(this.upperCanvasEl, 'touchmove', this._onMouseMove),
          'undefined' != typeof eventjs &&
            'remove' in eventjs &&
            (eventjs.remove(this.upperCanvasEl, 'gesture', this._onGesture),
            eventjs.remove(this.upperCanvasEl, 'drag', this._onDrag),
            eventjs.remove(
              this.upperCanvasEl,
              'orientation',
              this._onOrientationChange
            ),
            eventjs.remove(this.upperCanvasEl, 'shake', this._onShake),
            eventjs.remove(this.upperCanvasEl, 'longpress', this._onLongPress));
      },
      _onGesture: function (t, e) {
        this.__onTransformGesture && this.__onTransformGesture(t, e);
      },
      _onDrag: function (t, e) {
        this.__onDrag && this.__onDrag(t, e);
      },
      _onMouseWheel: function (t) {
        this.__onMouseWheel(t);
      },
      _onMouseOut: function (t) {
        var e = this._hoveredTarget;
        this.fire('mouse:out', { target: e, e: t }),
          (this._hoveredTarget = null),
          e && e.fire(fabric.eventMapping.out, { e: t }),
          this._iTextInstances &&
            this._iTextInstances.forEach(function (t) {
              t.isEditing && t.hiddenTextarea.focus();
            });
      },
      _onMouseEnter: function (t) {
        this.findTarget(t) ||
          (this.fire('mouse:over', { target: null, e: t }),
          (this._hoveredTarget = null));
      },
      _onOrientationChange: function (t, e) {
        this.__onOrientationChange && this.__onOrientationChange(t, e);
      },
      _onShake: function (t, e) {
        this.__onShake && this.__onShake(t, e);
      },
      _onLongPress: function (t, e) {
        this.__onLongPress && this.__onLongPress(t, e);
      },
      _onContextMenu: function (t) {
        return (
          this.stopContextMenu && (t.stopPropagation(), t.preventDefault()), !1
        );
      },
      _onMouseDown: function (t) {
        this.__onMouseDown(t),
          i(fabric.document, 'touchend', this._onMouseUp, { passive: !1 }),
          i(fabric.document, 'touchmove', this._onMouseMove, { passive: !1 }),
          r(this.upperCanvasEl, fabric.eventMapping.move, this._onMouseMove),
          r(this.upperCanvasEl, 'touchmove', this._onMouseMove),
          'touchstart' === t.type
            ? r(this.upperCanvasEl, fabric.eventMapping.down, this._onMouseDown)
            : (i(fabric.document, fabric.eventMapping.up, this._onMouseUp),
              i(fabric.document, fabric.eventMapping.move, this._onMouseMove));
      },
      _onMouseUp: function (t) {
        if (
          (this.__onMouseUp(t),
          r(fabric.document, fabric.eventMapping.up, this._onMouseUp),
          r(fabric.document, 'touchend', this._onMouseUp),
          r(fabric.document, fabric.eventMapping.move, this._onMouseMove),
          r(fabric.document, 'touchmove', this._onMouseMove),
          i(this.upperCanvasEl, fabric.eventMapping.move, this._onMouseMove),
          i(this.upperCanvasEl, 'touchmove', this._onMouseMove, {
            passive: !1,
          }),
          'touchend' === t.type)
        ) {
          var e = this;
          setTimeout(function () {
            i(e.upperCanvasEl, fabric.eventMapping.down, e._onMouseDown);
          }, 400);
        }
      },
      _onMouseMove: function (t) {
        !this.allowTouchScrolling && t.preventDefault && t.preventDefault(),
          this.__onMouseMove(t);
      },
      _onResize: function () {
        this.calcOffset();
      },
      _shouldRender: function (t, e) {
        var i = this.getActiveGroup() || this.getActiveObject();
        return (
          (!i || !i.isEditing || t !== i) &&
          !!(
            (t && (t.isMoving || t !== i)) ||
            (!t && i) ||
            (!t && !i && !this._groupSelector) ||
            (e &&
              this._previousPointer &&
              this.selection &&
              (e.x !== this._previousPointer.x ||
                e.y !== this._previousPointer.y))
          )
        );
      },
      __onMouseUp: function (t) {
        var e;
        if (a(t, 3)) this.fireRightClick && this._handleEvent(t, 'up', e, 3);
        else if (a(t, 2))
          this.fireMiddleClick && this._handleEvent(t, 'up', e, 2);
        else if (this.isDrawingMode && this._isCurrentlyDrawing)
          this._onMouseUpInDrawingMode(t);
        else {
          var i = !0,
            r = this._currentTransform,
            n = this._groupSelector,
            s = !n || (0 === n.left && 0 === n.top);
          r && (this._finalizeCurrentTransform(t), (i = !r.actionPerformed)),
            (e = i ? this.findTarget(t, !0) : r.target);
          var o = this._shouldRender(e, this.getPointer(t));
          e || !s
            ? this._maybeGroupObjects(t)
            : ((this._groupSelector = null), (this._currentTransform = null)),
            e && (e.isMoving = !1),
            this._setCursorFromEvent(t, e),
            this._handleEvent(t, 'up', e || null, 1, s),
            e && (e.__corner = 0),
            o && this.renderAll();
        }
      },
      _handleEvent: function (t, e, i, r, n) {
        var s = void 0 === i ? this.findTarget(t) : i,
          o = this.targets || [],
          a = {
            e: t,
            target: s,
            subTargets: o,
            button: r || 1,
            isClick: n || !1,
          };
        this.fire('mouse:' + e, a), s && s.fire('mouse' + e, a);
        for (var h = 0; h < o.length; h++) o[h].fire('mouse' + e, a);
      },
      _finalizeCurrentTransform: function (t) {
        var e = this._currentTransform,
          i = e.target;
        i._scaling && (i._scaling = !1),
          i.setCoords(),
          this._restoreOriginXY(i),
          (e.actionPerformed || (this.stateful && i.hasStateChanged())) &&
            (this.fire('object:modified', { target: i, e: t }),
            i.fire('modified', { e: t }));
      },
      _restoreOriginXY: function (t) {
        if (this._previousOriginX && this._previousOriginY) {
          var e = t.translateToOriginPoint(
            t.getCenterPoint(),
            this._previousOriginX,
            this._previousOriginY
          );
          (t.originX = this._previousOriginX),
            (t.originY = this._previousOriginY),
            (t.left = e.x),
            (t.top = e.y),
            (this._previousOriginX = null),
            (this._previousOriginY = null);
        }
      },
      _onMouseDownInDrawingMode: function (t) {
        (this._isCurrentlyDrawing = !0),
          this.discardActiveObject(t).renderAll(),
          this.clipTo && fabric.util.clipContext(this, this.contextTop);
        var e = this.getPointer(t);
        this.freeDrawingBrush.onMouseDown(e), this._handleEvent(t, 'down');
      },
      _onMouseMoveInDrawingMode: function (t) {
        if (this._isCurrentlyDrawing) {
          var e = this.getPointer(t);
          this.freeDrawingBrush.onMouseMove(e);
        }
        this.setCursor(this.freeDrawingCursor), this._handleEvent(t, 'move');
      },
      _onMouseUpInDrawingMode: function (t) {
        (this._isCurrentlyDrawing = !1),
          this.clipTo && this.contextTop.restore(),
          this.freeDrawingBrush.onMouseUp(),
          this._handleEvent(t, 'up');
      },
      __onMouseDown: function (t) {
        var e = this.findTarget(t);
        if (a(t, 3))
          this.fireRightClick && this._handleEvent(t, 'down', e || null, 3);
        else if (a(t, 2))
          this.fireMiddleClick && this._handleEvent(t, 'down', e || null, 2);
        else if (this.isDrawingMode) this._onMouseDownInDrawingMode(t);
        else if (!this._currentTransform) {
          var i = this.getPointer(t, !0);
          this._previousPointer = i;
          var r = this._shouldRender(e, i),
            n = this._shouldGroup(t, e);
          if (
            (this._shouldClearSelection(t, e)
              ? this.deactivateAllWithDispatch(t)
              : n && (this._handleGrouping(t, e), (e = this.getActiveGroup())),
            !this.selection ||
              (e && (e.selectable || e.isEditing)) ||
              (this._groupSelector = { ex: i.x, ey: i.y, top: 0, left: 0 }),
            e)
          ) {
            !e.selectable ||
              (!e.__corner && n) ||
              (this._beforeTransform(t, e), this._setupCurrentTransform(t, e));
            var s = this.getActiveObject();
            e !== this.getActiveGroup() &&
              e !== s &&
              (this.deactivateAll(),
              e.selectable &&
                (s && s.fire('deselected', { e: t }),
                this.setActiveObject(e, t)));
          }
          this._handleEvent(t, 'down', e || null), r && this.renderAll();
        }
      },
      _beforeTransform: function (t, e) {
        this.stateful && e.saveState(),
          e._findTargetCorner(this.getPointer(t)) &&
            this.onBeforeScaleRotate(e);
      },
      _setOriginToCenter: function (t) {
        (this._previousOriginX = this._currentTransform.target.originX),
          (this._previousOriginY = this._currentTransform.target.originY);
        var e = t.getCenterPoint();
        (t.originX = 'center'),
          (t.originY = 'center'),
          (t.left = e.x),
          (t.top = e.y),
          (this._currentTransform.left = t.left),
          (this._currentTransform.top = t.top);
      },
      _setCenterToOrigin: function (t) {
        var e = t.translateToOriginPoint(
          t.getCenterPoint(),
          this._previousOriginX,
          this._previousOriginY
        );
        (t.originX = this._previousOriginX),
          (t.originY = this._previousOriginY),
          (t.left = e.x),
          (t.top = e.y),
          (this._previousOriginX = null),
          (this._previousOriginY = null);
      },
      __onMouseMove: function (t) {
        var e, i;
        if (this.isDrawingMode) this._onMouseMoveInDrawingMode(t);
        else if (!(void 0 !== t.touches && 1 < t.touches.length)) {
          var r = this._groupSelector;
          r
            ? ((i = this.getPointer(t, !0)),
              (r.left = i.x - r.ex),
              (r.top = i.y - r.ey),
              this.renderTop())
            : this._currentTransform
            ? this._transformObject(t)
            : ((e = this.findTarget(t)), this._setCursorFromEvent(t, e)),
            this._handleEvent(t, 'move', e || null);
        }
      },
      __onMouseWheel: function (t) {
        this._handleEvent(t, 'wheel');
      },
      _transformObject: function (t) {
        var e = this.getPointer(t),
          i = this._currentTransform;
        (i.reset = !1),
          (i.target.isMoving = !0),
          (i.shiftKey = t.shiftKey),
          (i.altKey = t[this.centeredKey]),
          this._beforeScaleTransform(t, i),
          this._performTransformAction(t, i, e),
          i.actionPerformed && this.renderAll();
      },
      _performTransformAction: function (t, e, i) {
        var r = i.x,
          n = i.y,
          s = e.target,
          o = e.action,
          a = !1;
        'rotate' === o
          ? (a = this._rotateObject(r, n)) && this._fire('rotating', s, t)
          : 'scale' === o
          ? (a = this._onScale(t, e, r, n)) && this._fire('scaling', s, t)
          : 'scaleX' === o
          ? (a = this._scaleObject(r, n, 'x')) && this._fire('scaling', s, t)
          : 'scaleY' === o
          ? (a = this._scaleObject(r, n, 'y')) && this._fire('scaling', s, t)
          : 'skewX' === o
          ? (a = this._skewObject(r, n, 'x')) && this._fire('skewing', s, t)
          : 'skewY' === o
          ? (a = this._skewObject(r, n, 'y')) && this._fire('skewing', s, t)
          : (a = this._translateObject(r, n)) &&
            (this._fire('moving', s, t),
            this.setCursor(s.moveCursor || this.moveCursor)),
          (e.actionPerformed = e.actionPerformed || a);
      },
      _fire: function (t, e, i) {
        this.fire('object:' + t, { target: e, e: i }), e.fire(t, { e: i });
      },
      _beforeScaleTransform: function (t, e) {
        if (
          'scale' === e.action ||
          'scaleX' === e.action ||
          'scaleY' === e.action
        ) {
          var i = this._shouldCenterTransform(e.target);
          ((i && ('center' !== e.originX || 'center' !== e.originY)) ||
            (!i && 'center' === e.originX && 'center' === e.originY)) &&
            (this._resetCurrentTransform(), (e.reset = !0));
        }
      },
      _onScale: function (t, e, i, r) {
        return (!t[this.uniScaleKey] && !this.uniScaleTransform) ||
          e.target.get('lockUniScaling')
          ? (e.reset ||
              'scale' !== e.currentAction ||
              this._resetCurrentTransform(),
            (e.currentAction = 'scaleEqually'),
            this._scaleObject(i, r, 'equally'))
          : ((e.currentAction = 'scale'), this._scaleObject(i, r));
      },
      _setCursorFromEvent: function (t, e) {
        if (!e) return this.setCursor(this.defaultCursor), !1;
        var i = e.hoverCursor || this.hoverCursor,
          r = this.getActiveGroup(),
          n =
            e._findTargetCorner &&
            (!r || !r.contains(e)) &&
            e._findTargetCorner(this.getPointer(t, !0));
        return n ? this._setCornerCursor(n, e, t) : this.setCursor(i), !0;
      },
      _setCornerCursor: function (t, e, i) {
        if (t in n) this.setCursor(this._getRotatedCornerCursor(t, e, i));
        else {
          if ('mtr' !== t || !e.hasRotatingPoint)
            return this.setCursor(this.defaultCursor), !1;
          this.setCursor(this.rotationCursor);
        }
      },
      _getRotatedCornerCursor: function (t, e, i) {
        var r = Math.round((e.getAngle() % 360) / 45);
        return (
          r < 0 && (r += 8),
          (r += n[t]),
          i[this.altActionKey] && n[t] % 2 == 0 && (r += 2),
          (r %= 8),
          this.cursorMap[r]
        );
      },
    });
  })(),
  (function () {
    var l = Math.min,
      u = Math.max;
    fabric.util.object.extend(fabric.Canvas.prototype, {
      _shouldGroup: function (t, e) {
        var i = this.getActiveObject();
        return (
          t[this.selectionKey] &&
          e &&
          e.selectable &&
          (this.getActiveGroup() || (i && i !== e)) &&
          this.selection
        );
      },
      _handleGrouping: function (t, e) {
        var i = this.getActiveGroup();
        (e === i && !(e = this.findTarget(t, !0))) ||
          (i ? this._updateActiveGroup(e, t) : this._createActiveGroup(e, t),
          this._activeGroup && this._activeGroup.saveCoords());
      },
      _updateActiveGroup: function (t, e) {
        var i = this.getActiveGroup();
        if (i.contains(t)) {
          if ((i.removeWithUpdate(t), t.set('active', !1), 1 === i.size()))
            return (
              this.discardActiveGroup(e),
              void this.setActiveObject(i.item(0), e)
            );
        } else i.addWithUpdate(t);
        this.fire('selection:created', { target: i, e: e }),
          i.set('active', !0);
      },
      _createActiveGroup: function (t, e) {
        if (this._activeObject && t !== this._activeObject) {
          var i = this._createGroup(t);
          i.addWithUpdate(),
            this.setActiveGroup(i, e),
            (this._activeObject = null),
            this.fire('selection:created', { target: i, e: e });
        }
        t.set('active', !0);
      },
      _createGroup: function (t) {
        var e = this.getObjects(),
          i =
            e.indexOf(this._activeObject) < e.indexOf(t)
              ? [this._activeObject, t]
              : [t, this._activeObject];
        return (
          this._activeObject.isEditing && this._activeObject.exitEditing(),
          new fabric.Group(i, { canvas: this })
        );
      },
      _groupSelectedObjects: function (t) {
        var e = this._collectObjects();
        1 === e.length
          ? this.setActiveObject(e[0], t)
          : 1 < e.length &&
            ((e = new fabric.Group(e.reverse(), {
              canvas: this,
            })).addWithUpdate(),
            this.setActiveGroup(e, t),
            e.saveCoords(),
            this.fire('selection:created', { target: e, e: t }),
            this.renderAll());
      },
      _collectObjects: function () {
        for (
          var t,
            e = [],
            i = this._groupSelector.ex,
            r = this._groupSelector.ey,
            n = i + this._groupSelector.left,
            s = r + this._groupSelector.top,
            o = new fabric.Point(l(i, n), l(r, s)),
            a = new fabric.Point(u(i, n), u(r, s)),
            h = i === n && r === s,
            c = this._objects.length;
          c-- &&
          !(
            (t = this._objects[c]) &&
            t.selectable &&
            t.visible &&
            (t.intersectsWithRect(o, a) ||
              t.isContainedWithinRect(o, a) ||
              t.containsPoint(o) ||
              t.containsPoint(a)) &&
            (t.set('active', !0), e.push(t), h)
          );

        );
        return e;
      },
      _maybeGroupObjects: function (t) {
        this.selection && this._groupSelector && this._groupSelectedObjects(t);
        var e = this.getActiveGroup();
        e &&
          (e.setObjectsCoords().setCoords(),
          (e.isMoving = !1),
          this.setCursor(this.defaultCursor)),
          (this._groupSelector = null),
          (this._currentTransform = null);
      },
    });
  })(),
  (function () {
    var r = fabric.StaticCanvas.supports('toDataURLWithQuality');
    fabric.util.object.extend(fabric.StaticCanvas.prototype, {
      toDataURL: function (t) {
        var e = (t = t || {}).format || 'png',
          i = t.quality || 1,
          r = t.multiplier || 1,
          n = {
            left: t.left || 0,
            top: t.top || 0,
            width: t.width || 0,
            height: t.height || 0,
          };
        return this.__toDataURLWithMultiplier(e, i, n, r);
      },
      __toDataURLWithMultiplier: function (t, e, i, r) {
        var n = this.getWidth(),
          s = this.getHeight(),
          o = (i.width || this.getWidth()) * r,
          a = (i.height || this.getHeight()) * r,
          h = this.getZoom() * r,
          c = this.viewportTransform,
          l = [h, 0, 0, h, (c[4] - i.left) * r, (c[5] - i.top) * r],
          u = this.interactive;
        (this.viewportTransform = l),
          this.interactive && (this.interactive = !1),
          n !== o || s !== a
            ? this.setDimensions({ width: o, height: a })
            : this.renderAll();
        var f = this.__toDataURL(t, e, i);
        return (
          u && (this.interactive = u),
          (this.viewportTransform = c),
          this.setDimensions({ width: n, height: s }),
          f
        );
      },
      __toDataURL: function (t, e) {
        var i = this.contextContainer.canvas;
        return (
          'jpg' === t && (t = 'jpeg'),
          r ? i.toDataURL('image/' + t, e) : i.toDataURL('image/' + t)
        );
      },
      toDataURLWithMultiplier: function (t, e, i) {
        return this.toDataURL({ format: t, multiplier: e, quality: i });
      },
    });
  })(),
  fabric.util.object.extend(fabric.StaticCanvas.prototype, {
    loadFromDatalessJSON: function (t, e, i) {
      return this.loadFromJSON(t, e, i);
    },
    loadFromJSON: function (t, e, i) {
      if (t) {
        var r =
            'string' == typeof t ? JSON.parse(t) : fabric.util.object.clone(t),
          n = this,
          s = this.renderOnAddRemove;
        return (
          (this.renderOnAddRemove = !1),
          this._enlivenObjects(
            r.objects,
            function (t) {
              n.clear(),
                n._setBgOverlay(r, function () {
                  t.forEach(function (t, e) {
                    n.insertAt(t, e);
                  }),
                    (n.renderOnAddRemove = s),
                    delete r.objects,
                    delete r.backgroundImage,
                    delete r.overlayImage,
                    delete r.background,
                    delete r.overlay,
                    n._setOptions(r),
                    n.renderAll(),
                    e && e();
                });
            },
            i
          ),
          this
        );
      }
    },
    _setBgOverlay: function (t, e) {
      var i = {
        backgroundColor: !1,
        overlayColor: !1,
        backgroundImage: !1,
        overlayImage: !1,
      };
      if (t.backgroundImage || t.overlayImage || t.background || t.overlay) {
        function r() {
          i.backgroundImage &&
            i.overlayImage &&
            i.backgroundColor &&
            i.overlayColor &&
            e &&
            e();
        }
        this.__setBgOverlay('backgroundImage', t.backgroundImage, i, r),
          this.__setBgOverlay('overlayImage', t.overlayImage, i, r),
          this.__setBgOverlay('backgroundColor', t.background, i, r),
          this.__setBgOverlay('overlayColor', t.overlay, i, r);
      } else e && e();
    },
    __setBgOverlay: function (e, t, i, r) {
      var n = this;
      if (!t) return (i[e] = !0), void (r && r());
      'backgroundImage' === e || 'overlayImage' === e
        ? fabric.util.enlivenObjects([t], function (t) {
            (n[e] = t[0]), (i[e] = !0), r && r();
          })
        : this['set' + fabric.util.string.capitalize(e, !0)](t, function () {
            (i[e] = !0), r && r();
          });
    },
    _enlivenObjects: function (t, e, i) {
      t && 0 !== t.length
        ? fabric.util.enlivenObjects(
            t,
            function (t) {
              e && e(t);
            },
            null,
            i
          )
        : e && e([]);
    },
    _toDataURL: function (e, i) {
      this.clone(function (t) {
        i(t.toDataURL(e));
      });
    },
    _toDataURLWithMultiplier: function (e, i, r) {
      this.clone(function (t) {
        r(t.toDataURLWithMultiplier(e, i));
      });
    },
    clone: function (e, t) {
      var i = JSON.stringify(this.toJSON(t));
      this.cloneWithoutData(function (t) {
        t.loadFromJSON(i, function () {
          e && e(t);
        });
      });
    },
    cloneWithoutData: function (t) {
      var e = fabric.document.createElement('canvas');
      (e.width = this.getWidth()), (e.height = this.getHeight());
      var i = new fabric.Canvas(e);
      (i.clipTo = this.clipTo),
        this.backgroundImage
          ? (i.setBackgroundImage(this.backgroundImage.src, function () {
              i.renderAll(), t && t(i);
            }),
            (i.backgroundImageOpacity = this.backgroundImageOpacity),
            (i.backgroundImageStretch = this.backgroundImageStretch))
          : t && t(i);
    },
  }),
  (function (t) {
    'use strict';
    var v = t.fabric || (t.fabric = {}),
      e = v.util.object.extend,
      a = v.util.object.clone,
      r = v.util.toFixed,
      i = v.util.string.capitalize,
      n = v.util.degreesToRadians,
      s = v.StaticCanvas.supports('setLineDash'),
      o = !v.isLikelyNode;
    v.Object ||
      ((v.Object = v.util.createClass(v.CommonMethods, {
        type: 'object',
        originX: 'left',
        originY: 'top',
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        scaleX: 1,
        scaleY: 1,
        flipX: !1,
        flipY: !1,
        opacity: 1,
        angle: 0,
        skewX: 0,
        skewY: 0,
        cornerSize: 13,
        transparentCorners: !0,
        hoverCursor: null,
        moveCursor: null,
        padding: 0,
        borderColor: 'rgba(102,153,255,0.75)',
        borderDashArray: null,
        cornerColor: 'rgba(102,153,255,0.5)',
        cornerStrokeColor: null,
        cornerStyle: 'rect',
        cornerDashArray: null,
        centeredScaling: !1,
        centeredRotation: !0,
        fill: 'rgb(0,0,0)',
        fillRule: 'nonzero',
        globalCompositeOperation: 'source-over',
        backgroundColor: '',
        selectionBackgroundColor: '',
        stroke: null,
        strokeWidth: 1,
        strokeDashArray: null,
        strokeLineCap: 'butt',
        strokeLineJoin: 'miter',
        strokeMiterLimit: 10,
        shadow: null,
        borderOpacityWhenMoving: 0.4,
        borderScaleFactor: 1,
        transformMatrix: null,
        minScaleLimit: 0.01,
        selectable: !0,
        evented: !0,
        visible: !0,
        hasControls: !0,
        hasBorders: !0,
        hasRotatingPoint: !0,
        rotatingPointOffset: 40,
        perPixelTargetFind: !1,
        includeDefaultValues: !0,
        clipTo: null,
        lockMovementX: !1,
        lockMovementY: !1,
        lockRotation: !1,
        lockScalingX: !1,
        lockScalingY: !1,
        lockUniScaling: !1,
        lockSkewingX: !1,
        lockSkewingY: !1,
        lockScalingFlip: !1,
        excludeFromExport: !1,
        objectCaching: o,
        statefullCache: !1,
        noScaleCache: !0,
        dirty: !0,
        stateProperties:
          'top left width height scaleX scaleY flipX flipY originX originY transformMatrix stroke strokeWidth strokeDashArray strokeLineCap strokeLineJoin strokeMiterLimit angle opacity fill globalCompositeOperation shadow clipTo visible backgroundColor skewX skewY fillRule'.split(
            ' '
          ),
        cacheProperties:
          'fill stroke strokeWidth strokeDashArray width height strokeLineCap strokeLineJoin strokeMiterLimit backgroundColor'.split(
            ' '
          ),
        initialize: function (t) {
          (t = t || {}) && this.setOptions(t);
        },
        _createCacheCanvas: function () {
          (this._cacheProperties = {}),
            (this._cacheCanvas = v.document.createElement('canvas')),
            (this._cacheContext = this._cacheCanvas.getContext('2d')),
            this._updateCacheCanvas();
        },
        _limitCacheSize: function (t) {
          var e = v.perfLimitSizeTotal,
            i = v.cacheSideLimit,
            r = t.width,
            n = t.height,
            s = r / n,
            o = v.util.limitDimsByArea(s, e, i),
            a = v.util.capValue,
            h = v.maxCacheSideLimit,
            c = v.minCacheSideLimit,
            l = a(c, o.x, h),
            u = a(c, o.y, h);
          return (
            l < r
              ? ((t.zoomX /= r / l), (t.width = l))
              : r < c && (t.width = c),
            u < n
              ? ((t.zoomY /= n / u), (t.height = u))
              : n < c && (t.height = c),
            t
          );
        },
        _getCacheCanvasDimensions: function () {
          var t = (this.canvas && this.canvas.getZoom()) || 1,
            e = this.getObjectScaling(),
            i = this._getNonTransformedDimensions(),
            r =
              this.canvas && this.canvas._isRetinaScaling()
                ? v.devicePixelRatio
                : 1,
            n = e.scaleX * t * r,
            s = e.scaleY * t * r;
          return {
            width: 2 + i.x * n,
            height: 2 + i.y * s,
            zoomX: n,
            zoomY: s,
          };
        },
        _updateCacheCanvas: function () {
          if (
            this.noScaleCache &&
            this.canvas &&
            this.canvas._currentTransform
          ) {
            var t = this.canvas._currentTransform.action;
            if (t.slice && 'scale' === t.slice(0, 5)) return !1;
          }
          var e = this._limitCacheSize(this._getCacheCanvasDimensions()),
            i = v.minCacheSideLimit,
            r = e.width,
            n = e.height,
            s = e.zoomX,
            o = e.zoomY,
            a = r !== this.cacheWidth || n !== this.cacheHeight,
            h = this.zoomX !== s || this.zoomY !== o,
            c = a || h,
            l = 0,
            u = 0,
            f = !1;
          if (a) {
            var d = this._cacheCanvas.width,
              g = this._cacheCanvas.height,
              p = d < r || g < n;
            (f = p || ((r < 0.9 * d || n < 0.9 * g) && i < d && i < g)),
              p && ((l = (0.1 * r) & -2), (u = (0.1 * n) & -2));
          }
          return (
            c &&
            (f
              ? ((this._cacheCanvas.width = Math.max(Math.ceil(r) + l, i)),
                (this._cacheCanvas.height = Math.max(Math.ceil(n) + u, i)),
                (this.cacheTranslationX = (r + l) / 2),
                (this.cacheTranslationY = (n + u) / 2))
              : (this._cacheContext.setTransform(1, 0, 0, 1, 0, 0),
                this._cacheContext.clearRect(
                  0,
                  0,
                  this._cacheCanvas.width,
                  this._cacheCanvas.height
                )),
            (this.cacheWidth = r),
            (this.cacheHeight = n),
            this._cacheContext.translate(
              this.cacheTranslationX,
              this.cacheTranslationY
            ),
            this._cacheContext.scale(s, o),
            (this.zoomX = s),
            (this.zoomY = o),
            !0)
          );
        },
        setOptions: function (t) {
          this._setOptions(t),
            this._initGradient(t.fill, 'fill'),
            this._initGradient(t.stroke, 'stroke'),
            this._initClipping(t),
            this._initPattern(t.fill, 'fill'),
            this._initPattern(t.stroke, 'stroke');
        },
        transform: function (t, e) {
          this.group &&
            !this.group._transformDone &&
            this.group === this.canvas._activeGroup &&
            this.group.transform(t);
          var i = e ? this._getLeftTopCoords() : this.getCenterPoint();
          t.translate(i.x, i.y),
            this.angle && t.rotate(n(this.angle)),
            t.scale(
              this.scaleX * (this.flipX ? -1 : 1),
              this.scaleY * (this.flipY ? -1 : 1)
            ),
            this.skewX && t.transform(1, 0, Math.tan(n(this.skewX)), 1, 0, 0),
            this.skewY && t.transform(1, Math.tan(n(this.skewY)), 0, 1, 0, 0);
        },
        toObject: function (t) {
          var e = v.Object.NUM_FRACTION_DIGITS,
            i = {
              type: this.type,
              originX: this.originX,
              originY: this.originY,
              left: r(this.left, e),
              top: r(this.top, e),
              width: r(this.width, e),
              height: r(this.height, e),
              fill:
                this.fill && this.fill.toObject
                  ? this.fill.toObject()
                  : this.fill,
              stroke:
                this.stroke && this.stroke.toObject
                  ? this.stroke.toObject()
                  : this.stroke,
              strokeWidth: r(this.strokeWidth, e),
              strokeDashArray: this.strokeDashArray
                ? this.strokeDashArray.concat()
                : this.strokeDashArray,
              strokeLineCap: this.strokeLineCap,
              strokeLineJoin: this.strokeLineJoin,
              strokeMiterLimit: r(this.strokeMiterLimit, e),
              scaleX: r(this.scaleX, e),
              scaleY: r(this.scaleY, e),
              angle: r(this.getAngle(), e),
              flipX: this.flipX,
              flipY: this.flipY,
              opacity: r(this.opacity, e),
              shadow:
                this.shadow && this.shadow.toObject
                  ? this.shadow.toObject()
                  : this.shadow,
              visible: this.visible,
              clipTo: this.clipTo && String(this.clipTo),
              backgroundColor: this.backgroundColor,
              fillRule: this.fillRule,
              globalCompositeOperation: this.globalCompositeOperation,
              transformMatrix: this.transformMatrix
                ? this.transformMatrix.concat()
                : null,
              skewX: r(this.skewX, e),
              skewY: r(this.skewY, e),
            };
          return (
            v.util.populateWithProperties(this, i, t),
            this.includeDefaultValues || (i = this._removeDefaultValues(i)),
            i
          );
        },
        toDatalessObject: function (t) {
          return this.toObject(t);
        },
        _removeDefaultValues: function (e) {
          var i = v.util.getKlass(e.type).prototype;
          return (
            i.stateProperties.forEach(function (t) {
              e[t] === i[t] && delete e[t],
                '[object Array]' === Object.prototype.toString.call(e[t]) &&
                  '[object Array]' === Object.prototype.toString.call(i[t]) &&
                  0 === e[t].length &&
                  0 === i[t].length &&
                  delete e[t];
            }),
            e
          );
        },
        toString: function () {
          return '#<fabric.' + i(this.type) + '>';
        },
        getObjectScaling: function () {
          var t = this.scaleX,
            e = this.scaleY;
          if (this.group) {
            var i = this.group.getObjectScaling();
            (t *= i.scaleX), (e *= i.scaleY);
          }
          return { scaleX: t, scaleY: e };
        },
        _set: function (t, e) {
          return (
            ('scaleX' === t || 'scaleY' === t) && (e = this._constrainScale(e)),
            'scaleX' === t && e < 0
              ? ((this.flipX = !this.flipX), (e *= -1))
              : 'scaleY' === t && e < 0
              ? ((this.flipY = !this.flipY), (e *= -1))
              : 'shadow' !== t || !e || e instanceof v.Shadow
              ? 'dirty' === t && this.group && this.group.set('dirty', e)
              : (e = new v.Shadow(e)),
            (this[t] = e),
            -1 < this.cacheProperties.indexOf(t) &&
              (this.group && this.group.set('dirty', !0), (this.dirty = !0)),
            this.group &&
              -1 < this.stateProperties.indexOf(t) &&
              this.group.set('dirty', !0),
            ('width' !== t && 'height' !== t) ||
              (this.minScaleLimit = Math.min(
                0.1,
                1 / Math.max(this.width, this.height)
              )),
            this
          );
        },
        setOnGroup: function () {},
        setSourcePath: function (t) {
          return (this.sourcePath = t), this;
        },
        getViewportTransform: function () {
          return this.canvas && this.canvas.viewportTransform
            ? this.canvas.viewportTransform
            : v.iMatrix.concat();
        },
        isNotVisible: function () {
          return (
            0 === this.opacity ||
            (0 === this.width && 0 === this.height) ||
            !this.visible
          );
        },
        render: function (t, e) {
          this.isNotVisible() ||
            (this.canvas &&
              this.canvas.skipOffscreen &&
              !this.group &&
              !this.isOnScreen()) ||
            (t.save(),
            this._setupCompositeOperation(t),
            this.drawSelectionBackground(t),
            e || this.transform(t),
            this._setOpacity(t),
            this._setShadow(t),
            this.transformMatrix && t.transform.apply(t, this.transformMatrix),
            this.clipTo && v.util.clipContext(this, t),
            this.shouldCache(e)
              ? (this._cacheCanvas || this._createCacheCanvas(),
                this.isCacheDirty(e) &&
                  (this.statefullCache &&
                    this.saveState({ propertySet: 'cacheProperties' }),
                  this.drawObject(this._cacheContext, e),
                  (this.dirty = !1)),
                this.drawCacheOnCanvas(t))
              : ((this.dirty = !1),
                this.drawObject(t, e),
                e &&
                  this.objectCaching &&
                  this.statefullCache &&
                  this.saveState({ propertySet: 'cacheProperties' })),
            this.clipTo && t.restore(),
            t.restore());
        },
        needsItsOwnCache: function () {
          return !1;
        },
        shouldCache: function (t) {
          return (
            !t &&
            this.objectCaching &&
            (!this.group || this.needsItsOwnCache() || !this.group.isCaching())
          );
        },
        willDrawShadow: function () {
          return (
            !!this.shadow &&
            (0 !== this.shadow.offsetX || 0 !== this.shadow.offsetY)
          );
        },
        drawObject: function (t, e) {
          this._renderBackground(t),
            this._setStrokeStyles(t),
            this._setFillStyles(t),
            this._render(t, e);
        },
        drawCacheOnCanvas: function (t) {
          t.scale(1 / this.zoomX, 1 / this.zoomY),
            t.drawImage(
              this._cacheCanvas,
              -this.cacheTranslationX,
              -this.cacheTranslationY
            );
        },
        isCacheDirty: function (t) {
          if (this.isNotVisible()) return !1;
          if (this._cacheCanvas && !t && this._updateCacheCanvas()) return !0;
          if (
            this.dirty ||
            (this.statefullCache && this.hasStateChanged('cacheProperties'))
          ) {
            if (this._cacheCanvas && !t) {
              var e = this.cacheWidth / this.zoomX,
                i = this.cacheHeight / this.zoomY;
              this._cacheContext.clearRect(-e / 2, -i / 2, e, i);
            }
            return !0;
          }
          return !1;
        },
        _renderBackground: function (t) {
          if (this.backgroundColor) {
            var e = this._getNonTransformedDimensions();
            (t.fillStyle = this.backgroundColor),
              t.fillRect(-e.x / 2, -e.y / 2, e.x, e.y),
              this._removeShadow(t);
          }
        },
        _setOpacity: function (t) {
          t.globalAlpha *= this.opacity;
        },
        _setStrokeStyles: function (t) {
          this.stroke &&
            ((t.lineWidth = this.strokeWidth),
            (t.lineCap = this.strokeLineCap),
            (t.lineJoin = this.strokeLineJoin),
            (t.miterLimit = this.strokeMiterLimit),
            (t.strokeStyle = this.stroke.toLive
              ? this.stroke.toLive(t, this)
              : this.stroke));
        },
        _setFillStyles: function (t) {
          this.fill &&
            (t.fillStyle = this.fill.toLive
              ? this.fill.toLive(t, this)
              : this.fill);
        },
        _setLineDash: function (t, e, i) {
          e &&
            (1 & e.length && e.push.apply(e, e),
            s ? t.setLineDash(e) : i && i(t));
        },
        _renderControls: function (t) {
          if (
            this.active &&
            (!this.group || this.group === this.canvas.getActiveGroup())
          ) {
            var e,
              i = this.getViewportTransform(),
              r = this.calcTransformMatrix();
            (r = v.util.multiplyTransformMatrices(i, r)),
              (e = v.util.qrDecompose(r)),
              t.save(),
              t.translate(e.translateX, e.translateY),
              (t.lineWidth = 1 * this.borderScaleFactor),
              this.group ||
                (t.globalAlpha = this.isMoving
                  ? this.borderOpacityWhenMoving
                  : 1),
              this.group && this.group === this.canvas.getActiveGroup()
                ? (t.rotate(n(e.angle)), this.drawBordersInGroup(t, e))
                : (t.rotate(n(this.angle)), this.drawBorders(t)),
              this.drawControls(t),
              t.restore();
          }
        },
        _setShadow: function (t) {
          if (this.shadow) {
            var e = (this.canvas && this.canvas.viewportTransform[0]) || 1,
              i = (this.canvas && this.canvas.viewportTransform[3]) || 1,
              r = this.getObjectScaling();
            this.canvas &&
              this.canvas._isRetinaScaling() &&
              ((e *= v.devicePixelRatio), (i *= v.devicePixelRatio)),
              (t.shadowColor = this.shadow.color),
              (t.shadowBlur =
                (this.shadow.blur * (e + i) * (r.scaleX + r.scaleY)) / 4),
              (t.shadowOffsetX = this.shadow.offsetX * e * r.scaleX),
              (t.shadowOffsetY = this.shadow.offsetY * i * r.scaleY);
          }
        },
        _removeShadow: function (t) {
          this.shadow &&
            ((t.shadowColor = ''),
            (t.shadowBlur = t.shadowOffsetX = t.shadowOffsetY = 0));
        },
        _applyPatternGradientTransform: function (t, e) {
          if (e.toLive) {
            var i = e.gradientTransform || e.patternTransform;
            i && t.transform.apply(t, i);
            var r = -this.width / 2 + e.offsetX || 0,
              n = -this.height / 2 + e.offsetY || 0;
            t.translate(r, n);
          }
        },
        _renderFill: function (t) {
          this.fill &&
            (t.save(),
            this._applyPatternGradientTransform(t, this.fill),
            'evenodd' === this.fillRule ? t.fill('evenodd') : t.fill(),
            t.restore());
        },
        _renderStroke: function (t) {
          this.stroke &&
            0 !== this.strokeWidth &&
            (this.shadow && !this.shadow.affectStroke && this._removeShadow(t),
            t.save(),
            this._setLineDash(
              t,
              this.strokeDashArray,
              this._renderDashedStroke
            ),
            this._applyPatternGradientTransform(t, this.stroke),
            t.stroke(),
            t.restore());
        },
        clone: function (t, e) {
          return this.constructor.fromObject
            ? this.constructor.fromObject(this.toObject(e), t)
            : new v.Object(this.toObject(e));
        },
        cloneAsImage: function (e, t) {
          var i = this.toDataURL(t);
          return (
            v.util.loadImage(i, function (t) {
              e && e(new v.Image(t));
            }),
            this
          );
        },
        toDataURL: function (t) {
          t = t || {};
          var e = v.util.createCanvasElement(),
            i = this.getBoundingRect();
          (e.width = i.width),
            (e.height = i.height),
            v.util.wrapElement(e, 'div');
          var r = new v.StaticCanvas(e, {
            enableRetinaScaling: t.enableRetinaScaling,
          });
          'jpg' === t.format && (t.format = 'jpeg'),
            'jpeg' === t.format && (r.backgroundColor = '#fff');
          var n = {
            active: this.get('active'),
            left: this.getLeft(),
            top: this.getTop(),
          };
          this.set('active', !1),
            this.setPositionByOrigin(
              new v.Point(r.getWidth() / 2, r.getHeight() / 2),
              'center',
              'center'
            );
          var s = this.canvas;
          r.add(this);
          var o = r.toDataURL(t);
          return (
            this.set(n).setCoords(),
            (this.canvas = s),
            r.dispose(),
            (r = null),
            o
          );
        },
        isType: function (t) {
          return this.type === t;
        },
        complexity: function () {
          return 1;
        },
        toJSON: function (t) {
          return this.toObject(t);
        },
        setGradient: function (t, e) {
          e = e || {};
          var i = { colorStops: [] };
          return (
            (i.type = e.type || (e.r1 || e.r2 ? 'radial' : 'linear')),
            (i.coords = { x1: e.x1, y1: e.y1, x2: e.x2, y2: e.y2 }),
            (e.r1 || e.r2) && ((i.coords.r1 = e.r1), (i.coords.r2 = e.r2)),
            (i.gradientTransform = e.gradientTransform),
            v.Gradient.prototype.addColorStop.call(i, e.colorStops),
            this.set(t, v.Gradient.forObject(this, i))
          );
        },
        setPatternFill: function (t) {
          return this.set('fill', new v.Pattern(t));
        },
        setShadow: function (t) {
          return this.set('shadow', t ? new v.Shadow(t) : null);
        },
        setColor: function (t) {
          return this.set('fill', t), this;
        },
        setAngle: function (t) {
          var e =
            ('center' !== this.originX || 'center' !== this.originY) &&
            this.centeredRotation;
          return (
            e && this._setOriginToCenter(),
            this.set('angle', t),
            e && this._resetOrigin(),
            this
          );
        },
        centerH: function () {
          return this.canvas && this.canvas.centerObjectH(this), this;
        },
        viewportCenterH: function () {
          return this.canvas && this.canvas.viewportCenterObjectH(this), this;
        },
        centerV: function () {
          return this.canvas && this.canvas.centerObjectV(this), this;
        },
        viewportCenterV: function () {
          return this.canvas && this.canvas.viewportCenterObjectV(this), this;
        },
        center: function () {
          return this.canvas && this.canvas.centerObject(this), this;
        },
        viewportCenter: function () {
          return this.canvas && this.canvas.viewportCenterObject(this), this;
        },
        remove: function () {
          return (
            this.canvas &&
              (this.group &&
                this.group === this.canvas._activeGroup &&
                this.group.remove(this),
              this.canvas.remove(this)),
            this
          );
        },
        getLocalPointer: function (t, e) {
          e = e || this.canvas.getPointer(t);
          var i = new v.Point(e.x, e.y),
            r = this._getLeftTopCoords();
          return (
            this.angle && (i = v.util.rotatePoint(i, r, n(-this.angle))),
            { x: i.x - r.x, y: i.y - r.y }
          );
        },
        _setupCompositeOperation: function (t) {
          this.globalCompositeOperation &&
            (t.globalCompositeOperation = this.globalCompositeOperation);
        },
      })),
      v.util.createAccessors(v.Object),
      (v.Object.prototype.rotate = v.Object.prototype.setAngle),
      e(v.Object.prototype, v.Observable),
      (v.Object.NUM_FRACTION_DIGITS = 2),
      (v.Object._fromObject = function (t, i, r, e, n) {
        var s = v[t];
        if (((i = a(i, !0)), !e)) {
          var o = n ? new s(i[n], i) : new s(i);
          return r && r(o), o;
        }
        v.util.enlivenPatterns([i.fill, i.stroke], function (t) {
          void 0 !== t[0] && (i.fill = t[0]),
            void 0 !== t[1] && (i.stroke = t[1]);
          var e = n ? new s(i[n], i) : new s(i);
          r && r(e);
        });
      }),
      (v.Object.__uid = 0));
  })('undefined' != typeof exports ? exports : this),
  (function () {
    var a = fabric.util.degreesToRadians,
      l = { left: -0.5, center: 0, right: 0.5 },
      u = { top: -0.5, center: 0, bottom: 0.5 };
    fabric.util.object.extend(fabric.Object.prototype, {
      translateToGivenOrigin: function (t, e, i, r, n) {
        var s,
          o,
          a,
          h = t.x,
          c = t.y;
        return (
          'string' == typeof e ? (e = l[e]) : (e -= 0.5),
          'string' == typeof r ? (r = l[r]) : (r -= 0.5),
          'string' == typeof i ? (i = u[i]) : (i -= 0.5),
          'string' == typeof n ? (n = u[n]) : (n -= 0.5),
          (o = n - i),
          ((s = r - e) || o) &&
            ((a = this._getTransformedDimensions()),
            (h = t.x + s * a.x),
            (c = t.y + o * a.y)),
          new fabric.Point(h, c)
        );
      },
      translateToCenterPoint: function (t, e, i) {
        var r = this.translateToGivenOrigin(t, e, i, 'center', 'center');
        return this.angle ? fabric.util.rotatePoint(r, t, a(this.angle)) : r;
      },
      translateToOriginPoint: function (t, e, i) {
        var r = this.translateToGivenOrigin(t, 'center', 'center', e, i);
        return this.angle ? fabric.util.rotatePoint(r, t, a(this.angle)) : r;
      },
      getCenterPoint: function () {
        var t = new fabric.Point(this.left, this.top);
        return this.translateToCenterPoint(t, this.originX, this.originY);
      },
      getPointByOrigin: function (t, e) {
        var i = this.getCenterPoint();
        return this.translateToOriginPoint(i, t, e);
      },
      toLocalPoint: function (t, e, i) {
        var r,
          n,
          s = this.getCenterPoint();
        return (
          (r =
            void 0 !== e && void 0 !== i
              ? this.translateToGivenOrigin(s, 'center', 'center', e, i)
              : new fabric.Point(this.left, this.top)),
          (n = new fabric.Point(t.x, t.y)),
          this.angle && (n = fabric.util.rotatePoint(n, s, -a(this.angle))),
          n.subtractEquals(r)
        );
      },
      setPositionByOrigin: function (t, e, i) {
        var r = this.translateToCenterPoint(t, e, i),
          n = this.translateToOriginPoint(r, this.originX, this.originY);
        this.set('left', n.x), this.set('top', n.y);
      },
      adjustPosition: function (t) {
        var e,
          i,
          r = a(this.angle),
          n = this.getWidth(),
          s = Math.cos(r) * n,
          o = Math.sin(r) * n;
        (e =
          'string' == typeof this.originX
            ? l[this.originX]
            : this.originX - 0.5),
          (i = 'string' == typeof t ? l[t] : t - 0.5),
          (this.left += s * (i - e)),
          (this.top += o * (i - e)),
          this.setCoords(),
          (this.originX = t);
      },
      _setOriginToCenter: function () {
        (this._originalOriginX = this.originX),
          (this._originalOriginY = this.originY);
        var t = this.getCenterPoint();
        (this.originX = 'center'),
          (this.originY = 'center'),
          (this.left = t.x),
          (this.top = t.y);
      },
      _resetOrigin: function () {
        var t = this.translateToOriginPoint(
          this.getCenterPoint(),
          this._originalOriginX,
          this._originalOriginY
        );
        (this.originX = this._originalOriginX),
          (this.originY = this._originalOriginY),
          (this.left = t.x),
          (this.top = t.y),
          (this._originalOriginX = null),
          (this._originalOriginY = null);
      },
      _getLeftTopCoords: function () {
        return this.translateToOriginPoint(
          this.getCenterPoint(),
          'left',
          'top'
        );
      },
      onDeselect: function () {},
    });
  })(),
  (function () {
    var S = fabric.util.degreesToRadians,
      o = fabric.util.multiplyTransformMatrices;
    fabric.util.object.extend(fabric.Object.prototype, {
      oCoords: null,
      aCoords: null,
      getCoords: function (t, e) {
        this.oCoords || this.setCoords();
        var i,
          r = t ? this.aCoords : this.oCoords;
        return (
          (i = e ? this.calcCoords(t) : r),
          [
            new fabric.Point(i.tl.x, i.tl.y),
            new fabric.Point(i.tr.x, i.tr.y),
            new fabric.Point(i.br.x, i.br.y),
            new fabric.Point(i.bl.x, i.bl.y),
          ]
        );
      },
      intersectsWithRect: function (t, e, i, r) {
        var n = this.getCoords(i, r);
        return (
          'Intersection' ===
          fabric.Intersection.intersectPolygonRectangle(n, t, e).status
        );
      },
      intersectsWithObject: function (t, e, i) {
        return (
          'Intersection' ===
            fabric.Intersection.intersectPolygonPolygon(
              this.getCoords(e, i),
              t.getCoords(e, i)
            ).status ||
          t.isContainedWithinObject(this, e, i) ||
          this.isContainedWithinObject(t, e, i)
        );
      },
      isContainedWithinObject: function (t, e, i) {
        for (
          var r = this.getCoords(e, i),
            n = 0,
            s = t._getImageLines(
              i ? t.calcCoords(e) : e ? t.aCoords : t.oCoords
            );
          n < 4;
          n++
        )
          if (!t.containsPoint(r[n], s)) return !1;
        return !0;
      },
      isContainedWithinRect: function (t, e, i, r) {
        var n = this.getBoundingRect(i, r);
        return (
          n.left >= t.x &&
          n.left + n.width <= e.x &&
          n.top >= t.y &&
          n.top + n.height <= e.y
        );
      },
      containsPoint: function (t, e, i, r) {
        e =
          e ||
          this._getImageLines(
            r ? this.calcCoords(i) : i ? this.aCoords : this.oCoords
          );
        var n = this._findCrossPoints(t, e);
        return 0 !== n && n % 2 == 1;
      },
      isOnScreen: function (t) {
        if (!this.canvas) return !1;
        for (
          var e,
            i = this.canvas.vptCoords.tl,
            r = this.canvas.vptCoords.br,
            n = this.getCoords(!0, t),
            s = 0;
          s < 4;
          s++
        )
          if ((e = n[s]).x <= r.x && e.x >= i.x && e.y <= r.y && e.y >= i.y)
            return !0;
        if (this.intersectsWithRect(i, r, !0)) return !0;
        var o = { x: (i.x + r.x) / 2, y: (i.y + r.y) / 2 };
        return !!this.containsPoint(o, null, !0);
      },
      _getImageLines: function (t) {
        return {
          topline: { o: t.tl, d: t.tr },
          rightline: { o: t.tr, d: t.br },
          bottomline: { o: t.br, d: t.bl },
          leftline: { o: t.bl, d: t.tl },
        };
      },
      _findCrossPoints: function (t, e) {
        var i,
          r,
          n = 0;
        for (var s in e)
          if (
            !(
              ((r = e[s]).o.y < t.y && r.d.y < t.y) ||
              (r.o.y >= t.y && r.d.y >= t.y) ||
              ((r.o.x === r.d.x && r.o.x >= t.x
                ? r.o.x
                : ((i = (r.d.y - r.o.y) / (r.d.x - r.o.x)),
                  -(t.y - 0 * t.x - (r.o.y - i * r.o.x)) / (0 - i))) >= t.x &&
                (n += 1),
              2 !== n)
            )
          )
            break;
        return n;
      },
      getBoundingRectWidth: function () {
        return this.getBoundingRect().width;
      },
      getBoundingRectHeight: function () {
        return this.getBoundingRect().height;
      },
      getBoundingRect: function (t, e) {
        var i = this.getCoords(t, e);
        return fabric.util.makeBoundingBoxFromPoints(i);
      },
      getWidth: function () {
        return this._getTransformedDimensions().x;
      },
      getHeight: function () {
        return this._getTransformedDimensions().y;
      },
      _constrainScale: function (t) {
        return Math.abs(t) < this.minScaleLimit
          ? t < 0
            ? -this.minScaleLimit
            : this.minScaleLimit
          : t;
      },
      scale: function (t) {
        return (
          (t = this._constrainScale(t)) < 0 &&
            ((this.flipX = !this.flipX), (this.flipY = !this.flipY), (t *= -1)),
          (this.scaleX = t),
          (this.scaleY = t),
          this.setCoords()
        );
      },
      scaleToWidth: function (t) {
        var e = this.getBoundingRect().width / this.getWidth();
        return this.scale(t / this.width / e);
      },
      scaleToHeight: function (t) {
        var e = this.getBoundingRect().height / this.getHeight();
        return this.scale(t / this.height / e);
      },
      calcCoords: function (t) {
        var e = S(this.angle),
          i = this.getViewportTransform(),
          r = t
            ? this._getTransformedDimensions()
            : this._calculateCurrentDimensions(),
          n = r.x,
          s = r.y,
          o = Math.sin(e),
          a = Math.cos(e),
          h = 0 < n ? Math.atan(s / n) : 0,
          c = n / Math.cos(h) / 2,
          l = Math.cos(h + e) * c,
          u = Math.sin(h + e) * c,
          f = this.getCenterPoint(),
          d = t ? f : fabric.util.transformPoint(f, i),
          g = new fabric.Point(d.x - l, d.y - u),
          p = new fabric.Point(g.x + n * a, g.y + n * o),
          v = new fabric.Point(g.x - s * o, g.y + s * a),
          b = new fabric.Point(d.x + l, d.y + u);
        if (!t)
          var m = new fabric.Point((g.x + v.x) / 2, (g.y + v.y) / 2),
            _ = new fabric.Point((p.x + g.x) / 2, (p.y + g.y) / 2),
            y = new fabric.Point((b.x + p.x) / 2, (b.y + p.y) / 2),
            x = new fabric.Point((b.x + v.x) / 2, (b.y + v.y) / 2),
            C = new fabric.Point(
              _.x + o * this.rotatingPointOffset,
              _.y - a * this.rotatingPointOffset
            );
        d = { tl: g, tr: p, br: b, bl: v };
        return (
          t || ((d.ml = m), (d.mt = _), (d.mr = y), (d.mb = x), (d.mtr = C)), d
        );
      },
      setCoords: function (t, e) {
        return (
          (this.oCoords = this.calcCoords(t)),
          e || (this.aCoords = this.calcCoords(!0)),
          t || (this._setCornerCoords && this._setCornerCoords()),
          this
        );
      },
      _calcRotateMatrix: function () {
        if (this.angle) {
          var t = S(this.angle),
            e = Math.cos(t),
            i = Math.sin(t);
          return (
            (6123233995736766e-32 !== e && -18369701987210297e-32 !== e) ||
              (e = 0),
            [e, i, -i, e, 0, 0]
          );
        }
        return fabric.iMatrix.concat();
      },
      calcTransformMatrix: function (t) {
        var e,
          i,
          r = this.getCenterPoint(),
          n = [1, 0, 0, 1, r.x, r.y],
          s = this._calcDimensionsTransformMatrix(this.skewX, this.skewY, !0);
        return (
          (i = this.group && !t ? o(this.group.calcTransformMatrix(), n) : n),
          this.angle && ((e = this._calcRotateMatrix()), (i = o(i, e))),
          (i = o(i, s))
        );
      },
      _calcDimensionsTransformMatrix: function (t, e, i) {
        var r,
          n = [
            this.scaleX * (i && this.flipX ? -1 : 1),
            0,
            0,
            this.scaleY * (i && this.flipY ? -1 : 1),
            0,
            0,
          ];
        return (
          t && ((r = [1, 0, Math.tan(S(t)), 1]), (n = o(n, r, !0))),
          e && ((r = [1, Math.tan(S(e)), 0, 1]), (n = o(n, r, !0))),
          n
        );
      },
      _getNonTransformedDimensions: function () {
        var t = this.strokeWidth;
        return { x: this.width + t, y: this.height + t };
      },
      _getTransformedDimensions: function (t, e) {
        void 0 === t && (t = this.skewX), void 0 === e && (e = this.skewY);
        var i,
          r,
          n = this._getNonTransformedDimensions(),
          s = n.x / 2,
          o = n.y / 2,
          a = [
            { x: -s, y: -o },
            { x: s, y: -o },
            { x: -s, y: o },
            { x: s, y: o },
          ],
          h = this._calcDimensionsTransformMatrix(t, e, !1);
        for (i = 0; i < a.length; i++)
          a[i] = fabric.util.transformPoint(a[i], h);
        return {
          x: (r = fabric.util.makeBoundingBoxFromPoints(a)).width,
          y: r.height,
        };
      },
      _calculateCurrentDimensions: function () {
        var t = this.getViewportTransform(),
          e = this._getTransformedDimensions();
        return fabric.util.transformPoint(e, t, !0).scalarAdd(2 * this.padding);
      },
    });
  })(),
  fabric.util.object.extend(fabric.Object.prototype, {
    sendToBack: function () {
      return (
        this.group
          ? fabric.StaticCanvas.prototype.sendToBack.call(this.group, this)
          : this.canvas.sendToBack(this),
        this
      );
    },
    bringToFront: function () {
      return (
        this.group
          ? fabric.StaticCanvas.prototype.bringToFront.call(this.group, this)
          : this.canvas.bringToFront(this),
        this
      );
    },
    sendBackwards: function (t) {
      return (
        this.group
          ? fabric.StaticCanvas.prototype.sendBackwards.call(
              this.group,
              this,
              t
            )
          : this.canvas.sendBackwards(this, t),
        this
      );
    },
    bringForward: function (t) {
      return (
        this.group
          ? fabric.StaticCanvas.prototype.bringForward.call(this.group, this, t)
          : this.canvas.bringForward(this, t),
        this
      );
    },
    moveTo: function (t) {
      return (
        this.group
          ? fabric.StaticCanvas.prototype.moveTo.call(this.group, this, t)
          : this.canvas.moveTo(this, t),
        this
      );
    },
  }),
  (function () {
    function u(t, e) {
      if (e) {
        if (e.toLive) return t + ': url(#SVGID_' + e.id + '); ';
        var i = new fabric.Color(e),
          r = t + ': ' + i.toRgb() + '; ',
          n = i.getAlpha();
        return 1 !== n && (r += t + '-opacity: ' + n.toString() + '; '), r;
      }
      return t + ': none; ';
    }
    fabric.util.object.extend(fabric.Object.prototype, {
      getSvgStyles: function (t) {
        var e = this.fillRule,
          i = this.strokeWidth ? this.strokeWidth : '0',
          r = this.strokeDashArray ? this.strokeDashArray.join(' ') : 'none',
          n = this.strokeLineCap ? this.strokeLineCap : 'butt',
          s = this.strokeLineJoin ? this.strokeLineJoin : 'miter',
          o = this.strokeMiterLimit ? this.strokeMiterLimit : '4',
          a = void 0 !== this.opacity ? this.opacity : '1',
          h = this.visible ? '' : ' visibility: hidden;',
          c = t ? '' : this.getSvgFilter(),
          l = u('fill', this.fill);
        return [
          u('stroke', this.stroke),
          'stroke-width: ',
          i,
          '; ',
          'stroke-dasharray: ',
          r,
          '; ',
          'stroke-linecap: ',
          n,
          '; ',
          'stroke-linejoin: ',
          s,
          '; ',
          'stroke-miterlimit: ',
          o,
          '; ',
          l,
          'fill-rule: ',
          e,
          '; ',
          'opacity: ',
          a,
          ';',
          c,
          h,
        ].join('');
      },
      getSvgFilter: function () {
        return this.shadow ? 'filter: url(#SVGID_' + this.shadow.id + ');' : '';
      },
      getSvgId: function () {
        return this.id ? 'id="' + this.id + '" ' : '';
      },
      getSvgTransform: function () {
        if (this.group && 'path-group' === this.group.type) return '';
        var t = fabric.util.toFixed,
          e = this.getAngle(),
          i = this.getSkewX() % 360,
          r = this.getSkewY() % 360,
          n = this.getCenterPoint(),
          s = fabric.Object.NUM_FRACTION_DIGITS,
          o =
            'path-group' === this.type
              ? ''
              : 'translate(' + t(n.x, s) + ' ' + t(n.y, s) + ')',
          a = 0 !== e ? ' rotate(' + t(e, s) + ')' : '',
          h =
            1 === this.scaleX && 1 === this.scaleY
              ? ''
              : ' scale(' + t(this.scaleX, s) + ' ' + t(this.scaleY, s) + ')',
          c = 0 != i ? ' skewX(' + t(i, s) + ')' : '',
          l = 0 != r ? ' skewY(' + t(r, s) + ')' : '',
          u = 'path-group' === this.type ? this.width : 0,
          f = this.flipX ? ' matrix(-1 0 0 1 ' + u + ' 0) ' : '',
          d = 'path-group' === this.type ? this.height : 0;
        return [
          o,
          a,
          h,
          f,
          this.flipY ? ' matrix(1 0 0 -1 0 ' + d + ')' : '',
          c,
          l,
        ].join('');
      },
      getSvgTransformMatrix: function () {
        return this.transformMatrix
          ? ' matrix(' + this.transformMatrix.join(' ') + ') '
          : '';
      },
      _createBaseSVGMarkup: function () {
        var t = [];
        return (
          this.fill && this.fill.toLive && t.push(this.fill.toSVG(this, !1)),
          this.stroke &&
            this.stroke.toLive &&
            t.push(this.stroke.toSVG(this, !1)),
          this.shadow && t.push(this.shadow.toSVG(this)),
          t
        );
      },
    });
  })(),
  (function () {
    var n = fabric.util.object.extend,
      r = 'stateProperties';
    function s(e, t, i) {
      var r = {};
      i.forEach(function (t) {
        r[t] = e[t];
      }),
        n(e[t], r, !0);
    }
    fabric.util.object.extend(fabric.Object.prototype, {
      hasStateChanged: function (t) {
        var e = '_' + (t = t || r);
        return (
          Object.keys(this[e]).length < this[t].length ||
          !(function t(e, i, r) {
            if (e === i) return !0;
            if (Array.isArray(e)) {
              if (e.length !== i.length) return !1;
              for (var n = 0, s = e.length; n < s; n++)
                if (!t(e[n], i[n])) return !1;
              return !0;
            }
            if (e && 'object' == typeof e) {
              var o,
                a = Object.keys(e);
              if (!r && a.length !== Object.keys(i).length) return !1;
              for (n = 0, s = a.length; n < s; n++)
                if (!t(e[(o = a[n])], i[o])) return !1;
              return !0;
            }
          })(this[e], this, !0)
        );
      },
      saveState: function (t) {
        var e = (t && t.propertySet) || r,
          i = '_' + e;
        return this[i]
          ? (s(this, i, this[e]),
            t && t.stateProperties && s(this, i, t.stateProperties),
            this)
          : this.setupState(t);
      },
      setupState: function (t) {
        var e = (t = t || {}).propertySet || r;
        return (this['_' + (t.propertySet = e)] = {}), this.saveState(t), this;
      },
    });
  })(),
  (function () {
    var h = fabric.util.degreesToRadians;
    fabric.util.object.extend(fabric.Object.prototype, {
      _controlsVisibility: null,
      _findTargetCorner: function (t) {
        if (!this.hasControls || !this.active) return !1;
        var e,
          i,
          r = t.x,
          n = t.y;
        for (var s in ((this.__corner = 0), this.oCoords))
          if (
            this.isControlVisible(s) &&
            ('mtr' !== s || this.hasRotatingPoint) &&
            (!this.get('lockUniScaling') ||
              ('mt' !== s && 'mr' !== s && 'mb' !== s && 'ml' !== s)) &&
            ((i = this._getImageLines(this.oCoords[s].corner)),
            0 !== (e = this._findCrossPoints({ x: r, y: n }, i)) && e % 2 == 1)
          )
            return (this.__corner = s);
        return !1;
      },
      _setCornerCoords: function () {
        var t,
          e,
          i = this.oCoords,
          r = h(45 - this.angle),
          n = 0.707106 * this.cornerSize,
          s = n * Math.cos(r),
          o = n * Math.sin(r);
        for (var a in i)
          (t = i[a].x),
            (e = i[a].y),
            (i[a].corner = {
              tl: { x: t - o, y: e - s },
              tr: { x: t + s, y: e - o },
              bl: { x: t - s, y: e + o },
              br: { x: t + o, y: e + s },
            });
      },
      drawSelectionBackground: function (t) {
        if (
          !this.selectionBackgroundColor ||
          this.group ||
          !this.active ||
          (this.canvas && !this.canvas.interactive)
        )
          return this;
        t.save();
        var e = this.getCenterPoint(),
          i = this._calculateCurrentDimensions(),
          r = this.canvas.viewportTransform;
        return (
          t.translate(e.x, e.y),
          t.scale(1 / r[0], 1 / r[3]),
          t.rotate(h(this.angle)),
          (t.fillStyle = this.selectionBackgroundColor),
          t.fillRect(-i.x / 2, -i.y / 2, i.x, i.y),
          t.restore(),
          this
        );
      },
      drawBorders: function (t) {
        if (!this.hasBorders) return this;
        var e = this._calculateCurrentDimensions(),
          i = 1 / this.borderScaleFactor,
          r = e.x + i,
          n = e.y + i;
        if (
          (t.save(),
          (t.strokeStyle = this.borderColor),
          this._setLineDash(t, this.borderDashArray, null),
          t.strokeRect(-r / 2, -n / 2, r, n),
          this.hasRotatingPoint &&
            this.isControlVisible('mtr') &&
            !this.get('lockRotation') &&
            this.hasControls)
        ) {
          var s = -n / 2;
          t.beginPath(),
            t.moveTo(0, s),
            t.lineTo(0, s - this.rotatingPointOffset),
            t.closePath(),
            t.stroke();
        }
        return t.restore(), this;
      },
      drawBordersInGroup: function (t, e) {
        if (!this.hasBorders) return this;
        var i = this._getNonTransformedDimensions(),
          r = fabric.util.customTransformMatrix(e.scaleX, e.scaleY, e.skewX),
          n = fabric.util.transformPoint(i, r),
          s = 1 / this.borderScaleFactor,
          o = n.x + s,
          a = n.y + s;
        return (
          t.save(),
          this._setLineDash(t, this.borderDashArray, null),
          (t.strokeStyle = this.borderColor),
          t.strokeRect(-o / 2, -a / 2, o, a),
          t.restore(),
          this
        );
      },
      drawControls: function (t) {
        if (!this.hasControls) return this;
        var e = this._calculateCurrentDimensions(),
          i = e.x,
          r = e.y,
          n = this.cornerSize,
          s = -(i + n) / 2,
          o = -(r + n) / 2,
          a = this.transparentCorners ? 'stroke' : 'fill';
        return (
          t.save(),
          (t.strokeStyle = t.fillStyle = this.cornerColor),
          this.transparentCorners || (t.strokeStyle = this.cornerStrokeColor),
          this._setLineDash(t, this.cornerDashArray, null),
          this._drawControl('tl', t, a, s, o),
          this._drawControl('tr', t, a, s + i, o),
          this._drawControl('bl', t, a, s, o + r),
          this._drawControl('br', t, a, s + i, o + r),
          this.get('lockUniScaling') ||
            (this._drawControl('mt', t, a, s + i / 2, o),
            this._drawControl('mb', t, a, s + i / 2, o + r),
            this._drawControl('mr', t, a, s + i, o + r / 2),
            this._drawControl('ml', t, a, s, o + r / 2)),
          this.hasRotatingPoint &&
            this._drawControl(
              'mtr',
              t,
              a,
              s + i / 2,
              o - this.rotatingPointOffset
            ),
          t.restore(),
          this
        );
      },
      _drawControl: function (t, e, i, r, n) {
        if (this.isControlVisible(t)) {
          var s = this.cornerSize,
            o = !this.transparentCorners && this.cornerStrokeColor;
          switch (this.cornerStyle) {
            case 'circle':
              e.beginPath(),
                e.arc(r + s / 2, n + s / 2, s / 2, 0, 2 * Math.PI, !1),
                e[i](),
                o && e.stroke();
              break;
            default:
              'undefined' != typeof G_vmlCanvasManager ||
                this.transparentCorners ||
                e.clearRect(r, n, s, s),
                e[i + 'Rect'](r, n, s, s),
                o && e.strokeRect(r, n, s, s);
          }
        }
      },
      isControlVisible: function (t) {
        return this._getControlsVisibility()[t];
      },
      setControlVisible: function (t, e) {
        return (this._getControlsVisibility()[t] = e), this;
      },
      setControlsVisibility: function (t) {
        for (var e in (t = t || {})) this.setControlVisible(e, t[e]);
        return this;
      },
      _getControlsVisibility: function () {
        return (
          this._controlsVisibility ||
            (this._controlsVisibility = {
              tl: !0,
              tr: !0,
              br: !0,
              bl: !0,
              ml: !0,
              mt: !0,
              mr: !0,
              mb: !0,
              mtr: !0,
            }),
          this._controlsVisibility
        );
      },
    });
  })(),
  fabric.util.object.extend(fabric.StaticCanvas.prototype, {
    FX_DURATION: 500,
    fxCenterObjectH: function (e, t) {
      function i() {}
      var r = (t = t || {}).onComplete || i,
        n = t.onChange || i,
        s = this;
      return (
        fabric.util.animate({
          startValue: e.get('left'),
          endValue: this.getCenter().left,
          duration: this.FX_DURATION,
          onChange: function (t) {
            e.set('left', t), s.renderAll(), n();
          },
          onComplete: function () {
            e.setCoords(), r();
          },
        }),
        this
      );
    },
    fxCenterObjectV: function (e, t) {
      function i() {}
      var r = (t = t || {}).onComplete || i,
        n = t.onChange || i,
        s = this;
      return (
        fabric.util.animate({
          startValue: e.get('top'),
          endValue: this.getCenter().top,
          duration: this.FX_DURATION,
          onChange: function (t) {
            e.set('top', t), s.renderAll(), n();
          },
          onComplete: function () {
            e.setCoords(), r();
          },
        }),
        this
      );
    },
    fxRemove: function (e, t) {
      function i() {}
      var r = (t = t || {}).onComplete || i,
        n = t.onChange || i,
        s = this;
      return (
        fabric.util.animate({
          startValue: e.get('opacity'),
          endValue: 0,
          duration: this.FX_DURATION,
          onStart: function () {
            e.set('active', !1);
          },
          onChange: function (t) {
            e.set('opacity', t), s.renderAll(), n();
          },
          onComplete: function () {
            s.remove(e), r();
          },
        }),
        this
      );
    },
  }),
  fabric.util.object.extend(fabric.Object.prototype, {
    animate: function () {
      if (arguments[0] && 'object' == typeof arguments[0]) {
        var t,
          e,
          i = [];
        for (t in arguments[0]) i.push(t);
        for (var r = 0, n = i.length; r < n; r++)
          (t = i[r]),
            (e = r !== n - 1),
            this._animate(t, arguments[0][t], arguments[1], e);
      } else this._animate.apply(this, arguments);
      return this;
    },
    _animate: function (r, t, n, s) {
      var o,
        a = this;
      (t = t.toString()),
        (n = n ? fabric.util.object.clone(n) : {}),
        ~r.indexOf('.') && (o = r.split('.'));
      var e = o ? this.get(o[0])[o[1]] : this.get(r);
      'from' in n || (n.from = e),
        (t = ~t.indexOf('=')
          ? e + parseFloat(t.replace('=', ''))
          : parseFloat(t)),
        fabric.util.animate({
          startValue: n.from,
          endValue: t,
          byValue: n.by,
          easing: n.easing,
          duration: n.duration,
          abort:
            n.abort &&
            function () {
              return n.abort.call(a);
            },
          onChange: function (t, e, i) {
            o ? (a[o[0]][o[1]] = t) : a.set(r, t),
              s || (n.onChange && n.onChange(t, e, i));
          },
          onComplete: function (t, e, i) {
            s || (a.setCoords(), n.onComplete && n.onComplete(t, e, i));
          },
        });
    },
  }),
  (function (t) {
    'use strict';
    var s = t.fabric || (t.fabric = {}),
      n = s.util.object.extend,
      o = s.util.object.clone,
      i = { x1: 1, x2: 1, y1: 1, y2: 1 },
      a = s.StaticCanvas.supports('setLineDash');
    if (s.Line) s.warn('fabric.Line is already defined');
    else {
      var e = s.Object.prototype.cacheProperties.concat();
      e.push('x1', 'x2', 'y1', 'y2'),
        (s.Line = s.util.createClass(s.Object, {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 0,
          cacheProperties: e,
          initialize: function (t, e) {
            (t = t || [0, 0, 0, 0]),
              this.callSuper('initialize', e),
              this.set('x1', t[0]),
              this.set('y1', t[1]),
              this.set('x2', t[2]),
              this.set('y2', t[3]),
              this._setWidthHeight(e);
          },
          _setWidthHeight: function (t) {
            (t = t || {}),
              (this.width = Math.abs(this.x2 - this.x1)),
              (this.height = Math.abs(this.y2 - this.y1)),
              (this.left = 'left' in t ? t.left : this._getLeftToOriginX()),
              (this.top = 'top' in t ? t.top : this._getTopToOriginY());
          },
          _set: function (t, e) {
            return (
              this.callSuper('_set', t, e),
              void 0 !== i[t] && this._setWidthHeight(),
              this
            );
          },
          _getLeftToOriginX: r(
            { origin: 'originX', axis1: 'x1', axis2: 'x2', dimension: 'width' },
            { nearest: 'left', center: 'center', farthest: 'right' }
          ),
          _getTopToOriginY: r(
            {
              origin: 'originY',
              axis1: 'y1',
              axis2: 'y2',
              dimension: 'height',
            },
            { nearest: 'top', center: 'center', farthest: 'bottom' }
          ),
          _render: function (t, e) {
            if ((t.beginPath(), e)) {
              var i = this.getCenterPoint(),
                r = this.strokeWidth / 2;
              t.translate(
                i.x -
                  ('butt' === this.strokeLineCap && 0 === this.height ? 0 : r),
                i.y -
                  ('butt' === this.strokeLineCap && 0 === this.width ? 0 : r)
              );
            }
            if (!this.strokeDashArray || (this.strokeDashArray && a)) {
              var n = this.calcLinePoints();
              t.moveTo(n.x1, n.y1), t.lineTo(n.x2, n.y2);
            }
            t.lineWidth = this.strokeWidth;
            var s = t.strokeStyle;
            (t.strokeStyle = this.stroke || t.fillStyle),
              this.stroke && this._renderStroke(t),
              (t.strokeStyle = s);
          },
          _renderDashedStroke: function (t) {
            var e = this.calcLinePoints();
            t.beginPath(),
              s.util.drawDashedLine(
                t,
                e.x1,
                e.y1,
                e.x2,
                e.y2,
                this.strokeDashArray
              ),
              t.closePath();
          },
          toObject: function (t) {
            return n(this.callSuper('toObject', t), this.calcLinePoints());
          },
          _getNonTransformedDimensions: function () {
            var t = this.callSuper('_getNonTransformedDimensions');
            return (
              'butt' === this.strokeLineCap &&
                (0 === this.width && (t.y -= this.strokeWidth),
                0 === this.height && (t.x -= this.strokeWidth)),
              t
            );
          },
          calcLinePoints: function () {
            var t = this.x1 <= this.x2 ? -1 : 1,
              e = this.y1 <= this.y2 ? -1 : 1,
              i = t * this.width * 0.5,
              r = e * this.height * 0.5;
            return {
              x1: i,
              x2: t * this.width * -0.5,
              y1: r,
              y2: e * this.height * -0.5,
            };
          },
          toSVG: function (t) {
            var e = this._createBaseSVGMarkup(),
              i = { x1: this.x1, x2: this.x2, y1: this.y1, y2: this.y2 };
            return (
              (this.group && 'path-group' === this.group.type) ||
                (i = this.calcLinePoints()),
              e.push(
                '<line ',
                this.getSvgId(),
                'x1="',
                i.x1,
                '" y1="',
                i.y1,
                '" x2="',
                i.x2,
                '" y2="',
                i.y2,
                '" style="',
                this.getSvgStyles(),
                '" transform="',
                this.getSvgTransform(),
                this.getSvgTransformMatrix(),
                '"/>\n'
              ),
              t ? t(e.join('')) : e.join('')
            );
          },
        })),
        (s.Line.ATTRIBUTE_NAMES = s.SHARED_ATTRIBUTES.concat(
          'x1 y1 x2 y2'.split(' ')
        )),
        (s.Line.fromElement = function (t, e) {
          e = e || {};
          var i = s.parseAttributes(t, s.Line.ATTRIBUTE_NAMES),
            r = [i.x1 || 0, i.y1 || 0, i.x2 || 0, i.y2 || 0];
          return (
            (e.originX = 'left'), (e.originY = 'top'), new s.Line(r, n(i, e))
          );
        }),
        (s.Line.fromObject = function (t, e, i) {
          var r = o(t, !0);
          r.points = [t.x1, t.y1, t.x2, t.y2];
          var n = s.Object._fromObject(
            'Line',
            r,
            function (t) {
              delete t.points, e && e(t);
            },
            i,
            'points'
          );
          return n && delete n.points, n;
        });
    }
    function r(t, e) {
      var i = t.origin,
        r = t.axis1,
        n = t.axis2,
        s = t.dimension,
        o = e.nearest,
        a = e.center,
        h = e.farthest;
      return function () {
        switch (this.get(i)) {
          case o:
            return Math.min(this.get(r), this.get(n));
          case a:
            return Math.min(this.get(r), this.get(n)) + 0.5 * this.get(s);
          case h:
            return Math.max(this.get(r), this.get(n));
        }
      };
    }
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var s = t.fabric || (t.fabric = {}),
      l = Math.PI,
      o = s.util.object.extend;
    if (s.Circle) s.warn('fabric.Circle is already defined.');
    else {
      var e = s.Object.prototype.cacheProperties.concat();
      e.push('radius'),
        (s.Circle = s.util.createClass(s.Object, {
          type: 'circle',
          radius: 0,
          startAngle: 0,
          endAngle: 2 * l,
          cacheProperties: e,
          initialize: function (t) {
            this.callSuper('initialize', t),
              this.set('radius', (t && t.radius) || 0);
          },
          _set: function (t, e) {
            return (
              this.callSuper('_set', t, e),
              'radius' === t && this.setRadius(e),
              this
            );
          },
          toObject: function (t) {
            return this.callSuper(
              'toObject',
              ['radius', 'startAngle', 'endAngle'].concat(t)
            );
          },
          toSVG: function (t) {
            var e = this._createBaseSVGMarkup(),
              i = 0,
              r = 0,
              n = (this.endAngle - this.startAngle) % (2 * l);
            if (0 == n)
              this.group &&
                'path-group' === this.group.type &&
                ((i = this.left + this.radius), (r = this.top + this.radius)),
                e.push(
                  '<circle ',
                  this.getSvgId(),
                  'cx="' + i + '" cy="' + r + '" ',
                  'r="',
                  this.radius,
                  '" style="',
                  this.getSvgStyles(),
                  '" transform="',
                  this.getSvgTransform(),
                  ' ',
                  this.getSvgTransformMatrix(),
                  '"/>\n'
                );
            else {
              var s = Math.cos(this.startAngle) * this.radius,
                o = Math.sin(this.startAngle) * this.radius,
                a = Math.cos(this.endAngle) * this.radius,
                h = Math.sin(this.endAngle) * this.radius,
                c = l < n ? '1' : '0';
              e.push(
                '<path d="M ' + s + ' ' + o,
                ' A ' + this.radius + ' ' + this.radius,
                ' 0 ',
                +c + ' 1',
                ' ' + a + ' ' + h,
                '" style="',
                this.getSvgStyles(),
                '" transform="',
                this.getSvgTransform(),
                ' ',
                this.getSvgTransformMatrix(),
                '"/>\n'
              );
            }
            return t ? t(e.join('')) : e.join('');
          },
          _render: function (t, e) {
            t.beginPath(),
              t.arc(
                e ? this.left + this.radius : 0,
                e ? this.top + this.radius : 0,
                this.radius,
                this.startAngle,
                this.endAngle,
                !1
              ),
              this._renderFill(t),
              this._renderStroke(t);
          },
          getRadiusX: function () {
            return this.get('radius') * this.get('scaleX');
          },
          getRadiusY: function () {
            return this.get('radius') * this.get('scaleY');
          },
          setRadius: function (t) {
            return (
              (this.radius = t), this.set('width', 2 * t).set('height', 2 * t)
            );
          },
        })),
        (s.Circle.ATTRIBUTE_NAMES = s.SHARED_ATTRIBUTES.concat(
          'cx cy r'.split(' ')
        )),
        (s.Circle.fromElement = function (t, e) {
          e = e || {};
          var i,
            r = s.parseAttributes(t, s.Circle.ATTRIBUTE_NAMES);
          if (!('radius' in (i = r) && 0 <= i.radius))
            throw new Error(
              'value of `r` attribute is required and can not be negative'
            );
          (r.left = r.left || 0), (r.top = r.top || 0);
          var n = new s.Circle(o(r, e));
          return (n.left -= n.radius), (n.top -= n.radius), n;
        }),
        (s.Circle.fromObject = function (t, e, i) {
          return s.Object._fromObject('Circle', t, e, i);
        });
    }
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var r = t.fabric || (t.fabric = {});
    r.Triangle
      ? r.warn('fabric.Triangle is already defined')
      : ((r.Triangle = r.util.createClass(r.Object, {
          type: 'triangle',
          initialize: function (t) {
            this.callSuper('initialize', t),
              this.set('width', (t && t.width) || 100).set(
                'height',
                (t && t.height) || 100
              );
          },
          _render: function (t) {
            var e = this.width / 2,
              i = this.height / 2;
            t.beginPath(),
              t.moveTo(-e, i),
              t.lineTo(0, -i),
              t.lineTo(e, i),
              t.closePath(),
              this._renderFill(t),
              this._renderStroke(t);
          },
          _renderDashedStroke: function (t) {
            var e = this.width / 2,
              i = this.height / 2;
            t.beginPath(),
              r.util.drawDashedLine(t, -e, i, 0, -i, this.strokeDashArray),
              r.util.drawDashedLine(t, 0, -i, e, i, this.strokeDashArray),
              r.util.drawDashedLine(t, e, i, -e, i, this.strokeDashArray),
              t.closePath();
          },
          toSVG: function (t) {
            var e = this._createBaseSVGMarkup(),
              i = this.width / 2,
              r = this.height / 2,
              n = [-i + ' ' + r, '0 ' + -r, i + ' ' + r].join(',');
            return (
              e.push(
                '<polygon ',
                this.getSvgId(),
                'points="',
                n,
                '" style="',
                this.getSvgStyles(),
                '" transform="',
                this.getSvgTransform(),
                '"/>'
              ),
              t ? t(e.join('')) : e.join('')
            );
          },
        })),
        (r.Triangle.fromObject = function (t, e, i) {
          return r.Object._fromObject('Triangle', t, e, i);
        }));
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var n = t.fabric || (t.fabric = {}),
      i = 2 * Math.PI,
      s = n.util.object.extend;
    if (n.Ellipse) n.warn('fabric.Ellipse is already defined.');
    else {
      var e = n.Object.prototype.cacheProperties.concat();
      e.push('rx', 'ry'),
        (n.Ellipse = n.util.createClass(n.Object, {
          type: 'ellipse',
          rx: 0,
          ry: 0,
          cacheProperties: e,
          initialize: function (t) {
            this.callSuper('initialize', t),
              this.set('rx', (t && t.rx) || 0),
              this.set('ry', (t && t.ry) || 0);
          },
          _set: function (t, e) {
            switch ((this.callSuper('_set', t, e), t)) {
              case 'rx':
                (this.rx = e), this.set('width', 2 * e);
                break;
              case 'ry':
                (this.ry = e), this.set('height', 2 * e);
            }
            return this;
          },
          getRx: function () {
            return this.get('rx') * this.get('scaleX');
          },
          getRy: function () {
            return this.get('ry') * this.get('scaleY');
          },
          toObject: function (t) {
            return this.callSuper('toObject', ['rx', 'ry'].concat(t));
          },
          toSVG: function (t) {
            var e = this._createBaseSVGMarkup(),
              i = 0,
              r = 0;
            return (
              this.group &&
                'path-group' === this.group.type &&
                ((i = this.left + this.rx), (r = this.top + this.ry)),
              e.push(
                '<ellipse ',
                this.getSvgId(),
                'cx="',
                i,
                '" cy="',
                r,
                '" ',
                'rx="',
                this.rx,
                '" ry="',
                this.ry,
                '" style="',
                this.getSvgStyles(),
                '" transform="',
                this.getSvgTransform(),
                this.getSvgTransformMatrix(),
                '"/>\n'
              ),
              t ? t(e.join('')) : e.join('')
            );
          },
          _render: function (t, e) {
            t.beginPath(),
              t.save(),
              t.transform(1, 0, 0, this.ry / this.rx, 0, 0),
              t.arc(
                e ? this.left + this.rx : 0,
                e ? ((this.top + this.ry) * this.rx) / this.ry : 0,
                this.rx,
                0,
                i,
                !1
              ),
              t.restore(),
              this._renderFill(t),
              this._renderStroke(t);
          },
        })),
        (n.Ellipse.ATTRIBUTE_NAMES = n.SHARED_ATTRIBUTES.concat(
          'cx cy rx ry'.split(' ')
        )),
        (n.Ellipse.fromElement = function (t, e) {
          e = e || {};
          var i = n.parseAttributes(t, n.Ellipse.ATTRIBUTE_NAMES);
          (i.left = i.left || 0), (i.top = i.top || 0);
          var r = new n.Ellipse(s(i, e));
          return (r.top -= r.ry), (r.left -= r.rx), r;
        }),
        (n.Ellipse.fromObject = function (t, e, i) {
          return n.Object._fromObject('Ellipse', t, e, i);
        });
    }
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var s = t.fabric || (t.fabric = {}),
      n = s.util.object.extend;
    if (s.Rect) s.warn('fabric.Rect is already defined');
    else {
      var e = s.Object.prototype.stateProperties.concat();
      e.push('rx', 'ry');
      var i = s.Object.prototype.cacheProperties.concat();
      i.push('rx', 'ry'),
        (s.Rect = s.util.createClass(s.Object, {
          stateProperties: e,
          type: 'rect',
          rx: 0,
          ry: 0,
          cacheProperties: i,
          initialize: function (t) {
            this.callSuper('initialize', t), this._initRxRy();
          },
          _initRxRy: function () {
            this.rx && !this.ry
              ? (this.ry = this.rx)
              : this.ry && !this.rx && (this.rx = this.ry);
          },
          _render: function (t, e) {
            if (1 !== this.width || 1 !== this.height) {
              var i = this.rx ? Math.min(this.rx, this.width / 2) : 0,
                r = this.ry ? Math.min(this.ry, this.height / 2) : 0,
                n = this.width,
                s = this.height,
                o = e ? this.left : -this.width / 2,
                a = e ? this.top : -this.height / 2,
                h = 0 !== i || 0 !== r,
                c = 0.4477152502;
              t.beginPath(),
                t.moveTo(o + i, a),
                t.lineTo(o + n - i, a),
                h &&
                  t.bezierCurveTo(
                    o + n - c * i,
                    a,
                    o + n,
                    a + c * r,
                    o + n,
                    a + r
                  ),
                t.lineTo(o + n, a + s - r),
                h &&
                  t.bezierCurveTo(
                    o + n,
                    a + s - c * r,
                    o + n - c * i,
                    a + s,
                    o + n - i,
                    a + s
                  ),
                t.lineTo(o + i, a + s),
                h &&
                  t.bezierCurveTo(
                    o + c * i,
                    a + s,
                    o,
                    a + s - c * r,
                    o,
                    a + s - r
                  ),
                t.lineTo(o, a + r),
                h && t.bezierCurveTo(o, a + c * r, o + c * i, a, o + i, a),
                t.closePath(),
                this._renderFill(t),
                this._renderStroke(t);
            } else t.fillRect(-0.5, -0.5, 1, 1);
          },
          _renderDashedStroke: function (t) {
            var e = -this.width / 2,
              i = -this.height / 2,
              r = this.width,
              n = this.height;
            t.beginPath(),
              s.util.drawDashedLine(t, e, i, e + r, i, this.strokeDashArray),
              s.util.drawDashedLine(
                t,
                e + r,
                i,
                e + r,
                i + n,
                this.strokeDashArray
              ),
              s.util.drawDashedLine(
                t,
                e + r,
                i + n,
                e,
                i + n,
                this.strokeDashArray
              ),
              s.util.drawDashedLine(t, e, i + n, e, i, this.strokeDashArray),
              t.closePath();
          },
          toObject: function (t) {
            return this.callSuper('toObject', ['rx', 'ry'].concat(t));
          },
          toSVG: function (t) {
            var e = this._createBaseSVGMarkup(),
              i = this.left,
              r = this.top;
            return (
              (this.group && 'path-group' === this.group.type) ||
                ((i = -this.width / 2), (r = -this.height / 2)),
              e.push(
                '<rect ',
                this.getSvgId(),
                'x="',
                i,
                '" y="',
                r,
                '" rx="',
                this.get('rx'),
                '" ry="',
                this.get('ry'),
                '" width="',
                this.width,
                '" height="',
                this.height,
                '" style="',
                this.getSvgStyles(),
                '" transform="',
                this.getSvgTransform(),
                this.getSvgTransformMatrix(),
                '"/>\n'
              ),
              t ? t(e.join('')) : e.join('')
            );
          },
        })),
        (s.Rect.ATTRIBUTE_NAMES = s.SHARED_ATTRIBUTES.concat(
          'x y rx ry width height'.split(' ')
        )),
        (s.Rect.fromElement = function (t, e) {
          if (!t) return null;
          e = e || {};
          var i = s.parseAttributes(t, s.Rect.ATTRIBUTE_NAMES);
          (i.left = i.left || 0), (i.top = i.top || 0);
          var r = new s.Rect(n(e ? s.util.object.clone(e) : {}, i));
          return (r.visible = r.visible && 0 < r.width && 0 < r.height), r;
        }),
        (s.Rect.fromObject = function (t, e, i) {
          return s.Object._fromObject('Rect', t, e, i);
        });
    }
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var s = t.fabric || (t.fabric = {}),
      e = s.util.object.extend,
      o = s.util.array.min,
      a = s.util.array.max,
      h = s.util.toFixed,
      c = s.Object.NUM_FRACTION_DIGITS;
    if (s.Polyline) s.warn('fabric.Polyline is already defined');
    else {
      var i = s.Object.prototype.cacheProperties.concat();
      i.push('points'),
        (s.Polyline = s.util.createClass(s.Object, {
          type: 'polyline',
          points: null,
          minX: 0,
          minY: 0,
          cacheProperties: i,
          initialize: function (t, e) {
            (e = e || {}),
              (this.points = t || []),
              this.callSuper('initialize', e),
              this._calcDimensions(),
              'top' in e || (this.top = this.minY),
              'left' in e || (this.left = this.minX),
              (this.pathOffset = {
                x: this.minX + this.width / 2,
                y: this.minY + this.height / 2,
              });
          },
          _calcDimensions: function () {
            var t = this.points,
              e = o(t, 'x'),
              i = o(t, 'y'),
              r = a(t, 'x'),
              n = a(t, 'y');
            (this.width = r - e || 0),
              (this.height = n - i || 0),
              (this.minX = e || 0),
              (this.minY = i || 0);
          },
          toObject: function (t) {
            return e(this.callSuper('toObject', t), {
              points: this.points.concat(),
            });
          },
          toSVG: function (t) {
            var e = [],
              i = 0,
              r = 0,
              n = this._createBaseSVGMarkup();
            (this.group && 'path-group' === this.group.type) ||
              ((i = this.pathOffset.x), (r = this.pathOffset.y));
            for (var s = 0, o = this.points.length; s < o; s++)
              e.push(
                h(this.points[s].x - i, c),
                ',',
                h(this.points[s].y - r, c),
                ' '
              );
            return (
              n.push(
                '<',
                this.type,
                ' ',
                this.getSvgId(),
                'points="',
                e.join(''),
                '" style="',
                this.getSvgStyles(),
                '" transform="',
                this.getSvgTransform(),
                ' ',
                this.getSvgTransformMatrix(),
                '"/>\n'
              ),
              t ? t(n.join('')) : n.join('')
            );
          },
          commonRender: function (t, e) {
            var i,
              r = this.points.length,
              n = e ? 0 : this.pathOffset.x,
              s = e ? 0 : this.pathOffset.y;
            if (!r || isNaN(this.points[r - 1].y)) return !1;
            t.beginPath(), t.moveTo(this.points[0].x - n, this.points[0].y - s);
            for (var o = 0; o < r; o++)
              (i = this.points[o]), t.lineTo(i.x - n, i.y - s);
            return !0;
          },
          _render: function (t, e) {
            this.commonRender(t, e) &&
              (this._renderFill(t), this._renderStroke(t));
          },
          _renderDashedStroke: function (t) {
            var e, i;
            t.beginPath();
            for (var r = 0, n = this.points.length; r < n; r++)
              (e = this.points[r]),
                (i = this.points[r + 1] || e),
                s.util.drawDashedLine(
                  t,
                  e.x,
                  e.y,
                  i.x,
                  i.y,
                  this.strokeDashArray
                );
          },
          complexity: function () {
            return this.get('points').length;
          },
        })),
        (s.Polyline.ATTRIBUTE_NAMES = s.SHARED_ATTRIBUTES.concat()),
        (s.Polyline.fromElement = function (t, e) {
          if (!t) return null;
          e = e || {};
          var i = s.parsePointsAttribute(t.getAttribute('points')),
            r = s.parseAttributes(t, s.Polyline.ATTRIBUTE_NAMES);
          return new s.Polyline(i, s.util.object.extend(r, e));
        }),
        (s.Polyline.fromObject = function (t, e, i) {
          return s.Object._fromObject('Polyline', t, e, i, 'points');
        });
    }
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var n = t.fabric || (t.fabric = {}),
      s = n.util.object.extend;
    n.Polygon
      ? n.warn('fabric.Polygon is already defined')
      : ((n.Polygon = n.util.createClass(n.Polyline, {
          type: 'polygon',
          _render: function (t, e) {
            this.commonRender(t, e) &&
              (t.closePath(), this._renderFill(t), this._renderStroke(t));
          },
          _renderDashedStroke: function (t) {
            this.callSuper('_renderDashedStroke', t), t.closePath();
          },
        })),
        (n.Polygon.ATTRIBUTE_NAMES = n.SHARED_ATTRIBUTES.concat()),
        (n.Polygon.fromElement = function (t, e) {
          if (!t) return null;
          e = e || {};
          var i = n.parsePointsAttribute(t.getAttribute('points')),
            r = n.parseAttributes(t, n.Polygon.ATTRIBUTE_NAMES);
          return new n.Polygon(i, s(r, e));
        }),
        (n.Polygon.fromObject = function (t, e, i) {
          return n.Object._fromObject('Polygon', t, e, i, 'points');
        }));
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var b = t.fabric || (t.fabric = {}),
      m = b.util.array.min,
      _ = b.util.array.max,
      n = b.util.object.extend,
      r = Object.prototype.toString,
      p = b.util.drawArc,
      y = { m: 2, l: 2, h: 1, v: 1, c: 6, s: 4, q: 4, t: 2, a: 7 },
      x = { m: 'l', M: 'L' };
    if (b.Path) b.warn('fabric.Path is already defined');
    else {
      var e = b.Object.prototype.stateProperties.concat();
      e.push('path');
      var i = b.Object.prototype.cacheProperties.concat();
      i.push('path', 'fillRule'),
        (b.Path = b.util.createClass(b.Object, {
          type: 'path',
          path: null,
          minX: 0,
          minY: 0,
          cacheProperties: i,
          stateProperties: e,
          initialize: function (t, e) {
            (e = e || {}), this.callSuper('initialize', e), (t = t || []);
            var i = '[object Array]' === r.call(t);
            (this.path = i
              ? t
              : t.match && t.match(/[mzlhvcsqta][^mzlhvcsqta]*/gi)),
              this.path &&
                (i || (this.path = this._parsePath()),
                this._setPositionDimensions(e));
          },
          _setPositionDimensions: function (t) {
            var e = this._parseDimensions();
            (this.minX = e.left),
              (this.minY = e.top),
              (this.width = e.width),
              (this.height = e.height),
              void 0 === t.left &&
                (this.left =
                  e.left +
                  ('center' === this.originX
                    ? this.width / 2
                    : 'right' === this.originX
                    ? this.width
                    : 0)),
              void 0 === t.top &&
                (this.top =
                  e.top +
                  ('center' === this.originY
                    ? this.height / 2
                    : 'bottom' === this.originY
                    ? this.height
                    : 0)),
              (this.pathOffset = this.pathOffset || {
                x: this.minX + this.width / 2,
                y: this.minY + this.height / 2,
              });
          },
          _renderPathCommands: function (t) {
            var e,
              i,
              r,
              n = null,
              s = 0,
              o = 0,
              a = 0,
              h = 0,
              c = 0,
              l = 0,
              u = -this.pathOffset.x,
              f = -this.pathOffset.y;
            this.group && 'path-group' === this.group.type && (f = u = 0),
              t.beginPath();
            for (var d = 0, g = this.path.length; d < g; ++d) {
              switch ((e = this.path[d])[0]) {
                case 'l':
                  (a += e[1]), (h += e[2]), t.lineTo(a + u, h + f);
                  break;
                case 'L':
                  (a = e[1]), (h = e[2]), t.lineTo(a + u, h + f);
                  break;
                case 'h':
                  (a += e[1]), t.lineTo(a + u, h + f);
                  break;
                case 'H':
                  (a = e[1]), t.lineTo(a + u, h + f);
                  break;
                case 'v':
                  (h += e[1]), t.lineTo(a + u, h + f);
                  break;
                case 'V':
                  (h = e[1]), t.lineTo(a + u, h + f);
                  break;
                case 'm':
                  (s = a += e[1]), (o = h += e[2]), t.moveTo(a + u, h + f);
                  break;
                case 'M':
                  (s = a = e[1]), (o = h = e[2]), t.moveTo(a + u, h + f);
                  break;
                case 'c':
                  (i = a + e[5]),
                    (r = h + e[6]),
                    (c = a + e[3]),
                    (l = h + e[4]),
                    t.bezierCurveTo(
                      a + e[1] + u,
                      h + e[2] + f,
                      c + u,
                      l + f,
                      i + u,
                      r + f
                    ),
                    (a = i),
                    (h = r);
                  break;
                case 'C':
                  (a = e[5]),
                    (h = e[6]),
                    (c = e[3]),
                    (l = e[4]),
                    t.bezierCurveTo(
                      e[1] + u,
                      e[2] + f,
                      c + u,
                      l + f,
                      a + u,
                      h + f
                    );
                  break;
                case 's':
                  (i = a + e[3]),
                    (r = h + e[4]),
                    (l =
                      null === n[0].match(/[CcSs]/)
                        ? ((c = a), h)
                        : ((c = 2 * a - c), 2 * h - l)),
                    t.bezierCurveTo(
                      c + u,
                      l + f,
                      a + e[1] + u,
                      h + e[2] + f,
                      i + u,
                      r + f
                    ),
                    (c = a + e[1]),
                    (l = h + e[2]),
                    (a = i),
                    (h = r);
                  break;
                case 'S':
                  (i = e[3]),
                    (r = e[4]),
                    (l =
                      null === n[0].match(/[CcSs]/)
                        ? ((c = a), h)
                        : ((c = 2 * a - c), 2 * h - l)),
                    t.bezierCurveTo(
                      c + u,
                      l + f,
                      e[1] + u,
                      e[2] + f,
                      i + u,
                      r + f
                    ),
                    (a = i),
                    (h = r),
                    (c = e[1]),
                    (l = e[2]);
                  break;
                case 'q':
                  (i = a + e[3]),
                    (r = h + e[4]),
                    (c = a + e[1]),
                    (l = h + e[2]),
                    t.quadraticCurveTo(c + u, l + f, i + u, r + f),
                    (a = i),
                    (h = r);
                  break;
                case 'Q':
                  (i = e[3]),
                    (r = e[4]),
                    t.quadraticCurveTo(e[1] + u, e[2] + f, i + u, r + f),
                    (a = i),
                    (h = r),
                    (c = e[1]),
                    (l = e[2]);
                  break;
                case 't':
                  (i = a + e[1]),
                    (r = h + e[2]),
                    (l =
                      null === n[0].match(/[QqTt]/)
                        ? ((c = a), h)
                        : ((c = 2 * a - c), 2 * h - l)),
                    t.quadraticCurveTo(c + u, l + f, i + u, r + f),
                    (a = i),
                    (h = r);
                  break;
                case 'T':
                  (i = e[1]),
                    (r = e[2]),
                    (l =
                      null === n[0].match(/[QqTt]/)
                        ? ((c = a), h)
                        : ((c = 2 * a - c), 2 * h - l)),
                    t.quadraticCurveTo(c + u, l + f, i + u, r + f),
                    (a = i),
                    (h = r);
                  break;
                case 'a':
                  p(t, a + u, h + f, [
                    e[1],
                    e[2],
                    e[3],
                    e[4],
                    e[5],
                    e[6] + a + u,
                    e[7] + h + f,
                  ]),
                    (a += e[6]),
                    (h += e[7]);
                  break;
                case 'A':
                  p(t, a + u, h + f, [
                    e[1],
                    e[2],
                    e[3],
                    e[4],
                    e[5],
                    e[6] + u,
                    e[7] + f,
                  ]),
                    (a = e[6]),
                    (h = e[7]);
                  break;
                case 'z':
                case 'Z':
                  (a = s), (h = o), t.closePath();
              }
              n = e;
            }
          },
          _render: function (t) {
            this._renderPathCommands(t),
              this._renderFill(t),
              this._renderStroke(t);
          },
          toString: function () {
            return (
              '#<fabric.Path (' +
              this.complexity() +
              '): { "top": ' +
              this.top +
              ', "left": ' +
              this.left +
              ' }>'
            );
          },
          toObject: function (t) {
            return n(
              this.callSuper(
                'toObject',
                ['sourcePath', 'pathOffset'].concat(t)
              ),
              {
                path: this.path.map(function (t) {
                  return t.slice();
                }),
                top: this.top,
                left: this.left,
              }
            );
          },
          toDatalessObject: function (t) {
            var e = this.toObject(t);
            return (
              this.sourcePath && (e.path = this.sourcePath),
              delete e.sourcePath,
              e
            );
          },
          toSVG: function (t) {
            for (
              var e = [],
                i = this._createBaseSVGMarkup(),
                r = '',
                n = 0,
                s = this.path.length;
              n < s;
              n++
            )
              e.push(this.path[n].join(' '));
            var o = e.join(' ');
            return (
              (this.group && 'path-group' === this.group.type) ||
                (r =
                  ' translate(' +
                  -this.pathOffset.x +
                  ', ' +
                  -this.pathOffset.y +
                  ') '),
              i.push(
                '<path ',
                this.getSvgId(),
                'd="',
                o,
                '" style="',
                this.getSvgStyles(),
                '" transform="',
                this.getSvgTransform(),
                r,
                this.getSvgTransformMatrix(),
                '" stroke-linecap="round" ',
                '/>\n'
              ),
              t ? t(i.join('')) : i.join('')
            );
          },
          complexity: function () {
            return this.path.length;
          },
          _parsePath: function () {
            for (
              var t,
                e,
                i,
                r,
                n,
                s = [],
                o = [],
                a = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi,
                h = 0,
                c = this.path.length;
              h < c;
              h++
            ) {
              for (
                r = (t = this.path[h]).slice(1).trim(), o.length = 0;
                (i = a.exec(r));

              )
                o.push(i[0]);
              n = [t.charAt(0)];
              for (var l = 0, u = o.length; l < u; l++)
                (e = parseFloat(o[l])), isNaN(e) || n.push(e);
              var f = n[0],
                d = y[f.toLowerCase()],
                g = x[f] || f;
              if (n.length - 1 > d)
                for (var p = 1, v = n.length; p < v; p += d)
                  s.push([f].concat(n.slice(p, p + d))), (f = g);
              else s.push(n);
            }
            return s;
          },
          _parseDimensions: function () {
            for (
              var t,
                e,
                i,
                r,
                n = [],
                s = [],
                o = null,
                a = 0,
                h = 0,
                c = 0,
                l = 0,
                u = 0,
                f = 0,
                d = 0,
                g = this.path.length;
              d < g;
              ++d
            ) {
              switch ((t = this.path[d])[0]) {
                case 'l':
                  (c += t[1]), (l += t[2]), (r = []);
                  break;
                case 'L':
                  (c = t[1]), (l = t[2]), (r = []);
                  break;
                case 'h':
                  (c += t[1]), (r = []);
                  break;
                case 'H':
                  (c = t[1]), (r = []);
                  break;
                case 'v':
                  (l += t[1]), (r = []);
                  break;
                case 'V':
                  (l = t[1]), (r = []);
                  break;
                case 'm':
                  (a = c += t[1]), (h = l += t[2]), (r = []);
                  break;
                case 'M':
                  (a = c = t[1]), (h = l = t[2]), (r = []);
                  break;
                case 'c':
                  (e = c + t[5]),
                    (i = l + t[6]),
                    (u = c + t[3]),
                    (f = l + t[4]),
                    (r = b.util.getBoundsOfCurve(
                      c,
                      l,
                      c + t[1],
                      l + t[2],
                      u,
                      f,
                      e,
                      i
                    )),
                    (c = e),
                    (l = i);
                  break;
                case 'C':
                  (u = t[3]),
                    (f = t[4]),
                    (r = b.util.getBoundsOfCurve(
                      c,
                      l,
                      t[1],
                      t[2],
                      u,
                      f,
                      t[5],
                      t[6]
                    )),
                    (c = t[5]),
                    (l = t[6]);
                  break;
                case 's':
                  (e = c + t[3]),
                    (i = l + t[4]),
                    (f =
                      null === o[0].match(/[CcSs]/)
                        ? ((u = c), l)
                        : ((u = 2 * c - u), 2 * l - f)),
                    (r = b.util.getBoundsOfCurve(
                      c,
                      l,
                      u,
                      f,
                      c + t[1],
                      l + t[2],
                      e,
                      i
                    )),
                    (u = c + t[1]),
                    (f = l + t[2]),
                    (c = e),
                    (l = i);
                  break;
                case 'S':
                  (e = t[3]),
                    (i = t[4]),
                    (f =
                      null === o[0].match(/[CcSs]/)
                        ? ((u = c), l)
                        : ((u = 2 * c - u), 2 * l - f)),
                    (r = b.util.getBoundsOfCurve(c, l, u, f, t[1], t[2], e, i)),
                    (c = e),
                    (l = i),
                    (u = t[1]),
                    (f = t[2]);
                  break;
                case 'q':
                  (e = c + t[3]),
                    (i = l + t[4]),
                    (u = c + t[1]),
                    (f = l + t[2]),
                    (r = b.util.getBoundsOfCurve(c, l, u, f, u, f, e, i)),
                    (c = e),
                    (l = i);
                  break;
                case 'Q':
                  (u = t[1]),
                    (f = t[2]),
                    (r = b.util.getBoundsOfCurve(c, l, u, f, u, f, t[3], t[4])),
                    (c = t[3]),
                    (l = t[4]);
                  break;
                case 't':
                  (e = c + t[1]),
                    (i = l + t[2]),
                    (f =
                      null === o[0].match(/[QqTt]/)
                        ? ((u = c), l)
                        : ((u = 2 * c - u), 2 * l - f)),
                    (r = b.util.getBoundsOfCurve(c, l, u, f, u, f, e, i)),
                    (c = e),
                    (l = i);
                  break;
                case 'T':
                  (e = t[1]),
                    (i = t[2]),
                    (f =
                      null === o[0].match(/[QqTt]/)
                        ? ((u = c), l)
                        : ((u = 2 * c - u), 2 * l - f)),
                    (r = b.util.getBoundsOfCurve(c, l, u, f, u, f, e, i)),
                    (c = e),
                    (l = i);
                  break;
                case 'a':
                  (r = b.util.getBoundsOfArc(
                    c,
                    l,
                    t[1],
                    t[2],
                    t[3],
                    t[4],
                    t[5],
                    t[6] + c,
                    t[7] + l
                  )),
                    (c += t[6]),
                    (l += t[7]);
                  break;
                case 'A':
                  (r = b.util.getBoundsOfArc(
                    c,
                    l,
                    t[1],
                    t[2],
                    t[3],
                    t[4],
                    t[5],
                    t[6],
                    t[7]
                  )),
                    (c = t[6]),
                    (l = t[7]);
                  break;
                case 'z':
                case 'Z':
                  (c = a), (l = h);
              }
              (o = t),
                r.forEach(function (t) {
                  n.push(t.x), s.push(t.y);
                }),
                n.push(c),
                s.push(l);
            }
            var p = m(n) || 0,
              v = m(s) || 0;
            return {
              left: p,
              top: v,
              width: (_(n) || 0) - p,
              height: (_(s) || 0) - v,
            };
          },
        })),
        (b.Path.fromObject = function (i, r, t) {
          var n;
          if ('string' != typeof i.path)
            return b.Object._fromObject('Path', i, r, t, 'path');
          b.loadSVGFromURL(i.path, function (t) {
            var e = i.path;
            (n = t[0]),
              delete i.path,
              n.setOptions(i),
              n.setSourcePath(e),
              r && r(n);
          });
        }),
        (b.Path.ATTRIBUTE_NAMES = b.SHARED_ATTRIBUTES.concat(['d'])),
        (b.Path.fromElement = function (t, e, i) {
          var r = b.parseAttributes(t, b.Path.ATTRIBUTE_NAMES);
          e && e(new b.Path(r.d, n(r, i)));
        }),
        (b.Path.async = !0);
    }
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var u = t.fabric || (t.fabric = {}),
      e = u.util.object.extend;
    u.PathGroup
      ? u.warn('fabric.PathGroup is already defined')
      : ((u.PathGroup = u.util.createClass(u.Object, {
          type: 'path-group',
          fill: '',
          cacheProperties: [],
          initialize: function (t, e) {
            (e = e || {}), (this.paths = t || []);
            for (var i = this.paths.length; i--; ) this.paths[i].group = this;
            e.toBeParsed &&
              (this.parseDimensionsFromPaths(e), delete e.toBeParsed),
              this.setOptions(e),
              this.setCoords();
          },
          parseDimensionsFromPaths: function (t) {
            for (
              var e, i, r, n, s, o, a = [], h = [], c = this.paths.length;
              c--;

            ) {
              (n = (r = this.paths[c]).height + r.strokeWidth),
                (s = r.width + r.strokeWidth),
                (e = [
                  { x: r.left, y: r.top },
                  { x: r.left + s, y: r.top },
                  { x: r.left, y: r.top + n },
                  { x: r.left + s, y: r.top + n },
                ]),
                (o = this.paths[c].transformMatrix);
              for (var l = 0; l < e.length; l++)
                (i = e[l]),
                  o && (i = u.util.transformPoint(i, o, !1)),
                  a.push(i.x),
                  h.push(i.y);
            }
            (t.width = Math.max.apply(null, a)),
              (t.height = Math.max.apply(null, h));
          },
          drawObject: function (t) {
            t.save(), t.translate(-this.width / 2, -this.height / 2);
            for (var e = 0, i = this.paths.length; e < i; ++e)
              this.paths[e].render(t, !0);
            t.restore();
          },
          shouldCache: function () {
            var t =
              this.objectCaching &&
              (!this.group ||
                this.needsItsOwnCache() ||
                !this.group.isCaching());
            if ((this.caching = t))
              for (var e = 0, i = this.paths.length; e < i; e++)
                if (this.paths[e].willDrawShadow()) return (this.caching = !1);
            return t;
          },
          willDrawShadow: function () {
            if (this.shadow) return !0;
            for (var t = 0, e = this.paths.length; t < e; t++)
              if (this.paths[t].willDrawShadow()) return !0;
            return !1;
          },
          isCaching: function () {
            return this.caching || (this.group && this.group.isCaching());
          },
          isCacheDirty: function () {
            if (this.callSuper('isCacheDirty')) return !0;
            if (!this.statefullCache) return !1;
            for (var t = 0, e = this.paths.length; t < e; t++)
              if (this.paths[t].isCacheDirty(!0)) {
                if (this._cacheCanvas) {
                  var i = this.cacheWidth / this.zoomX,
                    r = this.cacheHeight / this.zoomY;
                  this._cacheContext.clearRect(-i / 2, -r / 2, i, r);
                }
                return !0;
              }
            return !1;
          },
          _set: function (t, e) {
            if ('fill' === t && e && this.isSameColor())
              for (var i = this.paths.length; i--; ) this.paths[i]._set(t, e);
            return this.callSuper('_set', t, e);
          },
          toObject: function (r) {
            var t = this.paths.map(function (t) {
              var e = t.includeDefaultValues;
              t.includeDefaultValues = t.group.includeDefaultValues;
              var i = t.toObject(r);
              return (t.includeDefaultValues = e), i;
            });
            return e(this.callSuper('toObject', ['sourcePath'].concat(r)), {
              paths: t,
            });
          },
          toDatalessObject: function (t) {
            var e = this.toObject(t);
            return this.sourcePath && (e.paths = this.sourcePath), e;
          },
          toSVG: function (t) {
            var e = this.getObjects(),
              i = this.getPointByOrigin('left', 'top'),
              r = 'translate(' + i.x + ' ' + i.y + ')',
              n = this._createBaseSVGMarkup();
            n.push(
              '<g ',
              this.getSvgId(),
              'style="',
              this.getSvgStyles(),
              '" ',
              'transform="',
              this.getSvgTransformMatrix(),
              r,
              this.getSvgTransform(),
              '" ',
              '>\n'
            );
            for (var s = 0, o = e.length; s < o; s++)
              n.push('\t', e[s].toSVG(t));
            return n.push('</g>\n'), t ? t(n.join('')) : n.join('');
          },
          toString: function () {
            return (
              '#<fabric.PathGroup (' +
              this.complexity() +
              '): { top: ' +
              this.top +
              ', left: ' +
              this.left +
              ' }>'
            );
          },
          isSameColor: function () {
            var i = this.getObjects()[0].get('fill') || '';
            return (
              'string' == typeof i &&
              ((i = i.toLowerCase()),
              this.getObjects().every(function (t) {
                var e = t.get('fill') || '';
                return 'string' == typeof e && e.toLowerCase() === i;
              }))
            );
          },
          complexity: function () {
            return this.paths.reduce(function (t, e) {
              return t + (e && e.complexity ? e.complexity() : 0);
            }, 0);
          },
          getObjects: function () {
            return this.paths;
          },
        })),
        (u.PathGroup.fromObject = function (r, n) {
          var s = r.paths;
          delete r.paths,
            'string' == typeof s
              ? u.loadSVGFromURL(s, function (t) {
                  var e = s,
                    i = u.util.groupSVGElements(t, r, e);
                  (r.paths = s), n(i);
                })
              : u.util.enlivenObjects(s, function (t) {
                  var e = new u.PathGroup(t, r);
                  (r.paths = s), n(e);
                });
        }),
        (u.PathGroup.async = !0));
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var o = t.fabric || (t.fabric = {}),
      e = o.util.object.extend,
      a = o.util.array.min,
      h = o.util.array.max;
    if (!o.Group) {
      var r = {
        lockMovementX: !0,
        lockMovementY: !0,
        lockRotation: !0,
        lockScalingX: !0,
        lockScalingY: !0,
        lockUniScaling: !0,
      };
      (o.Group = o.util.createClass(o.Object, o.Collection, {
        type: 'group',
        strokeWidth: 0,
        subTargetCheck: !1,
        cacheProperties: [],
        initialize: function (t, e, i) {
          (e = e || {}),
            (this._objects = []),
            i && this.callSuper('initialize', e),
            (this._objects = t || []);
          for (var r = this._objects.length; r--; )
            this._objects[r].group = this;
          e.originX && (this.originX = e.originX),
            e.originY && (this.originY = e.originY),
            i
              ? this._updateObjectsCoords(!0)
              : (this._calcBounds(),
                this._updateObjectsCoords(),
                this.callSuper('initialize', e)),
            this.setCoords(),
            this.saveCoords();
        },
        _updateObjectsCoords: function (t) {
          for (var e = this.getCenterPoint(), i = this._objects.length; i--; )
            this._updateObjectCoords(this._objects[i], e, t);
        },
        _updateObjectCoords: function (t, e, i) {
          if (
            ((t.__origHasControls = t.hasControls), (t.hasControls = !1), !i)
          ) {
            var r = t.getLeft(),
              n = t.getTop();
            t.set({ left: r - e.x, top: n - e.y }), t.setCoords(!0, !0);
          }
        },
        toString: function () {
          return '#<fabric.Group: (' + this.complexity() + ')>';
        },
        addWithUpdate: function (t) {
          return (
            this._restoreObjectsState(),
            o.util.resetObjectTransform(this),
            t &&
              (this._objects.push(t),
              (t.group = this),
              t._set('canvas', this.canvas)),
            this.forEachObject(this._setObjectActive, this),
            this._calcBounds(),
            this._updateObjectsCoords(),
            this.setCoords(),
            (this.dirty = !0),
            this
          );
        },
        _setObjectActive: function (t) {
          t.set('active', !0), (t.group = this);
        },
        removeWithUpdate: function (t) {
          return (
            this._restoreObjectsState(),
            o.util.resetObjectTransform(this),
            this.forEachObject(this._setObjectActive, this),
            this.remove(t),
            this._calcBounds(),
            this._updateObjectsCoords(),
            this.setCoords(),
            (this.dirty = !0),
            this
          );
        },
        _onObjectAdded: function (t) {
          (this.dirty = !0), (t.group = this), t._set('canvas', this.canvas);
        },
        _onObjectRemoved: function (t) {
          (this.dirty = !0), delete t.group, t.set('active', !1);
        },
        delegatedProperties: {
          fill: !0,
          stroke: !0,
          strokeWidth: !0,
          fontFamily: !0,
          fontWeight: !0,
          fontSize: !0,
          fontStyle: !0,
          lineHeight: !0,
          textDecoration: !0,
          textAlign: !0,
          backgroundColor: !0,
        },
        _set: function (t, e) {
          var i = this._objects.length;
          if (this.delegatedProperties[t] || 'canvas' === t)
            for (; i--; ) this._objects[i].set(t, e);
          else for (; i--; ) this._objects[i].setOnGroup(t, e);
          this.callSuper('_set', t, e);
        },
        toObject: function (r) {
          var t = this.getObjects().map(function (t) {
            var e = t.includeDefaultValues;
            t.includeDefaultValues = t.group.includeDefaultValues;
            var i = t.toObject(r);
            return (t.includeDefaultValues = e), i;
          });
          return e(this.callSuper('toObject', r), { objects: t });
        },
        toDatalessObject: function (r) {
          var t = this.getObjects().map(function (t) {
            var e = t.includeDefaultValues;
            t.includeDefaultValues = t.group.includeDefaultValues;
            var i = t.toDatalessObject(r);
            return (t.includeDefaultValues = e), i;
          });
          return e(this.callSuper('toDatalessObject', r), { objects: t });
        },
        render: function (t) {
          (this._transformDone = !0),
            this.callSuper('render', t),
            (this._transformDone = !1);
        },
        shouldCache: function () {
          var t =
            this.objectCaching &&
            (!this.group || this.needsItsOwnCache() || !this.group.isCaching());
          if ((this.caching = t))
            for (var e = 0, i = this._objects.length; e < i; e++)
              if (this._objects[e].willDrawShadow()) return (this.caching = !1);
          return t;
        },
        willDrawShadow: function () {
          if (this.callSuper('willDrawShadow')) return !0;
          for (var t = 0, e = this._objects.length; t < e; t++)
            if (this._objects[t].willDrawShadow()) return !0;
          return !1;
        },
        isCaching: function () {
          return this.caching || (this.group && this.group.isCaching());
        },
        drawObject: function (t) {
          for (var e = 0, i = this._objects.length; e < i; e++)
            this._renderObject(this._objects[e], t);
        },
        isCacheDirty: function () {
          if (this.callSuper('isCacheDirty')) return !0;
          if (!this.statefullCache) return !1;
          for (var t = 0, e = this._objects.length; t < e; t++)
            if (this._objects[t].isCacheDirty(!0)) {
              if (this._cacheCanvas) {
                var i = this.cacheWidth / this.zoomX,
                  r = this.cacheHeight / this.zoomY;
                this._cacheContext.clearRect(-i / 2, -r / 2, i, r);
              }
              return !0;
            }
          return !1;
        },
        _renderControls: function (t, e) {
          t.save(),
            (t.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1),
            this.callSuper('_renderControls', t, e);
          for (var i = 0, r = this._objects.length; i < r; i++)
            this._objects[i]._renderControls(t);
          t.restore();
        },
        _renderObject: function (t, e) {
          if (t.visible) {
            var i = t.hasRotatingPoint;
            (t.hasRotatingPoint = !1), t.render(e), (t.hasRotatingPoint = i);
          }
        },
        _restoreObjectsState: function () {
          return this._objects.forEach(this._restoreObjectState, this), this;
        },
        realizeTransform: function (t) {
          var e = t.calcTransformMatrix(),
            i = o.util.qrDecompose(e),
            r = new o.Point(i.translateX, i.translateY);
          return (
            (t.flipX = !1),
            (t.flipY = !1),
            t.set('scaleX', i.scaleX),
            t.set('scaleY', i.scaleY),
            (t.skewX = i.skewX),
            (t.skewY = i.skewY),
            (t.angle = i.angle),
            t.setPositionByOrigin(r, 'center', 'center'),
            t
          );
        },
        _restoreObjectState: function (t) {
          return (
            this.realizeTransform(t),
            t.setCoords(),
            (t.hasControls = t.__origHasControls),
            delete t.__origHasControls,
            t.set('active', !1),
            delete t.group,
            this
          );
        },
        destroy: function () {
          return this._restoreObjectsState();
        },
        saveCoords: function () {
          return (
            (this._originalLeft = this.get('left')),
            (this._originalTop = this.get('top')),
            this
          );
        },
        hasMoved: function () {
          return (
            this._originalLeft !== this.get('left') ||
            this._originalTop !== this.get('top')
          );
        },
        setObjectsCoords: function () {
          return (
            this.forEachObject(function (t) {
              t.setCoords(!0, !0);
            }),
            this
          );
        },
        _calcBounds: function (t) {
          for (
            var e,
              i,
              r,
              n = [],
              s = [],
              o = ['tr', 'br', 'bl', 'tl'],
              a = 0,
              h = this._objects.length,
              c = o.length;
            a < h;
            ++a
          )
            for ((e = this._objects[a]).setCoords(!0), r = 0; r < c; r++)
              (i = o[r]), n.push(e.oCoords[i].x), s.push(e.oCoords[i].y);
          this.set(this._getBounds(n, s, t));
        },
        _getBounds: function (t, e, i) {
          var r = new o.Point(a(t), a(e)),
            n = new o.Point(h(t), h(e)),
            s = { width: n.x - r.x || 0, height: n.y - r.y || 0 };
          return (
            i ||
              ((s.left = r.x || 0),
              (s.top = r.y || 0),
              'center' === this.originX && (s.left += s.width / 2),
              'right' === this.originX && (s.left += s.width),
              'center' === this.originY && (s.top += s.height / 2),
              'bottom' === this.originY && (s.top += s.height)),
            s
          );
        },
        toSVG: function (t) {
          var e = this._createBaseSVGMarkup();
          e.push(
            '<g ',
            this.getSvgId(),
            'transform="',
            this.getSvgTransform(),
            this.getSvgTransformMatrix(),
            '" style="',
            this.getSvgFilter(),
            '">\n'
          );
          for (var i = 0, r = this._objects.length; i < r; i++)
            e.push('\t', this._objects[i].toSVG(t));
          return e.push('</g>\n'), t ? t(e.join('')) : e.join('');
        },
        get: function (t) {
          if (t in r) {
            if (this[t]) return this[t];
            for (var e = 0, i = this._objects.length; e < i; e++)
              if (this._objects[e][t]) return !0;
            return !1;
          }
          return t in this.delegatedProperties
            ? this._objects[0] && this._objects[0].get(t)
            : this[t];
        },
      })),
        (o.Group.fromObject = function (i, r) {
          o.util.enlivenObjects(i.objects, function (t) {
            var e = o.util.object.clone(i, !0);
            delete e.objects, r && r(new o.Group(t, e, !0));
          });
        }),
        (o.Group.async = !0);
    }
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var o = fabric.util.object.extend;
    if ((t.fabric || (t.fabric = {}), t.fabric.Image))
      fabric.warn('fabric.Image is already defined.');
    else {
      var e = fabric.Object.prototype.stateProperties.concat();
      e.push('alignX', 'alignY', 'meetOrSlice'),
        (fabric.Image = fabric.util.createClass(fabric.Object, {
          type: 'image',
          crossOrigin: '',
          alignX: 'none',
          alignY: 'none',
          meetOrSlice: 'meet',
          strokeWidth: 0,
          _lastScaleX: 1,
          _lastScaleY: 1,
          minimumScaleTrigger: 0.5,
          stateProperties: e,
          objectCaching: !1,
          initialize: function (t, e, i) {
            (e = e || {}),
              (this.filters = []),
              (this.resizeFilters = []),
              this.callSuper('initialize', e),
              this._initElement(t, e, i);
          },
          getElement: function () {
            return this._element;
          },
          setElement: function (t, e, i) {
            var r, n;
            return (
              (this._element = t),
              (this._originalElement = t),
              this._initConfig(i),
              (r =
                0 === this.resizeFilters.length
                  ? e
                  : ((n = this),
                    function () {
                      n.applyFilters(
                        e,
                        n.resizeFilters,
                        n._filteredEl || n._originalElement,
                        !0
                      );
                    })),
              0 !== this.filters.length ? this.applyFilters(r) : r && r(this),
              this
            );
          },
          setCrossOrigin: function (t) {
            return (
              (this.crossOrigin = t), (this._element.crossOrigin = t), this
            );
          },
          getOriginalSize: function () {
            var t = this.getElement();
            return { width: t.width, height: t.height };
          },
          _stroke: function (t) {
            if (this.stroke && 0 !== this.strokeWidth) {
              var e = this.width / 2,
                i = this.height / 2;
              t.beginPath(),
                t.moveTo(-e, -i),
                t.lineTo(e, -i),
                t.lineTo(e, i),
                t.lineTo(-e, i),
                t.lineTo(-e, -i),
                t.closePath();
            }
          },
          _renderDashedStroke: function (t) {
            var e = -this.width / 2,
              i = -this.height / 2,
              r = this.width,
              n = this.height;
            t.save(),
              this._setStrokeStyles(t),
              t.beginPath(),
              fabric.util.drawDashedLine(
                t,
                e,
                i,
                e + r,
                i,
                this.strokeDashArray
              ),
              fabric.util.drawDashedLine(
                t,
                e + r,
                i,
                e + r,
                i + n,
                this.strokeDashArray
              ),
              fabric.util.drawDashedLine(
                t,
                e + r,
                i + n,
                e,
                i + n,
                this.strokeDashArray
              ),
              fabric.util.drawDashedLine(
                t,
                e,
                i + n,
                e,
                i,
                this.strokeDashArray
              ),
              t.closePath(),
              t.restore();
          },
          toObject: function (t) {
            var e = [],
              i = [],
              r = 1,
              n = 1;
            this.filters.forEach(function (t) {
              t &&
                ('Resize' === t.type && ((r *= t.scaleX), (n *= t.scaleY)),
                e.push(t.toObject()));
            }),
              this.resizeFilters.forEach(function (t) {
                t && i.push(t.toObject());
              });
            var s = o(
              this.callSuper(
                'toObject',
                ['crossOrigin', 'alignX', 'alignY', 'meetOrSlice'].concat(t)
              ),
              { src: this.getSrc(), filters: e, resizeFilters: i }
            );
            return (s.width /= r), (s.height /= n), s;
          },
          toSVG: function (t) {
            var e = this._createBaseSVGMarkup(),
              i = -this.width / 2,
              r = -this.height / 2,
              n = 'none';
            if (
              (this.group &&
                'path-group' === this.group.type &&
                ((i = this.left), (r = this.top)),
              'none' !== this.alignX &&
                'none' !== this.alignY &&
                (n =
                  'x' +
                  this.alignX +
                  'Y' +
                  this.alignY +
                  ' ' +
                  this.meetOrSlice),
              e.push(
                '<g transform="',
                this.getSvgTransform(),
                this.getSvgTransformMatrix(),
                '">\n',
                '<image ',
                this.getSvgId(),
                'xlink:href="',
                this.getSvgSrc(!0),
                '" x="',
                i,
                '" y="',
                r,
                '" style="',
                this.getSvgStyles(),
                '" width="',
                this.width,
                '" height="',
                this.height,
                '" preserveAspectRatio="',
                n,
                '"',
                '></image>\n'
              ),
              this.stroke || this.strokeDashArray)
            ) {
              var s = this.fill;
              (this.fill = null),
                e.push(
                  '<rect ',
                  'x="',
                  i,
                  '" y="',
                  r,
                  '" width="',
                  this.width,
                  '" height="',
                  this.height,
                  '" style="',
                  this.getSvgStyles(),
                  '"/>\n'
                ),
                (this.fill = s);
            }
            return e.push('</g>\n'), t ? t(e.join('')) : e.join('');
          },
          getSrc: function (t) {
            var e = t ? this._element : this._originalElement;
            return e ? (fabric.isLikelyNode ? e._src : e.src) : this.src || '';
          },
          setSrc: function (t, e, i) {
            fabric.util.loadImage(
              t,
              function (t) {
                return this.setElement(t, e, i);
              },
              this,
              i && i.crossOrigin
            );
          },
          toString: function () {
            return '#<fabric.Image: { src: "' + this.getSrc() + '" }>';
          },
          applyFilters: function (t, e, i, r) {
            if (((e = e || this.filters), (i = i || this._originalElement))) {
              var n,
                s,
                o = fabric.util.createImage(),
                a = this.canvas
                  ? this.canvas.getRetinaScaling()
                  : fabric.devicePixelRatio,
                h = this.minimumScaleTrigger / a,
                c = this;
              if (0 === e.length) return (this._element = i), t && t(this), i;
              var l = fabric.util.createCanvasElement();
              return (
                (l.width = i.width),
                (l.height = i.height),
                l.getContext('2d').drawImage(i, 0, 0, i.width, i.height),
                e.forEach(function (t) {
                  t &&
                    (r
                      ? ((n = c.scaleX < h ? c.scaleX : 1),
                        (s = c.scaleY < h ? c.scaleY : 1),
                        n * a < 1 && (n *= a),
                        s * a < 1 && (s *= a))
                      : ((n = t.scaleX), (s = t.scaleY)),
                    t.applyTo(l, n, s),
                    r ||
                      'Resize' !== t.type ||
                      ((c.width *= t.scaleX), (c.height *= t.scaleY)));
                }),
                (o.width = l.width),
                (o.height = l.height),
                fabric.isLikelyNode
                  ? ((o.src = l.toBuffer(void 0, fabric.Image.pngCompression)),
                    (c._element = o),
                    r || (c._filteredEl = o),
                    t && t(c))
                  : ((o.onload = function () {
                      (c._element = o),
                        r || (c._filteredEl = o),
                        t && t(c),
                        (o.onload = l = null);
                    }),
                    (o.src = l.toDataURL('image/png'))),
                l
              );
            }
          },
          _render: function (t, e) {
            var i,
              r,
              n,
              s = this._findMargins();
            (i = e ? this.left : -this.width / 2),
              (r = e ? this.top : -this.height / 2),
              'slice' === this.meetOrSlice &&
                (t.beginPath(),
                t.rect(i, r, this.width, this.height),
                t.clip()),
              (n =
                !1 === this.isMoving &&
                this.resizeFilters.length &&
                this._needsResize()
                  ? ((this._lastScaleX = this.scaleX),
                    (this._lastScaleY = this.scaleY),
                    this.applyFilters(
                      null,
                      this.resizeFilters,
                      this._filteredEl || this._originalElement,
                      !0
                    ))
                  : this._element) &&
                t.drawImage(n, i + s.marginX, r + s.marginY, s.width, s.height),
              this._stroke(t),
              this._renderStroke(t);
          },
          _needsResize: function () {
            return (
              this.scaleX !== this._lastScaleX ||
              this.scaleY !== this._lastScaleY
            );
          },
          _findMargins: function () {
            var t,
              e,
              i = this.width,
              r = this.height,
              n = 0,
              s = 0;
            return (
              ('none' === this.alignX && 'none' === this.alignY) ||
                ((t = [
                  this.width / this._element.width,
                  this.height / this._element.height,
                ]),
                (e =
                  'meet' === this.meetOrSlice
                    ? Math.min.apply(null, t)
                    : Math.max.apply(null, t)),
                (i = this._element.width * e),
                (r = this._element.height * e),
                'Mid' === this.alignX && (n = (this.width - i) / 2),
                'Max' === this.alignX && (n = this.width - i),
                'Mid' === this.alignY && (s = (this.height - r) / 2),
                'Max' === this.alignY && (s = this.height - r)),
              { width: i, height: r, marginX: n, marginY: s }
            );
          },
          _resetWidthHeight: function () {
            var t = this.getElement();
            this.set('width', t.width), this.set('height', t.height);
          },
          _initElement: function (t, e, i) {
            this.setElement(fabric.util.getById(t), i, e),
              fabric.util.addClass(this.getElement(), fabric.Image.CSS_CANVAS);
          },
          _initConfig: function (t) {
            (t = t || {}),
              this.setOptions(t),
              this._setWidthHeight(t),
              this._element &&
                this.crossOrigin &&
                (this._element.crossOrigin = this.crossOrigin);
          },
          _initFilters: function (t, e) {
            t && t.length
              ? fabric.util.enlivenObjects(
                  t,
                  function (t) {
                    e && e(t);
                  },
                  'fabric.Image.filters'
                )
              : e && e();
          },
          _setWidthHeight: function (t) {
            (this.width =
              'width' in t
                ? t.width
                : (this.getElement() && this.getElement().width) || 0),
              (this.height =
                'height' in t
                  ? t.height
                  : (this.getElement() && this.getElement().height) || 0);
          },
        })),
        (fabric.Image.CSS_CANVAS = 'canvas-img'),
        (fabric.Image.prototype.getSvgSrc = fabric.Image.prototype.getSrc),
        (fabric.Image.fromObject = function (i, r) {
          fabric.util.loadImage(
            i.src,
            function (e, t) {
              t
                ? r && r(null, t)
                : fabric.Image.prototype._initFilters.call(
                    i,
                    i.filters,
                    function (t) {
                      (i.filters = t || []),
                        fabric.Image.prototype._initFilters.call(
                          i,
                          i.resizeFilters,
                          function (t) {
                            return (
                              (i.resizeFilters = t || []),
                              new fabric.Image(e, i, r)
                            );
                          }
                        );
                    }
                  );
            },
            null,
            i.crossOrigin
          );
        }),
        (fabric.Image.fromURL = function (t, e, i) {
          fabric.util.loadImage(
            t,
            function (t) {
              e && e(new fabric.Image(t, i));
            },
            null,
            i && i.crossOrigin
          );
        }),
        (fabric.Image.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat(
          'x y width height preserveAspectRatio xlink:href crossOrigin'.split(
            ' '
          )
        )),
        (fabric.Image.fromElement = function (t, e, i) {
          var r,
            n = fabric.parseAttributes(t, fabric.Image.ATTRIBUTE_NAMES);
          n.preserveAspectRatio &&
            ((r = fabric.util.parsePreserveAspectRatioAttribute(
              n.preserveAspectRatio
            )),
            o(n, r)),
            fabric.Image.fromURL(
              n['xlink:href'],
              e,
              o(i ? fabric.util.object.clone(i) : {}, n)
            );
        }),
        (fabric.Image.async = !0),
        (fabric.Image.pngCompression = 1);
    }
  })('undefined' != typeof exports ? exports : this),
  fabric.util.object.extend(fabric.Object.prototype, {
    _getAngleValueForStraighten: function () {
      var t = this.getAngle() % 360;
      return 0 < t ? 90 * Math.round((t - 1) / 90) : 90 * Math.round(t / 90);
    },
    straighten: function () {
      return this.setAngle(this._getAngleValueForStraighten()), this;
    },
    fxStraighten: function (t) {
      function e() {}
      var i = (t = t || {}).onComplete || e,
        r = t.onChange || e,
        n = this;
      return (
        fabric.util.animate({
          startValue: this.get('angle'),
          endValue: this._getAngleValueForStraighten(),
          duration: this.FX_DURATION,
          onChange: function (t) {
            n.setAngle(t), r();
          },
          onComplete: function () {
            n.setCoords(), i();
          },
          onStart: function () {
            n.set('active', !1);
          },
        }),
        this
      );
    },
  }),
  fabric.util.object.extend(fabric.StaticCanvas.prototype, {
    straightenObject: function (t) {
      return t.straighten(), this.renderAll(), this;
    },
    fxStraightenObject: function (t) {
      return t.fxStraighten({ onChange: this.renderAll.bind(this) }), this;
    },
  }),
  (fabric.Image.filters = fabric.Image.filters || {}),
  (fabric.Image.filters.BaseFilter = fabric.util.createClass({
    type: 'BaseFilter',
    initialize: function (t) {
      t && this.setOptions(t);
    },
    setOptions: function (t) {
      for (var e in t) this[e] = t[e];
    },
    toObject: function () {
      return { type: this.type };
    },
    toJSON: function () {
      return this.toObject();
    },
  })),
  (fabric.Image.filters.BaseFilter.fromObject = function (t, e) {
    var i = new fabric.Image.filters[t.type](t);
    return e && e(i), i;
  }),
  (function (t) {
    'use strict';
    var e = t.fabric || (t.fabric = {}),
      i = e.util.object.extend,
      r = e.Image.filters,
      n = e.util.createClass;
    (r.Brightness = n(r.BaseFilter, {
      type: 'Brightness',
      initialize: function (t) {
        (t = t || {}), (this.brightness = t.brightness || 0);
      },
      applyTo: function (t) {
        for (
          var e = t.getContext('2d'),
            i = e.getImageData(0, 0, t.width, t.height),
            r = i.data,
            n = this.brightness,
            s = 0,
            o = r.length;
          s < o;
          s += 4
        )
          (r[s] += n), (r[s + 1] += n), (r[s + 2] += n);
        e.putImageData(i, 0, 0);
      },
      toObject: function () {
        return i(this.callSuper('toObject'), { brightness: this.brightness });
      },
    })),
      (e.Image.filters.Brightness.fromObject =
        e.Image.filters.BaseFilter.fromObject);
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var e = t.fabric || (t.fabric = {}),
      i = e.util.object.extend,
      r = e.Image.filters,
      n = e.util.createClass;
    (r.Convolute = n(r.BaseFilter, {
      type: 'Convolute',
      initialize: function (t) {
        (t = t || {}),
          (this.opaque = t.opaque),
          (this.matrix = t.matrix || [0, 0, 0, 0, 1, 0, 0, 0, 0]);
      },
      applyTo: function (t) {
        for (
          var e,
            i,
            r,
            n,
            s,
            o,
            a,
            h,
            c,
            l = this.matrix,
            u = t.getContext('2d'),
            f = u.getImageData(0, 0, t.width, t.height),
            d = Math.round(Math.sqrt(l.length)),
            g = Math.floor(d / 2),
            p = f.data,
            v = f.width,
            b = f.height,
            m = u.createImageData(v, b),
            _ = m.data,
            y = this.opaque ? 1 : 0,
            x = 0;
          x < b;
          x++
        )
          for (var C = 0; C < v; C++) {
            s = 4 * (x * v + C);
            for (var S = (n = r = i = e = 0); S < d; S++)
              for (var w = 0; w < d; w++)
                (o = C + w - g),
                  (a = x + S - g) < 0 ||
                    b < a ||
                    o < 0 ||
                    v < o ||
                    ((h = 4 * (a * v + o)),
                    (c = l[S * d + w]),
                    (e += p[h] * c),
                    (i += p[1 + h] * c),
                    (r += p[2 + h] * c),
                    (n += p[3 + h] * c));
            (_[s] = e),
              (_[1 + s] = i),
              (_[2 + s] = r),
              (_[3 + s] = n + y * (255 - n));
          }
        u.putImageData(m, 0, 0);
      },
      toObject: function () {
        return i(this.callSuper('toObject'), {
          opaque: this.opaque,
          matrix: this.matrix,
        });
      },
    })),
      (e.Image.filters.Convolute.fromObject =
        e.Image.filters.BaseFilter.fromObject);
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var e = t.fabric || (t.fabric = {}),
      i = e.util.object.extend,
      r = e.Image.filters,
      n = e.util.createClass;
    (r.GradientTransparency = n(r.BaseFilter, {
      type: 'GradientTransparency',
      initialize: function (t) {
        (t = t || {}), (this.threshold = t.threshold || 100);
      },
      applyTo: function (t) {
        for (
          var e = t.getContext('2d'),
            i = e.getImageData(0, 0, t.width, t.height),
            r = i.data,
            n = this.threshold,
            s = r.length,
            o = 0,
            a = r.length;
          o < a;
          o += 4
        )
          r[o + 3] = n + (255 * (s - o)) / s;
        e.putImageData(i, 0, 0);
      },
      toObject: function () {
        return i(this.callSuper('toObject'), { threshold: this.threshold });
      },
    })),
      (e.Image.filters.GradientTransparency.fromObject =
        e.Image.filters.BaseFilter.fromObject);
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var i = t.fabric || (t.fabric = {}),
      e = i.Image.filters,
      r = i.util.createClass;
    (e.Grayscale = r(e.BaseFilter, {
      type: 'Grayscale',
      applyTo: function (t) {
        for (
          var e,
            i = t.getContext('2d'),
            r = i.getImageData(0, 0, t.width, t.height),
            n = r.data,
            s = r.width * r.height * 4,
            o = 0;
          o < s;

        )
          (e = (n[o] + n[o + 1] + n[o + 2]) / 3),
            (n[o] = e),
            (n[o + 1] = e),
            (n[o + 2] = e),
            (o += 4);
        i.putImageData(r, 0, 0);
      },
    })),
      (i.Image.filters.Grayscale.fromObject = function (t, e) {
        return (
          ((t = t || {}).type = 'Grayscale'),
          i.Image.filters.BaseFilter.fromObject(t, e)
        );
      });
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var i = t.fabric || (t.fabric = {}),
      e = i.Image.filters,
      r = i.util.createClass;
    (e.Invert = r(e.BaseFilter, {
      type: 'Invert',
      applyTo: function (t) {
        var e,
          i = t.getContext('2d'),
          r = i.getImageData(0, 0, t.width, t.height),
          n = r.data,
          s = n.length;
        for (e = 0; e < s; e += 4)
          (n[e] = 255 - n[e]),
            (n[e + 1] = 255 - n[e + 1]),
            (n[e + 2] = 255 - n[e + 2]);
        i.putImageData(r, 0, 0);
      },
    })),
      (i.Image.filters.Invert.fromObject = function (t, e) {
        return (
          ((t = t || {}).type = 'Invert'),
          i.Image.filters.BaseFilter.fromObject(t, e)
        );
      });
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var l = t.fabric || (t.fabric = {}),
      e = l.util.object.extend,
      i = l.Image.filters,
      r = l.util.createClass;
    (i.Mask = r(i.BaseFilter, {
      type: 'Mask',
      initialize: function (t) {
        (t = t || {}),
          (this.mask = t.mask),
          (this.channel = -1 < [0, 1, 2, 3].indexOf(t.channel) ? t.channel : 0);
      },
      applyTo: function (t) {
        if (this.mask) {
          var e,
            i = t.getContext('2d'),
            r = i.getImageData(0, 0, t.width, t.height),
            n = r.data,
            s = this.mask.getElement(),
            o = l.util.createCanvasElement(),
            a = this.channel,
            h = r.width * r.height * 4;
          (o.width = t.width),
            (o.height = t.height),
            o.getContext('2d').drawImage(s, 0, 0, t.width, t.height);
          var c = o.getContext('2d').getImageData(0, 0, t.width, t.height).data;
          for (e = 0; e < h; e += 4) n[e + 3] = c[e + a];
          i.putImageData(r, 0, 0);
        }
      },
      toObject: function () {
        return e(this.callSuper('toObject'), {
          mask: this.mask.toObject(),
          channel: this.channel,
        });
      },
    })),
      (l.Image.filters.Mask.fromObject = function (e, i) {
        l.util.loadImage(e.mask.src, function (t) {
          return (
            (e.mask = new l.Image(t, e.mask)),
            l.Image.filters.BaseFilter.fromObject(e, i)
          );
        });
      }),
      (l.Image.filters.Mask.async = !0);
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var e = t.fabric || (t.fabric = {}),
      i = e.util.object.extend,
      r = e.Image.filters,
      n = e.util.createClass;
    (r.Noise = n(r.BaseFilter, {
      type: 'Noise',
      initialize: function (t) {
        (t = t || {}), (this.noise = t.noise || 0);
      },
      applyTo: function (t) {
        for (
          var e,
            i = t.getContext('2d'),
            r = i.getImageData(0, 0, t.width, t.height),
            n = r.data,
            s = this.noise,
            o = 0,
            a = n.length;
          o < a;
          o += 4
        )
          (e = (0.5 - Math.random()) * s),
            (n[o] += e),
            (n[o + 1] += e),
            (n[o + 2] += e);
        i.putImageData(r, 0, 0);
      },
      toObject: function () {
        return i(this.callSuper('toObject'), { noise: this.noise });
      },
    })),
      (e.Image.filters.Noise.fromObject =
        e.Image.filters.BaseFilter.fromObject);
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var e = t.fabric || (t.fabric = {}),
      i = e.util.object.extend,
      r = e.Image.filters,
      n = e.util.createClass;
    (r.Pixelate = n(r.BaseFilter, {
      type: 'Pixelate',
      initialize: function (t) {
        (t = t || {}), (this.blocksize = t.blocksize || 4);
      },
      applyTo: function (t) {
        var e,
          i,
          r,
          n,
          s,
          o,
          a,
          h = t.getContext('2d'),
          c = h.getImageData(0, 0, t.width, t.height),
          l = c.data,
          u = c.height,
          f = c.width;
        for (i = 0; i < u; i += this.blocksize)
          for (r = 0; r < f; r += this.blocksize) {
            (n = l[(e = 4 * i * f + 4 * r)]),
              (s = l[e + 1]),
              (o = l[e + 2]),
              (a = l[e + 3]);
            for (var d = i, g = i + this.blocksize; d < g; d++)
              for (var p = r, v = r + this.blocksize; p < v; p++)
                (l[(e = 4 * d * f + 4 * p)] = n),
                  (l[e + 1] = s),
                  (l[e + 2] = o),
                  (l[e + 3] = a);
          }
        h.putImageData(c, 0, 0);
      },
      toObject: function () {
        return i(this.callSuper('toObject'), { blocksize: this.blocksize });
      },
    })),
      (e.Image.filters.Pixelate.fromObject =
        e.Image.filters.BaseFilter.fromObject);
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var e = t.fabric || (t.fabric = {}),
      i = e.util.object.extend,
      r = e.Image.filters,
      n = e.util.createClass;
    (r.RemoveWhite = n(r.BaseFilter, {
      type: 'RemoveWhite',
      initialize: function (t) {
        (t = t || {}),
          (this.threshold = t.threshold || 30),
          (this.distance = t.distance || 20);
      },
      applyTo: function (t) {
        for (
          var e,
            i,
            r,
            n = t.getContext('2d'),
            s = n.getImageData(0, 0, t.width, t.height),
            o = s.data,
            a = this.threshold,
            h = this.distance,
            c = 255 - a,
            l = Math.abs,
            u = 0,
            f = o.length;
          u < f;
          u += 4
        )
          (e = o[u]),
            (i = o[u + 1]),
            (r = o[u + 2]),
            c < e &&
              c < i &&
              c < r &&
              l(e - i) < h &&
              l(e - r) < h &&
              l(i - r) < h &&
              (o[u + 3] = 0);
        n.putImageData(s, 0, 0);
      },
      toObject: function () {
        return i(this.callSuper('toObject'), {
          threshold: this.threshold,
          distance: this.distance,
        });
      },
    })),
      (e.Image.filters.RemoveWhite.fromObject =
        e.Image.filters.BaseFilter.fromObject);
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var i = t.fabric || (t.fabric = {}),
      e = i.Image.filters,
      r = i.util.createClass;
    (e.Sepia = r(e.BaseFilter, {
      type: 'Sepia',
      applyTo: function (t) {
        var e,
          i,
          r = t.getContext('2d'),
          n = r.getImageData(0, 0, t.width, t.height),
          s = n.data,
          o = s.length;
        for (e = 0; e < o; e += 4)
          (i = 0.3 * s[e] + 0.59 * s[e + 1] + 0.11 * s[e + 2]),
            (s[e] = 100 + i),
            (s[e + 1] = 50 + i),
            (s[e + 2] = 255 + i);
        r.putImageData(n, 0, 0);
      },
    })),
      (i.Image.filters.Sepia.fromObject = function (t, e) {
        return (
          ((t = t || {}).type = 'Sepia'),
          new i.Image.filters.BaseFilter.fromObject(t, e)
        );
      });
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var i = t.fabric || (t.fabric = {}),
      e = i.Image.filters,
      r = i.util.createClass;
    (e.Sepia2 = r(e.BaseFilter, {
      type: 'Sepia2',
      applyTo: function (t) {
        var e,
          i,
          r,
          n,
          s = t.getContext('2d'),
          o = s.getImageData(0, 0, t.width, t.height),
          a = o.data,
          h = a.length;
        for (e = 0; e < h; e += 4)
          (i = a[e]),
            (r = a[e + 1]),
            (n = a[e + 2]),
            (a[e] = (0.393 * i + 0.769 * r + 0.189 * n) / 1.351),
            (a[e + 1] = (0.349 * i + 0.686 * r + 0.168 * n) / 1.203),
            (a[e + 2] = (0.272 * i + 0.534 * r + 0.131 * n) / 2.14);
        s.putImageData(o, 0, 0);
      },
    })),
      (i.Image.filters.Sepia2.fromObject = function (t, e) {
        return (
          ((t = t || {}).type = 'Sepia2'),
          new i.Image.filters.BaseFilter.fromObject(t, e)
        );
      });
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var g = t.fabric || (t.fabric = {}),
      e = g.util.object.extend,
      i = g.Image.filters,
      r = g.util.createClass;
    (i.Tint = r(i.BaseFilter, {
      type: 'Tint',
      initialize: function (t) {
        (t = t || {}),
          (this.color = t.color || '#000000'),
          (this.opacity =
            void 0 !== t.opacity
              ? t.opacity
              : new g.Color(this.color).getAlpha());
      },
      applyTo: function (t) {
        var e,
          i,
          r,
          n,
          s,
          o,
          a,
          h,
          c,
          l = t.getContext('2d'),
          u = l.getImageData(0, 0, t.width, t.height),
          f = u.data,
          d = f.length;
        for (
          i = (c = new g.Color(this.color).getSource())[0] * this.opacity,
            r = c[1] * this.opacity,
            n = c[2] * this.opacity,
            h = 1 - this.opacity,
            e = 0;
          e < d;
          e += 4
        )
          (s = f[e]),
            (o = f[e + 1]),
            (a = f[e + 2]),
            (f[e] = i + s * h),
            (f[e + 1] = r + o * h),
            (f[e + 2] = n + a * h);
        l.putImageData(u, 0, 0);
      },
      toObject: function () {
        return e(this.callSuper('toObject'), {
          color: this.color,
          opacity: this.opacity,
        });
      },
    })),
      (g.Image.filters.Tint.fromObject = g.Image.filters.BaseFilter.fromObject);
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var a = t.fabric || (t.fabric = {}),
      e = a.util.object.extend,
      i = a.Image.filters,
      r = a.util.createClass;
    (i.Multiply = r(i.BaseFilter, {
      type: 'Multiply',
      initialize: function (t) {
        (t = t || {}), (this.color = t.color || '#000000');
      },
      applyTo: function (t) {
        var e,
          i,
          r = t.getContext('2d'),
          n = r.getImageData(0, 0, t.width, t.height),
          s = n.data,
          o = s.length;
        for (i = new a.Color(this.color).getSource(), e = 0; e < o; e += 4)
          (s[e] *= i[0] / 255),
            (s[e + 1] *= i[1] / 255),
            (s[e + 2] *= i[2] / 255);
        r.putImageData(n, 0, 0);
      },
      toObject: function () {
        return e(this.callSuper('toObject'), { color: this.color });
      },
    })),
      (a.Image.filters.Multiply.fromObject =
        a.Image.filters.BaseFilter.fromObject);
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var _ = t.fabric,
      e = _.Image.filters,
      i = _.util.createClass;
    (e.Blend = i(e.BaseFilter, {
      type: 'Blend',
      initialize: function (t) {
        (t = t || {}),
          (this.color = t.color || '#000'),
          (this.image = t.image || !1),
          (this.mode = t.mode || 'multiply'),
          (this.alpha = t.alpha || 1);
      },
      applyTo: function (t) {
        var e,
          i,
          r,
          n,
          s,
          o,
          a,
          h,
          c,
          l,
          u = t.getContext('2d'),
          f = u.getImageData(0, 0, t.width, t.height),
          d = f.data,
          g = !1;
        if (this.image) {
          g = !0;
          var p = _.util.createCanvasElement();
          (p.width = this.image.width), (p.height = this.image.height);
          var v = new _.StaticCanvas(p);
          v.add(this.image),
            (l = v.getContext('2d').getImageData(0, 0, v.width, v.height).data);
        } else
          (e = (l = new _.Color(this.color).getSource())[0] * this.alpha),
            (i = l[1] * this.alpha),
            (r = l[2] * this.alpha);
        for (var b = 0, m = d.length; b < m; b += 4)
          switch (
            ((n = d[b]),
            (s = d[b + 1]),
            (o = d[b + 2]),
            g &&
              ((e = l[b] * this.alpha),
              (i = l[b + 1] * this.alpha),
              (r = l[b + 2] * this.alpha)),
            this.mode)
          ) {
            case 'multiply':
              (d[b] = (n * e) / 255),
                (d[b + 1] = (s * i) / 255),
                (d[b + 2] = (o * r) / 255);
              break;
            case 'screen':
              (d[b] = 1 - (1 - n) * (1 - e)),
                (d[b + 1] = 1 - (1 - s) * (1 - i)),
                (d[b + 2] = 1 - (1 - o) * (1 - r));
              break;
            case 'add':
              (d[b] = Math.min(255, n + e)),
                (d[b + 1] = Math.min(255, s + i)),
                (d[b + 2] = Math.min(255, o + r));
              break;
            case 'diff':
            case 'difference':
              (d[b] = Math.abs(n - e)),
                (d[b + 1] = Math.abs(s - i)),
                (d[b + 2] = Math.abs(o - r));
              break;
            case 'subtract':
              (a = n - e),
                (h = s - i),
                (c = o - r),
                (d[b] = a < 0 ? 0 : a),
                (d[b + 1] = h < 0 ? 0 : h),
                (d[b + 2] = c < 0 ? 0 : c);
              break;
            case 'darken':
              (d[b] = Math.min(n, e)),
                (d[b + 1] = Math.min(s, i)),
                (d[b + 2] = Math.min(o, r));
              break;
            case 'lighten':
              (d[b] = Math.max(n, e)),
                (d[b + 1] = Math.max(s, i)),
                (d[b + 2] = Math.max(o, r));
          }
        u.putImageData(f, 0, 0);
      },
      toObject: function () {
        return {
          color: this.color,
          image: this.image,
          mode: this.mode,
          alpha: this.alpha,
        };
      },
    })),
      (_.Image.filters.Blend.fromObject =
        _.Image.filters.BaseFilter.fromObject);
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var b = t.fabric || (t.fabric = {}),
      P = Math.pow,
      A = Math.floor,
      E = Math.sqrt,
      I = Math.abs,
      m = Math.max,
      h = Math.round,
      n = Math.sin,
      L = Math.ceil,
      e = b.Image.filters,
      i = b.util.createClass;
    (e.Resize = i(e.BaseFilter, {
      type: 'Resize',
      resizeType: 'hermite',
      scaleX: 0,
      scaleY: 0,
      lanczosLobes: 3,
      applyTo: function (t, e, i) {
        if (1 !== e || 1 !== i) {
          (this.rcpScaleX = 1 / e), (this.rcpScaleY = 1 / i);
          var r,
            n = t.width,
            s = t.height,
            o = h(n * e),
            a = h(s * i);
          'sliceHack' === this.resizeType &&
            (r = this.sliceByTwo(t, n, s, o, a)),
            'hermite' === this.resizeType &&
              (r = this.hermiteFastResize(t, n, s, o, a)),
            'bilinear' === this.resizeType &&
              (r = this.bilinearFiltering(t, n, s, o, a)),
            'lanczos' === this.resizeType &&
              (r = this.lanczosResize(t, n, s, o, a)),
            (t.width = o),
            (t.height = a),
            t.getContext('2d').putImageData(r, 0, 0);
        }
      },
      sliceByTwo: function (t, e, i, r, n) {
        var s,
          o = t.getContext('2d'),
          a = 0.5,
          h = 0.5,
          c = 1,
          l = 1,
          u = !1,
          f = !1,
          d = e,
          g = i,
          p = b.util.createCanvasElement(),
          v = p.getContext('2d');
        for (
          r = A(r),
            n = A(n),
            p.width = m(r, e),
            p.height = m(n, i),
            e < r && ((a = 2), (c = -1)),
            i < n && ((h = 2), (l = -1)),
            s = o.getImageData(0, 0, e, i),
            t.width = m(r, e),
            t.height = m(n, i),
            o.putImageData(s, 0, 0);
          !u || !f;

        )
          (i = g),
            r * c < A((e = d) * a * c) ? (d = A(d * a)) : ((d = r), (u = !0)),
            n * l < A(g * h * l) ? (g = A(g * h)) : ((g = n), (f = !0)),
            (s = o.getImageData(0, 0, e, i)),
            v.putImageData(s, 0, 0),
            o.clearRect(0, 0, d, g),
            o.drawImage(p, 0, 0, e, i, 0, 0, d, g);
        return o.getImageData(0, 0, r, n);
      },
      lanczosResize: function (t, g, p, v, b) {
        var i,
          e = t.getContext('2d'),
          r = e.getImageData(0, 0, g, p),
          m = e.getImageData(0, 0, v, b),
          _ = r.data,
          y = m.data,
          x =
            ((i = this.lanczosLobes),
            function (t) {
              if (i < t) return 0;
              if (((t *= Math.PI), I(t) < 1e-16)) return 1;
              var e = t / i;
              return (n(t) * n(e)) / t / e;
            }),
          C = this.rcpScaleX,
          S = this.rcpScaleY,
          w = 2 / this.rcpScaleX,
          O = 2 / this.rcpScaleY,
          T = L((C * this.lanczosLobes) / 2),
          j = L((S * this.lanczosLobes) / 2),
          k = {},
          M = {},
          D = {};
        return (function t(e) {
          var i, r, n, s, o, a, h, c, l, u, f;
          for (M.x = (e + 0.5) * C, D.x = A(M.x), i = 0; i < b; i++) {
            for (
              M.y = (i + 0.5) * S,
                D.y = A(M.y),
                l = c = h = a = o = 0,
                r = D.x - T;
              r <= D.x + T;
              r++
            )
              if (!(r < 0 || g <= r)) {
                (u = A(1e3 * I(r - M.x))), k[u] || (k[u] = {});
                for (var d = D.y - j; d <= D.y + j; d++)
                  d < 0 ||
                    p <= d ||
                    ((f = A(1e3 * I(d - M.y))),
                    k[u][f] ||
                      (k[u][f] = x(E(P(u * w, 2) + P(f * O, 2)) / 1e3)),
                    0 < (n = k[u][f]) &&
                      ((o += n),
                      (a += n * _[(s = 4 * (d * g + r))]),
                      (h += n * _[s + 1]),
                      (c += n * _[s + 2]),
                      (l += n * _[s + 3])));
              }
            (y[(s = 4 * (i * v + e))] = a / o),
              (y[s + 1] = h / o),
              (y[s + 2] = c / o),
              (y[s + 3] = l / o);
          }
          return ++e < v ? t(e) : m;
        })(0);
      },
      bilinearFiltering: function (t, e, i, r, n) {
        var s,
          o,
          a,
          h,
          c,
          l,
          u,
          f,
          d,
          g = 0,
          p = this.rcpScaleX,
          v = this.rcpScaleY,
          b = t.getContext('2d'),
          m = 4 * (e - 1),
          _ = b.getImageData(0, 0, e, i).data,
          y = b.getImageData(0, 0, r, n),
          x = y.data;
        for (a = 0; a < n; a++)
          for (h = 0; h < r; h++)
            for (
              c = p * h - (s = A(p * h)),
                l = v * a - (o = A(v * a)),
                d = 4 * (o * e + s),
                u = 0;
              u < 4;
              u++
            )
              (f =
                _[d + u] * (1 - c) * (1 - l) +
                _[4 + d + u] * c * (1 - l) +
                _[d + m + u] * l * (1 - c) +
                _[d + m + 4 + u] * c * l),
                (x[g++] = f);
        return y;
      },
      hermiteFastResize: function (t, e, i, r, n) {
        for (
          var s = this.rcpScaleX,
            o = this.rcpScaleY,
            a = L(s / 2),
            h = L(o / 2),
            c = t.getContext('2d'),
            l = c.getImageData(0, 0, e, i).data,
            u = c.getImageData(0, 0, r, n),
            f = u.data,
            d = 0;
          d < n;
          d++
        )
          for (var g = 0; g < r; g++) {
            for (
              var p = 4 * (g + d * r),
                v = 0,
                b = 0,
                m = 0,
                _ = 0,
                y = 0,
                x = 0,
                C = 0,
                S = (d + 0.5) * o,
                w = A(d * o);
              w < (d + 1) * o;
              w++
            )
              for (
                var O = I(S - (w + 0.5)) / h,
                  T = (g + 0.5) * s,
                  j = O * O,
                  k = A(g * s);
                k < (g + 1) * s;
                k++
              ) {
                var M = I(T - (k + 0.5)) / a,
                  D = E(j + M * M);
                (1 < D && D < -1) ||
                  (0 < (v = 2 * D * D * D - 3 * D * D + 1) &&
                    ((C += v * l[(M = 4 * (k + w * e)) + 3]),
                    (m += v),
                    l[M + 3] < 255 && (v = (v * l[M + 3]) / 250),
                    (_ += v * l[M]),
                    (y += v * l[M + 1]),
                    (x += v * l[M + 2]),
                    (b += v)));
              }
            (f[p] = _ / b),
              (f[1 + p] = y / b),
              (f[2 + p] = x / b),
              (f[3 + p] = C / m);
          }
        return u;
      },
      toObject: function () {
        return {
          type: this.type,
          scaleX: this.scaleX,
          scaleY: this.scaleY,
          resizeType: this.resizeType,
          lanczosLobes: this.lanczosLobes,
        };
      },
    })),
      (b.Image.filters.Resize.fromObject =
        b.Image.filters.BaseFilter.fromObject);
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var e = t.fabric || (t.fabric = {}),
      i = e.util.object.extend,
      r = e.Image.filters,
      n = e.util.createClass;
    (r.ColorMatrix = n(r.BaseFilter, {
      type: 'ColorMatrix',
      initialize: function (t) {
        (t = t || {}),
          (this.matrix = t.matrix || [
            1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0,
          ]);
      },
      applyTo: function (t) {
        var e,
          i,
          r,
          n,
          s,
          o = t.getContext('2d'),
          a = o.getImageData(0, 0, t.width, t.height),
          h = a.data,
          c = h.length,
          l = this.matrix;
        for (e = 0; e < c; e += 4)
          (i = h[e]),
            (r = h[e + 1]),
            (n = h[e + 2]),
            (s = h[e + 3]),
            (h[e] = i * l[0] + r * l[1] + n * l[2] + s * l[3] + l[4]),
            (h[e + 1] = i * l[5] + r * l[6] + n * l[7] + s * l[8] + l[9]),
            (h[e + 2] = i * l[10] + r * l[11] + n * l[12] + s * l[13] + l[14]),
            (h[e + 3] = i * l[15] + r * l[16] + n * l[17] + s * l[18] + l[19]);
        o.putImageData(a, 0, 0);
      },
      toObject: function () {
        return i(this.callSuper('toObject'), {
          type: this.type,
          matrix: this.matrix,
        });
      },
    })),
      (e.Image.filters.ColorMatrix.fromObject =
        e.Image.filters.BaseFilter.fromObject);
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var e = t.fabric || (t.fabric = {}),
      i = e.util.object.extend,
      r = e.Image.filters,
      n = e.util.createClass;
    (r.Contrast = n(r.BaseFilter, {
      type: 'Contrast',
      initialize: function (t) {
        (t = t || {}), (this.contrast = t.contrast || 0);
      },
      applyTo: function (t) {
        for (
          var e = t.getContext('2d'),
            i = e.getImageData(0, 0, t.width, t.height),
            r = i.data,
            n = (259 * (this.contrast + 255)) / (255 * (259 - this.contrast)),
            s = 0,
            o = r.length;
          s < o;
          s += 4
        )
          (r[s] = n * (r[s] - 128) + 128),
            (r[s + 1] = n * (r[s + 1] - 128) + 128),
            (r[s + 2] = n * (r[s + 2] - 128) + 128);
        e.putImageData(i, 0, 0);
      },
      toObject: function () {
        return i(this.callSuper('toObject'), { contrast: this.contrast });
      },
    })),
      (e.Image.filters.Contrast.fromObject =
        e.Image.filters.BaseFilter.fromObject);
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var e = t.fabric || (t.fabric = {}),
      i = e.util.object.extend,
      r = e.Image.filters,
      n = e.util.createClass;
    (r.Saturate = n(r.BaseFilter, {
      type: 'Saturate',
      initialize: function (t) {
        (t = t || {}), (this.saturate = t.saturate || 0);
      },
      applyTo: function (t) {
        for (
          var e,
            i = t.getContext('2d'),
            r = i.getImageData(0, 0, t.width, t.height),
            n = r.data,
            s = 0.01 * -this.saturate,
            o = 0,
            a = n.length;
          o < a;
          o += 4
        )
          (e = Math.max(n[o], n[o + 1], n[o + 2])),
            (n[o] += e !== n[o] ? (e - n[o]) * s : 0),
            (n[o + 1] += e !== n[o + 1] ? (e - n[o + 1]) * s : 0),
            (n[o + 2] += e !== n[o + 2] ? (e - n[o + 2]) * s : 0);
        i.putImageData(r, 0, 0);
      },
      toObject: function () {
        return i(this.callSuper('toObject'), { saturate: this.saturate });
      },
    })),
      (e.Image.filters.Saturate.fromObject =
        e.Image.filters.BaseFilter.fromObject);
  })('undefined' != typeof exports ? exports : this),
  (function (t) {
    'use strict';
    var d = t.fabric || (t.fabric = {}),
      g = d.util.toFixed,
      p = d.Object.NUM_FRACTION_DIGITS;
    if (d.Text) d.warn('fabric.Text is already defined');
    else {
      var e = d.Object.prototype.stateProperties.concat();
      e.push(
        'fontFamily',
        'fontWeight',
        'fontSize',
        'text',
        'textDecoration',
        'textAlign',
        'fontStyle',
        'lineHeight',
        'textBackgroundColor',
        'charSpacing'
      );
      var i = d.Object.prototype.cacheProperties.concat();
      i.push(
        'fontFamily',
        'fontWeight',
        'fontSize',
        'text',
        'textDecoration',
        'textAlign',
        'fontStyle',
        'lineHeight',
        'textBackgroundColor',
        'charSpacing',
        'styles'
      ),
        (d.Text = d.util.createClass(d.Object, {
          _dimensionAffectingProps: [
            'fontSize',
            'fontWeight',
            'fontFamily',
            'fontStyle',
            'lineHeight',
            'text',
            'charSpacing',
            'textAlign',
          ],
          _reNewline: /\r?\n/,
          _reSpacesAndTabs: /[ \t\r]+/g,
          type: 'text',
          fontSize: 40,
          fontWeight: 'normal',
          fontFamily: 'Times New Roman',
          textDecoration: '',
          textAlign: 'left',
          fontStyle: '',
          lineHeight: 1.16,
          textBackgroundColor: '',
          stateProperties: e,
          cacheProperties: i,
          stroke: null,
          shadow: null,
          _fontSizeFraction: 0.25,
          _fontSizeMult: 1.13,
          charSpacing: 0,
          initialize: function (t, e) {
            (e = e || {}),
              (this.text = t),
              (this.__skipDimension = !0),
              this.callSuper('initialize', e),
              (this.__skipDimension = !1),
              this._initDimensions(),
              this.setCoords(),
              this.setupState({ propertySet: '_dimensionAffectingProps' });
          },
          _initDimensions: function (t) {
            this.__skipDimension ||
              (t ||
                ((t = d.util.createCanvasElement().getContext('2d')),
                this._setTextStyles(t)),
              (this._textLines = this._splitTextIntoLines()),
              this._clearCache(),
              (this.width = this._getTextWidth(t) || this.cursorWidth || 2),
              (this.height = this._getTextHeight(t)));
          },
          toString: function () {
            return (
              '#<fabric.Text (' +
              this.complexity() +
              '): { "text": "' +
              this.text +
              '", "fontFamily": "' +
              this.fontFamily +
              '" }>'
            );
          },
          _getCacheCanvasDimensions: function () {
            var t = this.callSuper('_getCacheCanvasDimensions'),
              e = this.fontSize;
            return (t.width += e * t.zoomX), (t.height += e * t.zoomY), t;
          },
          _render: function (t) {
            this._setTextStyles(t),
              this.group &&
                'path-group' === this.group.type &&
                t.translate(this.left, this.top),
              this._renderTextLinesBackground(t),
              this._renderText(t),
              this._renderTextDecoration(t);
          },
          _renderText: function (t) {
            this._renderTextFill(t), this._renderTextStroke(t);
          },
          _setTextStyles: function (t) {
            (t.textBaseline = 'alphabetic'),
              (t.font = this._getFontDeclaration());
          },
          _getTextHeight: function () {
            return (
              this._getHeightOfSingleLine() +
              (this._textLines.length - 1) * this._getHeightOfLine()
            );
          },
          _getTextWidth: function (t) {
            for (
              var e = this._getLineWidth(t, 0),
                i = 1,
                r = this._textLines.length;
              i < r;
              i++
            ) {
              var n = this._getLineWidth(t, i);
              e < n && (e = n);
            }
            return e;
          },
          _renderChars: function (t, e, i, r, n) {
            var s,
              o,
              a = t.slice(0, -4);
            if (this[a].toLive) {
              var h = -this.width / 2 + this[a].offsetX || 0,
                c = -this.height / 2 + this[a].offsetY || 0;
              e.save(), e.translate(h, c), (r -= h), (n -= c);
            }
            if (0 !== this.charSpacing)
              for (
                var l = this._getWidthOfCharSpacing(),
                  u = 0,
                  f = (i = i.split('')).length;
                u < f;
                u++
              )
                (s = i[u]),
                  (o = e.measureText(s).width + l),
                  e[t](s, r, n),
                  (r += 0 < o ? o : 0);
            else e[t](i, r, n);
            this[a].toLive && e.restore();
          },
          _renderTextLine: function (t, e, i, r, n, s) {
            n -= this.fontSize * this._fontSizeFraction;
            var o = this._getLineWidth(e, s);
            if ('justify' !== this.textAlign || this.width < o)
              this._renderChars(t, e, i, r, n, s);
            else
              for (
                var a,
                  h = i.split(/\s+/),
                  c = 0,
                  l = this._getWidthOfWords(e, h.join(' '), s, 0),
                  u = this.width - l,
                  f = h.length - 1,
                  d = 0 < f ? u / f : 0,
                  g = 0,
                  p = 0,
                  v = h.length;
                p < v;
                p++
              ) {
                for (; ' ' === i[c] && c < i.length; ) c++;
                (a = h[p]),
                  this._renderChars(t, e, a, r + g, n, s, c),
                  (g += this._getWidthOfWords(e, a, s, c) + d),
                  (c += a.length);
              }
          },
          _getWidthOfWords: function (t, e) {
            var i = t.measureText(e).width;
            return (
              0 !== this.charSpacing &&
                (i += e.split('').length * this._getWidthOfCharSpacing()),
              0 < i ? i : 0
            );
          },
          _getLeftOffset: function () {
            return -this.width / 2;
          },
          _getTopOffset: function () {
            return -this.height / 2;
          },
          isEmptyStyles: function () {
            return !0;
          },
          _renderTextCommon: function (t, e) {
            for (
              var i = 0,
                r = this._getLeftOffset(),
                n = this._getTopOffset(),
                s = 0,
                o = this._textLines.length;
              s < o;
              s++
            ) {
              var a = this._getHeightOfLine(t, s),
                h = a / this.lineHeight,
                c = this._getLineWidth(t, s),
                l = this._getLineLeftOffset(c);
              this._renderTextLine(
                e,
                t,
                this._textLines[s],
                r + l,
                n + i + h,
                s
              ),
                (i += a);
            }
          },
          _renderTextFill: function (t) {
            (!this.fill && this.isEmptyStyles()) ||
              this._renderTextCommon(t, 'fillText');
          },
          _renderTextStroke: function (t) {
            ((this.stroke && 0 !== this.strokeWidth) ||
              !this.isEmptyStyles()) &&
              (this.shadow &&
                !this.shadow.affectStroke &&
                this._removeShadow(t),
              t.save(),
              this._setLineDash(t, this.strokeDashArray),
              t.beginPath(),
              this._renderTextCommon(t, 'strokeText'),
              t.closePath(),
              t.restore());
          },
          _getHeightOfLine: function () {
            return this._getHeightOfSingleLine() * this.lineHeight;
          },
          _getHeightOfSingleLine: function () {
            return this.fontSize * this._fontSizeMult;
          },
          _renderTextLinesBackground: function (t) {
            if (this.textBackgroundColor) {
              var e,
                i,
                r,
                n = 0,
                s = t.fillStyle;
              t.fillStyle = this.textBackgroundColor;
              for (var o = 0, a = this._textLines.length; o < a; o++)
                (e = this._getHeightOfLine(t, o)),
                  0 < (i = this._getLineWidth(t, o)) &&
                    ((r = this._getLineLeftOffset(i)),
                    t.fillRect(
                      this._getLeftOffset() + r,
                      this._getTopOffset() + n,
                      i,
                      e / this.lineHeight
                    )),
                  (n += e);
              (t.fillStyle = s), this._removeShadow(t);
            }
          },
          _getLineLeftOffset: function (t) {
            return 'center' === this.textAlign
              ? (this.width - t) / 2
              : 'right' === this.textAlign
              ? this.width - t
              : 0;
          },
          _clearCache: function () {
            (this.__lineWidths = []), (this.__lineHeights = []);
          },
          _shouldClearDimensionCache: function () {
            var t = this._forceClearCache;
            return (
              (t = t || this.hasStateChanged('_dimensionAffectingProps')) &&
                (this.saveState({ propertySet: '_dimensionAffectingProps' }),
                (this.dirty = !0)),
              t
            );
          },
          _getLineWidth: function (t, e) {
            if (this.__lineWidths[e])
              return -1 === this.__lineWidths[e]
                ? this.width
                : this.__lineWidths[e];
            var i,
              r = this._textLines[e];
            return (
              (i = '' === r ? 0 : this._measureLine(t, e)),
              (this.__lineWidths[e] = i) &&
                'justify' === this.textAlign &&
                1 < r.split(/\s+/).length &&
                (this.__lineWidths[e] = -1),
              i
            );
          },
          _getWidthOfCharSpacing: function () {
            return 0 !== this.charSpacing
              ? (this.fontSize * this.charSpacing) / 1e3
              : 0;
          },
          _measureLine: function (t, e) {
            var i,
              r = this._textLines[e],
              n = t.measureText(r).width,
              s = 0;
            return (
              0 !== this.charSpacing &&
                (s = (r.split('').length - 1) * this._getWidthOfCharSpacing()),
              0 < (i = n + s) ? i : 0
            );
          },
          _renderTextDecoration: function (c) {
            if (this.textDecoration) {
              var l = this.height / 2,
                u = this,
                t = [];
              -1 < this.textDecoration.indexOf('underline') && t.push(0.85),
                -1 < this.textDecoration.indexOf('line-through') &&
                  t.push(0.43),
                -1 < this.textDecoration.indexOf('overline') && t.push(-0.12),
                0 < t.length &&
                  (function (t) {
                    var e,
                      i,
                      r,
                      n,
                      s,
                      o,
                      a,
                      h = 0;
                    for (e = 0, i = u._textLines.length; e < i; e++) {
                      for (
                        s = u._getLineWidth(c, e),
                          o = u._getLineLeftOffset(s),
                          a = u._getHeightOfLine(c, e),
                          r = 0,
                          n = t.length;
                        r < n;
                        r++
                      )
                        c.fillRect(
                          u._getLeftOffset() + o,
                          h + (u._fontSizeMult - 1 + t[r]) * u.fontSize - l,
                          s,
                          u.fontSize / 15
                        );
                      h += a;
                    }
                  })(t);
            }
          },
          _getFontDeclaration: function () {
            return [
              d.isLikelyNode ? this.fontWeight : this.fontStyle,
              d.isLikelyNode ? this.fontStyle : this.fontWeight,
              this.fontSize + 'px',
              d.isLikelyNode ? '"' + this.fontFamily + '"' : this.fontFamily,
            ].join(' ');
          },
          render: function (t, e) {
            this.visible &&
              ((this.canvas &&
                this.canvas.skipOffscreen &&
                !this.group &&
                !this.isOnScreen()) ||
                (this._shouldClearDimensionCache() &&
                  (this._setTextStyles(t), this._initDimensions(t)),
                this.callSuper('render', t, e)));
          },
          _splitTextIntoLines: function () {
            return this.text.split(this._reNewline);
          },
          toObject: function (t) {
            var e = [
              'text',
              'fontSize',
              'fontWeight',
              'fontFamily',
              'fontStyle',
              'lineHeight',
              'textDecoration',
              'textAlign',
              'textBackgroundColor',
              'charSpacing',
            ].concat(t);
            return this.callSuper('toObject', e);
          },
          toSVG: function (t) {
            this.ctx ||
              (this.ctx = d.util.createCanvasElement().getContext('2d'));
            var e = this._createBaseSVGMarkup(),
              i = this._getSVGLeftTopOffsets(this.ctx),
              r = this._getSVGTextAndBg(i.textTop, i.textLeft);
            return this._wrapSVGTextAndBg(e, r), t ? t(e.join('')) : e.join('');
          },
          _getSVGLeftTopOffsets: function (t) {
            var e = this._getHeightOfLine(t, 0);
            return {
              textLeft:
                -this.width / 2 +
                (this.group && 'path-group' === this.group.type
                  ? this.left
                  : 0),
              textTop:
                0 +
                (this.group && 'path-group' === this.group.type
                  ? -this.top
                  : 0),
              lineTop: e,
            };
          },
          _wrapSVGTextAndBg: function (t, e) {
            var i = this.getSvgFilter(),
              r = '' === i ? '' : ' style="' + i + '"';
            t.push(
              '\t<g ',
              this.getSvgId(),
              'transform="',
              this.getSvgTransform(),
              this.getSvgTransformMatrix(),
              '"',
              r,
              '>\n',
              e.textBgRects.join(''),
              '\t\t<text xml:space="preserve" ',
              this.fontFamily
                ? 'font-family="' + this.fontFamily.replace(/"/g, "'") + '" '
                : '',
              this.fontSize ? 'font-size="' + this.fontSize + '" ' : '',
              this.fontStyle ? 'font-style="' + this.fontStyle + '" ' : '',
              this.fontWeight ? 'font-weight="' + this.fontWeight + '" ' : '',
              this.textDecoration
                ? 'text-decoration="' + this.textDecoration + '" '
                : '',
              'style="',
              this.getSvgStyles(!0),
              '" >\n',
              e.textSpans.join(''),
              '\t\t</text>\n',
              '\t</g>\n'
            );
          },
          getSvgStyles: function (t) {
            return (
              d.Object.prototype.getSvgStyles.call(this, t) +
              ' white-space: pre;'
            );
          },
          _getSVGTextAndBg: function (t, e) {
            var i = [],
              r = [],
              n = 0;
            this._setSVGBg(r);
            for (var s = 0, o = this._textLines.length; s < o; s++)
              this.textBackgroundColor && this._setSVGTextLineBg(r, s, e, t, n),
                this._setSVGTextLineText(s, i, n, e, t, r),
                (n += this._getHeightOfLine(this.ctx, s));
            return { textSpans: i, textBgRects: r };
          },
          _setSVGTextLineText: function (t, e, i, r, n) {
            var s =
              this.fontSize * (this._fontSizeMult - this._fontSizeFraction) -
              n +
              i -
              this.height / 2;
            'justify' !== this.textAlign
              ? e.push(
                  '\t\t\t<tspan x="',
                  g(
                    r +
                      this._getLineLeftOffset(this._getLineWidth(this.ctx, t)),
                    p
                  ),
                  '" ',
                  'y="',
                  g(s, p),
                  '" ',
                  this._getFillAttributes(this.fill),
                  '>',
                  d.util.string.escapeXml(this._textLines[t]),
                  '</tspan>\n'
                )
              : this._setSVGTextLineJustifed(t, e, s, r);
          },
          _setSVGTextLineJustifed: function (t, e, i, r) {
            var n = d.util.createCanvasElement().getContext('2d');
            this._setTextStyles(n);
            var s,
              o,
              a = this._textLines[t].split(/\s+/),
              h = this._getWidthOfWords(n, a.join('')),
              c = this.width - h,
              l = a.length - 1,
              u = 0 < l ? c / l : 0,
              f = this._getFillAttributes(this.fill);
            for (
              r += this._getLineLeftOffset(this._getLineWidth(n, t)),
                t = 0,
                o = a.length;
              t < o;
              t++
            )
              (s = a[t]),
                e.push(
                  '\t\t\t<tspan x="',
                  g(r, p),
                  '" ',
                  'y="',
                  g(i, p),
                  '" ',
                  f,
                  '>',
                  d.util.string.escapeXml(s),
                  '</tspan>\n'
                ),
                (r += this._getWidthOfWords(n, s) + u);
          },
          _setSVGTextLineBg: function (t, e, i, r, n) {
            t.push(
              '\t\t<rect ',
              this._getFillAttributes(this.textBackgroundColor),
              ' x="',
              g(
                i + this._getLineLeftOffset(this._getLineWidth(this.ctx, e)),
                p
              ),
              '" y="',
              g(n - this.height / 2, p),
              '" width="',
              g(this._getLineWidth(this.ctx, e), p),
              '" height="',
              g(this._getHeightOfLine(this.ctx, e) / this.lineHeight, p),
              '"></rect>\n'
            );
          },
          _setSVGBg: function (t) {
            this.backgroundColor &&
              t.push(
                '\t\t<rect ',
                this._getFillAttributes(this.backgroundColor),
                ' x="',
                g(-this.width / 2, p),
                '" y="',
                g(-this.height / 2, p),
                '" width="',
                g(this.width, p),
                '" height="',
                g(this.height, p),
                '"></rect>\n'
              );
          },
          _getFillAttributes: function (t) {
            var e = t && 'string' == typeof t ? new d.Color(t) : '';
            return e && e.getSource() && 1 !== e.getAlpha()
              ? 'opacity="' +
                  e.getAlpha() +
                  '" fill="' +
                  e.setAlpha(1).toRgb() +
                  '"'
              : 'fill="' + t + '"';
          },
          _set: function (t, e) {
            this.callSuper('_set', t, e),
              -1 < this._dimensionAffectingProps.indexOf(t) &&
                (this._initDimensions(), this.setCoords());
          },
          complexity: function () {
            return 1;
          },
        })),
        (d.Text.ATTRIBUTE_NAMES = d.SHARED_ATTRIBUTES.concat(
          'x y dx dy font-family font-style font-weight font-size text-decoration text-anchor'.split(
            ' '
          )
        )),
        (d.Text.DEFAULT_SVG_FONT_SIZE = 16),
        (d.Text.fromElement = function (t, e) {
          if (!t) return null;
          var i = d.parseAttributes(t, d.Text.ATTRIBUTE_NAMES);
          ((e = d.util.object.extend(e ? d.util.object.clone(e) : {}, i)).top =
            e.top || 0),
            (e.left = e.left || 0),
            'dx' in i && (e.left += i.dx),
            'dy' in i && (e.top += i.dy),
            'fontSize' in e || (e.fontSize = d.Text.DEFAULT_SVG_FONT_SIZE),
            e.originX || (e.originX = 'left');
          var r = '';
          'textContent' in t
            ? (r = t.textContent)
            : 'firstChild' in t &&
              null !== t.firstChild &&
              'data' in t.firstChild &&
              null !== t.firstChild.data &&
              (r = t.firstChild.data),
            (r = r.replace(/^\s+|\s+$|\n+/g, '').replace(/\s+/g, ' '));
          var n = new d.Text(r, e),
            s = n.getHeight() / n.height,
            o = ((n.height + n.strokeWidth) * n.lineHeight - n.height) * s,
            a = n.getHeight() + o,
            h = 0;
          return (
            'left' === n.originX && (h = n.getWidth() / 2),
            'right' === n.originX && (h = -n.getWidth() / 2),
            n.set({
              left: n.getLeft() + h,
              top:
                n.getTop() -
                a / 2 +
                (n.fontSize * (0.18 + n._fontSizeFraction)) / n.lineHeight,
            }),
            n
          );
        }),
        (d.Text.fromObject = function (t, e, i) {
          return d.Object._fromObject('Text', t, e, i, 'text');
        }),
        d.util.createAccessors(d.Text);
    }
  })('undefined' != typeof exports ? exports : this),
  (function () {
    var u = fabric.util.object.clone;
    (fabric.IText = fabric.util.createClass(fabric.Text, fabric.Observable, {
      type: 'i-text',
      selectionStart: 0,
      selectionEnd: 0,
      selectionColor: 'rgba(17,119,255,0.3)',
      isEditing: !1,
      editable: !0,
      editingBorderColor: 'rgba(102,153,255,0.25)',
      cursorWidth: 2,
      cursorColor: '#333',
      cursorDelay: 1e3,
      cursorDuration: 600,
      styles: null,
      caching: !0,
      _reSpace: /\s|\n/,
      _currentCursorOpacity: 0,
      _selectionDirection: null,
      _abortCursorAnimation: !1,
      __widthOfSpace: [],
      initialize: function (t, e) {
        (this.styles = (e && e.styles) || {}),
          this.callSuper('initialize', t, e),
          this.initBehavior();
      },
      _clearCache: function () {
        this.callSuper('_clearCache'), (this.__widthOfSpace = []);
      },
      isEmptyStyles: function () {
        if (!this.styles) return !0;
        var t = this.styles;
        for (var e in t) for (var i in t[e]) for (var r in t[e][i]) return !1;
        return !0;
      },
      setSelectionStart: function (t) {
        (t = Math.max(t, 0)), this._updateAndFire('selectionStart', t);
      },
      setSelectionEnd: function (t) {
        (t = Math.min(t, this.text.length)),
          this._updateAndFire('selectionEnd', t);
      },
      _updateAndFire: function (t, e) {
        this[t] !== e && (this._fireSelectionChanged(), (this[t] = e)),
          this._updateTextarea();
      },
      _fireSelectionChanged: function () {
        this.fire('selection:changed'),
          this.canvas &&
            this.canvas.fire('text:selection:changed', { target: this });
      },
      getSelectionStyles: function (t, e) {
        if (2 === arguments.length) {
          for (var i = [], r = t; r < e; r++)
            i.push(this.getSelectionStyles(r));
          return i;
        }
        var n = this.get2DCursorLocation(t);
        return this._getStyleDeclaration(n.lineIndex, n.charIndex) || {};
      },
      setSelectionStyles: function (t) {
        if (this.selectionStart === this.selectionEnd)
          this._extendStyles(this.selectionStart, t);
        else
          for (var e = this.selectionStart; e < this.selectionEnd; e++)
            this._extendStyles(e, t);
        return (this._forceClearCache = !0), this;
      },
      _extendStyles: function (t, e) {
        var i = this.get2DCursorLocation(t);
        this._getLineStyle(i.lineIndex) || this._setLineStyle(i.lineIndex, {}),
          this._getStyleDeclaration(i.lineIndex, i.charIndex) ||
            this._setStyleDeclaration(i.lineIndex, i.charIndex, {}),
          fabric.util.object.extend(
            this._getStyleDeclaration(i.lineIndex, i.charIndex),
            e
          );
      },
      _initDimensions: function (t) {
        t || this.clearContextTop(), this.callSuper('_initDimensions', t);
      },
      render: function (t, e) {
        this.clearContextTop(),
          this.callSuper('render', t, e),
          (this.cursorOffsetCache = {}),
          this.renderCursorOrSelection();
      },
      _render: function (t) {
        this.callSuper('_render', t), (this.ctx = t);
      },
      clearContextTop: function () {
        if (
          this.active &&
          this.isEditing &&
          this.canvas &&
          this.canvas.contextTop
        ) {
          var t = this.canvas.contextTop;
          t.save(),
            t.transform.apply(t, this.canvas.viewportTransform),
            this.transform(t),
            this.transformMatrix && t.transform.apply(t, this.transformMatrix),
            this._clearTextArea(t),
            t.restore();
        }
      },
      renderCursorOrSelection: function () {
        if (this.active && this.isEditing) {
          var t,
            e,
            i = this.text.split('');
          this.canvas && this.canvas.contextTop
            ? ((e = this.canvas.contextTop).save(),
              e.transform.apply(e, this.canvas.viewportTransform),
              this.transform(e),
              this.transformMatrix &&
                e.transform.apply(e, this.transformMatrix),
              this._clearTextArea(e))
            : (e = this.ctx).save(),
            this.selectionStart === this.selectionEnd
              ? ((t = this._getCursorBoundaries(i, 'cursor')),
                this.renderCursor(t, e))
              : ((t = this._getCursorBoundaries(i, 'selection')),
                this.renderSelection(i, t, e)),
            e.restore();
        }
      },
      _clearTextArea: function (t) {
        var e = this.width + 4,
          i = this.height + 4;
        t.clearRect(-e / 2, -i / 2, e, i);
      },
      get2DCursorLocation: function (t) {
        void 0 === t && (t = this.selectionStart);
        for (var e = this._textLines.length, i = 0; i < e; i++) {
          if (t <= this._textLines[i].length)
            return { lineIndex: i, charIndex: t };
          t -= this._textLines[i].length + 1;
        }
        return {
          lineIndex: i - 1,
          charIndex:
            this._textLines[i - 1].length < t
              ? this._textLines[i - 1].length
              : t,
        };
      },
      getCurrentCharStyle: function (t, e) {
        var i = this._getStyleDeclaration(t, 0 === e ? 0 : e - 1);
        return {
          fontSize: (i && i.fontSize) || this.fontSize,
          fill: (i && i.fill) || this.fill,
          textBackgroundColor:
            (i && i.textBackgroundColor) || this.textBackgroundColor,
          textDecoration: (i && i.textDecoration) || this.textDecoration,
          fontFamily: (i && i.fontFamily) || this.fontFamily,
          fontWeight: (i && i.fontWeight) || this.fontWeight,
          fontStyle: (i && i.fontStyle) || this.fontStyle,
          stroke: (i && i.stroke) || this.stroke,
          strokeWidth: (i && i.strokeWidth) || this.strokeWidth,
        };
      },
      getCurrentCharFontSize: function (t, e) {
        var i = this._getStyleDeclaration(t, 0 === e ? 0 : e - 1);
        return i && i.fontSize ? i.fontSize : this.fontSize;
      },
      getCurrentCharColor: function (t, e) {
        var i = this._getStyleDeclaration(t, 0 === e ? 0 : e - 1);
        return i && i.fill ? i.fill : this.cursorColor;
      },
      _getCursorBoundaries: function (t, e) {
        var i = Math.round(this._getLeftOffset()),
          r = this._getTopOffset(),
          n = this._getCursorBoundariesOffsets(t, e);
        return {
          left: i,
          top: r,
          leftOffset: n.left + n.lineLeft,
          topOffset: n.top,
        };
      },
      _getCursorBoundariesOffsets: function (t, e) {
        if (this.cursorOffsetCache && 'top' in this.cursorOffsetCache)
          return this.cursorOffsetCache;
        for (
          var i, r = 0, n = 0, s = 0, o = 0, a = 0, h = 0;
          h < this.selectionStart;
          h++
        )
          '\n' === t[h]
            ? ((a = 0), (o += this._getHeightOfLine(this.ctx, n)), n++, (s = 0))
            : ((a += this._getWidthOfChar(this.ctx, t[h], n, s)), s++),
            (r = this._getLineLeftOffset(this._getLineWidth(this.ctx, n)));
        return (
          'cursor' === e &&
            (o +=
              ((1 - this._fontSizeFraction) *
                this._getHeightOfLine(this.ctx, n)) /
                this.lineHeight -
              this.getCurrentCharFontSize(n, s) * (1 - this._fontSizeFraction)),
          0 !== this.charSpacing &&
            s === this._textLines[n].length &&
            (a -= this._getWidthOfCharSpacing()),
          (i = { top: o, left: 0 < a ? a : 0, lineLeft: r }),
          (this.cursorOffsetCache = i),
          this.cursorOffsetCache
        );
      },
      renderCursor: function (t, e) {
        var i = this.get2DCursorLocation(),
          r = i.lineIndex,
          n = i.charIndex,
          s = this.getCurrentCharFontSize(r, n),
          o = t.leftOffset,
          a = this.scaleX * this.canvas.getZoom(),
          h = this.cursorWidth / a;
        (e.fillStyle = this.getCurrentCharColor(r, n)),
          (e.globalAlpha = this.__isMousedown ? 1 : this._currentCursorOpacity),
          e.fillRect(t.left + o - h / 2, t.top + t.topOffset, h, s);
      },
      renderSelection: function (t, e, i) {
        i.fillStyle = this.selectionColor;
        for (
          var r = this.get2DCursorLocation(this.selectionStart),
            n = this.get2DCursorLocation(this.selectionEnd),
            s = r.lineIndex,
            o = n.lineIndex,
            a = s;
          a <= o;
          a++
        ) {
          var h,
            c = this._getLineLeftOffset(this._getLineWidth(i, a)) || 0,
            l = this._getHeightOfLine(this.ctx, a),
            u = 0,
            f = this._textLines[a];
          if (a === s) {
            for (var d = 0, g = f.length; d < g; d++)
              d >= r.charIndex &&
                (a !== o || d < n.charIndex) &&
                (u += this._getWidthOfChar(i, f[d], a, d)),
                d < r.charIndex && (c += this._getWidthOfChar(i, f[d], a, d));
            d === f.length && (u -= this._getWidthOfCharSpacing());
          } else if (s < a && a < o) u += this._getLineWidth(i, a) || 5;
          else if (a === o) {
            for (var p = 0, v = n.charIndex; p < v; p++)
              u += this._getWidthOfChar(i, f[p], a, p);
            n.charIndex === f.length && (u -= this._getWidthOfCharSpacing());
          }
          (h = l),
            (this.lineHeight < 1 || (a === o && 1 < this.lineHeight)) &&
              (l /= this.lineHeight),
            i.fillRect(e.left + c, e.top + e.topOffset, 0 < u ? u : 0, l),
            (e.topOffset += h);
        }
      },
      _renderChars: function (t, e, i, r, n, s, o) {
        if (this.isEmptyStyles()) return this._renderCharsFast(t, e, i, r, n);
        o = o || 0;
        var a,
          h,
          c = this._getHeightOfLine(e, s),
          l = '';
        e.save(), (n -= (c / this.lineHeight) * this._fontSizeFraction);
        for (var u = o, f = i.length + o; u <= f; u++)
          (a = a || this.getCurrentCharStyle(s, u)),
            (h = this.getCurrentCharStyle(s, u + 1)),
            (!this._hasStyleChanged(a, h) && u !== f) ||
              (this._renderChar(t, e, s, u - 1, l, r, n, c), (l = ''), (a = h)),
            (l += i[u - o]);
        e.restore();
      },
      _renderCharsFast: function (t, e, i, r, n) {
        'fillText' === t &&
          this.fill &&
          this.callSuper('_renderChars', t, e, i, r, n),
          'strokeText' === t &&
            ((this.stroke && 0 < this.strokeWidth) ||
              this.skipFillStrokeCheck) &&
            this.callSuper('_renderChars', t, e, i, r, n);
      },
      _renderChar: function (t, e, i, r, n, s, o, a) {
        var h,
          c,
          l,
          u,
          f,
          d,
          g,
          p,
          v,
          b = this._getStyleDeclaration(i, r);
        if (
          (b
            ? ((c = this._getHeightOfChar(e, n, i, r)),
              (u = b.stroke),
              (l = b.fill),
              (d = b.textDecoration))
            : (c = this.fontSize),
          (u = (u || this.stroke) && 'strokeText' === t),
          (l = (l || this.fill) && 'fillText' === t),
          b && e.save(),
          (h = this._applyCharStylesGetWidth(e, n, i, r, b || null)),
          (d = d || this.textDecoration),
          b && b.textBackgroundColor && this._removeShadow(e),
          0 !== this.charSpacing)
        ) {
          p = this._getWidthOfCharSpacing();
          for (var m, _ = (h = 0), y = (g = n.split('')).length; _ < y; _++)
            (m = g[_]),
              l && e.fillText(m, s + h, o),
              u && e.strokeText(m, s + h, o),
              (h += 0 < (v = e.measureText(m).width + p) ? v : 0);
        } else l && e.fillText(n, s, o), u && e.strokeText(n, s, o);
        (!d && '' === d) ||
          ((f = (this._fontSizeFraction * a) / this.lineHeight),
          this._renderCharDecoration(e, d, s, o, f, h, c)),
          b && e.restore(),
          e.translate(h, 0);
      },
      _hasStyleChanged: function (t, e) {
        return (
          t.fill !== e.fill ||
          t.fontSize !== e.fontSize ||
          t.textBackgroundColor !== e.textBackgroundColor ||
          t.textDecoration !== e.textDecoration ||
          t.fontFamily !== e.fontFamily ||
          t.fontWeight !== e.fontWeight ||
          t.fontStyle !== e.fontStyle ||
          t.stroke !== e.stroke ||
          t.strokeWidth !== e.strokeWidth
        );
      },
      _renderCharDecoration: function (t, e, i, r, n, s, o) {
        if (e) {
          var a,
            h,
            c = o / 15,
            l = {
              underline: r + o / 10,
              'line-through':
                r - o * (this._fontSizeFraction + this._fontSizeMult - 1) + c,
              overline: r - (this._fontSizeMult - this._fontSizeFraction) * o,
            },
            u = ['underline', 'line-through', 'overline'];
          for (a = 0; a < u.length; a++)
            (h = u[a]), -1 < e.indexOf(h) && t.fillRect(i, l[h], s, c);
        }
      },
      _renderTextLine: function (t, e, i, r, n, s) {
        this.isEmptyStyles() ||
          (n += this.fontSize * (this._fontSizeFraction + 0.03)),
          this.callSuper('_renderTextLine', t, e, i, r, n, s);
      },
      _renderTextDecoration: function (t) {
        if (this.isEmptyStyles())
          return this.callSuper('_renderTextDecoration', t);
      },
      _renderTextLinesBackground: function (t) {
        this.callSuper('_renderTextLinesBackground', t);
        var e,
          i,
          r,
          n,
          s,
          o,
          a,
          h,
          c,
          l,
          u = 0,
          f = this._getLeftOffset(),
          d = this._getTopOffset(),
          g = '';
        t.save();
        for (var p = 0, v = this._textLines.length; p < v; p++)
          if (
            ((e = this._getHeightOfLine(t, p)),
            '' !== (n = this._textLines[p]) &&
              this.styles &&
              this._getLineStyle(p))
          ) {
            (i = this._getLineWidth(t, p)),
              (r = this._getLineLeftOffset(i)),
              (a = h = c = l = 0);
            for (var b = 0, m = n.length; b < m; b++)
              g !==
                (o = this._getStyleDeclaration(p, b) || {})
                  .textBackgroundColor &&
                (l && c && ((t.fillStyle = g), t.fillRect(a, h, c, l)),
                (a = h = c = l = 0),
                (g = o.textBackgroundColor || '')),
                o.textBackgroundColor
                  ? ((s = n[b]),
                    g === o.textBackgroundColor &&
                      ((g = o.textBackgroundColor),
                      (a = a || f + r + this._getWidthOfCharsAt(t, p, b)),
                      (h = d + u),
                      (c += this._getWidthOfChar(t, s, p, b)),
                      (l = e / this.lineHeight)))
                  : (g = '');
            l &&
              c &&
              ((t.fillStyle = g), t.fillRect(a, h, c, l), (a = h = c = l = 0)),
              (u += e);
          } else u += e;
        t.restore();
      },
      _getCacheProp: function (t, e) {
        return t + e.fontSize + e.fontWeight + e.fontStyle;
      },
      _getFontCache: function (t) {
        return (
          fabric.charWidthsCache[t] || (fabric.charWidthsCache[t] = {}),
          fabric.charWidthsCache[t]
        );
      },
      _applyCharStylesGetWidth: function (t, e, i, r, n) {
        var s,
          o,
          a,
          h = n || this._getStyleDeclaration(i, r),
          c = u(h);
        if (
          (this._applyFontStyles(c),
          (a = this._getFontCache(c.fontFamily)),
          (o = this._getCacheProp(e, c)),
          !h && a[o] && this.caching)
        )
          return a[o];
        'string' == typeof c.shadow && (c.shadow = new fabric.Shadow(c.shadow));
        var l = c.fill || this.fill;
        return (
          (t.fillStyle = l.toLive ? l.toLive(t, this) : l),
          c.stroke &&
            (t.strokeStyle =
              c.stroke && c.stroke.toLive
                ? c.stroke.toLive(t, this)
                : c.stroke),
          (t.lineWidth = c.strokeWidth || this.strokeWidth),
          (t.font = this._getFontDeclaration.call(c)),
          c.shadow &&
            ((c.scaleX = this.scaleX),
            (c.scaleY = this.scaleY),
            (c.canvas = this.canvas),
            (c.getObjectScaling = this.getObjectScaling),
            this._setShadow.call(c, t)),
          this.caching && a[o]
            ? a[o]
            : ((s = t.measureText(e).width), this.caching && (a[o] = s), s)
        );
      },
      _applyFontStyles: function (t) {
        t.fontFamily || (t.fontFamily = this.fontFamily),
          t.fontSize || (t.fontSize = this.fontSize),
          t.fontWeight || (t.fontWeight = this.fontWeight),
          t.fontStyle || (t.fontStyle = this.fontStyle);
      },
      _getStyleDeclaration: function (t, e, i) {
        return i
          ? this.styles[t] && this.styles[t][e]
            ? u(this.styles[t][e])
            : {}
          : this.styles[t] && this.styles[t][e]
          ? this.styles[t][e]
          : null;
      },
      _setStyleDeclaration: function (t, e, i) {
        this.styles[t][e] = i;
      },
      _deleteStyleDeclaration: function (t, e) {
        delete this.styles[t][e];
      },
      _getLineStyle: function (t) {
        return this.styles[t];
      },
      _setLineStyle: function (t, e) {
        this.styles[t] = e;
      },
      _deleteLineStyle: function (t) {
        delete this.styles[t];
      },
      _getWidthOfChar: function (t, e, i, r) {
        if (
          !this._isMeasuring &&
          'justify' === this.textAlign &&
          this._reSpacesAndTabs.test(e)
        )
          return this._getWidthOfSpace(t, i);
        t.save();
        var n = this._applyCharStylesGetWidth(t, e, i, r);
        return (
          0 !== this.charSpacing && (n += this._getWidthOfCharSpacing()),
          t.restore(),
          0 < n ? n : 0
        );
      },
      _getHeightOfChar: function (t, e, i) {
        var r = this._getStyleDeclaration(e, i);
        return r && r.fontSize ? r.fontSize : this.fontSize;
      },
      _getWidthOfCharsAt: function (t, e, i) {
        var r,
          n,
          s = 0;
        for (r = 0; r < i; r++)
          (n = this._textLines[e][r]), (s += this._getWidthOfChar(t, n, e, r));
        return s;
      },
      _measureLine: function (t, e) {
        this._isMeasuring = !0;
        var i = this._getWidthOfCharsAt(t, e, this._textLines[e].length);
        return (
          0 !== this.charSpacing && (i -= this._getWidthOfCharSpacing()),
          (this._isMeasuring = !1),
          0 < i ? i : 0
        );
      },
      _getWidthOfSpace: function (t, e) {
        if (this.__widthOfSpace[e]) return this.__widthOfSpace[e];
        var i = this._textLines[e],
          r = this._getWidthOfWords(t, i, e, 0),
          n = this.width - r,
          s = i.length - i.replace(this._reSpacesAndTabs, '').length,
          o = Math.max(n / s, t.measureText(' ').width);
        return (this.__widthOfSpace[e] = o);
      },
      _getWidthOfWords: function (t, e, i, r) {
        for (var n = 0, s = 0; s < e.length; s++) {
          var o = e[s];
          o.match(/\s/) || (n += this._getWidthOfChar(t, o, i, s + r));
        }
        return n;
      },
      _getHeightOfLine: function (t, e) {
        if (this.__lineHeights[e]) return this.__lineHeights[e];
        for (
          var i = this._textLines[e],
            r = this._getHeightOfChar(t, e, 0),
            n = 1,
            s = i.length;
          n < s;
          n++
        ) {
          var o = this._getHeightOfChar(t, e, n);
          r < o && (r = o);
        }
        return (
          (this.__lineHeights[e] = r * this.lineHeight * this._fontSizeMult),
          this.__lineHeights[e]
        );
      },
      _getTextHeight: function (t) {
        for (var e, i = 0, r = 0, n = this._textLines.length; r < n; r++)
          (e = this._getHeightOfLine(t, r)),
            (i += r === n - 1 ? e / this.lineHeight : e);
        return i;
      },
      toObject: function (t) {
        return fabric.util.object.extend(this.callSuper('toObject', t), {
          styles: u(this.styles, !0),
        });
      },
    })),
      (fabric.IText.fromObject = function (t, e, i) {
        return fabric.Object._fromObject('IText', t, e, i, 'text');
      });
  })(),
  (function () {
    var l = fabric.util.object.clone;
    fabric.util.object.extend(fabric.IText.prototype, {
      initBehavior: function () {
        this.initAddedHandler(),
          this.initRemovedHandler(),
          this.initCursorSelectionHandlers(),
          this.initDoubleClickSimulation(),
          (this.mouseMoveHandler = this.mouseMoveHandler.bind(this));
      },
      onDeselect: function () {
        this.isEditing && this.exitEditing(),
          (this.selected = !1),
          this.callSuper('onDeselect');
      },
      initAddedHandler: function () {
        var e = this;
        this.on('added', function () {
          var t = e.canvas;
          t &&
            (t._hasITextHandlers ||
              ((t._hasITextHandlers = !0), e._initCanvasHandlers(t)),
            (t._iTextInstances = t._iTextInstances || []),
            t._iTextInstances.push(e));
        });
      },
      initRemovedHandler: function () {
        var e = this;
        this.on('removed', function () {
          var t = e.canvas;
          t &&
            ((t._iTextInstances = t._iTextInstances || []),
            fabric.util.removeFromArray(t._iTextInstances, e),
            0 === t._iTextInstances.length &&
              ((t._hasITextHandlers = !1), e._removeCanvasHandlers(t)));
        });
      },
      _initCanvasHandlers: function (t) {
        (t._mouseUpITextHandler = function () {
          t._iTextInstances &&
            t._iTextInstances.forEach(function (t) {
              t.__isMousedown = !1;
            });
        }.bind(this)),
          t.on('mouse:up', t._mouseUpITextHandler);
      },
      _removeCanvasHandlers: function (t) {
        t.off('mouse:up', t._mouseUpITextHandler);
      },
      _tick: function () {
        this._currentTickState = this._animateCursor(
          this,
          1,
          this.cursorDuration,
          '_onTickComplete'
        );
      },
      _animateCursor: function (t, e, i, r) {
        var n;
        return (
          (n = {
            isAborted: !1,
            abort: function () {
              this.isAborted = !0;
            },
          }),
          t.animate('_currentCursorOpacity', e, {
            duration: i,
            onComplete: function () {
              n.isAborted || t[r]();
            },
            onChange: function () {
              t.canvas &&
                t.selectionStart === t.selectionEnd &&
                t.renderCursorOrSelection();
            },
            abort: function () {
              return n.isAborted;
            },
          }),
          n
        );
      },
      _onTickComplete: function () {
        var t = this;
        this._cursorTimeout1 && clearTimeout(this._cursorTimeout1),
          (this._cursorTimeout1 = setTimeout(function () {
            t._currentTickCompleteState = t._animateCursor(
              t,
              0,
              this.cursorDuration / 2,
              '_tick'
            );
          }, 100));
      },
      initDelayedCursor: function (t) {
        var e = this,
          i = t ? 0 : this.cursorDelay;
        this.abortCursorAnimation(),
          (this._currentCursorOpacity = 1),
          (this._cursorTimeout2 = setTimeout(function () {
            e._tick();
          }, i));
      },
      abortCursorAnimation: function () {
        var t = this._currentTickState || this._currentTickCompleteState;
        this._currentTickState && this._currentTickState.abort(),
          this._currentTickCompleteState &&
            this._currentTickCompleteState.abort(),
          clearTimeout(this._cursorTimeout1),
          clearTimeout(this._cursorTimeout2),
          (this._currentCursorOpacity = 0),
          t &&
            this.canvas &&
            this.canvas.clearContext(this.canvas.contextTop || this.ctx);
      },
      selectAll: function () {
        (this.selectionStart = 0),
          (this.selectionEnd = this.text.length),
          this._fireSelectionChanged(),
          this._updateTextarea();
      },
      getSelectedText: function () {
        return this.text.slice(this.selectionStart, this.selectionEnd);
      },
      findWordBoundaryLeft: function (t) {
        var e = 0,
          i = t - 1;
        if (this._reSpace.test(this.text.charAt(i)))
          for (; this._reSpace.test(this.text.charAt(i)); ) e++, i--;
        for (; /\S/.test(this.text.charAt(i)) && -1 < i; ) e++, i--;
        return t - e;
      },
      findWordBoundaryRight: function (t) {
        var e = 0,
          i = t;
        if (this._reSpace.test(this.text.charAt(i)))
          for (; this._reSpace.test(this.text.charAt(i)); ) e++, i++;
        for (; /\S/.test(this.text.charAt(i)) && i < this.text.length; )
          e++, i++;
        return t + e;
      },
      findLineBoundaryLeft: function (t) {
        for (var e = 0, i = t - 1; !/\n/.test(this.text.charAt(i)) && -1 < i; )
          e++, i--;
        return t - e;
      },
      findLineBoundaryRight: function (t) {
        for (
          var e = 0, i = t;
          !/\n/.test(this.text.charAt(i)) && i < this.text.length;

        )
          e++, i++;
        return t + e;
      },
      getNumNewLinesInSelectedText: function () {
        for (
          var t = this.getSelectedText(), e = 0, i = 0, r = t.length;
          i < r;
          i++
        )
          '\n' === t[i] && e++;
        return e;
      },
      searchWordBoundary: function (t, e) {
        for (
          var i = this._reSpace.test(this.text.charAt(t)) ? t - 1 : t,
            r = this.text.charAt(i),
            n = /[ \n\.,;!\?\-]/;
          !n.test(r) && 0 < i && i < this.text.length;

        )
          (i += e), (r = this.text.charAt(i));
        return n.test(r) && '\n' !== r && (i += 1 === e ? 0 : 1), i;
      },
      selectWord: function (t) {
        t = t || this.selectionStart;
        var e = this.searchWordBoundary(t, -1),
          i = this.searchWordBoundary(t, 1);
        (this.selectionStart = e),
          (this.selectionEnd = i),
          this._fireSelectionChanged(),
          this._updateTextarea(),
          this.renderCursorOrSelection();
      },
      selectLine: function (t) {
        t = t || this.selectionStart;
        var e = this.findLineBoundaryLeft(t),
          i = this.findLineBoundaryRight(t);
        (this.selectionStart = e),
          (this.selectionEnd = i),
          this._fireSelectionChanged(),
          this._updateTextarea();
      },
      enterEditing: function (t) {
        if (!this.isEditing && this.editable)
          return (
            this.canvas && this.exitEditingOnOthers(this.canvas),
            (this.isEditing = !0),
            (this.selected = !0),
            this.initHiddenTextarea(t),
            this.hiddenTextarea.focus(),
            this._updateTextarea(),
            this._saveEditingProps(),
            this._setEditingProps(),
            (this._textBeforeEdit = this.text),
            this._tick(),
            this.fire('editing:entered'),
            this._fireSelectionChanged(),
            this.canvas &&
              (this.canvas.fire('text:editing:entered', { target: this }),
              this.initMouseMoveHandler(),
              this.canvas.renderAll()),
            this
          );
      },
      exitEditingOnOthers: function (t) {
        t._iTextInstances &&
          t._iTextInstances.forEach(function (t) {
            (t.selected = !1), t.isEditing && t.exitEditing();
          });
      },
      initMouseMoveHandler: function () {
        this.canvas.on('mouse:move', this.mouseMoveHandler);
      },
      mouseMoveHandler: function (t) {
        if (this.__isMousedown && this.isEditing) {
          var e = this.getSelectionStartFromPointer(t.e),
            i = this.selectionStart,
            r = this.selectionEnd;
          ((e === this.__selectionStartOnMouseDown && i !== r) ||
            (i !== e && r !== e)) &&
            (e > this.__selectionStartOnMouseDown
              ? ((this.selectionStart = this.__selectionStartOnMouseDown),
                (this.selectionEnd = e))
              : ((this.selectionStart = e),
                (this.selectionEnd = this.__selectionStartOnMouseDown)),
            (this.selectionStart === i && this.selectionEnd === r) ||
              (this.restartCursorIfNeeded(),
              this._fireSelectionChanged(),
              this._updateTextarea(),
              this.renderCursorOrSelection()));
        }
      },
      _setEditingProps: function () {
        (this.hoverCursor = 'text'),
          this.canvas &&
            (this.canvas.defaultCursor = this.canvas.moveCursor = 'text'),
          (this.borderColor = this.editingBorderColor),
          (this.hasControls = this.selectable = !1),
          (this.lockMovementX = this.lockMovementY = !0);
      },
      _updateTextarea: function () {
        if (
          this.hiddenTextarea &&
          !this.inCompositionMode &&
          ((this.cursorOffsetCache = {}),
          (this.hiddenTextarea.value = this.text),
          (this.hiddenTextarea.selectionStart = this.selectionStart),
          (this.hiddenTextarea.selectionEnd = this.selectionEnd),
          this.selectionStart === this.selectionEnd)
        ) {
          var t = this._calcTextareaPosition();
          (this.hiddenTextarea.style.left = t.left),
            (this.hiddenTextarea.style.top = t.top),
            (this.hiddenTextarea.style.fontSize = t.fontSize);
        }
      },
      _calcTextareaPosition: function () {
        if (!this.canvas) return { x: 1, y: 1 };
        var t = this.text.split(''),
          e = this._getCursorBoundaries(t, 'cursor'),
          i = this.get2DCursorLocation(),
          r = i.lineIndex,
          n = i.charIndex,
          s = this.getCurrentCharFontSize(r, n),
          o = e.leftOffset,
          a = this.calcTransformMatrix(),
          h = { x: e.left + o, y: e.top + e.topOffset + s },
          c = this.canvas.upperCanvasEl,
          l = c.width - s,
          u = c.height - s;
        return (
          (h = fabric.util.transformPoint(h, a)),
          (h = fabric.util.transformPoint(h, this.canvas.viewportTransform)).x <
            0 && (h.x = 0),
          h.x > l && (h.x = l),
          h.y < 0 && (h.y = 0),
          h.y > u && (h.y = u),
          (h.x += this.canvas._offset.left),
          (h.y += this.canvas._offset.top),
          { left: h.x + 'px', top: h.y + 'px', fontSize: s }
        );
      },
      _saveEditingProps: function () {
        this._savedProps = {
          hasControls: this.hasControls,
          borderColor: this.borderColor,
          lockMovementX: this.lockMovementX,
          lockMovementY: this.lockMovementY,
          hoverCursor: this.hoverCursor,
          defaultCursor: this.canvas && this.canvas.defaultCursor,
          moveCursor: this.canvas && this.canvas.moveCursor,
        };
      },
      _restoreEditingProps: function () {
        this._savedProps &&
          ((this.hoverCursor = this._savedProps.overCursor),
          (this.hasControls = this._savedProps.hasControls),
          (this.borderColor = this._savedProps.borderColor),
          (this.lockMovementX = this._savedProps.lockMovementX),
          (this.lockMovementY = this._savedProps.lockMovementY),
          this.canvas &&
            ((this.canvas.defaultCursor = this._savedProps.defaultCursor),
            (this.canvas.moveCursor = this._savedProps.moveCursor)));
      },
      exitEditing: function () {
        var t = this._textBeforeEdit !== this.text;
        return (
          (this.selected = !1),
          (this.isEditing = !1),
          (this.selectable = !0),
          (this.selectionEnd = this.selectionStart),
          this.hiddenTextarea &&
            (this.hiddenTextarea.blur && this.hiddenTextarea.blur(),
            this.canvas &&
              this.hiddenTextarea.parentNode.removeChild(this.hiddenTextarea),
            (this.hiddenTextarea = null)),
          this.abortCursorAnimation(),
          this._restoreEditingProps(),
          (this._currentCursorOpacity = 0),
          this.fire('editing:exited'),
          t && this.fire('modified'),
          this.canvas &&
            (this.canvas.off('mouse:move', this.mouseMoveHandler),
            this.canvas.fire('text:editing:exited', { target: this }),
            t && this.canvas.fire('object:modified', { target: this })),
          this
        );
      },
      _removeExtraneousStyles: function () {
        for (var t in this.styles) this._textLines[t] || delete this.styles[t];
      },
      _removeCharsFromTo: function (t, e) {
        for (; e !== t; ) this._removeSingleCharAndStyle(t + 1), e--;
        (this.selectionStart = t), (this.selectionEnd = t);
      },
      _removeSingleCharAndStyle: function (t) {
        var e = '\n' === this.text[t - 1],
          i = e ? t : t - 1;
        this.removeStyleObject(e, i),
          (this.text = this.text.slice(0, t - 1) + this.text.slice(t)),
          (this._textLines = this._splitTextIntoLines());
      },
      insertChars: function (t, e) {
        var i;
        if (
          (1 < this.selectionEnd - this.selectionStart &&
            this._removeCharsFromTo(this.selectionStart, this.selectionEnd),
          e || !this.isEmptyStyles())
        )
          for (var r = 0, n = t.length; r < n; r++)
            e && (i = fabric.util.object.clone(fabric.copiedTextStyle[r], !0)),
              this.insertChar(t[r], r < n - 1, i);
        else this.insertChar(t, !1);
      },
      insertChar: function (t, e, i) {
        var r = '\n' === this.text[this.selectionStart];
        (this.text =
          this.text.slice(0, this.selectionStart) +
          t +
          this.text.slice(this.selectionEnd)),
          (this._textLines = this._splitTextIntoLines()),
          this.insertStyleObjects(t, r, i),
          (this.selectionStart += t.length),
          (this.selectionEnd = this.selectionStart),
          e ||
            (this._updateTextarea(),
            this.setCoords(),
            this._fireSelectionChanged(),
            this.fire('changed'),
            this.restartCursorIfNeeded(),
            this.canvas &&
              (this.canvas.fire('text:changed', { target: this }),
              this.canvas.renderAll()));
      },
      restartCursorIfNeeded: function () {
        (this._currentTickState &&
          !this._currentTickState.isAborted &&
          this._currentTickCompleteState &&
          !this._currentTickCompleteState.isAborted) ||
          this.initDelayedCursor();
      },
      insertNewlineStyleObject: function (t, e, i) {
        this.shiftLineStyles(t, 1);
        var r = {},
          n = {};
        if (
          (this.styles[t] &&
            this.styles[t][e - 1] &&
            (r = this.styles[t][e - 1]),
          i && r)
        )
          (n[0] = l(r)), (this.styles[t + 1] = n);
        else {
          var s = !1;
          for (var o in this.styles[t]) {
            var a = parseInt(o, 10);
            e <= a &&
              ((s = !0),
              (n[a - e] = this.styles[t][o]),
              delete this.styles[t][o]);
          }
          s && (this.styles[t + 1] = n);
        }
        this._forceClearCache = !0;
      },
      insertCharStyleObject: function (t, e, i) {
        var r = this.styles[t],
          n = l(r);
        for (var s in (0 !== e || i || (e = 1), n)) {
          var o = parseInt(s, 10);
          e <= o && ((r[o + 1] = n[o]), n[o - 1] || delete r[o]);
        }
        var a = i || l(r[e - 1]);
        a && (this.styles[t][e] = a), (this._forceClearCache = !0);
      },
      insertStyleObjects: function (t, e, i) {
        var r = this.get2DCursorLocation(),
          n = r.lineIndex,
          s = r.charIndex;
        this._getLineStyle(n) || this._setLineStyle(n, {}),
          '\n' === t
            ? this.insertNewlineStyleObject(n, s, e)
            : this.insertCharStyleObject(n, s, i);
      },
      shiftLineStyles: function (t, e) {
        var i = l(this.styles);
        for (var r in i) {
          (n = parseInt(r, 10)) <= t && delete i[n];
        }
        for (var r in this.styles) {
          var n;
          t < (n = parseInt(r, 10)) &&
            ((this.styles[n + e] = i[n]), i[n - e] || delete this.styles[n]);
        }
      },
      removeStyleObject: function (t, e) {
        var i = this.get2DCursorLocation(e),
          r = i.lineIndex,
          n = i.charIndex;
        this._removeStyleObject(t, i, r, n);
      },
      _getTextOnPreviousLine: function (t) {
        return this._textLines[t - 1];
      },
      _removeStyleObject: function (t, e, i, r) {
        if (t) {
          var n = this._getTextOnPreviousLine(e.lineIndex),
            s = n ? n.length : 0;
          for (r in (this.styles[i - 1] || (this.styles[i - 1] = {}),
          this.styles[i]))
            this.styles[i - 1][parseInt(r, 10) + s] = this.styles[i][r];
          this.shiftLineStyles(e.lineIndex, -1);
        } else {
          var o = this.styles[i];
          o && delete o[r];
          var a = l(o);
          for (var h in a) {
            var c = parseInt(h, 10);
            r <= c && 0 !== c && ((o[c - 1] = a[c]), delete o[c]);
          }
        }
      },
      insertNewline: function () {
        this.insertChars('\n');
      },
      setSelectionStartEndWithShift: function (t, e, i) {
        i <= t
          ? (e === t
              ? (this._selectionDirection = 'left')
              : 'right' === this._selectionDirection &&
                ((this._selectionDirection = 'left'), (this.selectionEnd = t)),
            (this.selectionStart = i))
          : t < i && i < e
          ? 'right' === this._selectionDirection
            ? (this.selectionEnd = i)
            : (this.selectionStart = i)
          : (e === t
              ? (this._selectionDirection = 'right')
              : 'left' === this._selectionDirection &&
                ((this._selectionDirection = 'right'),
                (this.selectionStart = e)),
            (this.selectionEnd = i));
      },
      setSelectionInBoundaries: function () {
        var t = this.text.length;
        this.selectionStart > t
          ? (this.selectionStart = t)
          : this.selectionStart < 0 && (this.selectionStart = 0),
          this.selectionEnd > t
            ? (this.selectionEnd = t)
            : this.selectionEnd < 0 && (this.selectionEnd = 0);
      },
    });
  })(),
  fabric.util.object.extend(fabric.IText.prototype, {
    initDoubleClickSimulation: function () {
      (this.__lastClickTime = +new Date()),
        (this.__lastLastClickTime = +new Date()),
        (this.__lastPointer = {}),
        this.on(fabric.eventMapping.down, this.onMouseDown.bind(this));
    },
    onMouseDown: function (t) {
      this.__newClickTime = +new Date();
      var e = this.canvas.getPointer(t.e);
      this.isTripleClick(e, t.e)
        ? (this.fire('tripleclick', t), this._stopEvent(t.e))
        : this.isDoubleClick(e) &&
          (this.fire('dblclick', t), this._stopEvent(t.e)),
        (this.__lastLastClickTime = this.__lastClickTime),
        (this.__lastClickTime = this.__newClickTime),
        (this.__lastPointer = e),
        (this.__lastIsEditing = this.isEditing),
        (this.__lastSelected = this.selected);
    },
    isDoubleClick: function (t) {
      return (
        this.__newClickTime - this.__lastClickTime < 500 &&
        this.__lastPointer.x === t.x &&
        this.__lastPointer.y === t.y &&
        this.__lastIsEditing
      );
    },
    isTripleClick: function (t) {
      return (
        this.__newClickTime - this.__lastClickTime < 500 &&
        this.__lastClickTime - this.__lastLastClickTime < 500 &&
        this.__lastPointer.x === t.x &&
        this.__lastPointer.y === t.y
      );
    },
    _stopEvent: function (t) {
      t.preventDefault && t.preventDefault(),
        t.stopPropagation && t.stopPropagation();
    },
    initCursorSelectionHandlers: function () {
      this.initMousedownHandler(), this.initMouseupHandler(), this.initClicks();
    },
    initClicks: function () {
      this.on('dblclick', function (t) {
        this.selectWord(this.getSelectionStartFromPointer(t.e));
      }),
        this.on('tripleclick', function (t) {
          this.selectLine(this.getSelectionStartFromPointer(t.e));
        });
    },
    initMousedownHandler: function () {
      this.on(fabric.eventMapping.down, function (t) {
        if (this.editable && (!t.e.button || 1 === t.e.button)) {
          var e = this.canvas.getPointer(t.e);
          (this.__mousedownX = e.x),
            (this.__mousedownY = e.y),
            (this.__isMousedown = !0),
            this.selected && this.setCursorByClick(t.e),
            this.isEditing &&
              ((this.__selectionStartOnMouseDown = this.selectionStart),
              this.selectionStart === this.selectionEnd &&
                this.abortCursorAnimation(),
              this.renderCursorOrSelection());
        }
      });
    },
    _isObjectMoved: function (t) {
      var e = this.canvas.getPointer(t);
      return this.__mousedownX !== e.x || this.__mousedownY !== e.y;
    },
    initMouseupHandler: function () {
      this.on(fabric.eventMapping.up, function (t) {
        (this.__isMousedown = !1),
          !this.editable ||
            this._isObjectMoved(t.e) ||
            (t.e.button && 1 !== t.e.button) ||
            (this.__lastSelected &&
              !this.__corner &&
              (this.enterEditing(t.e),
              this.selectionStart === this.selectionEnd
                ? this.initDelayedCursor(!0)
                : this.renderCursorOrSelection()),
            (this.selected = !0));
      });
    },
    setCursorByClick: function (t) {
      var e = this.getSelectionStartFromPointer(t),
        i = this.selectionStart,
        r = this.selectionEnd;
      t.shiftKey
        ? this.setSelectionStartEndWithShift(i, r, e)
        : ((this.selectionStart = e), (this.selectionEnd = e)),
        this.isEditing &&
          (this._fireSelectionChanged(), this._updateTextarea());
    },
    getSelectionStartFromPointer: function (t) {
      for (
        var e,
          i = this.getLocalPointer(t),
          r = 0,
          n = 0,
          s = 0,
          o = 0,
          a = 0,
          h = this._textLines.length;
        a < h;
        a++
      ) {
        (e = this._textLines[a]),
          (s += this._getHeightOfLine(this.ctx, a) * this.scaleY);
        var c = this._getLineWidth(this.ctx, a);
        n = this._getLineLeftOffset(c) * this.scaleX;
        for (var l = 0, u = e.length; l < u; l++) {
          if (
            ((r = n),
            (n +=
              this._getWidthOfChar(this.ctx, e[l], a, this.flipX ? u - l : l) *
              this.scaleX),
            !(s <= i.y || n <= i.x))
          )
            return this._getNewSelectionStartFromOffset(i, r, n, o + a, u);
          o++;
        }
        if (i.y < s)
          return this._getNewSelectionStartFromOffset(i, r, n, o + a - 1, u);
      }
      return this.text.length;
    },
    _getNewSelectionStartFromOffset: function (t, e, i, r, n) {
      var s = r + (t.x - e < i - t.x ? 0 : 1);
      return (
        this.flipX && (s = n - s),
        s > this.text.length && (s = this.text.length),
        s
      );
    },
  }),
  fabric.util.object.extend(fabric.IText.prototype, {
    initHiddenTextarea: function () {
      (this.hiddenTextarea = fabric.document.createElement('textarea')),
        this.hiddenTextarea.setAttribute('autocapitalize', 'off'),
        this.hiddenTextarea.setAttribute('autocorrect', 'off'),
        this.hiddenTextarea.setAttribute('autocomplete', 'off'),
        this.hiddenTextarea.setAttribute('spellcheck', 'false'),
        this.hiddenTextarea.setAttribute('data-fabric-hiddentextarea', ''),
        this.hiddenTextarea.setAttribute('wrap', 'off');
      var t = this._calcTextareaPosition();
      (this.hiddenTextarea.style.cssText =
        'position: absolute; top: ' +
        t.top +
        '; left: ' +
        t.left +
        '; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px; line-height: 1px; paddingｰtop: ' +
        t.fontSize +
        ';'),
        fabric.document.body.appendChild(this.hiddenTextarea),
        fabric.util.addListener(
          this.hiddenTextarea,
          'keydown',
          this.onKeyDown.bind(this)
        ),
        fabric.util.addListener(
          this.hiddenTextarea,
          'keyup',
          this.onKeyUp.bind(this)
        ),
        fabric.util.addListener(
          this.hiddenTextarea,
          'input',
          this.onInput.bind(this)
        ),
        fabric.util.addListener(
          this.hiddenTextarea,
          'copy',
          this.copy.bind(this)
        ),
        fabric.util.addListener(
          this.hiddenTextarea,
          'cut',
          this.cut.bind(this)
        ),
        fabric.util.addListener(
          this.hiddenTextarea,
          'paste',
          this.paste.bind(this)
        ),
        fabric.util.addListener(
          this.hiddenTextarea,
          'compositionstart',
          this.onCompositionStart.bind(this)
        ),
        fabric.util.addListener(
          this.hiddenTextarea,
          'compositionupdate',
          this.onCompositionUpdate.bind(this)
        ),
        fabric.util.addListener(
          this.hiddenTextarea,
          'compositionend',
          this.onCompositionEnd.bind(this)
        ),
        !this._clickHandlerInitialized &&
          this.canvas &&
          (fabric.util.addListener(
            this.canvas.upperCanvasEl,
            'click',
            this.onClick.bind(this)
          ),
          (this._clickHandlerInitialized = !0));
    },
    keysMap: {
      8: 'removeChars',
      9: 'exitEditing',
      27: 'exitEditing',
      13: 'insertNewline',
      33: 'moveCursorUp',
      34: 'moveCursorDown',
      35: 'moveCursorRight',
      36: 'moveCursorLeft',
      37: 'moveCursorLeft',
      38: 'moveCursorUp',
      39: 'moveCursorRight',
      40: 'moveCursorDown',
      46: 'forwardDelete',
    },
    ctrlKeysMapUp: { 67: 'copy', 88: 'cut' },
    ctrlKeysMapDown: { 65: 'selectAll' },
    onClick: function () {
      this.hiddenTextarea && this.hiddenTextarea.focus();
    },
    onKeyDown: function (t) {
      if (this.isEditing) {
        if (t.keyCode in this.keysMap) this[this.keysMap[t.keyCode]](t);
        else {
          if (!(t.keyCode in this.ctrlKeysMapDown && (t.ctrlKey || t.metaKey)))
            return;
          this[this.ctrlKeysMapDown[t.keyCode]](t);
        }
        t.stopImmediatePropagation(),
          t.preventDefault(),
          33 <= t.keyCode && t.keyCode <= 40
            ? (this.clearContextTop(), this.renderCursorOrSelection())
            : this.canvas && this.canvas.renderAll();
      }
    },
    onKeyUp: function (t) {
      this.isEditing && !this._copyDone
        ? t.keyCode in this.ctrlKeysMapUp &&
          (t.ctrlKey || t.metaKey) &&
          (this[this.ctrlKeysMapUp[t.keyCode]](t),
          t.stopImmediatePropagation(),
          t.preventDefault(),
          this.canvas && this.canvas.renderAll())
        : (this._copyDone = !1);
    },
    onInput: function (t) {
      if (this.isEditing && !this.inCompositionMode) {
        var e,
          i,
          r,
          n = this.selectionStart || 0,
          s = this.selectionEnd || 0,
          o = this.text.length,
          a = this.hiddenTextarea.value.length;
        (i =
          o < a
            ? ((r = 'left' === this._selectionDirection ? s : n),
              (e = a - o),
              this.hiddenTextarea.value.slice(r, r + e))
            : ((e = a - o + s - n), this.hiddenTextarea.value.slice(n, n + e))),
          this.insertChars(i),
          t.stopPropagation();
      }
    },
    onCompositionStart: function () {
      (this.inCompositionMode = !0),
        (this.prevCompositionLength = 0),
        (this.compositionStart = this.selectionStart);
    },
    onCompositionEnd: function () {
      this.inCompositionMode = !1;
    },
    onCompositionUpdate: function (t) {
      var e = t.data;
      (this.selectionStart = this.compositionStart),
        (this.selectionEnd =
          this.selectionEnd === this.selectionStart
            ? this.compositionStart + this.prevCompositionLength
            : this.selectionEnd),
        this.insertChars(e, !1),
        (this.prevCompositionLength = e.length);
    },
    forwardDelete: function (t) {
      if (this.selectionStart === this.selectionEnd) {
        if (this.selectionStart === this.text.length) return;
        this.moveCursorRight(t);
      }
      this.removeChars(t);
    },
    copy: function (t) {
      if (this.selectionStart !== this.selectionEnd) {
        var e = this.getSelectedText(),
          i = this._getClipboardData(t);
        i && i.setData('text', e),
          (fabric.copiedText = e),
          (fabric.copiedTextStyle = this.getSelectionStyles(
            this.selectionStart,
            this.selectionEnd
          )),
          t.stopImmediatePropagation(),
          t.preventDefault(),
          (this._copyDone = !0);
      }
    },
    paste: function (t) {
      var e = null,
        i = this._getClipboardData(t),
        r = !0;
      i
        ? ((e = i.getData('text').replace(/\r/g, '')),
          (fabric.copiedTextStyle && fabric.copiedText === e) || (r = !1))
        : (e = fabric.copiedText),
        e && this.insertChars(e, r),
        t.stopImmediatePropagation(),
        t.preventDefault();
    },
    cut: function (t) {
      this.selectionStart !== this.selectionEnd &&
        (this.copy(t), this.removeChars(t));
    },
    _getClipboardData: function (t) {
      return (t && t.clipboardData) || fabric.window.clipboardData;
    },
    _getWidthBeforeCursor: function (t, e) {
      for (
        var i,
          r = this._textLines[t].slice(0, e),
          n = this._getLineWidth(this.ctx, t),
          s = this._getLineLeftOffset(n),
          o = 0,
          a = r.length;
        o < a;
        o++
      )
        (i = r[o]), (s += this._getWidthOfChar(this.ctx, i, t, o));
      return s;
    },
    getDownCursorOffset: function (t, e) {
      var i = this._getSelectionForOffset(t, e),
        r = this.get2DCursorLocation(i),
        n = r.lineIndex;
      if (n === this._textLines.length - 1 || t.metaKey || 34 === t.keyCode)
        return this.text.length - i;
      var s = r.charIndex,
        o = this._getWidthBeforeCursor(n, s),
        a = this._getIndexOnLine(n + 1, o);
      return this._textLines[n].slice(s).length + a + 2;
    },
    _getSelectionForOffset: function (t, e) {
      return t.shiftKey && this.selectionStart !== this.selectionEnd && e
        ? this.selectionEnd
        : this.selectionStart;
    },
    getUpCursorOffset: function (t, e) {
      var i = this._getSelectionForOffset(t, e),
        r = this.get2DCursorLocation(i),
        n = r.lineIndex;
      if (0 === n || t.metaKey || 33 === t.keyCode) return -i;
      var s = r.charIndex,
        o = this._getWidthBeforeCursor(n, s),
        a = this._getIndexOnLine(n - 1, o),
        h = this._textLines[n].slice(0, s);
      return -this._textLines[n - 1].length + a - h.length;
    },
    _getIndexOnLine: function (t, e) {
      for (
        var i,
          r = this._getLineWidth(this.ctx, t),
          n = this._textLines[t],
          s = this._getLineLeftOffset(r),
          o = 0,
          a = 0,
          h = n.length;
        a < h;
        a++
      ) {
        var c = n[a],
          l = this._getWidthOfChar(this.ctx, c, t, a);
        if (e < (s += l)) {
          i = !0;
          var u = s - l,
            f = s,
            d = Math.abs(u - e);
          o = Math.abs(f - e) < d ? a : a - 1;
          break;
        }
      }
      return i || (o = n.length - 1), o;
    },
    moveCursorDown: function (t) {
      (this.selectionStart >= this.text.length &&
        this.selectionEnd >= this.text.length) ||
        this._moveCursorUpOrDown('Down', t);
    },
    moveCursorUp: function (t) {
      (0 === this.selectionStart && 0 === this.selectionEnd) ||
        this._moveCursorUpOrDown('Up', t);
    },
    _moveCursorUpOrDown: function (t, e) {
      var i = this['get' + t + 'CursorOffset'](
        e,
        'right' === this._selectionDirection
      );
      e.shiftKey ? this.moveCursorWithShift(i) : this.moveCursorWithoutShift(i),
        0 !== i &&
          (this.setSelectionInBoundaries(),
          this.abortCursorAnimation(),
          (this._currentCursorOpacity = 1),
          this.initDelayedCursor(),
          this._fireSelectionChanged(),
          this._updateTextarea());
    },
    moveCursorWithShift: function (t) {
      var e =
        'left' === this._selectionDirection
          ? this.selectionStart + t
          : this.selectionEnd + t;
      return (
        this.setSelectionStartEndWithShift(
          this.selectionStart,
          this.selectionEnd,
          e
        ),
        0 !== t
      );
    },
    moveCursorWithoutShift: function (t) {
      return (
        t < 0
          ? ((this.selectionStart += t),
            (this.selectionEnd = this.selectionStart))
          : ((this.selectionEnd += t),
            (this.selectionStart = this.selectionEnd)),
        0 !== t
      );
    },
    moveCursorLeft: function (t) {
      (0 === this.selectionStart && 0 === this.selectionEnd) ||
        this._moveCursorLeftOrRight('Left', t);
    },
    _move: function (t, e, i) {
      var r;
      if (t.altKey) r = this['findWordBoundary' + i](this[e]);
      else {
        if (!t.metaKey && 35 !== t.keyCode && 36 !== t.keyCode)
          return (this[e] += 'Left' === i ? -1 : 1), !0;
        r = this['findLineBoundary' + i](this[e]);
      }
      if (this[e] !== r) return (this[e] = r), !0;
    },
    _moveLeft: function (t, e) {
      return this._move(t, e, 'Left');
    },
    _moveRight: function (t, e) {
      return this._move(t, e, 'Right');
    },
    moveCursorLeftWithoutShift: function (t) {
      var e = !0;
      return (
        (this._selectionDirection = 'left'),
        this.selectionEnd === this.selectionStart &&
          0 !== this.selectionStart &&
          (e = this._moveLeft(t, 'selectionStart')),
        (this.selectionEnd = this.selectionStart),
        e
      );
    },
    moveCursorLeftWithShift: function (t) {
      return 'right' === this._selectionDirection &&
        this.selectionStart !== this.selectionEnd
        ? this._moveLeft(t, 'selectionEnd')
        : 0 !== this.selectionStart
        ? ((this._selectionDirection = 'left'),
          this._moveLeft(t, 'selectionStart'))
        : void 0;
    },
    moveCursorRight: function (t) {
      (this.selectionStart >= this.text.length &&
        this.selectionEnd >= this.text.length) ||
        this._moveCursorLeftOrRight('Right', t);
    },
    _moveCursorLeftOrRight: function (t, e) {
      var i = 'moveCursor' + t + 'With';
      (this._currentCursorOpacity = 1),
        e.shiftKey ? (i += 'Shift') : (i += 'outShift'),
        this[i](e) &&
          (this.abortCursorAnimation(),
          this.initDelayedCursor(),
          this._fireSelectionChanged(),
          this._updateTextarea());
    },
    moveCursorRightWithShift: function (t) {
      return 'left' === this._selectionDirection &&
        this.selectionStart !== this.selectionEnd
        ? this._moveRight(t, 'selectionStart')
        : this.selectionEnd !== this.text.length
        ? ((this._selectionDirection = 'right'),
          this._moveRight(t, 'selectionEnd'))
        : void 0;
    },
    moveCursorRightWithoutShift: function (t) {
      var e = !0;
      return (
        (this._selectionDirection = 'right'),
        this.selectionStart === this.selectionEnd
          ? ((e = this._moveRight(t, 'selectionStart')),
            (this.selectionEnd = this.selectionStart))
          : (this.selectionStart = this.selectionEnd),
        e
      );
    },
    removeChars: function (t) {
      this.selectionStart === this.selectionEnd
        ? this._removeCharsNearCursor(t)
        : this._removeCharsFromTo(this.selectionStart, this.selectionEnd),
        this.set('dirty', !0),
        this.setSelectionEnd(this.selectionStart),
        this._removeExtraneousStyles(),
        this.canvas && this.canvas.renderAll(),
        this.setCoords(),
        this.fire('changed'),
        this.canvas && this.canvas.fire('text:changed', { target: this });
    },
    _removeCharsNearCursor: function (t) {
      if (0 !== this.selectionStart)
        if (t.metaKey) {
          var e = this.findLineBoundaryLeft(this.selectionStart);
          this._removeCharsFromTo(e, this.selectionStart),
            this.setSelectionStart(e);
        } else if (t.altKey) {
          var i = this.findWordBoundaryLeft(this.selectionStart);
          this._removeCharsFromTo(i, this.selectionStart),
            this.setSelectionStart(i);
        } else
          this._removeSingleCharAndStyle(this.selectionStart),
            this.setSelectionStart(this.selectionStart - 1);
    },
  }),
  (function () {
    var o = fabric.util.toFixed,
      a = fabric.Object.NUM_FRACTION_DIGITS;
    fabric.util.object.extend(fabric.IText.prototype, {
      _setSVGTextLineText: function (t, e, i, r, n, s) {
        this._getLineStyle(t)
          ? this._setSVGTextLineChars(t, e, i, r, s)
          : fabric.Text.prototype._setSVGTextLineText.call(this, t, e, i, r, n);
      },
      _setSVGTextLineChars: function (t, e, i, r, n) {
        for (
          var s = this._textLines[t],
            o = 0,
            a =
              this._getLineLeftOffset(this._getLineWidth(this.ctx, t)) -
              this.width / 2,
            h = this._getSVGLineTopOffset(t),
            c = this._getHeightOfLine(this.ctx, t),
            l = 0,
            u = s.length;
          l < u;
          l++
        ) {
          var f = this._getStyleDeclaration(t, l) || {};
          e.push(this._createTextCharSpan(s[l], f, a, h.lineTop + h.offset, o));
          var d = this._getWidthOfChar(this.ctx, s[l], t, l);
          f.textBackgroundColor &&
            n.push(this._createTextCharBg(f, a, h.lineTop, c, d, o)),
            (o += d);
        }
      },
      _getSVGLineTopOffset: function (t) {
        for (var e, i = 0, r = 0; r < t; r++)
          i += this._getHeightOfLine(this.ctx, r);
        return (
          (e = this._getHeightOfLine(this.ctx, r)),
          {
            lineTop: i,
            offset:
              ((this._fontSizeMult - this._fontSizeFraction) * e) /
              (this.lineHeight * this._fontSizeMult),
          }
        );
      },
      _createTextCharBg: function (t, e, i, r, n, s) {
        return [
          '\t\t<rect fill="',
          t.textBackgroundColor,
          '" x="',
          o(e + s, a),
          '" y="',
          o(i - this.height / 2, a),
          '" width="',
          o(n, a),
          '" height="',
          o(r / this.lineHeight, a),
          '"></rect>\n',
        ].join('');
      },
      _createTextCharSpan: function (t, e, i, r, n) {
        var s = this.getSvgStyles.call(
          fabric.util.object.extend(
            {
              visible: !0,
              fill: this.fill,
              stroke: this.stroke,
              type: 'text',
              getSvgFilter: fabric.Object.prototype.getSvgFilter,
            },
            e
          )
        );
        return [
          '\t\t\t<tspan x="',
          o(i + n, a),
          '" y="',
          o(r - this.height / 2, a),
          '" ',
          e.fontFamily
            ? 'font-family="' + e.fontFamily.replace(/"/g, "'") + '" '
            : '',
          e.fontSize ? 'font-size="' + e.fontSize + '" ' : '',
          e.fontStyle ? 'font-style="' + e.fontStyle + '" ' : '',
          e.fontWeight ? 'font-weight="' + e.fontWeight + '" ' : '',
          e.textDecoration ? 'text-decoration="' + e.textDecoration + '" ' : '',
          'style="',
          s,
          '">',
          fabric.util.string.escapeXml(t),
          '</tspan>\n',
        ].join('');
      },
    });
  })(),
  (function (t) {
    'use strict';
    var r = t.fabric || (t.fabric = {});
    (r.Textbox = r.util.createClass(r.IText, r.Observable, {
      type: 'textbox',
      minWidth: 20,
      dynamicMinWidth: 2,
      __cachedLines: null,
      lockScalingY: !0,
      lockScalingFlip: !0,
      noScaleCache: !1,
      initialize: function (t, e) {
        this.callSuper('initialize', t, e),
          this.setControlsVisibility(r.Textbox.getTextboxControlVisibility()),
          (this.ctx = this.objectCaching
            ? this._cacheContext
            : r.util.createCanvasElement().getContext('2d')),
          this._dimensionAffectingProps.push('width');
      },
      _initDimensions: function (t) {
        this.__skipDimension ||
          (t ||
            ((t = r.util.createCanvasElement().getContext('2d')),
            this._setTextStyles(t),
            this.clearContextTop()),
          (this.dynamicMinWidth = 0),
          (this._textLines = this._splitTextIntoLines(t)),
          this.dynamicMinWidth > this.width &&
            this._set('width', this.dynamicMinWidth),
          this._clearCache(),
          (this.height = this._getTextHeight(t)));
      },
      _generateStyleMap: function () {
        for (
          var t = 0, e = 0, i = 0, r = {}, n = 0;
          n < this._textLines.length;
          n++
        )
          '\n' === this.text[i] && 0 < n
            ? ((e = 0), i++, t++)
            : ' ' === this.text[i] && 0 < n && (e++, i++),
            (r[n] = { line: t, offset: e }),
            (i += this._textLines[n].length),
            (e += this._textLines[n].length);
        return r;
      },
      _getStyleDeclaration: function (t, e, i) {
        if (this._styleMap) {
          var r = this._styleMap[t];
          if (!r) return i ? {} : null;
          (t = r.line), (e = r.offset + e);
        }
        return this.callSuper('_getStyleDeclaration', t, e, i);
      },
      _setStyleDeclaration: function (t, e, i) {
        var r = this._styleMap[t];
        (t = r.line), (e = r.offset + e), (this.styles[t][e] = i);
      },
      _deleteStyleDeclaration: function (t, e) {
        var i = this._styleMap[t];
        (t = i.line), (e = i.offset + e), delete this.styles[t][e];
      },
      _getLineStyle: function (t) {
        var e = this._styleMap[t];
        return this.styles[e.line];
      },
      _setLineStyle: function (t, e) {
        var i = this._styleMap[t];
        this.styles[i.line] = e;
      },
      _deleteLineStyle: function (t) {
        var e = this._styleMap[t];
        delete this.styles[e.line];
      },
      _wrapText: function (t, e) {
        var i,
          r = e.split(this._reNewline),
          n = [];
        for (i = 0; i < r.length; i++) n = n.concat(this._wrapLine(t, r[i], i));
        return n;
      },
      _measureText: function (t, e, i, r) {
        var n = 0;
        r = r || 0;
        for (var s = 0, o = e.length; s < o; s++)
          n += this._getWidthOfChar(t, e[s], i, s + r);
        return n;
      },
      _wrapLine: function (t, e, i) {
        for (
          var r = 0,
            n = [],
            s = '',
            o = e.split(' '),
            a = '',
            h = 0,
            c = 0,
            l = 0,
            u = 0,
            f = !0,
            d = this._getWidthOfCharSpacing(),
            g = 0;
          g < o.length;
          g++
        )
          (a = o[g]),
            (c = this._measureText(t, a, i, h)),
            (h += a.length),
            (r += l + c - d) >= this.width && !f
              ? (n.push(s), (r = c), (f = !(s = '')))
              : (r += d),
            f || (s += ' '),
            (s += a),
            (l = this._measureText(t, ' ', i, h)),
            h++,
            (f = !1),
            u < c && (u = c);
        return (
          g && n.push(s),
          u > this.dynamicMinWidth && (this.dynamicMinWidth = u - d),
          n
        );
      },
      _splitTextIntoLines: function (t) {
        t = t || this.ctx;
        var e = this.textAlign;
        (this._styleMap = null),
          t.save(),
          this._setTextStyles(t),
          (this.textAlign = 'left');
        var i = this._wrapText(t, this.text);
        return (
          (this.textAlign = e),
          t.restore(),
          (this._textLines = i),
          (this._styleMap = this._generateStyleMap()),
          i
        );
      },
      setOnGroup: function (t, e) {
        'scaleX' === t &&
          (this.set('scaleX', Math.abs(1 / e)),
          this.set(
            'width',
            (this.get('width') * e) /
              (void 0 === this.__oldScaleX ? 1 : this.__oldScaleX)
          ),
          (this.__oldScaleX = e));
      },
      get2DCursorLocation: function (t) {
        void 0 === t && (t = this.selectionStart);
        for (var e = this._textLines.length, i = 0, r = 0; r < e; r++) {
          var n = this._textLines[r].length;
          if (t <= i + n) return { lineIndex: r, charIndex: t - i };
          (i += n), ('\n' !== this.text[i] && ' ' !== this.text[i]) || i++;
        }
        return { lineIndex: e - 1, charIndex: this._textLines[e - 1].length };
      },
      _getCursorBoundariesOffsets: function (t, e) {
        for (
          var i = 0,
            r = 0,
            n = this.get2DCursorLocation(),
            s = this._textLines[n.lineIndex].split(''),
            o = this._getLineLeftOffset(
              this._getLineWidth(this.ctx, n.lineIndex)
            ),
            a = 0;
          a < n.charIndex;
          a++
        )
          r += this._getWidthOfChar(this.ctx, s[a], n.lineIndex, a);
        for (a = 0; a < n.lineIndex; a++)
          i += this._getHeightOfLine(this.ctx, a);
        return (
          'cursor' === e &&
            (i +=
              ((1 - this._fontSizeFraction) *
                this._getHeightOfLine(this.ctx, n.lineIndex)) /
                this.lineHeight -
              this.getCurrentCharFontSize(n.lineIndex, n.charIndex) *
                (1 - this._fontSizeFraction)),
          { top: i, left: r, lineLeft: o }
        );
      },
      getMinWidth: function () {
        return Math.max(this.minWidth, this.dynamicMinWidth);
      },
      toObject: function (t) {
        return this.callSuper('toObject', ['minWidth'].concat(t));
      },
    })),
      (r.Textbox.fromObject = function (t, e, i) {
        return r.Object._fromObject('Textbox', t, e, i, 'text');
      }),
      (r.Textbox.getTextboxControlVisibility = function () {
        return {
          tl: !1,
          tr: !1,
          br: !1,
          bl: !1,
          ml: !0,
          mt: !1,
          mr: !0,
          mb: !1,
          mtr: !0,
        };
      });
  })('undefined' != typeof exports ? exports : this),
  (function () {
    var c = fabric.Canvas.prototype._setObjectScale;
    (fabric.Canvas.prototype._setObjectScale = function (t, e, i, r, n, s, o) {
      var a = e.target;
      if (!(a instanceof fabric.Textbox))
        return c.call(fabric.Canvas.prototype, t, e, i, r, n, s, o);
      var h = a.width * (t.x / e.scaleX / (a.width + a.strokeWidth));
      return h >= a.getMinWidth() ? (a.set('width', h), !0) : void 0;
    }),
      (fabric.Group.prototype._refreshControlsVisibility = function () {
        if (void 0 !== fabric.Textbox)
          for (var t = this._objects.length; t--; )
            if (this._objects[t] instanceof fabric.Textbox)
              return void this.setControlsVisibility(
                fabric.Textbox.getTextboxControlVisibility()
              );
      }),
      fabric.util.object.extend(fabric.Textbox.prototype, {
        _removeExtraneousStyles: function () {
          for (var t in this._styleMap)
            this._textLines[t] || delete this.styles[this._styleMap[t].line];
        },
        insertCharStyleObject: function (t, e, i) {
          var r = this._styleMap[t];
          (t = r.line),
            (e = r.offset + e),
            fabric.IText.prototype.insertCharStyleObject.apply(this, [t, e, i]);
        },
        insertNewlineStyleObject: function (t, e, i) {
          var r = this._styleMap[t];
          (t = r.line),
            (e = r.offset + e),
            fabric.IText.prototype.insertNewlineStyleObject.apply(this, [
              t,
              e,
              i,
            ]);
        },
        shiftLineStyles: function (t, e) {
          (t = this._styleMap[t].line),
            fabric.IText.prototype.shiftLineStyles.call(this, t, e);
        },
        _getTextOnPreviousLine: function (t) {
          for (
            var e = this._textLines[t - 1];
            this._styleMap[t - 2] &&
            this._styleMap[t - 2].line === this._styleMap[t - 1].line;

          )
            (e = this._textLines[t - 2] + e), t--;
          return e;
        },
        removeStyleObject: function (t, e) {
          var i = this.get2DCursorLocation(e),
            r = this._styleMap[i.lineIndex],
            n = r.line,
            s = r.offset + i.charIndex;
          this._removeStyleObject(t, i, n, s);
        },
      });
  })(),
  (function () {
    var h = fabric.IText.prototype._getNewSelectionStartFromOffset;
    fabric.IText.prototype._getNewSelectionStartFromOffset = function (
      t,
      e,
      i,
      r,
      n
    ) {
      r = h.call(this, t, e, i, r, n);
      for (
        var s = 0, o = 0, a = 0;
        a < this._textLines.length &&
        !(r <= (s += this._textLines[a].length) + o);
        a++
      )
        ('\n' !== this.text[s + o] && ' ' !== this.text[s + o]) || o++;
      return r - a + o;
    };
  })(),
  (function () {
    if ('undefined' == typeof document || 'undefined' == typeof window) {
      var DOMParser = null,
        URL = null,
        HTTP = null,
        HTTPS = null,
        Canvas = require('canvas'),
        Image = require('canvas').Image;
      (fabric.util.loadImage = function (e, i, r) {
        function t(t) {
          t
            ? ((n.src = new Buffer(t, 'binary')),
              (n._src = e),
              i && i.call(r, n))
            : ((n = null), i && i.call(r, null, !0));
        }
        var n = new Image();
        e && (e instanceof Buffer || 0 === e.indexOf('data'))
          ? ((n.src = n._src = e), i && i.call(r, n))
          : e && 0 !== e.indexOf('http')
          ? requestFs(e, t)
          : e
          ? request(e, 'binary', t)
          : i && i.call(r, e);
      }),
        (fabric.loadSVGFromURL = function (t, e, i) {
          0 !==
          (t = t
            .replace(/^\n\s*/, '')
            .replace(/\?.*$/, '')
            .trim()).indexOf('http')
            ? requestFs(t, function (t) {
                fabric.loadSVGFromString(t.toString(), e, i);
              })
            : request(t, '', function (t) {
                fabric.loadSVGFromString(t, e, i);
              });
        }),
        (fabric.loadSVGFromString = function (t, i, e) {
          var r = new DOMParser().parseFromString(t);
          fabric.parseSVGDocument(
            r.documentElement,
            function (t, e) {
              i && i(t, e);
            },
            e
          );
        }),
        (fabric.util.getScript = function (url, callback) {
          request(url, '', function (body) {
            eval(body), callback && callback();
          });
        }),
        (fabric.createCanvasForNode = function (t, e, i, r) {
          r = r || i;
          var n = fabric.document.createElement('canvas'),
            s = new Canvas(t || 600, e || 600, r),
            o = new Canvas(t || 600, e || 600, r);
          (n.style = {}),
            (n.width = s.width),
            (n.height = s.height),
            ((i = i || {}).nodeCanvas = s),
            (i.nodeCacheCanvas = o);
          var a = new (fabric.Canvas || fabric.StaticCanvas)(n, i);
          return (
            (a.nodeCanvas = s),
            (a.nodeCacheCanvas = o),
            (a.contextContainer = s.getContext('2d')),
            (a.contextCache = o.getContext('2d')),
            (a.Font = Canvas.Font),
            a
          );
        });
      var originaInitStatic = fabric.StaticCanvas.prototype._initStatic;
      (fabric.StaticCanvas.prototype._initStatic = function (t, e) {
        (t = t || fabric.document.createElement('canvas')),
          (this.nodeCanvas = new Canvas(t.width, t.height)),
          (this.nodeCacheCanvas = new Canvas(t.width, t.height)),
          originaInitStatic.call(this, t, e),
          (this.contextContainer = this.nodeCanvas.getContext('2d')),
          (this.contextCache = this.nodeCacheCanvas.getContext('2d')),
          (this.Font = Canvas.Font);
      }),
        (fabric.StaticCanvas.prototype.createPNGStream = function () {
          return this.nodeCanvas.createPNGStream();
        }),
        (fabric.StaticCanvas.prototype.createJPEGStream = function (t) {
          return this.nodeCanvas.createJPEGStream(t);
        }),
        (fabric.StaticCanvas.prototype._initRetinaScaling = function () {
          if (this._isRetinaScaling())
            return (
              this.lowerCanvasEl.setAttribute(
                'width',
                this.width * fabric.devicePixelRatio
              ),
              this.lowerCanvasEl.setAttribute(
                'height',
                this.height * fabric.devicePixelRatio
              ),
              (this.nodeCanvas.width = this.width * fabric.devicePixelRatio),
              (this.nodeCanvas.height = this.height * fabric.devicePixelRatio),
              this.contextContainer.scale(
                fabric.devicePixelRatio,
                fabric.devicePixelRatio
              ),
              this
            );
        }),
        fabric.Canvas &&
          (fabric.Canvas.prototype._initRetinaScaling =
            fabric.StaticCanvas.prototype._initRetinaScaling);
      var origSetBackstoreDimension =
        fabric.StaticCanvas.prototype._setBackstoreDimension;
      (fabric.StaticCanvas.prototype._setBackstoreDimension = function (t, e) {
        return (
          origSetBackstoreDimension.call(this, t, e),
          (this.nodeCanvas[t] = e),
          this
        );
      }),
        fabric.Canvas &&
          (fabric.Canvas.prototype._setBackstoreDimension =
            fabric.StaticCanvas.prototype._setBackstoreDimension);
    }
    function request(t, r, n) {
      var e = URL.parse(t);
      e.port || (e.port = 0 === e.protocol.indexOf('https:') ? 443 : 80);
      var i = (0 === e.protocol.indexOf('https:') ? HTTPS : HTTP).request(
        { hostname: e.hostname, port: e.port, path: e.path, method: 'GET' },
        function (e) {
          var i = '';
          r && e.setEncoding(r),
            e.on('end', function () {
              n(i);
            }),
            e.on('data', function (t) {
              200 === e.statusCode && (i += t);
            });
        }
      );
      i.on('error', function (t) {
        t.errno === process.ECONNREFUSED
          ? fabric.log(
              'ECONNREFUSED: connection refused to ' + e.hostname + ':' + e.port
            )
          : fabric.log(t.message),
          n(null);
      }),
        i.end();
    }
    function requestFs(t, i) {
      null.readFile(t, function (t, e) {
        if (t) throw (fabric.log(t), t);
        i(e);
      });
    }
  })();
